module.exports = /******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/
  var installedModules = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/
  __webpack_require__.c = installedModules;
  /******/
  /******/ // identity function for calling harmony imports with the correct context
  /******/
  __webpack_require__.i = function (value) {
    return value;
  };
  /******/
  /******/ // define getter function for harmony exports
  /******/
  __webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        /******/configurable: false,
        /******/enumerable: true,
        /******/get: getter
        /******/
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/
  __webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ? /******/function getDefault() {
      return module['default'];
    } : /******/function getModuleExports() {
      return module;
    };
    /******/
    __webpack_require__.d(getter, 'a', getter);
    /******/
    return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/
  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/
  __webpack_require__.p = "";
  /******/
  /******/ // Load entry module and return exports
  /******/
  return __webpack_require__(__webpack_require__.s = 24);
  /******/
}
/************************************************************************/
/******/([/* 0 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.toCssSelectorSection = undefined;
    exports.fullSelector = fullSelector;
    exports.fullXPath = fullXPath;
    exports.shortSelector = shortSelector;
    exports.getPath = getPath;
    exports.toMultiCssSelector = toMultiCssSelector;
    exports.toCssSelector = toCssSelector;
    exports.querySelectorAll = querySelectorAll;
    exports.getByFullXPath = getByFullXPath;
    exports.selectByXPath = selectByXPath;
    exports.selectNodes = selectNodes;
    exports.updatePathFormat = updatePathFormat;
    exports.compactSelector = compactSelector;
    exports.uniqueNode = uniqueNode;
    exports.selectNode = selectNode;
    exports.indexCondition = indexCondition;
    var _css = __webpack_require__(12);
    var _css2 = _interopRequireDefault(_css);
    var _utils = __webpack_require__(1);
    var _logger = __webpack_require__(4);
    var _logger2 = _interopRequireDefault(_logger);
    var _timer = __webpack_require__(5);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }

    // limit the number of nodes a user supplied xpath will return so it doesn't hang the browser
    var maximumXPathNodes = 1000;
    var nodejs = typeof global.window === 'undefined';

    // hyphen!
    var nwmatcher = nodejs ? __webpack_require__(34) : undefined;

    /**
     * Work out what index (reversed, to end) for nth-last-of-type
     * @param  {Element} e
     * @return {Integer}
     */
    var lastOfType = function lastOfType(e) {
      var pos = 0;
      for (var child = e.parentNode.lastChild; child; child = child.previousSibling) {
        if (e.nodeType === 3 && child.nodeType === 3 || e.nodeType === 1 && child.localName === e.localName) pos++;
        if (child === e) break;
      }
      return pos;
    };

    /**
     * Compute the full selector for the element
     * @param  {Element} el
     * @return {String}
     */
    function fullSelector(el) {
      if (el.__fullSelector) return el.__fullSelector;
      var names = [];
      while (el && el.parentNode && el.ownerDocument) {
        if (el === el.ownerDocument.documentElement) names.unshift(el.localName);else {
          var c = 1;
          for (var e = el.previousESibling; e; e = e.previousSibling) {
            if (e.localName === el.localName) c++;
          }
          var part = el.nodeType === 3 ? '#text' : el.localName;
          if (part !== 'html' && part !== 'body') part += ':nth-child(' + c + ')';
          names.unshift(part);
        }
        el = el.parentNode;
      }
      var sel = names.join(' > ');
      el.__fullSelector = sel;
      return sel;
    }
    ;

    /**
     * Compute the full xpath for the element (using just positions)
     * @param  {Element} el
     * @return {String}
     */
    function fullXPath(el) {
      var forDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var textName = forDisplay ? 'io-text' : 'text()';
      if (!forDisplay && useCache && el.__xpath) return el.__xpath;else if (forDisplay && useCache && el.__xpathDisplay) return el.__xpathDisplay;
      var start = el;
      if (el.parentNode && el.parentNode.localName === 'io-text') el = el.parentNode;
      var names = [];
      while (el && el.parentNode && el.ownerDocument) {
        var c = 1;
        for (var e = el.previousSibling; e; e = e.previousSibling) {
          if (e.localName === el.localName) c++;
        }
        var name = el.nodeType === 3 || el.localName === 'io-text' ? textName : el.localName;
        if (name !== 'html' && name !== 'body') name += '[' + c + ']';
        names.unshift(name);
        el = el.parentNode;
      }
      var xp = '/' + names.join('/');
      if (!forDisplay && useCache) start.__xpath = xp;else if (forDisplay && useCache) start.__xpathDisplay = xp;
      return xp;
    }
    ;

    /**
     * This is a workaround for element.classList sometimes
     * returning lower cased element names
     */
    function classList(element) {
      var className = typeof element.className === 'string' ? element.className : element.getAttribute('class');
      if (className) {
        var cl = element.className.trim();
        if (!cl) return [];
        return cl.split(/\s+/g);
      } else {
        return [];
      }
    }
    function shortSelector(element) {
      var document = element.ownerDocument;
      _logger2.default.debug('shortSelector', element);
      var selector = '';
      while (element.parentNode) {
        var sel = element.localName;
        if (element.id) {
          sel += '#' + element.id;
        }
        if (element.classList.length) {
          classList(element).forEach(function (x) {
            return sel += '.' + (0, _css2.default)(x);
          });
        }
        var newSelector = sel + ' ' + selector;
        if (document.querySelectorAll(newSelector).length == 1) {
          return newSelector;
        }
        selector = sel + ':nth-of-type(' + childOfType(element) + ') ' + selector;
        element = element.parentNode;
      }
      throw 'Couldn\'t form selector';
    }

    /**
     * Work out what index for nth-child-of-type
     * @param  {Element} e
     * @return {Integer}
     */
    var childOfType = function childOfType(e) {
      var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (useCache && e.__childOfType) return e.__childOfType;
      var pos = 0;
      for (var child = e.parentNode.firstChild; child; child = child.nextSibling) {
        if (e.nodeType === 3 && child.nodeType === 3 || e.nodeType === 1 && child.localName === e.localName) pos++;
        if (child === e) break;
      }
      if (useCache) e.__childOfType = pos;
      return pos;
    };
    function attributes(el) {
      var result = {};
      if (el.attributes) {
        for (var att, i = 0, atts = el.attributes, n = atts.length; i < n; i++) {
          att = atts[i];
          result[att.nodeName] = att.nodeValue;
        }
      }
      return result;
    }
    function getPath(e, forRegion) {
      var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (useCache && e.__path) return e.__path;
      var buffer = [];
      var x = e;
      var covers = true;
      while (x) {
        //allow text nodes to be wrapped in an io-text element
        var name = x.localName ? x.localName === 'io-text' ? '#text' : x.localName : x.nodeName;
        var pathSection = {
          name: name,
          childOfType: childOfType(x, useCache),
          lastOfType: lastOfType(x),
          attributes: attributes(x)
        };

        // Check if there is more than one element with the same ID. If there is, remove id attribute.
        if (pathSection.attributes && pathSection.attributes.id) {
          if (x.ownerDocument && querySelectorAll(x.ownerDocument, '#' + (0, _css2.default)(pathSection.attributes.id)).length > 1) {
            delete pathSection.attributes.id;
          }
        }
        if (x.nodeType === 1) {
          pathSection.classes = classList(x).filter(function (clazz) {
            return !/^_iohighlight-\w+$/.exec(clazz);
          });
        } else {
          pathSection.classes = [];
        }
        if (covers && e !== x) {
          if (e.tagName === 'IMG') {
            covers = false;
          } else {
            // work out if we've got a non-whitespace text node that's a child of this node
            for (var child = x.firstChild; child; child = child.nextSibling) {
              if (child !== e && !(0, _utils.isWhitespace)(child)) {
                covers = false;
                break;
              }
            }
          }
        }
        pathSection.covers = covers;
        if (covers) {
          if (forRegion) {
            covers = false;
          }
          // if we step outside of the link, consider it non-covering
          if (x.localName === 'a' && (0, _utils.validHref)(x.getAttribute('href'))) covers = false;
        }
        buffer.push(pathSection);
        if (x.localName && x.localName.toLowerCase() === 'html') break;
        x = x.parentNode;
      }
      if (useCache) e.__path = buffer;
      return buffer;
    }
    ;
    function toMultiCssSelector(paths) {
      var forDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return paths.map(function (x) {
        return toCssSelector(x, forDisplay);
      }).join(', ');
    }
    function toCssSelector(path) {
      var forDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var result = function () {
        if (Array.isArray(path[0])) {
          return toMultiCssSelector(path, forDisplay);
        }
        if (path.length == 0) {
          return ':this';
        }
        updatePathFormat(path);
        var temp = [];
        for (var i = 0; i < path.length; i++) {
          var useIdValue = i == path.length - 1;
          var skipIndex = false;
          temp.push(toCssSelectorSection(path[i], skipIndex, useIdValue, forDisplay));
        }
        temp.reverse();
        var result = temp.join(' > ');
        return result;
      }();
      _logger2.default.debug('Created CSS selector', result);
      return result;
    }
    ;
    function querySelectorAll(context, sel) {
      if (sel === ':this') return [context];
      if (!context.__querySelectorAll) context.__querySelectorAll = {};else {
        var cached = context.__querySelectorAll[sel];
        if (cached) {
          return cached;
        }
      }
      try {
        var result = void 0;
        if (nodejs) {
          // on server, use nwmatcher directly

          var document = context.ownerDocument || context;
          if (!document._nwmatcher) {
            document._nwmatcher = nwmatcher({
              document: document
            });
            document._nwmatcher.configure({
              UNIQUE_ID: false
            });
          }

          // caching useful for magic
          result = document._nwmatcher.select(sel, context);
        } else {
          result = Array.from(context.querySelectorAll(sel));
        }
        // useful to cache for magic
        context.__querySelectorAll[sel] = result;
        return result;
      } catch (e) {
        _logger2.default.error('ERROR: Cannot execute selector: ', sel, e.stack);
        return [];
      }
    }
    function querySelector(context, sel) {
      if (sel === ':this') return context;
      if (!context.__querySelector) context.__querySelector = {};else {
        var cached = context.__querySelector[sel];
        if (cached) {
          return cached;
        }
      }
      var result = void 0;
      if (nodejs) {
        // on server, use nwmatcher directly

        var document = context.ownerDocument || context;
        if (!document._nwmatcher) {
          document._nwmatcher = nwmatcher({
            document: document
          });
          document._nwmatcher.configure({
            UNIQUE_ID: false
          });
        }

        // useful to cache for magic
        result = document._nwmatcher.first(sel, context);
      } else {
        result = context.querySelector(sel);
      }
      context.__querySelector[sel] = result;
      return result;
    }
    function getByFullXPath(xpath, document) {
      if (!xpath) throw 'No xpath';

      // there is an edge case where we end up with xpaths like
      // /html/body[1]/form[1]/div[3]/div[4]/div[1]/div[1]/div[1]/div[1]/div[2]/div[1]/*[name()='tp:socialbuttonsandwidgets'][1]/*[name()='tp:socialbuttonsandwidgets'][1]/div[1]/div[1]/div[4]/div[1]/table[1]/tbody[1]/tr[11]/td[3]/a[1]
      // because 'tp:socialbuttonsandwidgets' is not a valid XML element name
      xpath = xpath.replace(/\*\[name\(\)='([^']+)'\]/g, '$1');
      var sections = xpath.split('/');
      var current = document.documentElement;
      for (var i = 2; i < sections.length; i++) {
        var section = sections[i];
        var idx = section.lastIndexOf('[');
        var name = void 0,
          index = void 0;
        if (idx === -1) {
          name = section;
          index = 1;
        } else {
          name = section.substring(0, idx);
          index = parseInt(section.substring(idx + 1, section.length - 1));
        }
        var type = name === 'text()' ? 3 : 1;
        var child = current.firstChild;
        var j = 0;
        while (child) {
          if (type === child.nodeType && (type === 3 || child.localName === name) || type === 3 && child.localName === 'io-text') j++;
          if (index === j) {
            current = child;
            break;
          }
          child = child.nextSibling;
        }
        if (!child) {
          _logger2.default.warn('FAIL getByFullXPath');
          return null;
        }
      }
      return current;
    }
    function compileXPath(document, xpath) {
      try {
        if (!document.__xpathExpressions) document.__xpathExpressions = {};
        var x = document.__xpathExpressions[xpath];
        if (!x) {
          x = document.createExpression(xpath, null);
          document.__xpathExpressions[xpath] = x;
        }
        return x;
      } catch (e) {
        _logger2.default.warn('Invalid xpath: ', xpath);
        return null;
      }
    }
    var enableXPathResultCache = !nodejs;
    function selectByXPath(xpath, context) {
      var forDisplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var ordered = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (enableXPathResultCache) {
        if (!context.__xpathResults) context.__xpathResults = {};else if (context.__xpathResults[xpath]) return context.__xpathResults[xpath];
      }
      var doc = context.ownerDocument || context;
      try {
        if (forDisplay) {
          xpath = xpath.replace(/text\(\)/g, 'io-text').replace(/@(style|class)/g, '@_$1');
        }
        xpath = xpath.replace('$childOfType', function () {
          return childOfType(context);
        });
        var compiled = compileXPath(doc, xpath);
        if (!compiled) return []; // bad xpath

        var iterator = compiled.evaluate(context, ordered ? 5 : 4, null);
        var result = [];
        var thisNode = iterator.iterateNext();
        var i = 0;
        while (thisNode && (!forDisplay || i < maximumXPathNodes)) {
          i++;
          result.push(thisNode);
          thisNode = iterator.iterateNext();
        }
        if (enableXPathResultCache) {
          context.__xpathResults[xpath] = result;
        }
        _logger2.default.debug('selectByXPath', context.tagName, xpath, result.length);
        return result;
      } catch (e) {
        _logger2.default.error('XPath error', e.stack);
        return [];
      }
    }
    function selectNodes(pathOrPathsOrField, context) {
      var forDisplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!pathOrPathsOrField) return [];

      // Field Object with a manual xpath
      if (pathOrPathsOrField.xpath) {
        return selectByXPath(pathOrPathsOrField.xpath, context, forDisplay);
      }

      // is a Field object
      if (pathOrPathsOrField.id) {
        return selectNodes(pathOrPathsOrField.selector, context, forDisplay);
      }
      if (!Array.isArray(pathOrPathsOrField)) {
        throw new Error('Bad type in selectNodes: ', pathOrPathsOrField);
      }
      if (pathOrPathsOrField.length === 0) {
        return [];
      }

      // compact selector
      if (typeof pathOrPathsOrField[0][0] === 'string') {
        return getByCompactSelector(pathOrPathsOrField, context, forDisplay);
      }
      return getBySelector(pathOrPathsOrField, context, forDisplay);
    }
    var toSelector = function toSelector(x) {
      var sel = void 0;
      if (x[1] === null) sel = x[0];else if (x[1] === '*') sel = x[0] + ' > io-text';else sel = x[0] + ' > io-text:nth-of-type(' + x[1] + ')';
      return sel;
    };

    // TODO: this uniques in O(n^2) time, test if faster to sort elements array and then dedupe by removing where n == n-1
    function getByCompactSelector(selectors, context, forDisplay) {
      if (!selectors.length) return [];
      try {
        var notTextPaths = forDisplay ? selectors : selectors.filter(function (x) {
          return x[1] === null;
        });
        var elements = void 0;
        if (notTextPaths.length > 0) {
          if (notTextPaths.length === 1) {
            elements = querySelectorAll(context, toSelector(notTextPaths[0]));
          } else {
            elements = [];
            // more efficient not to run them with commas with nwmatcher
            notTextPaths.forEach(function (x) {
              var _elements;
              (_elements = elements).push.apply(_elements, _toConsumableArray(querySelectorAll(context, toSelector(x))));
            });
          }
          if (notTextPaths.length === selectors.length) {
            return Array.from(new Set(elements));
          }
        } else {
          elements = [];
        }
        var textPaths = selectors.filter(function (x) {
          return x[1] !== null;
        });
        textPaths.forEach(function (textPath) {
          var sel = textPath[0];
          _logger2.default.debug('Running', sel, ' with text=', textPath[0].childOfType);
          (0, _timer.time)(sel);
          var parentElements = querySelectorAll(context, sel);
          var pos = textPath[1];
          (0, _timer.timeEnd)(sel);
          parentElements.forEach(function (parent) {
            // TODO: better 2n+2 style extraction for text nodes?
            if (!pos) {
              elements.push(parent);
              return;
            }
            if (pos === '*') {
              for (var c = parent.firstChild; c; c = c.nextSibling) {
                if (c.nodeType === 3) {
                  elements.push(c);
                }
              }
            } else {
              var element = getText(pos, parent);
              if (element) {
                elements.push(element);
              }
            }
          });
        });
        return Array.from(new Set(elements));
      } catch (e) {
        _logger2.default.error('ERROR: ', selectors, e);
        return [];
      }
    }
    ;
    function updatePathFormat(path) {
      // fix up old path format
      path.forEach(function (section) {
        if (!section.classes) section.classes = [];
        if (section.attributes) return;
        section.attributes = {};
        if (section.id !== undefined) section.attributes.id = section.id;
        if (section.style !== undefined) section.attributes.style = section.style;
        if (section.classAttribute !== undefined) section.attributes.class = section.classAttribute;
        delete section.class;
        delete section.id;
        delete section.style;
      });
    }
    function getBySelector(pathOrPaths, context, forDisplay) {
      var paths = (Array.isArray(pathOrPaths[0]) ? pathOrPaths : [pathOrPaths]).filter(function (x) {
        return x;
      });
      if (!paths.length) return [];
      paths.forEach(updatePathFormat);
      var notTextPaths = forDisplay ? paths : paths.filter(function (x) {
        return x.length === 0 || x[0].name !== '#text';
      });
      var elements = void 0;
      if (notTextPaths.length > 0) {
        var sel = toCssSelector(notTextPaths, forDisplay);
        (0, _timer.time)(sel);
        elements = querySelectorAll(context, sel);
        (0, _timer.timeEnd)(sel);
        if (notTextPaths.length === paths.length) {
          return elements;
        }
      } else {
        elements = [];
      }
      var textPaths = paths.filter(function (x) {
        return x[0].name === '#text';
      });
      textPaths.forEach(function (textPath) {
        var sel = toCssSelector(textPath.slice(1), forDisplay);
        (0, _timer.time)(sel);
        var parentElements = querySelectorAll(context, sel);
        (0, _timer.timeEnd)(sel);
        parentElements.forEach(function (parent) {
          var pos = textPath[0].childOfType;
          // TODO: better 2n+2 style extraction for text nodes?
          if (pos && !Array.isArray(pos)) {
            var element = getText(pos, parent);
            if (element && elements.indexOf(element) < 0) {
              elements.push(element);
            }
          } else {
            // all text nodes
            for (var c = parent.firstChild; c; c = c.nextSibling) {
              if (c.nodeType === 3 && elements.indexOf(c) < 0) {
                elements.push(c);
              }
            }
          }
        });
      });
      return elements;
    }
    ;

    /**
     * Compact to the short form of a selector (uses CSS selectors)
     */
    function compactSelector(selectorOrSelectors) {
      if (!selectorOrSelectors) return null;

      // normal form is [ sel, textPos ]
      var selectors = (Array.isArray(selectorOrSelectors[0]) ? selectorOrSelectors : [selectorOrSelectors]).filter(function (x) {
        return x;
      });
      if (!selectors.length) return [];
      return selectors.map(function (path) {
        if (path.length === 0) {
          return [':this', null];
        }
        var text = void 0;
        if (path[0].name === '#text') {
          text = path[0];
          path = path.slice(1);
        }
        var sel = toCssSelector(path);
        if (!text) return [sel, null];
        var pos = text.childOfType;
        return [sel, pos && !Array.isArray(pos) ? pos : '*'];
      });
    }

    // TODO: work out if we can make this quicker
    function uniqueNode(path, context) {
      if (path[0].name !== '#text') {
        var _sel = toCssSelector(path);
        var result = querySelectorAll(context, _sel);
        (0, _timer.time)(_sel);
        return result.length === 1;
      }
      var sel = toCssSelector(path.slice(1));
      (0, _timer.time)(sel);
      var parents = querySelectorAll(context, sel);
      var seen = false;
      for (var i = 0; i < parents.length; i++) {
        var parent = parents[i];
        var pos = path[0].childOfType;
        if (pos) {
          var element = getText(pos, parent);
          if (element) {
            if (seen) return false;
            seen = true;
          }
        } else {
          // all text nodes
          for (var c = parent.firstChild; c; c = c.nextSibling) {
            if (c.nodeType === 3) {
              if (seen) return false;
              seen = true;
            }
          }
        }
      }
      return seen;
    }
    ;
    function selectNode(path, context) {
      if (path[0].name !== '#text') {
        var _sel2 = toCssSelector(path);
        (0, _timer.time)(_sel2);
        return querySelector(context, _sel2);
      }
      var sel = toCssSelector(path.slice(1));
      (0, _timer.time)(sel);
      var parent = querySelector(context, sel);
      (0, _timer.timeEnd)(sel);
      var pos = path[0].childOfType;
      if (pos) {
        var element = getText(pos, parent);
        if (element) {
          return element;
        }
      } else {
        // all text nodes
        for (var c = parent.firstChild; c; c = c.nextSibling) {
          if (c.nodeType === 3) {
            return c;
          }
        }
      }
    }
    ;
    var getText = function getText(pos, element) {
      if (!element || !pos) return element;
      var current = 0;
      for (var c = element.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3) {
          current++;
          if (current == pos) return c;
        }
      }
      return null;
    };
    var toCssSelectorSection = exports.toCssSelectorSection = function toCssSelectorSection(pathSection, skipIdx, useIdValue, forDisplay) {
      var clazz = forDisplay ? '_class' : 'class';
      var style = forDisplay ? '_style' : 'style';

      // TODO: This could be improved to be not global to the section
      // TODO: Use this in the generation
      var skipNots = !pathSection.explicitNot;
      if (pathSection.name === 'body') {
        return 'body';
      }
      var result = '';

      // it is a good idea to ignore ID values when within multiple records, they tend to change depending on content
      if (hasValue(pathSection.attributes.id)) {
        if (Array.isArray(pathSection.attributes.id)) {
          if (pathSection.attributes.id.findIndex(function (i) {
            return !hasValue(i);
          }) < 0) {
            result += '[id]';
          }
          if (pathSection.attributes.id.findIndex(function (i) {
            return hasValue(i);
          }) < 0) {
            if (!skipNots) result += ':not([id])';
          }
        } else {
          if (useIdValue && pathSection.attributes.id) {
            var escaped = (0, _css2.default)(pathSection.attributes.id);
            result += escaped === pathSection.attributes.id ? '#' + pathSection.attributes.id : '[id="' + escaped + '"]';
          } else {
            result += '[id]';
          }
        }
      } else {
        if (!skipNots) result += ':not([id])';
      }
      if (result[0] === '#') return result;
      result = pathSectionTagName(pathSection, forDisplay) + result;
      if (hasValue(pathSection.attributes.style)) {
        if (Array.isArray(pathSection.attributes.style)) {
          if (pathSection.attributes.style.findIndex(function (i) {
            return !hasValue(i);
          }) < 0) {
            result += '[' + style + ']';
          }
          if (pathSection.attributes.style.findIndex(function (i) {
            return hasValue(i);
          }) < 0) {
            if (!skipNots) result += ':not([' + style + '])';
          }
        } else {
          result += '[' + style + ']';
        }
      } else {
        if (!skipNots) result += ':not([' + style + '])';
      }
      if (pathSection.classes && pathSection.classes.length) {
        pathSection.classes.forEach(function (c) {
          var escaped = (0, _css2.default)(c);
          result += escaped === c ? '.' + c : '[' + clazz + '~="' + escaped + '"]';
        });
      } else {
        if (hasValue(pathSection.attributes.class)) {
          if (Array.isArray(pathSection.attributes.class)) {
            if (pathSection.attributes.class.findIndex(function (i) {
              return i !== '';
            }) < 0) {
              result += '[' + clazz + '=\'\']';
            } else if (pathSection.attributes.class.findIndex(hasValue) < 0) {
              if (!skipNots) result += ':not([' + clazz + '])';
            }
          } else {
            // class with out values
            // TODO: what if it has whitespace?
            result += '[' + clazz + '=\'\']';
          }
        } else {
          if (!skipNots) result += ':not([' + clazz + '])';
        }
      }
      if (pathSection.not) {
        if (pathSection.not.classes) {
          pathSection.not.classes.forEach(function (c) {
            var escaped = (0, _css2.default)(c);
            result += ':not(' + (escaped === c ? '.' + c : '[' + clazz + '~="' + escaped + '"]') + ')';
          });
        }
      }
      ['itemprop', 'itemtype', 'typeof', 'property', 'name', 'type'].forEach(function (attr) {
        var val = pathSection.attributes[attr];
        if (hasValue(val)) {
          if (Array.isArray(val)) {
            if (val.findIndex(function (i) {
              return !hasValue(i);
            }) < 0) {
              result += '[' + attr + ']';
            }
          } else {
            var _escaped = (0, _css2.default)(val);
            result += '[' + attr + '="' + _escaped + '"]';
          }
        }
      });
      return result + indexCondition(pathSection);
    };
    var hasValue = function hasValue(s) {
      return s !== null && s !== undefined;
    };
    var pathSectionTagName = function pathSectionTagName(pathSection, forDisplay) {
      if (!pathSection.name) {
        throw 'No name for element: ' + JSON.stringify(pathSection);
      }
      if (pathSection.name === 'html' || pathSection.name === 'head' || pathSection.name === 'body') {
        return pathSection.name;
      }
      var name = forDisplay && pathSection.name === '#text' ? 'io-text' : pathSection.name;
      return name;
    };
    function indexCondition(pathSection) {
      // should only ever be one of each of these!
      if (pathSection.name === 'html' || pathSection.name === 'head' || pathSection.name === 'body') {
        return '';
      }

      // exact match from start
      if (pathSection.childOfType) {
        if (!Array.isArray(pathSection.childOfType)) {
          return ':nth-of-type(' + pathSection.childOfType + ')';
        }
        if (pathSection.childOfType.length === 1) {
          return ':nth-of-type(' + pathSection.childOfType[0] + ')';
        }
      }

      // exact match from end
      if (pathSection.lastOfType) {
        if (!Array.isArray(pathSection.lastOfType)) {
          return ':nth-last-of-type(' + pathSection.lastOfType + ')';
        }
        if (pathSection.lastOfType.length === 1) {
          return ':nth-last-of-type(' + pathSection.lastOfType[0] + ')';
        }
      }

      // not an exact match
      var result = '';
      if (pathSection.childOfType) {
        pathSection.childOfType.sort(function (a, b) {
          return a - b;
        });
        var diff = pathSection.childOfType.map(function (n, i) {
          return i == 0 ? pathSection.childOfType[1] - n : n - pathSection.childOfType[i - 1];
        });
        if (diff[0] != 1) {
          if (diff.every(function (n) {
            return n === diff[0];
          })) {
            result += ':nth-of-type(' + (diff[0] == 1 ? '' : diff[0]) + 'n+' + pathSection.childOfType[0] + ')';
          }
        } else {
          if (pathSection.childOfType[0] != 1) {
            result += ':nth-of-type(n+' + pathSection.childOfType[0] + ')';
          }
        }
      }

      // if we've already calculated that it's a distance form the front, don't bother for the back
      if (!result && pathSection.lastOfType) {
        pathSection.lastOfType.sort(function (a, b) {
          return a - b;
        });
        var _diff = pathSection.lastOfType.map(function (n, i) {
          return i == 0 ? pathSection.lastOfType[1] - n : n - pathSection.lastOfType[i - 1];
        });
        if (_diff[0] != 1) {
          if (_diff.every(function (n) {
            return n === _diff[0];
          })) {
            result += ':nth-last-of-type(' + (_diff[0] == 1 ? '' : _diff[0]) + 'n+' + pathSection.lastOfType[0] + ')';
          }
        }
      }
      if (pathSection.not && pathSection.not.childOfType) {
        var _childOfType = pathSection.childOfType || pathSection._childOfType;
        if (_childOfType) {
          var max = Math.max.apply(Math, _toConsumableArray(_childOfType));
          var countersAfter = pathSection.not.childOfType.filter(function (x) {
            return x > max;
          });
          if (countersAfter.length) {
            var upper = Math.min.apply(Math, _toConsumableArray(countersAfter));
            result += ':nth-child(-n+' + (upper - 1) + ')';
          }
          pathSection.not.childOfType.filter(function (x) {
            return x <= max;
          }).forEach(function (c) {
            result += ':not(:nth-of-type(' + c + '))';
          });
        } else {
          pathSection.not.childOfType.forEach(function (c) {
            result += ':not(:nth-of-type(' + c + '))';
          });
        }
      }
      return result;
    }
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(6));

  /***/
}, /* 1 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.stripSessionIds = stripSessionIds;
  exports.normalizeSpace = normalizeSpace;
  exports.isWhitespace = isWhitespace;
  exports.arraysEqual = arraysEqual;
  exports.validHref = validHref;
  exports.textContent = textContent;
  exports.getElementsByXPath = getElementsByXPath;
  exports.makeUrlAbsolute = makeUrlAbsolute;
  function isWhitespaceChar(ch) {
    return ch === 32 || ch === 9 || ch === 10 || ch === 11 || ch === 160;
  }
  function stripSessionIds(href) {
    href = href.replace(/(?:(\?)|[&;])(_?(l|j|bv_)?(phpsessid|sessionid)=.*?)([?#&;]|$)/i, '$1$5').replace('?&', '?').replace('?#', '#');
    if (href.endsWith('?')) href = href.slice(0, -1);
    return href;
  }
  function normalizeSpace(s) {
    if (!s) {
      return '';
    }
    var start = -1;
    var result = '';
    for (var i = 0; i < s.length; i++) {
      if (isWhitespaceChar(s.charCodeAt(i))) {
        if (start >= 0) {
          if (result) result += ' ';
          result += s.substring(start, i);
        }
        start = -1;
      } else {
        if (start < 0) start = i;
      }
    }
    if (start >= 0) {
      if (result) result += ' ';
      result += s.substring(start);
    }
    return result;
  }
  ;
  function isWhitespace(value) {
    if (value.constructor == String) {
      for (var i = 0; i < value.length; i++) {
        if (!isWhitespaceChar(value.charCodeAt(i))) {
          return false;
        }
      }
      return true;
    }
    // DOM node
    var node = value;
    if (node.nodeType === 2 || node.nodeType === undefined) {
      // Attr
      return isWhitespace(node.value);
    }
    if (node.nodeType == 3) {
      return isWhitespace(node.textContent);
    }
    for (var child = node.firstChild; child; child = child.nextSibling) {
      if (!isWhitespace(child)) {
        return false;
      }
    }
    return true;
  }
  ;

  /**
   * Check if arrays are equal (shallow, ===)
   * @param  {Array} a
   * @param  {Array} b
   * @return {Boolean}
   */
  function arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;
    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  ;
  function validHref(href) {
    return href && !/^\s*javascript\s*:/i.exec(href) && !/^\s*#/i.exec(href);
  }

  /**
   * Return human readable text content from a node.
   * @param  {Node} node
   * @return {String}
   */
  function textContent(node) {
    var b = '';
    if (node.nodeType === 2 || node.nodeType === undefined) {
      // Attr
      b = node.value;
    } else if (node.nodeType == 3) {
      // #text
      b = node.textContent;
    } else {
      var blockRegex = /^(address|blockquote|body|center|dir|div|dl|fieldset|form|h[1-6]|hr|isindex|menu|noframes|noscript|ol|p|pre|table|ul|dd|dt|frameset|li|tbody|td|tfoot|th|thead|tr|html)$/i;
      var content = function content(node) {
        for (var childNode = node.firstChild; childNode; childNode = childNode.nextSibling) {
          if (childNode.nodeType == 3) {
            b += childNode.textContent.replace(/\s+/g, ' ');
            continue;
          }
          // some elements are 'whitespace'
          if (childNode.nodeType == 1) {
            switch (childNode.localName) {
              case 'script':
              case 'style':
                // don't process script or style tags, or superscript
                continue;
              case 'br':
              case 'hr':
                // these elements render as whitespace visually
                b += '\n';
                break;
              default:
                var isBlock = blockRegex.exec(childNode.localName);
                if (isBlock) b += '\n';
                content(childNode);
                if (isBlock) b += '\n';
                break;
            }
          }
        }
      };
      content(node);
    }
    return b.replace(/\n+/g, '\n').replace(/ +/g, ' ').trim();
  }

  /**
   *
   */
  function getElementsByXPath(xpath, context) {
    var results = [];
    var query = context.ownerDocument.evaluate(xpath, context, null, 7 /*XPathResult.ORDERED_NODE_SNAPSHOT_TYPE*/, null);
    for (var i = 0, length = query.snapshotLength; i < length; ++i) {
      results.push(query.snapshotItem(i));
    }
    return results;
  }
  ;
  function makeUrlAbsolute(base, relative) {
    if (/^(\w+:|\/\/)/.exec(relative)) {
      return relative;
    }
    var split = relative.split('?');
    relative = split[0];
    var stack = base.split('/');
    var parts = relative.split('/');
    if (relative[0] === '/') {
      stack = stack.slice(0, 3);
    } else if (stack.length > 3) {
      stack.pop();
    }
    if (!parts[0]) parts.shift();
    for (var i = 0; i < parts.length; i++) {
      if (parts[i] === '.') continue;
      if (parts[i] === '..') stack.pop();else stack.push(parts[i]);
    }
    if (stack.length === 3) stack.push('');
    var result = stack.join('/');
    if (split[1]) result += '?' + split[1];
    return result;
  }

  /***/
}, /* 2 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  exports.makeExample = makeExample;
  exports.makeRegionExample = makeRegionExample;
  var _selector = __webpack_require__(0);
  var _uuid = __webpack_require__(8);
  var _uuid2 = _interopRequireDefault(_uuid);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var Example = function () {
    function Example(_ref) {
      var id = _ref.id,
        path = _ref.path,
        xpath = _ref.xpath,
        counterexample = _ref.counterexample;
      _classCallCheck(this, Example);
      this._id = id || _uuid2.default.v4();
      this._xpath = xpath;
      this._counterexample = counterexample;
      this._path = path;
      (0, _selector.updatePathFormat)(this._path);
    }
    _createClass(Example, [{
      key: 'toJSON',
      value: function toJSON() {
        return {
          id: this._id,
          xpath: this._xpath,
          path: this._path,
          counterexample: this._counterexample
        };
      }
    }, {
      key: 'xpath',
      get: function get() {
        return this._xpath;
      }
    }, {
      key: 'path',
      get: function get() {
        return this._path;
      }
    }, {
      key: 'id',
      get: function get() {
        return this._id;
      },
      set: function set(id) {
        this._id = id;
      }
    }, {
      key: 'counterexample',
      get: function get() {
        return this._counterexample;
      }
    }, {
      key: 'coversIndex',
      get: function get() {
        var idx = this._path.findIndex(function (x) {
          return !x.covers;
        });
        if (idx < 0) {
          return this._path.length;
        }
        return idx - 1;
      }
    }]);
    return Example;
  }();
  exports.default = Example;
  function makeExample(dom, xpath, counterexample) {
    var el = (0, _selector.getByFullXPath)(xpath, dom);
    if (!el) {
      throw 'XPath [' + xpath + '] doesn\'t match any node';
    }
    var path = (0, _selector.getPath)(el);
    return new Example({
      path: path,
      xpath: xpath,
      counterexample: counterexample
    });
  }
  function makeRegionExample(el, counterexample) {
    var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var path = (0, _selector.getPath)(el, true, useCache);
    return new Example({
      path: path,
      xpath: (0, _selector.fullXPath)(el, false, useCache),
      counterexample: counterexample
    });
  }

  /***/
}, /* 3 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
  exports.getFieldElements = getFieldElements;
  exports.extract = extract;
  exports.getRecordElements = getRecordElements;
  exports.getEnclosingLink = getEnclosingLink;
  var _group = __webpack_require__(10);
  var _selector = __webpack_require__(0);
  var _utils = __webpack_require__(1);
  var _timer = __webpack_require__(5);
  var _logger = __webpack_require__(4);
  var _logger2 = _interopRequireDefault(_logger);
  var _lazyimg = __webpack_require__(16);
  var _micro = __webpack_require__(17);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  var emitXPaths = false;
  function getMicroData(url, microPath, document) {
    var data = (0, _micro.getMainItem)(url, document, microPath.type);
    if (data) return data[microPath.id];
  }

  /**
   * Execpting re to be of the form { re, replace }
   */
  function applyRe(re, fieldName, text) {
    var m = text.match(re.re);
    if (m) {
      if (re.replace) {
        // can't find a better way to do this
        m = m.map(function (s) {
          return s.replace(re.re, re.replace);
        });
      }
      return m.map(function (text) {
        var o = {};
        o[fieldName] = text;
        return o;
      });
    }
  }
  function getFieldElements(record, fields) {
    var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // time('getFieldElements');
    fields.forEach(function (field) {
      var _result$field$name;
      if (!field.selector && !field.xpath) return;
      var nodes = (0, _selector.selectNodes)(field, record);
      if (!nodes || !nodes.length) return;
      if (!result[field.name]) {
        result[field.name] = nodes;
        return;
      }
      (_result$field$name = result[field.name]).push.apply(_result$field$name, _toConsumableArray(nodes));
    });
    // timeEnd('getFieldElements');
    return result;
  }
  function getXPathFieldElements(record, fields) {
    var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    fields.forEach(function (field) {
      // we want the result ordered
      result[field.name] = (0, _selector.selectByXPath)(field.xpath, record, false, true);
    });
    return result;
  }
  function toRecord(url, recordElement, fields, fieldRegexp, fieldElements, useIds) {
    var result = {};
    var added = 0;
    Object.keys(fieldElements).forEach(function (name) {
      if (name[0] === '_') return;
      var field = fields[name];
      var re = fieldRegexp[name];
      var elements = fieldElements[name];
      if (!Array.isArray(elements)) elements = [elements];else {
        elements.sort(function (a, b) {
          a = a.ownerElement || a;
          b = b.ownerElement || b;
          if (a === b || a.equals && a.equals(b)) return 0;
          return a.compareDocumentPosition(b) & 4 ? -1 : 1;
        });
      }
      var value = elements.reduce(function (arr, element) {
        var ret = null;
        if ((field.type === 'IMAGE' || field.type === 'AUTO') && element.tagName === 'IMG') {
          (0, _lazyimg.showLazyImage)(element);
          var src = element.getAttribute('src');
          if (!src) {
            return arr;
          }
          var absoluteSrc = element.src;
          if (!absoluteSrc) absoluteSrc = (0, _utils.makeUrlAbsolute)(url, src);
          var obj = {
            src: absoluteSrc
          };
          ['alt', 'title', 'aria-label'].forEach(function (attr) {
            if (element.hasAttribute(attr)) {
              obj[attr] = element.getAttribute(attr).replace(/\s+/g, ' ').trim();
              if (!obj[attr]) delete obj[attr];
            }
          });

          // sites often just duplicate the alt to other attrs
          ['title', 'aria-label'].forEach(function (attr) {
            if (obj[attr] === obj.alt) delete obj[attr];
          });
          if (!obj.alt && obj.title) obj.alt = obj.title;
          if (!obj.alt && obj['aria-label']) obj.alt = obj['aria-label'];
          ret = [obj];
        } else {
          var fieldName = field.type === 'IMAGE' ? 'alt' : 'text';
          var text = field.html ? element.outerHTML : (0, _utils.textContent)(element);
          if (!text) {
            return arr;
          }
          if (re) {
            // just take the first value
            ret = applyRe(re, fieldName, text);
          } else {
            ret = [{}];
            ret[0][fieldName] = text;
          }
        }
        if (ret) {
          if (emitXPaths) {
            var xpath = (0, _selector.fullXPath)(element);
            ret.forEach(function (o) {
              return o.xpath = xpath;
            });
          }
          if (field.captureLink) {
            var enclosingLink = getEnclosingLink(element, url);
            if (enclosingLink) {
              ret.forEach(function (o) {
                return o.href = enclosingLink;
              });
            }
          }
        }
        if (ret) {
          arr.push.apply(arr, _toConsumableArray(ret));
        }
        return arr;
      }, []);
      if (value.length) {
        if (useIds) result[field.id] = value;else result[field.name] = value;
        added++;
      }
    });
    if (added > 0) {
      return result;
    }
  }
  function toGroup(url, fieldTypes, fieldRes, records, element, useIds) {
    var group = records.map(function (_ref) {
      var fields = _ref.fields,
        element = _ref.element;
      return toRecord(url, element, fieldTypes, fieldRes, fields, useIds);
    }).filter(function (x) {
      return x;
    });
    var result = {
      group: group
    };
    if (emitXPaths) result.xpath = (0, _selector.fullXPath)(element);
    return result;
  }

  /*
   * Apply filters to rows
   * required flag is deprecated by filters, but applied here for backward compatibility
   */
  function applyRowFilters(key, group, rowFiltersForField, required) {
    // Apply the deprecated required flag
    group = group.filter(function (result) {
      return !required.find(function (field) {
        return result[field[key]] === undefined;
      });
    });

    // Apply the regex filters
    if (rowFiltersForField.size) {
      group = group.filter(function (result) {
        var _loop = function _loop(fieldKey, regExps) {
          _logger2.default.info(rowFiltersForField);
          var data = result[fieldKey];
          if (data) {
            var passedFilter = data.find(function (d) {
              return d.text && !regExps.find(function (re) {
                return !re.test(d.text);
              });
            });
            if (!passedFilter) {
              _logger2.default.info('Removing result row', result);
              return {
                v: false
              };
            }
          }
          return {
            v: true
          };
        };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
          for (var _iterator = rowFiltersForField[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;
            var _ref3 = _slicedToArray(_ref2, 2);
            var fieldKey = _ref3[0];
            var regExps = _ref3[1];
            var _ret = _loop(fieldKey, regExps);
            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        ;
      });
    }
    return group;
  }

  /*
   * Apply default values to empty fields.
   */
  function applyDefaultValues(key, group, defaults) {
    group.forEach(function (result) {
      defaults.forEach(function (field) {
        if (result[field[key]] === undefined) result[field[key]] = [{
          text: field.defaultValue
        }];
      });
    });
    return group;
  }

  /*
   * Apply default values to empty fields.
   * This includes values got from the microdata
   */
  function applyMicroDataValues(url, group, document, key, microPaths, fieldRes) {
    group.forEach(function (result) {
      microPaths.forEach(function (field) {
        if (result[field[key]] === undefined) {
          result[field[key]] = getMicroData(url, field.microPath, document);
          var re = fieldRes[field.name];
          if (re) {
            result[field[key]] = result[field[key]].reduce(function (acc, val) {
              var temp = applyRe(re, 'text', val.text);
              if (temp) acc.push.apply(acc, _toConsumableArray(temp));
              return acc;
            }, []);
          }
        }
      });
    });
    return group;
  }

  // useIds is a boolean flag indicating whether to key data by ids (as in chainsaw and
  // lightning moving forward) or names (as in lightning previously)
  function extract(runtimeConfig, document, url, useIds) {
    (0, _timer.time)('extract');
    if (document.head) {
      var base = Array.from(document.head.children).find(function (x) {
        return x.tagName === 'BASE';
      });
      if (base) {
        url = base.getAttribute('href');
      }
    }
    if (!url) url = document.location.href;

    // calculate the field types
    var fieldTypes = {};
    var fieldRes = {};
    runtimeConfig.fields.forEach(function (field) {
      fieldTypes[field.name] = field;
      if (field.regExp) {
        try {
          fieldRes[field.name] = {
            re: new RegExp(field.regExp, 'g'),
            replace: field.regExpReplace
          };
        } catch (e) {
          // bad regex
        }
      }
    });
    var formGroups = function formGroups() {
      var recordElements = getRecordElements(document, runtimeConfig);
      if (recordElements) {
        // we are using manual record selection

        if (!recordElements.length) return [];

        // TODO: we could extend this for other fields, i.e. we could have a boolean
        // that would allow us to remove the "data noise" that happens when you remove this from magic
        var manualXPathFields = runtimeConfig.fields.filter(function (x) {
          return x.xpath;
        });
        var manualXPathFieldElements = null;
        var fields = runtimeConfig.fields.filter(function (x) {
          return !x.microPath;
        });
        if (manualXPathFields.length) {
          // we have at least 1 field with a manual xpath

          // process the absolute xpaths
          var _fieldElements = getXPathFieldElements(document, manualXPathFields.filter(function (x) {
            return x.xpath.trim()[0] === '/';
          }));
          var relativeXPathsFields = manualXPathFields.filter(function (x) {
            return x.xpath.trim()[0] != '/';
          });

          // an array of elements to mix in with the non-manual elements
          manualXPathFieldElements = function () {
            var result = recordElements.map(function () {
              return {};
            });

            // loop over each field and partition the elements
            for (var i = 0; i < manualXPathFields.length; i++) {
              var field = manualXPathFields[i];
              var elements = _fieldElements[field.name];
              if (!elements) continue;
              var elIdx = 0;
              var recordIdx = 0;

              // partition each element - both fields and elements are ordered
              while (elIdx < elements.length && recordIdx < recordElements.length) {
                var recordElement = recordElements[recordIdx];
                var el = elements[elIdx];
                var node = el.ownerElement ? el.ownerElement : el;
                var comparison = null;
                if (node === recordElement || (comparison = recordElement.compareDocumentPosition(node)) & 16) {
                  var arr = result[recordIdx][field.name];
                  if (!arr) {
                    arr = [];
                    result[recordIdx][field.name] = arr;
                  }
                  arr.push(el);
                  elIdx++;
                } else {
                  if (comparison & 2) {
                    // we are binning this, it doesn't fit
                    elIdx++;
                  } else {
                    recordIdx++;
                  }
                }
              }
            }

            // merge in all the relative xpath elts
            recordElements.forEach(function (recordElt, idx) {
              getXPathFieldElements(recordElt, relativeXPathsFields, result[idx]);
            });
            return result;
          }();
          fields = runtimeConfig.fields.filter(function (x) {
            return !x.xpath && !x.microPath;
          });
        }

        // This presumes that it's a list of siblings
        var recordFields = recordElements.map(function (element, i) {
          // these are the elements for this record
          var fieldElements = getFieldElements(element, fields);

          // mix in the manual xpath elements
          if (manualXPathFieldElements) {
            Object.assign(fieldElements, manualXPathFieldElements[i]);
          }

          // we need to merge out the fields here
          return {
            fields: fieldElements,
            element: element
          };
        });
        return [toGroup(url, fieldTypes, fieldRes, recordFields, document.documentElement, useIds)];
      }

      // no manual row definition
      var fieldElements = getFieldElements(document, runtimeConfig.fields);
      var groups = void 0;
      if (runtimeConfig.regionsSelector) {
        var regions = (0, _selector.selectNodes)(runtimeConfig.regionsSelector, document);
        groups = (0, _group.groupToRecords)(document, fieldElements, regions);
      } else {
        _logger2.default.warn('(deprecation) No predetermined regions, calculating on the fly');
        groups = (0, _group.calculateRegionsAndGroupToRecords)(document, fieldElements);
      }
      return groups.map(function (_ref4) {
        var records = _ref4.records,
          element = _ref4.element;
        return toGroup(url, fieldTypes, fieldRes, records, element, useIds);
      });
    };
    var groups = formGroups().filter(function (g) {
      return g.group.length;
    });

    // required is @deprecated by the rowFilter
    var required = runtimeConfig.fields.filter(function (f) {
      return f.required;
    });
    var defaults = runtimeConfig.fields.filter(function (f) {
      return f.defaultValue;
    });
    var microPaths = runtimeConfig.fields.filter(function (f) {
      return f.microPath;
    });

    // add in default values
    var key = useIds ? 'id' : 'name';
    var rowFiltersForField = new Map();
    runtimeConfig.fields.forEach(function (f) {
      if (f.rowFilters) {
        var rowFilterList = new Array();
        f.rowFilters.forEach(function (rowFilter) {
          try {
            rowFilterList.push(new RegExp(rowFilter.regExp));
          } catch (e) {
            _logger2.default.warn('bad regular expression for filter', e);
          }
          rowFiltersForField.set(f[key], rowFilterList);
        });
      }
    });
    if (microPaths.length) {
      if (groups.length === 0) {
        // we need to inject a bogus group
        groups.push({
          group: [{}]
        });
      }
      groups.forEach(function (g) {
        g.group = applyMicroDataValues(url, g.group, document, key, microPaths, fieldRes);
      });
      if (groups[0].group.length === 0) {
        groups.length = 0;
      }
    }
    groups.forEach(function (g) {
      g.group = applyRowFilters(key, g.group, rowFiltersForField, required);
      g.group = applyDefaultValues(key, g.group, defaults);
      g.group.forEach(function (result) {
        runtimeConfig.fields.forEach(function (field) {
          if (result[field[key]] && field.downloadContent) {
            result[field[key]].forEach(function (o) {
              return o.linkToDownload = o[field.downloadContent];
            });
          }
        });
      });
    });
    (0, _timer.timeEnd)('extract');
    return groups;
  }

  // TODO: move to selector.js
  function getRecordElements(document, runtimeConfig, forDisplay) {
    (0, _timer.time)('getRecordElements');
    try {
      if (runtimeConfig.singleRecord) {
        return [document.documentElement];
      }
      var records = void 0;
      if (runtimeConfig.recordXPath) {
        records = (0, _selector.selectByXPath)(runtimeConfig.recordXPath, document, forDisplay, true);
        if (records.length == 0) {
          _logger2.default.warn('WARNING no records for xpath so returning an empty set ', runtimeConfig.recordXPath);
        }
      }
      if (runtimeConfig.recordSelector) {
        // TODO: forDisplay transform
        records = Array.from(document.querySelectorAll(runtimeConfig.recordSelector));
        if (records.length == 0) {
          _logger2.default.warn('WARNING no records for selector so returning an empty set ', runtimeConfig.recordSelector);
        }
      }
      return records;
    } finally {
      (0, _timer.timeEnd)('getRecordElements');
    }
  }
  function getAnchor(element) {
    do {
      if (element.tagName === 'A') return element;
    } while (element = element.parentNode);
  }
  function getEnclosingLink(element, url) {
    var a = getAnchor(element);
    if (a) {
      var attr = a.getAttribute('href');
      if ((0, _utils.validHref)(attr)) {
        var href = void 0;
        if (!a.href) {
          // not sure why this sometimes happens in the browser
          href = (0, _utils.makeUrlAbsolute)(url, attr);
        } else {
          href = a.href;
        }
        // strip session identifiers
        href = (0, _utils.stripSessionIds)(href);
        return href;
      }
    }
  }

  /***/
}, /* 4 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (process) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var levels = exports.levels = ['debug', 'info', 'warn', 'error'];
    var _ref = 'undefined' !== typeof window ? window.env || {} : process.env,
      LOG_LEVEL = _ref.LOG_LEVEL;
    var Logger = function () {
      function Logger() {
        _classCallCheck(this, Logger);
        this.level = LOG_LEVEL ? LOG_LEVEL : 'info';
      }
      _createClass(Logger, [{
        key: 'log',
        value: function log() {
          var level = arguments[0];
          if (level >= this._level) {
            var _console;
            var args = [].concat(Array.prototype.slice.call(arguments)).map(function (x) {
              return typeof x === 'function' ? x() : x;
            });
            args[0] = '[' + levels[level] + ']';
            (_console = console).log.apply(_console, _toConsumableArray(args));
          }
        }
      }, {
        key: 'debug',
        value: function debug(msg) {
          for (var _len = arguments.length, attributes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            attributes[_key - 1] = arguments[_key];
          }
          this.log.apply(this, [0, msg].concat(attributes));
        }
      }, {
        key: 'info',
        value: function info(msg) {
          for (var _len2 = arguments.length, attributes = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            attributes[_key2 - 1] = arguments[_key2];
          }
          this.log.apply(this, [1, msg].concat(attributes));
        }
      }, {
        key: 'warn',
        value: function warn(msg) {
          for (var _len3 = arguments.length, attributes = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            attributes[_key3 - 1] = arguments[_key3];
          }
          this.log.apply(this, [2, msg].concat(attributes));
        }
      }, {
        key: 'error',
        value: function error(msg) {
          for (var _len4 = arguments.length, attributes = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            attributes[_key4 - 1] = arguments[_key4];
          }
          this.log.apply(this, [3, msg].concat(attributes));
        }
      }, {
        key: 'level',
        set: function set(level) {
          this._level = levels.indexOf(level);
        }
      }]);
      return Logger;
    }();
    exports.default = new Logger();
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(35));

  /***/
}, /* 5 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setFilter = setFilter;
  exports.time = time;
  exports.timeEnd = timeEnd;
  var filter = null; // regexp, e.g. /findRegion/;

  function setFilter(val) {
    filter = val;
  }
  function time(msg) {
    if (filter && filter.exec(msg)) {
      console.time(msg);
    }
  }
  function timeEnd(msg) {
    if (filter && filter.exec(msg)) {
      console.timeEnd(msg);
    }
  }

  /***/
}, /* 6 */
/***/function (module, exports) {
  var g;

  // This works in non-strict mode
  g = function () {
    return this;
  }();
  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  }

  // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}

  module.exports = g;

  /***/
}, /* 7 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _uuid = __webpack_require__(8);
  var _uuid2 = _interopRequireDefault(_uuid);
  var _selector = __webpack_require__(0);
  var _RowFilter = __webpack_require__(23);
  var _RowFilter2 = _interopRequireDefault(_RowFilter);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var Field = function () {
    function Field(_ref) {
      var id = _ref.id,
        name = _ref.name,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'AUTO' : _ref$type,
        selector = _ref.selector,
        xpath = _ref.xpath,
        defaultValue = _ref.defaultValue,
        regExp = _ref.regExp,
        captureLink = _ref.captureLink,
        html = _ref.html,
        required = _ref.required,
        rowFilters = _ref.rowFilters,
        regExpReplace = _ref.regExpReplace,
        _ref$ranking = _ref.ranking,
        ranking = _ref$ranking === undefined ? 0 : _ref$ranking,
        _ref$downloadContent = _ref.downloadContent,
        downloadContent = _ref$downloadContent === undefined ? null : _ref$downloadContent,
        microPath = _ref.microPath;
      _classCallCheck(this, Field);
      this._id = id || _uuid2.default.v4();
      this.name = name;
      this._type = type;
      this._selector = selector;
      this._manualXPath = xpath;
      this._defaultValue = defaultValue;
      this._regExp = regExp;
      this._captureLink = captureLink;
      this._required = required;
      if (rowFilters) {
        this._rowFilters = rowFilters.map(function (filt) {
          return new _RowFilter2.default(filt);
        });
      }
      this._regExpReplace = regExpReplace;
      this._html = html;
      this._ranking = ranking;
      this._downloadContent = downloadContent;
      this._microPath = microPath;
    }
    _createClass(Field, [{
      key: 'toJSON',
      value: function toJSON() {
        return {
          id: this.id,
          name: this.name,
          type: this.type,
          selector: this.selector,
          xpath: this.xpath,
          defaultValue: this.defaultValue,
          regExp: this.regExp,
          regExpReplace: this.regExpReplace,
          captureLink: this.captureLink,
          html: this.html,
          required: this.required,
          ranking: this.ranking,
          downloadContent: this.downloadContent,
          microPath: this.microPath
        };
      }
    }, {
      key: 'cloneWithCompactSelector',
      value: function cloneWithCompactSelector() {
        var f = new Field(JSON.parse(JSON.stringify(this)));
        f.selector = (0, _selector.compactSelector)(this.selector);
        return f;
      }
    }, {
      key: 'xpath',
      get: function get() {
        return this._manualXPath;
      },
      set: function set(xpath) {
        this._manualXPath = xpath;
      }

      /*
       * @deprecated, use rowFilters instead
       */
    }, {
      key: 'required',
      get: function get() {
        return this._required;
      }

      /*
       * @deprecated, use rowFilters instead
       */,

      set: function set(required) {
        this._required = required;
      }
    }, {
      key: 'rowFilters',
      get: function get() {
        return this._rowFilters;
      },
      set: function set(rowFilters) {
        this._rowFilters = rowFilters;
      }
    }, {
      key: 'html',
      get: function get() {
        return this._html;
      },
      set: function set(html) {
        this._html = html;
      }
    }, {
      key: 'captureLink',
      get: function get() {
        return this._captureLink;
      },
      set: function set(captureLink) {
        this._captureLink = captureLink;
      }
    }, {
      key: 'id',
      get: function get() {
        return this._id;
      },
      set: function set(id) {
        this._id = id;
      }
    }, {
      key: 'type',
      get: function get() {
        return this.xpath ? 'AUTO' : this._type;
      },
      set: function set(type) {
        this._type = type;
      }
    }, {
      key: 'defaultValue',
      get: function get() {
        return this._defaultValue;
      },
      set: function set(defaultValue) {
        this._defaultValue = defaultValue;
      }
    }, {
      key: 'regExp',
      get: function get() {
        return this._regExp;
      },
      set: function set(regExp) {
        this._regExp = regExp;
      }
    }, {
      key: 'regExpReplace',
      get: function get() {
        return this._regExpReplace;
      },
      set: function set(regExpReplace) {
        this._regExpReplace = regExpReplace;
      }
    }, {
      key: 'name',
      get: function get() {
        return this._name;
      },
      set: function set(name) {
        this._name = name ? name.trim() : name;
      }
    }, {
      key: 'selector',
      set: function set(selector) {
        this._selector = selector;
      },
      get: function get() {
        return this._selector;
      }
    }, {
      key: 'ranking',
      set: function set(ranking) {
        this._ranking = ranking;
      },
      get: function get() {
        return this._ranking;
      }
    }, {
      key: 'downloadContent',
      set: function set(downloadContent) {
        this._downloadContent = downloadContent;
      },
      get: function get() {
        return this._downloadContent;
      }

      /**
        * Of the form {type, id}
        */
    }, {
      key: 'microPath',
      set: function set(microPath) {
        this._microPath = microPath;
      },
      get: function get() {
        return this._microPath;
      }
    }]);
    return Field;
  }();
  exports.default = Field;

  /***/
}, /* 8 */
/***/function (module, exports, __webpack_require__) {
  //     uuid.js
  //
  //     Copyright (c) 2010-2012 Robert Kieffer
  //     MIT License - http://opensource.org/licenses/mit-license.php

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng = __webpack_require__(36);

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = buf && offset || 0,
      ii = 0;
    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
      if (ii < 16) {
        // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }
    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0,
      bth = _byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0,
    _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }
    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;
    if (typeof options == 'string') {
      buf = options == 'binary' ? new Array(16) : null;
      options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }
    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  module.exports = uuid;

  /***/
}, /* 9 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _uuid = __webpack_require__(8);
  var _uuid2 = _interopRequireDefault(_uuid);
  var _Example = __webpack_require__(2);
  var _Example2 = _interopRequireDefault(_Example);
  var _htmlparser = __webpack_require__(15);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var nbspRe = new RegExp(String.fromCharCode(160) + '|&nbsp;', 'g');

  /**
   * Parses an HTML string into an HTMLDocument.
   * @param {string} HTML markup
   * @returns {HTMLDocument} Document object
   */
  function parseHTML(html) {
    var doc = document.implementation.createHTMLDocument('New Document Title');
    (0, _htmlparser.importIntoDocument)(html.replace(nbspRe, ' '), doc);
    return doc;
  }

  /**
   * Returns a sanitised DOM tree for a given page.
   * @param {Page} page Page.
   */
  function generateDOM(page, noscript) {
    var dom = parseHTML(noscript ? page.noscriptHtml : page.html);
    return dom;
  }

  /**
  * WebPage class.
  *
  * Represents a web page.
  *
  * @class Page
   */

  var Page = function () {
    /**
     * Creates a Page.
     * @param {Object} input the initial values for the page
     */
    function Page(input) {
      var _this = this;
      _classCallCheck(this, Page);
      this._id = _uuid2.default.v4();
      this._fieldExamples = {};
      if (input) {
        Object.assign(this, input);
        Object.keys(this._fieldExamples).forEach(function (k) {
          return _this._fieldExamples[k] = _this._fieldExamples[k].map(function (e) {
            return new _Example2.default(e);
          });
        });
        // These are cleared by setting the HTML properties
        this._noscriptDom = input._noscriptDom;
        this._scriptDom = input._scriptDom;
      }
      delete this._pageSet;
    }
    _createClass(Page, [{
      key: 'dom',
      /**
       * The document object that represents a sanitised version of the markup.
       * @type {HTMLDocument}
       * @readonly
       */
      value: function dom() {
        var noscript = this.pageSet && this.pageSet.noscriptAvailable && this.pageSet.noscript;
        return noscript ? this.noscriptDom() : this.scriptDom();
      }
    }, {
      key: 'scriptDom',
      value: function scriptDom() {
        return this._scriptDom || (this._scriptDom = generateDOM(this, false));
      }
    }, {
      key: 'noscriptDom',
      value: function noscriptDom() {
        return this._noscriptDom || (this._noscriptDom = generateDOM(this, true));
      }

      /**
       * Override the scripted dom
       * @type {HTMLDocument}
       */
    }, {
      key: 'overrideDom',
      value: function overrideDom(dom) {
        this._scriptDom = dom;
      }

      /**
       * Adds a known-good example of a field element.
       * @param {Field} name
       * @param {Example} fieldExample
       */
    }, {
      key: 'addFieldExample',
      value: function addFieldExample(field, fieldExample) {
        if (!this._fieldExamples[field.id]) {
          this._fieldExamples[field.id] = [];
        }
        this._fieldExamples[field.id].push(fieldExample);
      }

      /**
       * Returns all the known-good field examples for a given name.
       * @param {Field} field
       * @returns {Example[]}
       */
    }, {
      key: 'fieldExamplesFor',
      value: function fieldExamplesFor(field) {
        return this._fieldExamples[field.id] || [];
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return {
          id: this._id,
          url: this._url,
          resourceId: this._resourceId,
          html: this._html,
          noscriptHtml: this._noscriptHtml,
          fieldExamples: this._fieldExamples
        };
      }
    }, {
      key: 'pageSet',
      set: function set(pageSet) {
        this._pageSet = pageSet;
      },
      get: function get() {
        return this._pageSet;
      }

      /**
       * URL of the page.
       * @type {string}
       */
    }, {
      key: 'url',
      set: function set(url) {
        if (typeof url !== 'string') {
          throw TypeError('url must be a string');
        }
        this._url = url;
      },
      get: function get() {
        return this._url;
      }
    }, {
      key: 'id',
      get: function get() {
        return this._id;
      },
      set: function set(id) {
        this._id = id;
      }
    }, {
      key: 'resourceId',
      get: function get() {
        return this._resourceId;
      },
      set: function set(id) {
        this._resourceId = id;
      }
    }, {
      key: 'fieldExamples',
      set: function set(examples) {
        this._fieldExamples = examples;
      }

      /**
       * Document markup of the page.
       * @type {string}
       */
    }, {
      key: 'html',
      set: function set(html) {
        if (typeof html !== 'string') {
          throw TypeError('html must be a string');
        }
        this._scriptDom = undefined;
        this._html = html;
      },
      get: function get() {
        return this._html;
      }

      /**
       * Document markup of the page.
       * @type {string}
       */
    }, {
      key: 'noscriptHtml',
      set: function set(html) {
        if (typeof html !== 'string') {
          throw TypeError('html must be a string');
        }
        this._noscriptDom = undefined;
        this._noscriptHtml = html;
      },
      get: function get() {
        return this._noscriptHtml;
      }
    }]);
    return Page;
  }();
  exports.default = Page;

  /***/
}, /* 10 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.enablePageCache = enablePageCache;
  exports.disablePageCache = disablePageCache;
  exports.getRegions = getRegions;
  exports.calculateRegionsAndGroupToRecords = calculateRegionsAndGroupToRecords;
  exports.groupToRecords = groupToRecords;
  var _utils = __webpack_require__(1);
  var _selector = __webpack_require__(0);
  var _timer = __webpack_require__(5);
  var _regiondetect = __webpack_require__(18);
  var _selectorcalculator = __webpack_require__(11);
  var _Example = __webpack_require__(2);
  var _logger = __webpack_require__(4);
  var _logger2 = _interopRequireDefault(_logger);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  var _cacheRegions = false;

  /**
   * Enable the caching of information for a dom,
   * possibly at a higher startup cost
   */
  function enablePageCache(dom) {
    _cacheRegions = true;
    findRegions(dom);
  }
  function disablePageCache() {
    _cacheRegions = false;
  }
  var childNode = function childNode(e) {
    var pos = 0;
    var children = e.parentNode.childNodes;
    for (var i = 0, j = children.length; i < j; i++) {
      var child = children[i];
      pos++;
      if (child === e) break;
    }
    return pos;
  };
  var getKey = function getKey(element) {
    var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!element.parentNode) return acc;
    var name = element.nodeType === 3 ? '#text' : element.localName;
    if (!acc) acc = name;else acc = name + ' ' + acc;
    return getKey(element.parentNode, acc);
  };
  var nodeDepth = function nodeDepth(el) {
    var depth = -1;
    do {
      depth++;
    } while (el = el.parentNode);
    return depth;
  };
  function partition(siblings) {
    var partitions = [];

    // work out sets of fields that each belong to
    siblings.forEach(function (record) {
      if (!record) {
        return;
      }
      var intersectionIndexes = partitions.map(function (partition, idx) {
        if (partition.find(function (field) {
          return record.__fields.indexOf(field) >= 0;
        })) {
          return idx;
        }
        return -1;
      }).filter(function (idx) {
        return idx >= 0;
      });
      if (intersectionIndexes.length == 0) {
        // no intersection with any partition
        var fields = record.__fields.slice();
        fields.__indexes = [record.__position];
        partitions.push(fields);
      } else {
        if (intersectionIndexes.length == 1 && (0, _utils.arraysEqual)(partitions[intersectionIndexes[0]], record.__fields)) {
          // do nothing, same partition
          partitions[intersectionIndexes[0]].__indexes.push(record.__position);
        } else {
          // swap the order around to remove them with same indexes
          intersectionIndexes.reverse();
          var _partition = [];
          _partition.__indexes = [];
          var addFields = function addFields(fields) {
            fields.forEach(function (field) {
              if (_partition.indexOf(field) < 0) {
                _partition.push(field);
              }
            });
          };
          intersectionIndexes.forEach(function (idx) {
            var fields = partitions.splice(idx, 1)[0];
            _partition.__indexes = _partition.__indexes.concat(fields.__indexes);
            addFields(fields);
          });
          _partition.__indexes.push(record.__position);
          addFields(record.__fields);
          _partition.__indexes.sort(function (a, b) {
            return a - b;
          });
          _partition.sort();
          partitions.splice(intersectionIndexes[0], 0, _partition);
        }
      }
    });
    return partitions;
  }
  function findRegions(node) {
    (0, _timer.time)('findRegions');
    try {
      if (!_cacheRegions) {
        return (0, _regiondetect.findRegions)(node);
      }
      var document = node.ownerDocument ? node.ownerDocument : node;
      if (!document._regions) {
        document._regions = (0, _regiondetect.findRegions)(document);
      }
      if (node.tagName !== 'HTML') {
        var map = new Map();
        document._regions.forEach(function (v, k) {
          if (node === k || node.contains(k)) {
            map.set(k, v);
          }
        });
        return map;
      }
      return new Map(document._regions.entries());
    } finally {
      (0, _timer.timeEnd)('findRegions');
    }
  }
  ;
  var sum = function sum(arr) {
    return arr.reduce(function (p, c) {
      return p + c;
    }, 0);
  };

  /**
   * Group a set of records into areas on the page, and records.
   * @param  {Object} elementMap A map of name => element for fields
   * @return {Array<Array<Element>>}
   */
  // TODO: this needs refactoring, it's bcome messy
  function getRegions(document, elementMap) {
    (0, _timer.time)('getRegions');
    try {
      // group into siblings
      var ancestors = new Map();
      var ungroupedElements = new Set();
      var fieldNames = Object.keys(elementMap);

      // initially create a datastructure of the ancestors of the elements we have
      fieldNames.forEach(function (name) {
        var arr = elementMap[name];
        if (!Array.isArray(arr)) arr = Array.prototype.slice.apply(arr);
        arr.forEach(function (element) {
          ungroupedElements.add(element);
          if (!element.__fields) {
            element.__fields = [];
          }
          element.__fields.push(name);
          var initial = element;
          var el = element.ownerElement || element;
          var depth = nodeDepth(el);
          do {
            var a = ancestors.get(el);
            if (!a) {
              a = {
                key: getKey(el),
                element: el,
                depth: depth,
                elements: new Set()
              };
              ancestors.set(el, a);
            }
            a.elements.add(initial);
            depth--;
          } while (el = el.parentNode);
        });
      }); // end initializing data structure

      var allElements = new Set(ungroupedElements);
      var ancestorsArray = Array.from(ancestors.values());
      if (ancestorsArray.length === 0) return [document.documentElement];

      // sort the array such that the most elements underneath first
      ancestorsArray.sort(function (a, b) {
        var x = b.elements.size - a.elements.size;
        if (x != 0) return x;
        return b.depth - a.depth;
      });

      // the common ancestor must be first
      var commonAncestor = ancestorsArray[0].element;

      // only 1 element
      if (ancestorsArray[0].elements.size <= 1) {
        _logger2.default.info('Single element, setting region as its parent');
        return [commonAncestor.parentNode];
      }

      // look underneath this for lists regions using the "magic" style heuristics
      var listRegions = findRegions(commonAncestor);
      var uniqueFieldsForAncestor = function uniqueFieldsForAncestor(a) {
        var fields = new Set();
        a.elements.forEach(function (el) {
          el.__fields.forEach(function (name) {
            fields.add(name);
          });
        });
        return fields;
      };
      ancestors.forEach(function (a) {
        return a.fields = uniqueFieldsForAncestor(a);
      });

      // this will ensure that we pick up everything as a "catch all"
      if (!listRegions.has(commonAncestor)) {
        listRegions.set(commonAncestor, {
          node: commonAncestor,
          score: 0,
          linkedRegions: []
        });
      }

      // pick the "best" list regions until we fallback to grouping everything else in a single rows
      listRegions.forEach(function (region) {
        region.rows = Array.from(region.node.children).map(function (node) {
          return ancestors.get(node);
        }).filter(function (x) {
          return x;
        });
      });
      var rescore = function rescore() {
        listRegions.forEach(function (region) {
          // give each child a score
          region.partitions = partition(region.rows.map(function (c) {
            return {
              __position: childNode(c.element) - 1,
              __fields: Array.from(c.fields)
            };
          }));
          var scores = region.rows.map(function (a) {
            // how many ungrouped elements are beneath this ancestor
            var elementsBeneath = Math.max(1, a.elements.size);

            // how many unique fields are beneath this ancestor attached to ungrouped elements
            var uniqueFields = Math.max(1, a.fields.size);

            // how many elements on average per field are underneath this
            // a higher value of this should imply that we have multiple rows
            // underneath this point
            var elementsPerField = elementsBeneath / uniqueFields;

            // the higher this is the more chance it's a record
            // we don't want to match single fields
            var f = a.fields.values().next().value;
            var fieldNameRatio = uniqueFields / region.partitions.find(function (x) {
              return x.indexOf(f) >= 0;
            }).length;
            return fieldNameRatio / elementsPerField;
          });
          // this is a "quality" score for the list region
          region.rowQuality = sum(scores);

          // this scoring is a heuristic and probably needs tuning to get right
          region.quality = region.rows.length * region.score * region.rowQuality;
          region._originalQuality = region.quality;
        });

        // link the grid region quality
        (function () {
          var processed = new Set();
          listRegions.forEach(function (region) {
            if (processed.has(region)) return;
            var sum = 0;
            region.linkedRegions.forEach(function (region) {
              if (!region._originalQuality) return; // this region didn't actually make the cut of regions
              processed.add(region);
              if (region.rows.length > 1) {
                // discount single rows so we don't grid a load of siblings
                sum += region._originalQuality;
              }
            });
            region.linkedRegions.forEach(function (region) {
              if (!region._originalQuality) return; // this region didn't actually make the cut of regions
              region.quality = sum;
            });
          });
        })();
      };
      rescore();
      var regionsArray = Array.from(listRegions.values()).filter(function (x) {
        return x.rows.length > 1;
      }).sort(function (a, b) {
        return b.quality - a.quality;
      });
      if (regionsArray.length === 0) {
        return [commonAncestor];
      }
      var result = [];

      // TODO: use this to optimize rescoring
      var newlyGroupElements = [];
      var process = function process(region) {
        var ret = false;
        for (var i = 0; i < region.rows.length && ungroupedElements.size; i++) {
          var ungroupedElementsBefore = ungroupedElements.size;
          region.rows[i].elements.forEach(function (el) {
            if (!ungroupedElements.has(el)) {
              return;
            }
            ungroupedElements.delete(el);
            newlyGroupElements.push(el);
          });
          if (ungroupedElementsBefore === ungroupedElements.size) {
            continue;
          }
          ret = true;
        }
        if (!ret) return false;

        // TODO: this is currently unused because I can't work out how to use this information at runtime
        // perhaps it needs to be linked to the full xpath of the region?
        // region.siblingSpan = ( () => {
        //   const siblingPartition = [];
        //   region.partitions.forEach( (partition,partitionIndex) => partition.__indexes.forEach( siblingIndex => siblingPartition[siblingIndex] = partitionIndex) );
        //
        //
        //   const seen = new Set();
        //   const gaps = [];
        //   let start = 0;
        //   let i=0;
        //   for ( ; i<siblingPartition.length; i++ ) {
        //     const p = siblingPartition[i];
        //     if ( p === undefined ) continue;
        //     if ( seen.has(p) ) {
        //       // we are into a different row
        //       if ( seen.size == region.partitions.length ) {
        //         gaps.push(i-start);
        //       }
        //       seen.clear();
        //       start = i;
        //     }
        //     seen.add(p);
        //   }
        //
        //   if ( seen.size == region.partitions.length ) {
        //     // we can't bank on this because there may be nodes in between "rows" apart from at the end
        //     gaps.push( region.children.length - start );
        //   }
        //
        //   gaps.sort();
        //   // if there is one which is < 2*min take that as the effective maximum number of siblings for a result because there may be optional nodes
        //   for ( i=0; i < gaps.length && gaps[i+1] < 2*gaps[0]; i++ ) {
        //   }
        //   return gaps[i];
        // } ) ();

        return ret;
      };
      while (ancestors.size && regionsArray.length) {
        var region = regionsArray.shift();
        var regions = region.linkedRegions.length ? region.linkedRegions : [region];
        for (var i = 0; i < regions.length && ungroupedElements.size; i++) {
          var r = regions[i];
          if (process(r)) {
            result.push(r.node);
          }
        }

        // recalculate the scores
        rescore();
      }

      // reset the __fields for all the elements
      allElements.forEach(function (el) {
        return delete el.__fields;
      });
      return result;
    } catch (e) {
      _logger2.default.error(e.stack);
      throw e;
    } finally {
      (0, _timer.timeEnd)('getRegions');
    }
  }
  function calculateRegionsAndGroupToRecords(document, elementMap) {
    var regions = getRegions(document, elementMap);
    var regionSelector = (0, _selector.compactSelector)((0, _selectorcalculator.getRegionSelector)([new _selectorcalculator.DocumentExamples(document, regions.map(function (x) {
      return (0, _Example.makeRegionExample)(x);
    }))]));
    _logger2.default.debug('regionSelector', regionSelector);
    // re-select with the generated selectors
    regions = (0, _selector.selectNodes)(regionSelector, document);
    _logger2.default.debug('selected region nodes', regions);
    var g = groupToRecords(document, elementMap, regions);
    _logger2.default.debug('grouped', g);
    return g;
  }
  function groupToRecords(document, elementMap, regions) {
    (0, _timer.time)('groupToRecords');
    try {
      regions = Array.from(regions);

      // group into siblings
      var groups = [];
      var fieldNames = Object.keys(elementMap);
      var map = new Map();
      regions.forEach(function (region) {
        return map.set(region, new Map());
      });

      // initially create a datastructure of the ancestors of the elements we have
      fieldNames.forEach(function (name) {
        var arr = elementMap[name];
        if (!Array.isArray(arr)) arr = Array.prototype.slice.apply(arr);
        arr.forEach(function (element) {
          var e = element.ownerElement || element;
          do {
            // is the parent of this a region, i.e. is it a row?
            var i = regions.indexOf(e.parentNode);
            if (i >= 0) {
              // put it in a row
              var regionRecords = map.get(regions[i]);
              var record = regionRecords.get(e);
              if (!record) {
                record = {};
                record.__recordElement = e;
                record.__position = childNode(e) - 1;
                record.__fields = [];
                regionRecords.set(e, record);
              }
              if (record[name]) {
                if (!Array.isArray(record[name])) record[name] = [record[name]];
                record[name].push(element);
              } else {
                record[name] = element;
                record.__fields.push(name);
              }
              return;
            }
          } while (e = e.parentNode);
          _logger2.default.warn('Cannot find a region for element');
        });
      }); // end initializing data structure

      var process = function process(region) {
        try {
          var records = [];
          var siblingMap = {};
          var siblingsArray = [];
          var regionRecords = map.get(region);
          var children = region.childNodes;
          for (var i = 0; i < children.length; i++) {
            var recordElement = children[i];
            var record = regionRecords.get(recordElement);
            if (!record) continue;

            // TODO: efore regions could have different records (grids) - still the case?
            var parentPath = (0, _selector.fullXPath)(record.__recordElement.parentNode);
            if (!siblingMap[parentPath]) {
              var newGroup = [];
              siblingMap[parentPath] = newGroup;
              newGroup.groupPath = parentPath;
              siblingsArray.push(newGroup);
            }
            siblingMap[parentPath][record.__position] = record;
          }
          siblingsArray.forEach(function (siblings) {
            var partitions = partition(siblings);
            var tryPartition = function tryPartition() {
              // this is the maximum number of siblings to consider grouping together
              // if we have:
              // 1 => a
              // 2 => [none]
              // 3 => [none]
              // 4 => b
              // 5 => a
              // 6 => b
              // The sibling span would be 2 because this is the maximum number of siblings to group together
              //
              // If we have:
              // 1 => a
              // 2 => a
              // 3 => a
              // 4 => b
              // 5 => a
              // 6 => a
              // 7 => b
              // The sibling span would also be 2
              //
              // We should consider the minimum distance it takes to do a cycle with all partitions

              var siblingSpan = function () {
                var siblingPartition = [];
                partitions.forEach(function (partition, partitionIndex) {
                  return partition.__indexes.forEach(function (siblingIndex) {
                    return siblingPartition[siblingIndex] = partitionIndex;
                  });
                });
                var seen = new Set();
                var gaps = [];
                var start = 0;
                var i = 0;
                for (; i < siblingPartition.length; i++) {
                  var p = siblingPartition[i];
                  if (p === undefined) continue;
                  if (seen.has(p)) {
                    // we are into a different row
                    if (seen.size == partitions.length) {
                      gaps.push(i - start);
                    }
                    seen.clear();
                    start = i;
                  }
                  seen.add(p);
                }
                if (seen.size == partitions.length) {
                  // we can't bank on this because there may be nodes in between "rows" apart from at the end
                  gaps.push(region.childNodes.length - start);
                }
                gaps.sort();
                // if there is one which is < 2*min take that as the effective maximum number of siblings for a result because there may be optional nodes
                for (i = 0; i < gaps.length && gaps[i + 1] < 2 * gaps[0]; i++) {}
                return gaps[i];
              }();

              // if we cannot work out how many siblings constitutes a "row" don't group them
              if (siblingSpan === null) {
                return false;
              }

              // bundle them together
              var partitionIdx = 0;
              var newRecord = null;
              var start = null;
              for (var _i = 0; _i < siblings.length;) {
                var _record = siblings[_i];

                // there is no next partition, save the record
                if (start !== null && _i - start == siblingSpan || partitionIdx == partitions.length) {
                  partitionIdx = 0;
                  if (newRecord) {
                    records.push(newRecord);
                  }
                  newRecord = null;
                  start = _i;
                }

                // we are missing this sibling
                // TODO: what to do?
                if (!_record) {
                  _i++;
                  continue;
                }

                // is it the suspected partition number?
                if (_record.__fields.every(function (field) {
                  return partitions[partitionIdx].indexOf(field) >= 0;
                })) {
                  if (start === null) start = _i;

                  // copy values
                  if (!newRecord) {
                    newRecord = {};
                  }
                  Object.assign(newRecord, _record);
                  delete newRecord.__fields;
                  delete newRecord.__position;
                  partitionIdx++;
                  _i++;
                } else {
                  // look at next partititon
                  partitionIdx++;
                }
              }
              if (newRecord) {
                records.push(newRecord);
              }
              return true;
            };
            if (partitions.length > 1 && tryPartition()) {
              // we've added successfully
            } else {
              siblings.forEach(function (s) {
                return records.push(s);
              });
            }
          });
          if (records.length) {
            records = records.map(function (r) {
              // TODO: we could use objects elsewhere and make this unneccessary, it's a bit messy
              var res = {
                fields: r,
                element: r.__recordElement
              };
              delete r.__fields;
              delete r.__position;
              delete r.__recordElement;
              return res;
            });
            groups.push({
              records: records,
              element: region
            });
          }
        } catch (e) {
          _logger2.default.error(e.stack);
        }
      };
      regions.forEach(process);
      groups.sort(function (a, b) {
        a = a.records[0].element;
        b = b.records[0].element;
        if (a === b) return 0;
        return a.compareDocumentPosition(b) & 4 ? -1 : 1;
      });

      // ok so now we need to collapse any regions with only one field,
      // or with multiple fields with only one value together

      var collapseGroups = function collapseGroups() {
        groups.forEach(function (group) {
          if (group.records.length <= 1) return;

          // if the group is partitioned, merge the rows
          var mergedFields = {};
          var overlap = group.records.find(function (record) {
            return Object.keys(record.fields).find(function (fieldName) {
              if (mergedFields[fieldName]) {
                return true;
              }
              mergedFields[fieldName] = record.fields[fieldName];
            });
          });
          if (!overlap) {
            // TODO: element
            group.records = [{
              element: document.documentElement,
              fields: mergedFields
            }];
          }
        });
        var onlySingleValuesOrOneField = function onlySingleValuesOrOneField(group) {
          // there's only one record, cool:
          if (group.records.length === 1) return true;

          // there is more than one record, we need to check that there is only one field
          return !group.records.find(function (record) {
            return Object.keys(record.fields).length > 1;
          });
        };

        // merge the groups together
        var toMerge = groups.filter(onlySingleValuesOrOneField);
        var mergeGroups = function mergeGroups() {
          var mergedFields = {};
          var overlap = toMerge.find(function (group) {
            // collapse the records
            var collapsed = {};
            group.records.forEach(function (record) {
              Object.keys(record.fields).forEach(function (fieldName) {
                var _collapsed$fieldName;
                if (!collapsed[fieldName]) collapsed[fieldName] = [];
                var fields = record.fields[fieldName];
                if (Array.isArray(fields)) (_collapsed$fieldName = collapsed[fieldName]).push.apply(_collapsed$fieldName, _toConsumableArray(fields));else collapsed[fieldName].push(fields);
              });
            });
            return Object.keys(collapsed).find(function (fieldName) {
              if (mergedFields[fieldName]) {
                return true;
              }
              mergedFields[fieldName] = collapsed[fieldName];
            });
          });
          if (overlap) return null;
          return mergedFields;
        };
        var mergedFields = null;
        if (toMerge.length > 1 && (mergedFields = mergeGroups())) {
          // let's do the merge
        } else {
          toMerge = [];
        }

        // rebuild the groups
        var merged = false;
        var normalizedGroups = [];
        groups.forEach(function (group) {
          if (toMerge.indexOf(group) >= 0) {
            if (merged) return;
            merged = true;
            normalizedGroups.push({
              element: document.documentElement,
              records: [{
                fields: mergedFields,
                element: document.documentElement
              }]
            });
            return;
          }
          normalizedGroups.push(group);
        });

        // now merge groups who are direct sibilngs
        var mergedGroups = [];
        normalizedGroups.forEach(function (group) {
          if (!mergedGroups.length) {
            mergedGroups.push(group);
            return;
          }
          var last = mergedGroups[mergedGroups.length - 1];
          if (last.element.nextElementSibling === group.element) {
            var _last$records;
            last.merged = true;
            (_last$records = last.records).push.apply(_last$records, _toConsumableArray(group.records));
            last.element = group.element;
          } else {
            mergedGroups.push(group);
          }
        });
        mergedGroups.forEach(function (group) {
          if (!group.merged) return;
          group.element = group.element.parentNode;
          delete group.merged;
        });
        return mergedGroups;
      };
      var result = collapseGroups();
      return result;
    } catch (e) {
      _logger2.default.error(e.stack);
    } finally {
      (0, _timer.timeEnd)('groupToRecords');
    }
  }

  /***/
}, /* 11 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DocumentExamples = undefined;
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  exports.initializeEditorDocument = initializeEditorDocument;
  exports.getElementSelector = getElementSelector;
  exports.trainField = trainField;
  exports.suggestElements = suggestElements;
  exports.calculateAndSetFieldSelector = calculateAndSetFieldSelector;
  exports.calculateAndSetRegionsSelector = calculateAndSetRegionsSelector;
  exports.getRegionsSelector = getRegionsSelector;
  exports.exampleFromSelector = exampleFromSelector;
  exports.getSelector = getSelector;
  exports.getRegionSelector = getRegionSelector;
  var _utils = __webpack_require__(1);
  var _Example = __webpack_require__(2);
  var _selector2 = __webpack_require__(0);
  var _extractor = __webpack_require__(3);
  var _group = __webpack_require__(10);
  var _timer = __webpack_require__(5);
  var _logger = __webpack_require__(4);
  var _logger2 = _interopRequireDefault(_logger);
  var _css = __webpack_require__(12);
  var _css2 = _interopRequireDefault(_css);
  var _deepEqual = __webpack_require__(13);
  var _deepEqual2 = _interopRequireDefault(_deepEqual);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  /**
   * Initialize a document for editing
   */
  function initializeEditorDocument(document) {
    // cache the original class attribute value so we can mutate it later
    Array.prototype.slice.apply(document.querySelectorAll('[class]')).forEach(function (e) {
      e.setAttribute('_class', e.getAttribute('class'));
    });
    Array.prototype.slice.apply(document.querySelectorAll('[style]')).forEach(function (e) {
      e.setAttribute('_style', e.getAttribute('style'));
    });
    wrapTextNodes(document);
  }

  /**
   * Function used in page interaction to get a selector of an arbitrary element in the DOM.
   * @param  {Element} element HTML element node.
   * @param  {Element} dom     window.document node.
   * @return {Selector}        Selector object pointing to the element.
   */
  function getElementSelector(element, dom) {
    var useCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var example = (0, _Example.makeRegionExample)(element, null, useCache);
    var elementSelector = getSelector('html', [new DocumentExamples(dom, [example])]);
    return elementSelector;
  }

  /**
   * Add training to a field
   *
   * @param  {Page} page
   * @param  {Field} field
   * @param  {Element} clickedElement
   * @param  {Boolean} counterexample
   * @return {Boolean|Example}
   */
  function trainField(pageSet, page, field, clickedElement, counterexample) {
    // zoom in onto the text
    clickedElement = zoomIn(clickedElement);
    var xpath = (0, _selector2.fullXPath)(clickedElement);
    var example = (0, _Example.makeExample)(page.dom(), xpath, counterexample);
    page.addFieldExample(field, example);
    calculateAndSetFieldSelector(pageSet, field);
    return example;
  }

  /**
   * Suggest other similar elements to display
   *
   * @param  {Page} page
   * @param  {Field} field
   * @return {Array}          An array of xpaths
   */
  function suggestElements(page, field) {
    // try getting the selector and stripping out the nth-child

    // copy the selector
    // TODO: use a library
    var sel = JSON.parse(JSON.stringify(field.selector));
    sel.forEach(function (path) {
      return path.forEach(function (section) {
        section.childOfType = null;
        // generalize out the ids
        if (section.attributes.id) section.attributes.id = [0, 1];
      });
    });
    var elts = Array.prototype.slice.apply((0, _selector2.selectNodes)(sel, page.dom()));
    var current = page.fieldExamplesFor(field);
    var result = elts.map(function (e) {
      return (0, _selector2.fullXPath)(e, true);
    }).filter(function (xpath) {
      return !current.find(function (example) {
        return example.xpath === xpath;
      });
    });
    return result;
  }

  /**
   * Calculate and set the field selector for the PageSet
   * @param  {Field} field
   * @return {void}
   */
  function calculateAndSetFieldSelector(pageSet, field) {
    var fieldSelector = getSelector(pageSet, pageSet.pages.map(function (page) {
      return new DocumentExamples(page.dom(), page.fieldExamplesFor(field));
    }));
    _logger2.default.info('Setting selector for', field.name, 'to', function () {
      return (0, _selector2.toCssSelector)(fieldSelector);
    });
    pageSet.fieldWithId(field.id).selector = fieldSelector;
  }
  function calculateAndSetRegionsSelector(pageSet) {
    if (pageSet.recordSelector || pageSet.recordXPath || pageSet.singleRecord) {
      pageSet.regionsSelector = null;
      return;
    }
    // first we need to extract the data
    var regions = [];
    pageSet.pages.forEach(function (page) {
      var fieldElements = (0, _extractor.getFieldElements)(page.dom(), pageSet.runtimeConfig().fields);
      regions.push((0, _group.getRegions)(page.dom(), fieldElements));
    });
    pageSet.regionsSelector = getRegionsSelector(regions);
  }
  function getRegionsSelector(regions) {
    if (!Array.isArray(regions[0])) {
      regions = [regions];
    }
    regions = regions.filter(function (r) {
      return r.length;
    });
    if (!regions || regions.length == 0) {
      return null;
    }
    var selector = (0, _selector2.compactSelector)(getRegionSelector(regions.map(function (r) {
      return new DocumentExamples(r[0].ownerDocument, r.map(function (x) {
        return (0, _Example.makeRegionExample)(x);
      }));
    })));

    // TODO: fix this better
    selector.forEach(function (sel) {
      if (sel[0] === ':this') sel[0] = 'html';
    });
    return selector;
  }
  function wrapTextNodes(dom) {
    Array.from(dom.querySelectorAll('body *:not(script):not(style):not(tr):not(tbody):not(thead):not(table):not(tfoot):not(col):not(colgroup)')).forEach(function (tag) {
      var childNodes = Array.from(tag.childNodes).filter(function (c) {
        return c.nodeType === 3;
      });
      if (childNodes.every(function (n) {
        return (0, _utils.isWhitespace)(n);
      })) {
        // if all the siblings are whitespace don't bother
        // this should also (hopfeully) reduce the chance of CSS side-effects from this text wrapping, e.g. with li blocks
        return;
      }
      for (var i = 0; i < childNodes.length; i++) {
        var c = childNodes[i];
        var w = dom.createElement('io-text');
        tag.replaceChild(w, c);
        w.appendChild(c);
      }
    });
  }

  /**
   * Find a descendant with the same text content, if one exists.
   * Returns the element input if not.
   *
   * @param  {Element} element
   * @return {Element}
   */
  var zoomIn = function zoomIn(element) {
    if (element.children.length) {
      (function () {
        var text = (0, _utils.normalizeSpace)(element.textContent);
        while (element.children.length) {
          var newElement = Array.prototype.slice.call(element.children).find(function (e) {
            return (0, _utils.normalizeSpace)(e.textContent) == text;
          });
          if (newElement) {
            element = newElement;
          } else {
            break;
          }
        }
        if (element.firstChild && element.firstChild.nodeType == 3 && element.firstChild.textContent === element.textContent) {
          element = element.firstChild;
        }
      })();
    }
    return element;
  };

  /**
   * Get the intersection of two arrays
   * @param  {Array} arr1
   * @param  {Array} arr2
   * @return {Array}
   */
  var getIntersect = function getIntersect(arr1, arr2) {
    var temp = [];
    for (var i = 0; i < arr1.length; i++) {
      if (arr2.indexOf(arr1[i]) >= 0) {
        temp.push(arr1[i]);
      }
    }
    return temp;
  };
  var UNIQUE_CACHE_FIELD_NAME = 'hhfkdytweirelld';
  var getUniqueClass = function getUniqueClass(context, section) {
    return section.classes.find(function (clazz) {
      if (!context[UNIQUE_CACHE_FIELD_NAME]) context[UNIQUE_CACHE_FIELD_NAME] = {};else {
        var cached = context[UNIQUE_CACHE_FIELD_NAME][clazz];
        if (cached !== undefined) return cached;
      }
      var unique = (0, _selector2.querySelectorAll)(context, '.' + (0, _css2.default)(clazz)).length === 1;
      context[UNIQUE_CACHE_FIELD_NAME][clazz] = unique;
      if (unique) {
        _logger2.default.debug('Class', clazz, 'is unique');
        return true;
      }
      return false;
    });
  };
  var POSITION = 1;
  var NAME = 2;
  var ID = 4;
  var STYLE = 8;
  var CLASSES_EXACT = 16;
  var CLASSES_COVERED = 32;
  var CLASSES_INTERSECT = 64;
  var CLASSES_BOTH_UNIQUE = 128;
  var SAME_MICRODATA = 256;
  var COMPATIBLE = 512;
  var MICRO_ATTRS = ['itemprop', 'itemtype', 'typeof'];
  var compare = function compare(thisSection, otherSection, thisExample, otherExample) {
    var result = 0;
    if (otherSection.name === thisSection.name) result |= NAME;
    if (otherSection.attributes.id === thisSection.attributes.id) result |= ID;
    if (!!otherSection.attributes.style === !!thisSection.attributes.style) result |= STYLE;
    // exactly the same classes
    if ((0, _utils.arraysEqual)(otherSection.classes, thisSection.classes)) {
      result |= CLASSES_EXACT | CLASSES_COVERED | CLASSES_INTERSECT;
      // if all the other classes are in this one, i.e. less specific, it is covering
    } else if (otherSection.classes.every(function (x) {
      return thisSection.classes.indexOf(x) >= 0;
    })) {
      result |= CLASSES_COVERED | CLASSES_INTERSECT;
    } else if (getIntersect(thisSection.classes, otherSection.classes).length) {
      result |= CLASSES_INTERSECT;
    } else {
      // if the sections both have a unique class and nothing else, count it as an intersection
      if (thisSection.classes.length === 1 && otherSection.classes.length === 1 && getUniqueClass(thisExample.document, thisSection) && getUniqueClass(otherExample.document, otherSection)) {
        result |= CLASSES_BOTH_UNIQUE;
      }
    }
    if (otherSection.childOfType === thisSection.childOfType) result |= POSITION;
    if ((0, _deepEqual2.default)(MICRO_ATTRS.map(function (x) {
      return otherSection.attributes[x];
    }), MICRO_ATTRS.map(function (x) {
      return thisSection.attributes[x];
    }))) result |= SAME_MICRODATA;
    if (result & NAME && result & SAME_MICRODATA && result & CLASSES_INTERSECT | result & CLASSES_BOTH_UNIQUE) {
      result |= COMPATIBLE;
    }
    return result;
  };

  /**
   * Checks to see if two paths could be merged together
   */
  var arePathsCompatible = function arePathsCompatible(thisPath, otherPath, thisExample, otherExample) {
    if (thisPath.length !== otherPath.length) {
      return false;
    }
    var _loop = function _loop(k) {
      var otherSection = otherPath[k];
      var thisSection = thisPath[k];
      var comparison = compare(thisSection, otherSection, thisExample, otherExample);
      if (!(comparison & COMPATIBLE)) {
        _logger2.default.debug('Sections are incompatible', function () {
          return (0, _selector2.toCssSelectorSection)(thisSection);
        }, function () {
          return (0, _selector2.toCssSelectorSection)(otherSection);
        });
        return {
          v: false
        };
      }
    };
    for (var k = 0; k < otherPath.length; k++) {
      var _ret2 = _loop(k);
      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
    return true;
  };

  /**
   * Reduces a set of examples by combining examples
   * which are COMPATIBLE
   */
  var reduce = function reduce(selector) {
    // copy the data before we mutate it
    // TODO: use a library
    var examples = JSON.parse(JSON.stringify(selector.paths));
    _logger2.default.debug('Trying to reduce', examples.length, 'selectors');
    var removed = [];
    examples = examples.filter(function (thisPath, index) {
      var _loop2 = function _loop2(i, j) {
        if (i === index) return 'continue';
        var otherPath = examples[i];
        // if it's already been removed it can't cover
        if (removed.indexOf(otherPath) >= 0) return 'continue';
        if (!arePathsCompatible(thisPath, otherPath, selector.examples[index], selector.examples[i])) return 'continue';
        _logger2.default.debug('Compatible selectors, will merge', function () {
          return (0, _selector2.toCssSelector)(thisPath);
        }, function () {
          return (0, _selector2.toCssSelector)(otherPath);
        });
        var _loop3 = function _loop3(k) {
          var otherSection = otherPath[k];
          var thisSection = thisPath[k];
          Object.keys(thisSection.attributes).map(function (x) {
            return '.' + x;
          }).concat(['childOfType', 'lastOfType', 'text', 'covers']).forEach(function (attr) {
            var attribute = attr[0] === '.';
            if (attribute) attr = attr.substr(1);
            var srcObj = attribute ? thisSection.attributes : thisSection;
            var destObj = attribute ? otherSection.attributes : otherSection;
            var source = srcObj[attr];
            var dest = destObj[attr];
            if (dest !== source) {
              if (!Array.isArray(dest)) {
                destObj[attr] = [dest];
                dest = destObj[attr];
              }
              var merge = function merge(x) {
                if (dest.indexOf(x) < 0) {
                  dest.push(x);
                }
              };
              if (Array.isArray(source)) {
                source.forEach(merge);
              } else {
                merge(source);
              }
            }
          });
          if (!otherSection.classLists) {
            otherSection.classLists = [otherSection.classes];
          }
          if (!thisSection.classLists) {
            thisSection.classLists = [thisSection.classes];
          }
          thisSection.classLists.forEach(function (toAdd) {
            if (!otherSection.classLists.find(function (arr) {
              return (0, _utils.arraysEqual)(arr, toAdd);
            })) {
              otherSection.classLists.push(toAdd);
            }
          });
          otherSection.classes = getIntersect(thisSection.classes, otherSection.classes);
        };
        for (var k = 0; k < otherPath.length; k++) {
          _loop3(k);
        }
        removed.push(thisPath);
        _logger2.default.debug('Merged path', function () {
          return (0, _selector2.toCssSelector)(otherPath);
        });
        return {
          v: false
        };
      };
      for (var i = 0, j = examples.length; i < j; i++) {
        var _ret3 = _loop2(i, j);
        switch (_ret3) {
          case 'continue':
            continue;
          default:
            if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
        }
      }

      // we couldn't find any other one to merge with
      return true;
    });
    _logger2.default.debug('Reduced to', examples.length, 'selectors');
    examples.forEach(function (path) {
      return path.forEach(function (section) {
        if (!section.classLists) section.classLists = [section.classes];
      });
    });
    return examples;
  };
  var getKey = function getKey(path, record) {
    return path.map(function (x, idx) {
      if (!record || idx !== path.length - 1) return x.name;
      if (x.attributes.id) return x.name + '#' + x.attributes.id;
      var uniqueClass = getUniqueClass(record, x);
      if (uniqueClass) return x.name + '#' + uniqueClass;
      return x.name;
    }).join(' ');
  };
  var createSelectorLookup = function createSelectorLookup(examples, counterexampleLookup) {
    var lookup = {};
    var nonUnique = {};
    examples.forEach(function (recordExample) {
      var example = recordExample.example;
      example.path.forEach(function (b, idx) {
        for (var i = 0, j = example.coversIndex; i <= j && i <= recordExample.recordAncestor; i++) {
          var path = example.path.slice(i, idx + 1);
          if (path.length == 0) break;
          var textNode = path[0].name === '#text';
          // can't just select a text node
          if (path.length == 1 && textNode) continue;
          // if the text node has same text content as element above, ignore
          if (example.coversIndex > 0 && textNode) continue;

          // for coutner examples we just use a plain key as later we compare with merged keys
          var key = getKey(path, counterexampleLookup ? recordExample.record : undefined);
          if (counterexampleLookup && nonUnique[key]) {
            // don't use counter examples
            _logger2.default.debug('Ignoring path as not unique for another: ', key);
            continue;
          }
          if (!(0, _selector2.uniqueNode)(path, recordExample.record)) {
            _logger2.default.debug('Ignoring path as not unique', key);
            if (counterexampleLookup) {
              nonUnique[key] = true;
              delete lookup[key];
            }
            return;
          }
          if (lookup[key] === undefined) {
            _logger2.default.debug('New counterxample @', key);
            var _selector = {
              path: key,
              count: 0,
              examples: [],
              paths: [],
              depth: path.length,
              textNode: textNode
            };
            lookup[key] = _selector;
          }
          var selector = lookup[key];
          selector.count++;
          selector.examples.push(recordExample);
          selector.paths.push(path);
          selector.topScope |= recordExample.recordAncestor === i;
        }
      });
    });
    return lookup;
  };

  /**
   * Calculates a selector given the examples and counterexamples
   */
  var _calcSelector = function _calcSelector(examples, counterexamples) {
    if (examples.find(function (x) {
      return x.example.coversIndex >= x.recordAncestor;
    })) {
      return [[]];
    }
    var result = [];
    _logger2.default.debug('There are', examples.length, 'examples');
    _logger2.default.debug('There are', counterexamples.length, 'counterexamples');
    var counterLookup = createSelectorLookup(counterexamples);
    _logger2.default.debug('******', 'Counterexample paths:', function () {
      return Object.values(counterLookup).map(function (s) {
        return s.path + ' (' + s.count + ')';
      }).join(', ');
    });

    // reduce down the counter lookup
    Object.keys(counterLookup).forEach(function (key) {
      return counterLookup[key] = reduce(counterLookup[key]);
    });
    var lookup = createSelectorLookup(examples, counterLookup);
    var selectors = Object.values(lookup);

    // sort to order with the most hits first, followed by least length
    var sortSelectors = function sortSelectors() {
      selectors.sort(function (a, b) {
        if (b.count == a.count) {
          if (a.depth == b.depth) {
            if (a.textNode && b.textNode) return 0;
            if (a.textNode) return 1;
            return -1;
          }
          return a.depth - b.depth;
        }
        return b.count - a.count;
      });
    };
    sortSelectors();
    _logger2.default.debug('******', 'First pass selector paths:', function () {
      return selectors.map(function (s) {
        return s.path + ' (' + s.count + ')';
      }).join(', ');
    });
    var ungroupedExamples = [].concat(_toConsumableArray(examples));
    var chooseSelectors = function chooseSelectors(excludeIgnore) {
      var _loop4 = function _loop4(_idx) {
        // the next best....
        var best = selectors[_idx];
        if (best.examples.length === 0) {
          // no examples left in this option
          return 'continue';
        }

        // if it's the topmose element, that's all it can be.
        if (best.topScope) {
          return {
            v: ':this'
          };
        }
        _logger2.default.debug('Reducing', best.length, 'paths into a consistent selector');
        var selector = reduce(best);
        _logger2.default.debug('Reduced to', function () {
          return (0, _selector2.toCssSelector)(selector);
        });

        // currently we just look at the classes for negation
        _logger2.default.debug('Checking counter-examples');
        selector.forEach(function (path) {
          var key = getKey(path);
          _logger2.default.debug('Got key', key);
          var counterPaths = counterLookup[key];
          if (!counterPaths) return;
          var _loop5 = function _loop5(i) {
            var section = path[i];
            var classes = [];
            var childOfType = [];
            counterPaths.forEach(function (counterPath) {
              var before = classes.length;
              counterPath[i].classLists.forEach(function (arr) {
                return arr.forEach(function (clazz) {
                  if (classes.indexOf(section) < 0 && !section.classLists.find(function (arr) {
                    return arr.indexOf(clazz) >= 0;
                  })) {
                    // it is enough to just exclude it on one other class
                    classes.push(clazz);
                    return;
                  }
                });
              });
              // it is enough to just exclude it on one other class, don't need position as well
              if (before !== classes.length) {
                return;
              }
              var positions = counterPath[i].childOfType;
              if (!Array.isArray(positions)) positions = [positions];
              positions.forEach(function (c) {
                if ((Array.isArray(section.childOfType) && section.childOfType.indexOf(c) < 0 || !Array.isArray(section.childOfType) && section.childOfType !== c) && childOfType.indexOf(c) < 0) {
                  childOfType.push(c);
                }
              });
            });
            section.not = {
              classes: classes,
              childOfType: childOfType
            };
          };
          for (var i = 0; i < path.length; i++) {
            _loop5(i);
          }
        });

        // TODO: this could be more efficient
        var matchesCounterExample = function matchesCounterExample() {
          return counterexamples.find(function (recordExample) {
            var matches = Array.from((0, _selector2.selectNodes)(selector, recordExample.record));
            return matches.find(function (x) {
              return recordExample.ancestors.find(function (y) {
                return y === x;
              });
            });
          });
        };
        if (!excludeIgnore) {
          if (matchesCounterExample()) {
            _logger2.default.debug('Not using', best.path, 'as matches a counterexample');
            return 'continue';
          }
        }
        selector = selector.map(function (path) {
          _logger2.default.debug('Trying to simplify selector', function () {
            return (0, _selector2.compactSelector)(path);
          });

          // When multiple examples have same record, e.g. repeated items in one row
          // only examine alternativeOk over uniq record. code equal to:
          // const expected = examples.map( recordExample => Array.from(selectNodes(path, recordExample.record)) );
          var uniq_records = new Set(examples.map(function (_ref) {
            var record = _ref.record;
            return record;
          }));
          var expected = Array.from(uniq_records).map(function (record) {
            return {
              elements: Array.from((0, _selector2.selectNodes)(path, record)),
              record: record
            };
          });
          var alternativeOk = function alternativeOk(alternative) {
            return !expected.find(function (_ref2) {
              var elements = _ref2.elements,
                record = _ref2.record;
              var matches = Array.from((0, _selector2.selectNodes)(alternative, record));
              return !(0, _utils.arraysEqual)(matches, elements);
            });
          };
          var tryWithoutPositionAndId = function tryWithoutPositionAndId(slice, idx) {
            var input = path;
            if (slice) input = input.slice(0, slice);
            var alternative = JSON.parse(JSON.stringify(input));
            if (idx === undefined) idx = alternative.length - 1;
            var section = alternative[idx];

            // don't go all the way up to <head/>
            if (input.length == 1 && section.name === 'head') {
              return false;
            }
            if (!slice && !section.childOfType && !section.attributes.id) {
              return true;
            }
            section._childOfType = section.childOfType;
            section._lastOfType = section.lastOfType;
            section.attributes._id = section.attributes.id;
            delete section.childOfType;
            delete section.lastOfType;
            delete section.attributes.id;
            var ok = alternativeOk(alternative);
            _logger2.default.debug('Checking if alternative ok', function () {
              return (0, _selector2.compactSelector)(alternative);
            }, ok);
            if (ok) {
              if (slice) {
                path = alternative;
              } else {
                path[idx] = alternative[idx];
              }
            }
            return ok;
          };

          // take a copy of the path and kill all the positions/ids
          // optimization for the common case
          var opt = JSON.parse(JSON.stringify(path));
          opt.forEach(function (section) {
            section._childOfType = section.childOfType;
            section._lastOfType = section.lastOfType;
            section.attributes._id = section.attributes.id;
            delete section.childOfType;
            delete section.lastOfType;
            delete section.attributes.id;
          });
          var noIdOrPos = alternativeOk(opt);
          if (noIdOrPos) {
            _logger2.default.debug('Can remove id and positions', function () {
              return (0, _selector2.compactSelector)(opt);
            });
            path = opt;
          }
          for (var i = 1, j = path.length; i < j; i++) {
            // try shortest first
            if (tryWithoutPositionAndId(i)) {
              break;
            }
          }
          if (!noIdOrPos) {
            for (var _i = 0, _j = path.length; _i < _j; _i++) {
              // try removing any remaining
              tryWithoutPositionAndId(null, _i);
            }
          }
          return path;
        });
        selector.forEach(function (x) {
          return result.push(x);
        });
        ungroupedExamples = ungroupedExamples.filter(function (g) {
          return best.examples.indexOf(g) < 0;
        });
        _logger2.default.debug('Examples left to merge: ', ungroupedExamples.length);

        // remove this selector, resort
        selectors.splice(_idx, 1);
        _idx = -1;
        selectors.forEach(function (sel) {
          best.examples.forEach(function (e) {
            var i = sel.examples.indexOf(e);
            if (i < 0) return;
            sel.examples.splice(i, 1);
            sel.paths.splice(i, 1);
            sel.count--;
          });
        });

        // resort
        sortSelectors();
        idx = _idx;
      };
      for (var idx = 0; idx < selectors.length && ungroupedExamples.length; idx++) {
        var _ret5 = _loop4(idx);
        switch (_ret5) {
          case 'continue':
            continue;
          default:
            if ((typeof _ret5 === 'undefined' ? 'undefined' : _typeof(_ret5)) === "object") return _ret5.v;
        }
      }
    };
    chooseSelectors();
    if (ungroupedExamples.length) {
      // remove counterexample restrictions
      chooseSelectors(true);
    }
    return result;
  };
  var getRow = function getRow(e, records) {
    return records.find(function (row) {
      return row === e || row.contains(e);
    });
  };
  function exampleFromSelector(dom, selector, counterexample) {
    var xpath = (0, _selector2.fullXPath)(dom.querySelector(selector));
    return (0, _Example.makeExample)(dom, xpath, counterexample);
  }
  var DocumentExamples = exports.DocumentExamples = function () {
    function DocumentExamples(document, examples) {
      _classCallCheck(this, DocumentExamples);
      this._document = document;
      this._examples = examples;
    }
    _createClass(DocumentExamples, [{
      key: 'document',
      get: function get() {
        return this._document;
      }
    }, {
      key: 'examples',
      get: function get() {
        return this._examples;
      }
    }]);
    return DocumentExamples;
  }();

  // TODO: use a class for record examples

  var toRecordExample = function toRecordExample(document, example, records) {
    var element = (0, _selector2.getByFullXPath)(example.xpath, document);
    if (!element) return;
    var record = getRow(element, records);
    if (!record) return;
    var ancestors = [];
    var e = element;
    var recordAncestor = -1;
    do {
      if (e === record) {
        recordAncestor = ancestors.length;
      }
      ancestors.push(e);
    } while (e = e.parentNode);
    return {
      document: document,
      record: record,
      example: example,
      element: element,
      ancestors: ancestors,
      recordAncestor: recordAncestor
    };
  };
  function getSelector(pageSet, documentExamplesArray) {
    if (documentExamplesArray.length === 0) {
      return null;
    }
    var examples = [];
    var counterexamples = [];
    documentExamplesArray.forEach(function (documentExamples) {
      var doc = documentExamples.document;
      // these are what we are calculating the selector relative to
      var records = (0, _extractor.getRecordElements)(doc, pageSet);
      if (!records) records = [doc.documentElement];
      documentExamples.examples.forEach(function (example) {
        var x = toRecordExample(doc, example, records);
        if (!x) {
          return;
        }
        if (example.counterexample) {
          counterexamples.push(x);
        } else {
          examples.push(x);
        }
      });
    });
    if (examples.length == 0) {
      return null;
    }

    // get a selector for the clicked element
    var selector = calcSelector(examples, counterexamples);
    _logger2.default.info('Calculated selector as', JSON.stringify((0, _selector2.compactSelector)(selector)));
    return selector;
  }
  ;
  function getRegionSelector(documentExamplesArray) {
    if (documentExamplesArray.length === 0) {
      return null;
    }
    var examples = [];
    var counterexamples = [];
    documentExamplesArray.forEach(function (documentExamples) {
      var doc = documentExamples.document;
      if (!doc || !doc.documentElement) throw Error('No document element');

      // these are what we are calculating the selector relative to
      var records = [doc];
      documentExamples.examples.forEach(function (example) {
        var x = toRecordExample(doc, example, records);
        if (!x) {
          return;
        }
        if (example.counterexample) {
          counterexamples.push(x);
        } else {
          examples.push(x);
        }
      });
    });
    if (examples.length == 0) {
      return null;
    }

    // get a selector for the clicked element
    var selector = calcSelector(examples, counterexamples);
    _logger2.default.info('Calculated region selector as', JSON.stringify((0, _selector2.compactSelector)(selector)));
    return selector;
  }
  ;
  var calcSelector = function calcSelector(examples, counterexamples) {
    (0, _timer.time)('calcSelector');
    try {
      return _calcSelector(examples, counterexamples);
    } finally {
      (0, _timer.timeEnd)('calcSelector');
    }
  };

  /***/
}, /* 12 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global) {
    /*! https://mths.be/cssescape v1.5.1 by @mathias | MIT license */
    ;
    (function (root, factory) {
      // https://github.com/umdjs/umd/blob/master/returnExports.js
      if (true) {
        // For Node.js.
        module.exports = factory(root);
      } else if (typeof define == 'function' && define.amd) {
        // For AMD. Register as an anonymous module.
        define([], factory.bind(root, root));
      } else {
        // For browser globals (not exposing the function separately).
        factory(root);
      }
    })(typeof global != 'undefined' ? global : this, function (root) {
      if (root.CSS && root.CSS.escape) {
        return root.CSS.escape;
      }

      // https://drafts.csswg.org/cssom/#serialize-an-identifier
      var cssEscape = function cssEscape(value) {
        if (arguments.length == 0) {
          throw new TypeError('`CSS.escape` requires an argument.');
        }
        var string = String(value);
        var length = string.length;
        var index = -1;
        var codeUnit;
        var result = '';
        var firstCodeUnit = string.charCodeAt(0);
        while (++index < length) {
          codeUnit = string.charCodeAt(index);
          // Note: there’s no need to special-case astral symbols, surrogate
          // pairs, or lone surrogates.

          // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER
          // (U+FFFD).
          if (codeUnit == 0x0000) {
            result += "\uFFFD";
            continue;
          }
          if (
          // If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
          // U+007F, […]
          codeUnit >= 0x0001 && codeUnit <= 0x001F || codeUnit == 0x007F ||
          // If the character is the first character and is in the range [0-9]
          // (U+0030 to U+0039), […]
          index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
          // If the character is the second character and is in the range [0-9]
          // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]

          index == 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit == 0x002D) {
            // https://drafts.csswg.org/cssom/#escape-a-character-as-code-point
            result += '\\' + codeUnit.toString(16) + ' ';
            continue;
          }
          if (
          // If the character is the first character and is a `-` (U+002D), and
          // there is no second character, […]
          index == 0 && length == 1 && codeUnit == 0x002D) {
            result += '\\' + string.charAt(index);
            continue;
          }

          // If the character is not handled by one of the above rules and is
          // greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
          // is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
          // U+005A), or [a-z] (U+0061 to U+007A), […]
          if (codeUnit >= 0x0080 || codeUnit == 0x002D || codeUnit == 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
            // the character itself
            result += string.charAt(index);
            continue;
          }

          // Otherwise, the escaped character.
          // https://drafts.csswg.org/cssom/#escape-a-character
          result += '\\' + string.charAt(index);
        }
        return result;
      };
      if (!root.CSS) {
        root.CSS = {};
      }
      root.CSS.escape = cssEscape;
      return cssEscape;
    });

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(6));

  /***/
}, /* 13 */
/***/function (module, exports, __webpack_require__) {
  var pSlice = Array.prototype.slice;
  var objectKeys = __webpack_require__(26);
  var isArguments = __webpack_require__(25);
  var deepEqual = module.exports = function (actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) {
      return true;
    } else if (actual instanceof Date && expected instanceof Date) {
      return actual.getTime() === expected.getTime();

      // 7.3. Other pairs that do not both pass typeof value == 'object',
      // equivalence is determined by ==.
    } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
      return opts.strict ? actual === expected : actual == expected;

      // 7.4. For all other Object pairs, including Array objects, equivalence is
      // determined by having the same number of owned properties (as verified
      // with Object.prototype.hasOwnProperty.call), the same set of keys
      // (although not necessarily the same order), equivalent values for every
      // corresponding key, and an identical 'prototype' property. Note: this
      // accounts for both named and indexed properties on Arrays.
    } else {
      return objEquiv(actual, expected, opts);
    }
  };
  function isUndefinedOrNull(value) {
    return value === null || value === undefined;
  }
  function isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
      return false;
    }
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
  }
  function objEquiv(a, b, opts) {
    var i, key;
    if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if (isArguments(a)) {
      if (!isArguments(b)) {
        return false;
      }
      a = pSlice.call(a);
      b = pSlice.call(b);
      return deepEqual(a, b, opts);
    }
    if (isBuffer(a)) {
      if (!isBuffer(b)) {
        return false;
      }
      if (a.length !== b.length) return false;
      for (i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }
    try {
      var ka = objectKeys(a),
        kb = objectKeys(b);
    } catch (e) {
      //happens when one is a string literal and the other isn't
      return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for (i = ka.length - 1; i >= 0; i--) {
      if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for (i = ka.length - 1; i >= 0; i--) {
      key = ka[i];
      if (!deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
  }

  /***/
}, /* 14 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _Page = __webpack_require__(9);
  var _Page2 = _interopRequireDefault(_Page);
  var _Field = __webpack_require__(7);
  var _Field2 = _interopRequireDefault(_Field);
  var _extractor = __webpack_require__(3);
  var _deepEqual = __webpack_require__(13);
  var _deepEqual2 = _interopRequireDefault(_deepEqual);
  var _uuid = __webpack_require__(8);
  var _uuid2 = _interopRequireDefault(_uuid);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var PageSet = function () {
    function PageSet(data) {
      _classCallCheck(this, PageSet);
      this._id = _uuid2.default.v4();
      this._pages = [];
      this._fields = [];
      this._recordSelector = null;
      this.load(data);
      this._noscript = !!this._noscript;
    }
    _createClass(PageSet, [{
      key: 'load',
      value: function load(data) {
        var _this = this;
        if (data) {
          Object.assign(this, data);
          this._fields = data.fields.map(function (o) {
            return new _Field2.default(o);
          });
          this._pages = [];
          data.pages.forEach(function (o) {
            return _this.addPage(new _Page2.default(o));
          });
        }
      }
    }, {
      key: 'addPage',
      value: function addPage(page) {
        this._pages.push(page);
        page.pageSet = this;
      }
    }, {
      key: 'addField',
      value: function addField(field, position) {
        if (position) {
          this._fields.splice(position, 0, field);
        } else {
          this._fields.push(field);
        }
      }
    }, {
      key: 'getRuntimeConfigWithNoscriptDetect',
      /**
       * deprecated
       */
      value: function getRuntimeConfigWithNoscriptDetect() {
        return this.getOptimizedRuntimeConfig();
      }
    }, {
      key: 'getOptimizedRuntimeConfig',
      value: function getOptimizedRuntimeConfig() {
        var runtimeConfig = this.runtimeConfig();
        return this.optimize(runtimeConfig);
      }
    }, {
      key: 'optimize',
      value: function optimize(runtimeConfig) {
        // manually set js off?
        if (!runtimeConfig.noscript && this.noscriptAvailable) {
          // if we can find one where
          var differentResultsWithoutScripts = this.pages.find(function (page) {
            var scripted = (0, _extractor.extract)(runtimeConfig, page.scriptDom(), page.url);
            var noscripted = (0, _extractor.extract)(runtimeConfig, page.noscriptDom(), page.url);
            return !(0, _deepEqual2.default)(scripted, noscripted);
          });
          if (!differentResultsWithoutScripts) {
            // they are all the same
            runtimeConfig.noscript = true;
          }
        }
        var moreThanOneRow = this.pages.find(function (page) {
          var groupsArray = (0, _extractor.extract)(runtimeConfig, page.scriptDom(), page.url);
          return groupsArray.length > 1 || groupsArray[0].group.length > 1;
        });
        if (!moreThanOneRow) {
          runtimeConfig.singleRecord = true;
          runtimeConfig.regionsSelector = undefined;
        }
        return runtimeConfig;
      }
    }, {
      key: 'fieldWithId',
      value: function fieldWithId(id) {
        return this._fields.find(function (e) {
          return e.id === id;
        });
      }
    }, {
      key: 'toJSON',
      value: function toJSON() {
        return {
          fields: this.fields,
          recordSelector: this._recordSelector,
          recordXPath: this._recordXPath,
          pages: this.pages,
          singleRecord: this.singleRecord,
          regionsSelector: this.regionsSelector,
          noscript: this.noscript,
          screenCapture: !!this.screenCapture
        };
      }
    }, {
      key: 'runtimeConfig',
      value: function runtimeConfig() {
        return {
          fields: this._fields.map(function (f) {
            return f.cloneWithCompactSelector();
          }),
          recordSelector: this._recordSelector,
          recordXPath: this.recordXPath,
          regionsSelector: this.regionsSelector,
          singleRecord: !!this.singleRecord,
          noscript: !!this.noscript,
          screenCapture: !!this.screenCapture
        };
      }
    }, {
      key: 'pages',
      get: function get() {
        return this._pages;
      },
      set: function set(pages) {
        this._pages = pages;
      }
    }, {
      key: 'autoDetectRecords',
      get: function get() {
        return !this._recordSelector && !this._recordXPath && !this._singleRecord;
      }
    }, {
      key: 'recordXPath',
      set: function set(xpath) {
        this._recordXPath = xpath;
      },
      get: function get() {
        return this._recordXPath;
      }
    }, {
      key: 'recordSelector',
      set: function set(selector) {
        this._recordSelector = selector;
      },
      get: function get() {
        return this._recordSelector;
      }
    }, {
      key: 'fields',
      get: function get() {
        return this._fields;
      },
      set: function set(fields) {
        this._fields = fields;
      }
    }, {
      key: 'singleRecord',
      get: function get() {
        return this._singleRecord;
      },
      set: function set(singleRecord) {
        this._singleRecord = singleRecord;
      }
    }, {
      key: 'regionsSelector',
      get: function get() {
        return this._regionsSelector;
      },
      set: function set(regionsSelector) {
        this._regionsSelector = regionsSelector;
      }
    }, {
      key: 'noscript',
      get: function get() {
        return this._noscript;
      },
      set: function set(noscript) {
        this._noscript = !!noscript;
      }
    }, {
      key: 'screenCapture',
      get: function get() {
        return this._screenCapture;
      },
      set: function set(screenCapture) {
        this._screenCapture = !!screenCapture;
      }
    }, {
      key: 'noscriptAvailable',
      get: function get() {
        return !this.pages.find(function (page) {
          return !page.noscriptHtml;
        });
      }
    }]);
    return PageSet;
  }();
  exports.default = PageSet;

  /***/
}, /* 15 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  /* WEBPACK VAR INJECTION */
  (function (global) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.CDATA = exports.COMMENT = exports.TEXT = exports.END_ELEMENT = exports.SELF_CLOSING_ELEMENT = exports.START_ELEMENT = exports.VOID_ELEMENT = undefined;
    exports.parse = parse;
    exports.importIntoDocument = importIntoDocument;
    var _he = __webpack_require__(33);
    var _he2 = _interopRequireDefault(_he);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var nodejs = typeof global.window === 'undefined';
    var VOID_ELTS = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
    var VOID_ELEMENT = exports.VOID_ELEMENT = 0;
    var START_ELEMENT = exports.START_ELEMENT = 1;
    var SELF_CLOSING_ELEMENT = exports.SELF_CLOSING_ELEMENT = 2;
    var END_ELEMENT = exports.END_ELEMENT = 3;
    var TEXT = exports.TEXT = 4;
    var COMMENT = exports.COMMENT = 5;
    var CDATA = exports.CDATA = 6;
    var EVENT_NAMES = ['VOID_ELEMENT', 'START_ELEMENT', 'SELF_CLOSING_ELEMENT', 'END_ELEMENT', 'TEXT', 'COMMENT', 'CDATA'];
    var BANG = 0x0021;
    var DASH = 0x002d;
    var OPEN_TAG = 0x003c;
    var EQUALS = 0x003d;
    var CLOSE_TAG = 0x003e;
    var SLASH = 0x002f;
    var SINGLE_QUOTE = 0x0027;
    var DOUBLE_QUOTE = 0x0022;
    var LEFT_SQUARE_BRACKET = 0x005b;
    function parse(html, emit) {
      function isWhitespace(ch) {
        return ch === 0x0020 || ch === 0x0009 || ch === 0x000A || ch === 0x000C || ch === 0x000D;
      }
      var i = 0;
      var c = html.charCodeAt(i);
      var max = function () {
        var max = html.length;
        while (isWhitespace(html.charCodeAt(max - 1))) {
          max--;
        }
        return max;
      }();
      function decodeHtml(html) {
        return _he2.default.decode(html);
      }
      function next() {
        i++;
        c = html.charCodeAt(i);
      }
      function skip(j) {
        i += j;
        c = html.charCodeAt(i);
      }
      function goto(j) {
        if (j < i) {
          throw Error('Cannot go backwards');
        }
        i = j;
        c = html.charCodeAt(i);
      }
      function peek() {
        return html.charCodeAt(i + 1);
      }
      function skipWhitespace() {
        while (isWhitespace(c)) {
          next();
        }
      }
      function skipPast(ch) {
        while (i < max && c !== ch) {
          next();
        }
        next();
      }
      function consumeElementName() {
        var start = i;
        while (c !== CLOSE_TAG && c !== SLASH && !isWhitespace(c)) {
          next();
        }
        return html.substring(start, i);
      }
      function consumeAttributeName() {
        var start = i;
        while (c !== CLOSE_TAG && c !== SLASH && c !== EQUALS && !isWhitespace(c)) {
          next();
        }
        if (i === start) return undefined;
        return html.substring(start, i);
      }
      function consumeAttributeValue(delim) {
        var start = i;
        while (c !== delim) {
          next();
        }
        var result = html.substring(start, i);
        next();
        return result;
      }
      function consumeAttributes() {
        var attributes = [];
        while (true) {
          skipWhitespace();
          var name = consumeAttributeName();
          var value = undefined;
          if (!name) break;
          var _next = peek();
          if (_next === DOUBLE_QUOTE || _next === SINGLE_QUOTE) {
            skip(2);
            value = decodeHtml(consumeAttributeValue(_next));
          }
          attributes.push(name, value);
        }
        return attributes;
      }
      function consumeScriptStyle(name) {
        // State machine implemented below is based on this description:
        // http://stackoverflow.com/questions/14574471/how-do-browsers-parse-a-script-tag-exactly/14577094#14577094

        var start = i;
        var state = 1;
        // we need to ignore comments within the script tag, i.e. if the </script is within a comment
        var openTagStr = '<' + name;
        var closeTagStr = '</' + name + '>';
        var openComment = function openComment() {
          return {
            action: 'openComment',
            position: html.indexOf('<!--', i)
          };
        };
        var closeComment = function closeComment() {
          return {
            action: 'closeComment',
            position: html.indexOf('-->', i)
          };
        };
        var openTag = function openTag() {
          var from = i;
          var next = function next() {
            var pos = html.indexOf(openTagStr, from);
            if (pos === -1) {
              return {
                action: 'openTag',
                position: -1
              };
            }
            var ch = html.charCodeAt(pos + openTagStr.length);
            if (isWhitespace(ch) || ch === CLOSE_TAG) {
              return {
                action: 'openTag',
                position: pos
              };
            }
            from = pos + 1;
            return next();
          };
          return next();
        };
        var closeTag = function closeTag() {
          return {
            action: 'closeTag',
            position: html.indexOf(closeTagStr, i)
          };
        };
        var finders = [{
          name: 'openComment',
          fn: openComment
        }, {
          name: 'closeComment',
          fn: closeComment
        }, {
          name: 'openTag',
          fn: openTag
        }, {
          name: 'closeTag',
          fn: closeTag
        }];
        var transitions = {
          // DEFAULT START STATE
          1: {
            closeTag: function closeTag(iPos) {
              // we are done
              state = 0;
              i = iPos;
            },
            openComment: function openComment(iPos) {
              state = 2;
              i = iPos + 1;
            },
            closeComment: function closeComment(iPos) {
              state = 1;
              i = iPos + 1;
            },
            possibleActions: ['closeTag', 'openComment', 'closeComment']
          },
          // OPEN COMMENT STATE
          2: {
            closeTag: function closeTag(iPos) {
              // we are done
              state = 0;
              i = iPos;
            },
            openTag: function openTag(iPos) {
              state = 3;
              i = iPos + 1;
              skipPast(CLOSE_TAG);
            },
            closeComment: function closeComment(iPos) {
              state = 1;
              i = iPos + 1;
            },
            possibleActions: ['closeTag', 'openTag', 'closeComment']
          },
          // INNER TAG STATE
          3: {
            closeComment: function closeComment(iPos) {
              state = 1;
              i = iPos + 1;
            },
            closeTag: function closeTag(iPos) {
              state = 2;
              i = iPos + 1;
              skipPast(CLOSE_TAG);
            },
            possibleActions: ['closeTag', 'closeComment']
          }
        };
        while (state !== 0) {
          var nextAction = finders.filter(function (act) {
            return transitions[state].possibleActions.indexOf(act.name) !== -1;
          }).map(function (f) {
            return f.fn();
          }).filter(function (res) {
            return res.position !== -1;
          }).sort(function (a, b) {
            return a.position - b.position;
          })[0];
          if (!nextAction) {
            i = html.length;
            // No possible next tag was found, probably we searched till the end of file.
            break;
          }
          transitions[state][nextAction.action](nextAction.position);
        }
        emit({
          type: TEXT,
          value: html.substring(start, i)
        });
        skipPast(CLOSE_TAG);
        emit({
          type: END_ELEMENT,
          name: name
        });
      }
      function consumeText() {
        var start = i;
        while (c !== OPEN_TAG) {
          next();
        }
        if (start === i) return undefined;
        return decodeHtml(html.substring(start, i));
      }
      function consumeElement() {
        while (i < max) {
          if (c !== OPEN_TAG) {
            var text = consumeText();
            if (text) {
              emit({
                type: TEXT,
                value: text
              });
            }
            continue;
          }
          // we're at a <
          next();
          if (c === SLASH) {
            next();
            var _event = {
              type: END_ELEMENT,
              name: consumeElementName()
            };
            skipPast(CLOSE_TAG);
            if (VOID_ELTS.indexOf(_event.name) < 0) {
              emit(_event);
            }
            continue;
          }
          if (c === BANG) {
            if (peek() == DASH) {
              // <!-- .... -->)
              skip(3);
              var end = html.indexOf('-->', i);
              if (end < 0) {
                emit({
                  type: COMMENT,
                  value: html.substring(i)
                });
                i = max;
                break;
              }
              var _event2 = {
                type: COMMENT,
                value: decodeHtml(html.substring(i, end))
              };
              goto(end + 3);
              emit(_event2);
              continue;
            }
            if (peek() == LEFT_SQUARE_BRACKET) {
              // <![CDATA[ ... ]]>
              skip(8);
              var _end = html.indexOf(']]>', i);
              if (_end < 0) {
                emit({
                  type: CDATA,
                  value: html.substring(i)
                });
                i = max;
                break;
              }
              var _event3 = {
                type: CDATA,
                value: decodeHtml(html.substring(i, _end))
              };
              goto(_end + 3);
              emit(_event3);
              continue;
            }
            // doctype
            skipPast(CLOSE_TAG);
            continue;
          }
          var event = {};
          event.name = consumeElementName(); // already lower case
          event.attributes = consumeAttributes();
          if (c === SLASH) {
            event.type = SELF_CLOSING_ELEMENT;
            skipPast(CLOSE_TAG);
            emit(event);
            continue;
          }
          if (VOID_ELTS.indexOf(event.name) >= 0) {
            event.type = VOID_ELEMENT;
            skipPast(CLOSE_TAG);
            emit(event);
            continue;
          }
          event.type = START_ELEMENT;
          skipPast(CLOSE_TAG);
          emit(event);
          if (event.name === 'script' || event.name == 'style') {
            consumeScriptStyle(event.name);
          }
        }
      }
      consumeElement();
    }
    var DEBUG = false;
    function importIntoDocument(html, document) {
      var stack = [];
      var current = undefined;
      var documentElement = undefined;
      function toDoc(event) {
        if (DEBUG) {
          console.log('parent=' + (current ? current.localName : null) + ' ' + EVENT_NAMES[event.type] + ' ' + JSON.stringify(event));
        }
        if (event.type === START_ELEMENT || event.type === SELF_CLOSING_ELEMENT || event.type === VOID_ELEMENT) {
          var elt = void 0;
          try {
            elt = document.createElement(event.name);
          } catch (e) {
            // webkit can produce names that are invalid
            elt = document.createElement(event.name.replace(/[^a-z0-9\-_:\.]/g, ''));
          }
          for (var i = 0; i < event.attributes.length; i += 2) {
            try {
              var value = event.attributes[i + 1];
              elt.setAttribute(event.attributes[i], /\S/.test(value) ? value : '');
            } catch (e) {
              // webkit can produce names that are invalid
            }
          }
          if (!nodejs) {
            // weird hack to make elt.classList keep the correct case
            var cn = elt.className.trim();
            if (cn && cn.replace(/\s+/g, ' ') !== Array.from(elt.classList).join(' ')) {
              console.warn('Potential DOM issue: className does not tally with classList');
            }
          }
          if (current) {
            current.appendChild(elt);
          } else {
            if (documentElement) {
              throw Error('Redefining document element');
            }
            documentElement = elt;
          }
          if (event.type === START_ELEMENT) {
            stack.push(current);
            if (event.name === 'template') {
              try {
                elt.content = document.createDocumentFragment();
              } catch (e) {
                // jsdom only has a getter
                elt._templateContents = document.createDocumentFragment();
              }
              current = elt.content;
            } else {
              current = elt;
            }
          }
          return;
        }
        if (event.type === END_ELEMENT) {
          current = stack.pop();
          return;
        }
        if (event.type === TEXT || event.type === CDATA) {
          if (current) {
            // ignore text that is unrooted before the do elt
            var node = document.createTextNode(event.value);
            current.appendChild(node);
          }
          return;
        }
        if (event.type === COMMENT) {
          if (current) {
            // ignore comments that are unrooted before the do elt
            var _node = document.createComment(event.value);
            current.appendChild(_node);
          }
          return;
        }
      }
      parse(html, toDoc);
      document.replaceChild(documentElement, document.documentElement);
    }
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(6));

  /***/
}, /* 16 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.showLazyImage = showLazyImage;
  exports.showLazyImages = showLazyImages;
  var PROCESSED_ATTRIBUTE = 'processed-for-lazy-images';
  var ALLOWED_LAZY_SRC_ATTRIBUTES = /src(?!set)|lazy|thumb|original|url/i;
  function showLazyImage(el) {
    if (el[PROCESSED_ATTRIBUTE]) return;
    el[PROCESSED_ATTRIBUTE] = true;
    if (!('getAttribute' in el) || el.tagName !== 'IMG') {
      return;
    }
    for (var i = 0; i < el.attributes.length; i++) {
      var attrib = el.attributes[i];
      if (attrib.name === 'srcset' || attrib.name === 'src') continue;

      /*
       We want to check for either 'src', 'original' or 'lazy' in the attribute name
       This is a rough heuristic and we could replace with something better in
      future where we are trying to determine which images are lazy load by
      looking at the # of instances of an image with each src, and assuming
      that any with more than a certain amount of hits are lazy.
       This is more deterministic and will work with known sites on the flip side.
       'datasrc', // BBC
      'data-src', // SOURCEBUG-487
      'original-src', // SOURCEBUG-397
      'data-original', // shop.nordstrom.com
      'data-lazy-src', // realtor.com
      'image-src', // alibaba.com
      'lazysrc', //snapdeal.com
      'lazy-src', // http://www.dinobulk.com/mens-dress-shoes/
      'data-lazyload-src', //producthunt
       */

      // check the name is a candidate
      // perhaps this isn't necessary, not sure how many edge cases there are
      if (ALLOWED_LAZY_SRC_ATTRIBUTES.test(attrib.name)) {
        // check for an absolute URL
        if (attrib.value.startsWith('http:') || attrib.value.startsWith('https:')) {
          el.setAttribute('src', attrib.value);
          return;
        }
      }
    }
  }

  /**
   * Adds a <base> tag to the document with the base path of the given URL.
   * @param {HTMLDocument} doc Document
   * @param {string} url Document URL
   */
  function showLazyImages(doc) {
    Array.from(doc.querySelectorAll('img')).forEach(showLazyImage);
  }

  /***/
}, /* 17 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  exports.toLabel = toLabel;
  exports.getData = getData;
  exports.getMainItemRuntimeConfig = getMainItemRuntimeConfig;
  exports.getMainItem = getMainItem;
  var _utils = __webpack_require__(1);
  var _extractor = __webpack_require__(3);
  var _entities = __webpack_require__(27);
  var _entities2 = _interopRequireDefault(_entities);
  var _Field = __webpack_require__(7);
  var _Field2 = _interopRequireDefault(_Field);
  var _deepEqual = __webpack_require__(13);
  var _deepEqual2 = _interopRequireDefault(_deepEqual);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    } else {
      return Array.from(arr);
    }
  }
  var DEFAULT_WORD_SET_SIMILARITY = 0.8;

  // This doesn't actually use the information from schema.org as the moment
  var isImage = function isImage(label) {
    return /(^|\b|_)(image|thumbnail|logo)(\.?(secure_)?url\b|$)/i.test(label);
  };
  var NO_TEXT_LINK = '(link)';

  /**
   * Convert a dot format data name into a Human Name
   */
  function toLabel(key) {
    var last = void 0;
    var label = key.replace(/^([A-Z][A-Za-z]*\.)+/, '').replace(/[A-Z]{2,}/g, function (x) {
      return x[0] + x.substring(1).toLowerCase();
    }).split(/[\s.]|(?=[A-Z]+)/g).filter(function (x) {
      return x;
    }).map(function (x) {
      if (!x) return x;
      var temp = x[0].toUpperCase() + x.substring(1).toLowerCase();
      if (last == temp) return;
      last = temp;
      return temp;
    }).filter(function (x) {
      return x;
    }).join(' ').replace(/ (Name|Value|Same As)$/, '').replace(/(Offer|Item|Detail|Address|Aggregate)s? /g, '');
    return label;
  }

  /**
   * Add a value into a row for a key
   */
  var add = function add(fieldNames, row, key, value) {
    // don't want these related lists
    if (/(\.|^)(?:reviews?|isSimilarTo|isRelatedTo|suggestedAnswer)\./i.test(key)) {
      return;
    }
    if (!key) return;
    if (!value.text && !value.src) {
      if (value.href) value.text = NO_TEXT_LINK;else return;
    }

    // fix bad nesting
    key = key.replace(/(^|\.)(\w+\.)\1\./g, '$1$2');
    // remove array modifiers .X.
    key = key.replace(/\.\d+/g, '');
    key = key.replace(/URL/g, 'Url');
    if (!row[key]) row[key] = [];else if (key === 'name' && row[key].length === 1) return;
    fieldNames.add(key);

    // protect against
    if (value.text) {
      var re = /^(?:https?:)?\/\/(schema|data-vocabulary).org\//i;
      if (/(^|\.)(item)?(availability|condition)$/i.test(key) || re.test(value.text)) {
        value.text = value.text.replace('_', ' ').replace(re, '').replace(/(\S)([A-Z])/g, '$1 $2').trim().split(/\s+/g).map(function (x) {
          return x[0].toUpperCase() + x.substring(1);
        }).join(' ');
      }
    }
    if (value.src) {
      // bad data cleaning, e.g. https://www.purplle.com/product/maybelline-lasting-drama-gel-liner-black-2-5-g
      value.src = value.src.replace(/^https?:\/\/(https?):\/\//, '$1://');
    }
    row[key].push(value);
  };
  var isUrl = function isUrl(key, value) {
    return isImage(key) || key.endsWith('url') || /^\s*(https?:)?\/\//.test(value) && !/^(?:https?:)?\/\/schema.org\//.test(value);
  };
  var decodeHtml = function decodeHtml(html) {
    return _entities2.default.decodeHTML(html);
  };
  function getData(url, document) {
    if (!document.__extractedMicroData) document.__extractedMicroData = {};else if (document.__extractedMicroData[url]) return document.__extractedMicroData[url];
    var table = {};
    processSchemaDotOrgLDJSON(url, document, table);
    processSchemaDotOrgMicrodata(url, document, table);

    // squash down dupes that
    var types = Object.keys(table);
    types.forEach(function (t) {
      if (!table[t] || !table[t].fieldNames.size) {
        delete table[t];
        return;
      }
      table[t] = dedupe(table[t]);
    });
    processMeta(document, table);
    document.__extractedMicroData[url] = table;
    return table;
  }

  /**
   * Normalize text to UPPER CASE and only word characters
   * Doesn't support unicode
   */
  var norm = function norm(text) {
    return text.replace(/(?:[\0-\x08\x0E-\x1F!-\/:-@\[-\^`\{-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
  };
  function merge(from, to) {
    Object.keys(from).forEach(function (k) {
      if (!to[k]) to[k] = from[k];
    });
  }
  var sw = '\n\nthe\nof\nin\na\nand\nis\nto\nwas\nit\nfor\nthat\nare\nas\nhe\non\nby\nwith\nfrom\nor\nthis\nthey\nbe\nan\nat\nhis\nnot\nalso\nhas\nwere\nwhich\nhave\none\ncan\nbut\nthere\nother\ntheir\nwhen\nhad\nwho\nused\nabout\nsome\nafter\nits\nif\nthem\nup\nthan\nso\nsuch\nthen\ndetails\n';
  var stopWords = new Set(sw.split(/\n/g).map(function (x) {
    return x.trim().toUpperCase();
  }).filter(function (x) {
    return x;
  }));

  /**
   * Word set similarity as a % of input
   * Takes word sets as inputs
   */
  var similarity = function similarity(input, title) {
    var intersection = new Set(Array.from(input).filter(function (x) {
      return title.has(x);
    }));
    return intersection.size / input.size;
  };

  /**
   * 80% similarity required
   * Takes word sets as inputs
   */
  var isSimilar = function isSimilar(input, title) {
    var pct = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_WORD_SET_SIMILARITY;

    // require 80% of the words in the microdata to be in the page title
    return similarity(input, title) >= pct;
  };

  /**
   * Convert text to a word set with an optional maximum size
   */
  var toWordSet = function toWordSet(text, size) {
    var split = norm(text).split(/\s+/g).filter(function (x) {
      return !stopWords.has(x);
    });
    if (size) split = split.slice(0, size);
    return new Set(split);
  };

  /**
   * Dedupe a list of rows based on their name.
   * Name isn't always exactly the same in microdata vs ld-json (god knows why)
   * so we use the similarity measure of >= 90% of words being the same
   * TODO: check key values don't differ, like price? Outside chance of false positives
   */
  function dedupe(typedRows) {
    if (!typedRows || !typedRows.rows || typedRows.rows.length <= 1) return typedRows;
    var result = [];
    typedRows.rows.forEach(function (item) {
      if (result.length === 0 || !item.name || !item.name[0].text) {
        result.push(item);
        return;
      }
      var itemName = toWordSet(item.name[0].text);
      for (var i = 0; i < result.length; i++) {
        var comp = result[i];
        if (!comp.name || !comp.name[0].text) continue;
        var compName = toWordSet(comp.name[0].text);
        if (isSimilar(itemName, compName, 0.9)) {
          merge(item, comp);
          return;
        }
      }
      result.push(item);
    });
    return {
      fieldNames: typedRows.fieldNames,
      rows: result
    };
  }

  /**
   * Resolve the name for a row
   */
  function getName(obj) {
    if (obj.name && obj.name.length === 1 && obj.name[0].text && NO_TEXT_LINK !== obj.name[0].text) return obj.name[0].text;
    if (obj.headline && obj.headline.length === 1 && obj.headline[0].text && obj.headline[0].text != NO_TEXT_LINK) return obj.headline[0].text;
  }
  var columnOrder = ['Sku', 'Image', 'Name', 'Description', 'Price', 'Price Currency', 'Availability', 'Rating', 'Rating Count', 'Category'];

  /**
   * Generate a runtime config for the main item on this page.
   * If type is not supplied we guess the type.
   */
  function getMainItemRuntimeConfig(document, type) {
    var item = getMainItem(undefined, document, type);
    if (!item) return;
    type = item['@type'];
    var labels = {},
      map = {};
    var fields = Object.keys(item).map(function (id) {
      if (id[0] === '@' || !item[id] || !item[id].length) return;
      var field = {};
      field.microPath = {
        type: type,
        id: id
      };
      var label = toLabel(id);
      if (!labels[label]) {
        labels[label] = 1;
      } else {
        // if this is the same as the first one we saw - simple dedupe
        if ((0, _deepEqual2.default)(item[id], item[map[label]])) {
          return;
        }
        labels[label]++;
        label += ' (' + labels[label] + ')';
      }
      map[label] = id;
      field.name = label;
      field.type = item[id][0].text ? 'TEXT' : 'IMAGE';
      field.captureLink = !!item[id][0].href;
      return new _Field2.default(field);
    }).filter(function (x) {
      return x;
    }).sort(function (a, b) {
      var iA = columnOrder.indexOf(a.name);
      var iB = columnOrder.indexOf(b.name);
      if (iA < 0) {
        if (iB < 0) {
          return a.name.localeCompare(b.name);
        }
        return 1;
      }
      // iA > 0
      if (iB < 0) {
        return -1;
      }
      return iA - iB;
    });
    return {
      fields: fields,
      singleRecord: true
    };
  }

  /**
   * Generate data for the main item on this page.
   * If type is not supplied we guess the type.
   */
  function getMainItem(url, document, type) {
    if (!document.__extractedMicroDataTypes) {
      document.__extractedMicroDataTypes = {};
    } else {
      if (document.__extractedMicroDataTypes[type] !== undefined) {
        return document.__extractedMicroDataTypes[type];
      }
    }

    // TODO: we could optimize this to not get all the microdata but pre-filter?
    var data = getData(url, document);

    // collapse the data into a single array
    var objects = [];
    Object.keys(data).forEach(function (k) {
      if (type && type !== k || ['meta', 'Breadcrumb', 'BreadcrumbList'].indexOf(k) >= 0) return;
      data[k].rows.forEach(function (row) {
        if (row._descriptor = getName(row)) {
          row['@type'] = k;
          objects.push(row);
        }
      });
    });
    if (objects.length === 0) return;
    var mainItem = function () {
      // If we've only got one of something return that
      if (type && objects.length === 1) return objects[0];

      // Look at opengraph / twitter / page title
      var attrs = ['meta.og.title', 'meta.twitter.title', 'meta.title'];
      var wordsToConsider = 5;
      var _loop = function _loop(i) {
        objects.forEach(function (obj) {
          obj._similarity = 0;
          obj._intersection = 0;
          obj._descriptor = undefined;
        });
        var attrName = attrs[i];
        var attr = data.meta.rows[0][attrName];
        if (!attr) return 'continue';
        var titleText = attr[0].text;
        var title = toWordSet(titleText, wordsToConsider);

        // pick the thing whose name is most similar to the title
        objects.forEach(function (obj) {
          obj._descriptor = getName(obj);
          var ws = toWordSet(obj._descriptor, wordsToConsider);
          obj._similarity = similarity(ws, title) || 0;
          if (titleText.indexOf(obj._descriptor) >= 0) obj._similarity *= 2;
          obj._intersection = ws.size * obj._similarity;
        });
        objects.sort(function (a, b) {
          if (b._intersection !== a._intersection || !a._descriptor) return b._intersection - a._intersection;
          return a._descriptor.length - b._descriptor.length;
        });

        // console.log(JSON.stringify(objects, null, '  '));

        var bestMatch = objects[0];
        if (bestMatch && bestMatch._similarity >= DEFAULT_WORD_SET_SIMILARITY) {
          return {
            v: bestMatch
          };
        }
      };
      for (var i = 0; i < attrs.length; i++) {
        var _ret = _loop(i);
        switch (_ret) {
          case 'continue':
            continue;
          default:
            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
      }
    }();
    objects.forEach(function (obj) {
      delete obj._descriptor;
      delete obj._similarity;
      delete obj._intersection;
    });
    if (mainItem) {
      // specical case here where we want to inject Breadcrumbs into category
      var category = [];
      if (data.BreadcrumbList) {
        category = data.BreadcrumbList.rows.reduce(function (acc, row) {
          if (row['itemListElement.item.name']) acc.push.apply(acc, _toConsumableArray(row['itemListElement.item.name']));
          return acc;
        }, []);
      }
      if (category.length === 0 && data.Breadcrumb) {
        category = data.Breadcrumb.rows.reduce(function (acc, row) {
          if (row.name) acc.push.apply(acc, _toConsumableArray(row.name));
          return acc;
        }, []);
      }
      if (category.length > 0) {
        mainItem.category = category;
      }
    } else {
      mainItem = null;
    }
    document.__extractedMicroDataTypes[type] = mainItem;
    return mainItem;
  }

  /**
   * Adds microdata from the ld-json into the microdata table
   */
  var processSchemaDotOrgLDJSON = function processSchemaDotOrgLDJSON(url, document, table) {
    var ldjson = Array.from(document.querySelectorAll('script[type="application/ld+json"]'));
    ldjson = ldjson.map(function (j) {
      var json = j.innerHTML.trim();
      try {
        return JSON.parse(json);
      } catch (e) {
        try {
          // try to fix stupid inch measurements wrongly encoded (dabs.com) and newlines inside strings
          json = json.replace(/(\d+\s*)"(?!,|\s*[\]}])/g, '$1\\"').replace(/\n/g, ' ');
          return JSON.parse(json);
        } catch (e) {
          console.error('Malformed ld-json found in page, discarding :(');
        }
      }
    }).filter(function (x) {
      return x;
    });
    addToTable(url, table, ldjson);
  };
  var addToTable = function addToTable(url, table, objects) {
    objects.forEach(function (json) {
      var thisRow = {};
      var type = json['@type'];
      if (/^BreadcrumbList$/i.test(type)) {
        try {
          var items = json.itemListElement.map(function (x) {
            return x.item;
          });
          items.forEach(function (item) {
            return item['@type'] = 'Breadcrumb';
          });
          addToTable(url, table, items);
        } catch (e) {
          console.error(e);
        }
        return;
      }
      flattenSingleItemLdJson(url, json, thisRow, fieldNames);
      if (!table[type]) table[type] = {
        rows: [],
        fieldNames: new Set()
      };
      var fieldNames = table[type].fieldNames;
      table[type].rows.push(thisRow);
      Object.keys(thisRow).forEach(function (key) {
        return fieldNames.add(key);
      });
    });
  };

  /**
   * Flatten the ld-json into a 2D table
   */
  var flattenSingleItemLdJson = function flattenSingleItemLdJson(url, item, row, fieldNames, ctx) {
    fieldNames = fieldNames || new Set();
    row = row || {};
    Object.keys(item).forEach(function (key) {
      var array = item[key];
      if (!array) return;
      if (!Array.isArray(array)) array = [array];
      if (key === '@id') {
        if (item.name || !isUrl(key, array[0])) {
          return;
        }
        key = 'url';
      }
      if (key[0] === '@' || key === 'position') return;
      key = ctx ? ctx + '.' + key : key;
      array.forEach(function (value) {
        var href = void 0,
          alt = void 0,
          imageElt = void 0;
        if (value.localName) {
          // is an element
          href = (0, _extractor.getEnclosingLink)(value, url);
          if (value.tagName === 'IMG') {
            imageElt = true;
            alt = value.getAttribute('alt');
          }
          value = toText(url, key, value);
        }
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
          // recurse into the item
          flattenSingleItemLdJson(url, value, row, fieldNames, key);
          return;
        }
        var obj = {};
        if (imageElt || isUrl(key, value)) {
          if (url) {
            value = (0, _utils.makeUrlAbsolute)(url, value);
          }
          if (imageElt || isImage(key)) {
            obj.src = value;
            if (alt) obj.alt = alt;
          } else {
            obj.href = value;
          }
        } else {
          obj.text = decodeHtml(value);
          if (key === 'name' && isUrl('@id', item['@id'])) {
            obj.href = item['@id'];
          }
        }
        if (!obj.hef && href) {
          obj.href = href;
        }
        add(fieldNames, row, key, obj);
      });
    });
    return {
      fieldNames: Array.from(fieldNames),
      row: row
    };
  };
  var ELEMENT_TEXT_PROP = {
    meta: 'content',
    audio: 'src',
    embed: 'src',
    iframe: 'src',
    img: 'src',
    source: 'src',
    video: 'src',
    object: 'data',
    time: 'datetime'
  };

  /**
   * Convert an element that has microdata to the text for the microdata
   */
  var toText = function toText(url, name, elem) {
    var attr = elem.hasAttribute('content') ? 'content' : ELEMENT_TEXT_PROP[elem.localName];
    if (!attr) return (0, _utils.textContent)(elem);
    var val = elem[attr] || elem.getAttribute(attr);
    if (val == null) {
      val = '';
    }
    if (val) val = val.replace(/\s+/, ' ').trim();
    if (url && (isUrl(name) || attr === 'src' || attr === 'href')) {
      val = (0, _utils.makeUrlAbsolute)(url, val);
    }
    return val;
  };
  var processSchemaDotOrgMicrodata = function processSchemaDotOrgMicrodata(url, document, table) {
    function microdata(scope) {
      scope = scope || document.documentElement;

      // pick something that either has:

      // (1) @itemtype and @itemprop="mainEntity" or "mainEntityOfPage" - these get wrongly used seemingly
      // (2) @itemtype and not @itemprop - top level entity, not an attribute of another entity
      // (3) @itemtype and @itemprop but no @itemscope above it, excluding the body element

      var candidates = (0, _utils.getElementsByXPath)('//*[@itemtype and ( @itemprop="mainEntity" or @itemprop="mainEntityOfPage" or not(@itemprop) or not(ancestor::*[@itemscope][local-name()!="body"]) ) ]', document.documentElement),
        arr = [];

      // for things which are https://schema.org/ItemList, expand them out into the items
      var elems = [];
      candidates.forEach(function (candidate) {
        var type = candidate.getAttribute('itemtype');
        if (/(?:https?:)?\/\/schema.org\/ListItem/i.test(type)) return;
        if (/(?:https?:)?\/\/schema.org\/BreadcrumbList/i.test(type)) {
          var items = (0, _utils.getElementsByXPath)('.//*[@itemprop="itemListElement"]//*[@itemprop="item"]', candidate);
          items.forEach(function (item) {
            return item.setAttribute('itemtype', 'Breadcrumb');
          });
          elems.push.apply(elems, _toConsumableArray(items));
          return;
        }
        elems.push(candidate);
      });
      for (var i = 0, len = elems.length; i < len; i++) {
        arr.push(extract(elems[i]));
      }
      return arr;
    }
    function extract(scope) {
      var type = scope.getAttribute('itemtype');
      if (type) type = type.trim().replace(/^(?:https?:)?\/\/(schema|data-vocabulary).org\//, '');
      var obj = {
          '@type': type
        },
        elems = Array.from(scope.children);
      var elem = void 0,
        key = void 0;
      while (elem = elems.shift()) {
        if (key = elem.getAttribute('itemprop')) {
          add(obj, key, value(elem));
        }
        // if element is not an itemprop but is an itemscope it's some other "thing"
        if (elem.getAttribute('itemscope') === null) {
          elems.unshift.apply(elems, _toConsumableArray(elem.children));
        }
      }
      return obj;
    }
    function add(obj, key, val) {
      if (!val) return;
      var prop = obj[key];
      if (!prop) obj[key] = val;else if (Array.isArray(prop)) prop.push(val);else obj[key] = [prop, val];
    }
    function value(elem) {
      if (elem.getAttribute('itemscope') !== null) {
        return extract(elem);
      }
      return elem;
    }
    var data = microdata();
    addToTable(url, table, data);
  };
  var processMeta = function processMeta(document, table) {
    var row = {};
    var fieldNames = new Set();
    var addMeta = function addMeta(meta) {
      var oname = meta.getAttribute('name');
      if (!oname) oname = meta.getAttribute('property');
      if (!oname) return;
      var name = 'meta.' + oname.replace(/:/g, '.').toLowerCase();
      var value = meta.getAttribute('content');
      if (value) value = value.replace(/\s+/g, ' ').trim();
      if (!value) return;
      var obj = {};
      if (isUrl(name, value)) {
        if (isImage(name)) {
          obj.src = value;
        } else {
          obj.href = value;
        }
      } else {
        obj.text = value;
      }
      add(fieldNames, row, name, obj);
    };
    var metas = Array.from(document.querySelectorAll('meta[name],meta[property]'));
    metas.forEach(addMeta);
    var title = document.querySelector('title');
    if (title && !row['meta.title']) {
      add(fieldNames, row, 'meta.title', {
        text: title.textContent.trim()
      });
    }
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      add(fieldNames, row, 'link.canonical', {
        href: canonical.getAttribute('href')
      });
    }
    if (fieldNames.size) table.meta = {
      rows: [row],
      fieldNames: fieldNames
    };
  };

  /***/
}, /* 18 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.findRegions = findRegions;
  exports.getContainingList = getContainingList;
  var _timer = __webpack_require__(5);
  var _utils = __webpack_require__(1);
  var STOP = {
    'IFRAME': 1,
    'PARAM': 1,
    'U': 1,
    'OBJECT': 1,
    'SELECT': 1,
    'STYLE': 1,
    'STRONG': 1,
    'B': 1,
    'SCRIPT': 1,
    'LINK': 1,
    'META': 1,
    'INPUT': 1,
    'OPTION': 1,
    'BR': 1,
    'BUTTON': 1,
    'LABEL': 1
  };
  var getKey = function getKey(element) {
    var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!element.parentNode) return acc;
    var name = element.nodeType === 3 ? '#text' : element.localName;
    if (!acc) acc = name;else acc = name + ' ' + acc;
    return getKey(element.parentNode, acc);
  };

  // MultiMap<String,Integer>.put
  function addTo(o, s, n) {
    o[s] = n == null ? 1 : (o[s] || 0) + n;
  }
  ;

  // MultiMap<String,Integer>.putAll
  function addAllTo(o, m) {
    for (var s in m) {
      addTo(o, s, m[s]);
    }
  }
  ;

  // (Map|Set|Object).size()
  function sizeOf(o) {
    return Object.keys(o).length;
  }
  ;

  // MultiMap.size()
  function sumOf(o) {
    var c = 0;
    for (var k in o) {
      c += o[k];
    }
    return c;
  }
  ;

  /**
   * Whether or not two styles produced by the region detector are similar
   * enough to be considered the same template
   */
  function similarStyles(s1, s2) {
    var keys = [];
    var count = 0;
    for (var i in s1) {
      if (i === 'size') {
        continue;
      }
      if (i in s2) {
        keys.push(i);
      }
      count++;
    }

    // cache the object sizes
    // TODO: consider using new Map()
    if (s1.size === undefined) s1.size = count;
    if (s2.size === undefined) {
      count = 0;
      for (var _i in s2) {
        if (_i !== 'size') count++;
      } // eslint-disable-line
      s2.size = count;
    }

    // require a 75% match in "styles"
    var required = Math.floor(0.75 * Math.min(s1.size, s2.size));
    var result = keys.length >= required;
    return result;
  }
  var mappedAttributes = new Set(['style', 'itemprop', 'itemscope', 'itemtype', 'typeof', 'property']);

  // qualifying a node by it's environment: level, parent, name, classes, style
  function styleOf(node, level) {
    var style = {};
    if (node.nodeType != 1) return style;
    addTo(style, 'L' + level + ' ' + node.parentNode.nodeName + ' ' + node.nodeName + ':');
    for (var i = 0; i < node.attributes.length; i++) {
      var a = node.attributes.item(i);
      if (a.nodeName == 'class') {
        var cs = a.nodeValue.split(/ /);
        for (var c = 0; c < cs.length; c++) {
          if (cs[c].length > 0) {
            addTo(style, 'L' + level + ' ' + node.parentNode.nodeName + ' ' + node.nodeName + ': ' + a.nodeName + '=' + cs[c]);
          }
        }
      } else if (mappedAttributes.has(a.nodeName)) {
        addTo(style, 'L' + level + ' ' + node.parentNode.nodeName + ' ' + node.nodeName + ': ' + a.nodeName + '=' + a.nodeValue);
      }
    }
    return style;
  }
  ;
  function processRegion(regions, node, level, childTreeStyles) {
    // MultiMap<String,Integer>
    var nodeTreeStyle = {};
    // put all child styles into the bag
    for (var i = 0; i < childTreeStyles.length; i++) {
      addAllTo(nodeTreeStyle, childTreeStyles[i]);
    }
    var region = {
      node: node,
      style: {},
      score: 0
    };
    // remove repeated styles and put them into region.style
    for (var s in nodeTreeStyle) {
      var v = nodeTreeStyle[s];
      if (v > 1) {
        region.style[s] = v;
        delete nodeTreeStyle[s];
      }
    }
    // put back repeated styles as (singular) 'grid' styles, so that repeated grid styles can fire up a region at a higher level
    for (var _s in region.style) {
      addTo(nodeTreeStyle, _s + ' G', 1);
    }
    // remember region if it is a branch (having at least 2 children)
    // score: number of styles * number of occurrence (it's a better score then only one of those)
    // note: this is heuristical. for better scoring we should process text nodes. not sure how slow that would be
    if (childTreeStyles.length >= 1) {
      region.score = sizeOf(region.style) * sumOf(region.style);
      regions.push(region);
    }

    // we only processed the children so far, so also add styles of this node to process in parent levels
    addAllTo(nodeTreeStyle, styleOf(node, level));
    return nodeTreeStyle;
  }
  ;

  // collect to style information top down
  function collectRegions(regions, node, level) {
    var childTreeStyles = [];
    if (!node || STOP[node.tagName]) return {};
    for (var child = node.firstChild; child; child = child.nextSibling) {
      childTreeStyles.push(collectRegions(regions, child, level + 1));
    }
    return processRegion(regions, node, level, childTreeStyles);
  }
  ;
  function findRegions(node) {
    var detectGrids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    /*
       The algorithm here is building up a list of "styles"
       {
        "L10 TD A: class=mw-redirect": 256,
        "L10 TD A: G": 512,
        "L10 TD A: class=external G": 505,
        "L10 TD A: class=text G": 505,
        "L9 TR TD: G": 505,
        "L8 TBODY TR:": 505,
        "L10 TD A: class=mw-redirect G": 100,
        "L10 TD A: class=new": 3,
        "L11 SUP A:": 3,
        "L10 TD SUP:": 3,
        "L10 TD SUP: class=reference": 3
      }
       These styles are effectively the repeating structure of the
      HTML below the node.
       The more signals repeat, the more likely it is that we have
      a repeating structure.
       We score the regions by taking the number of repeated styles (N)
      multiplied by the sum of the repeated styles (S)
       Therefore if there are more children the repeated N would be constant
      but S would be linear with the number of children.
       If there is the same number of children but richer similarity S would
      increase.
       We are also interested in the child of the parent node having "similar"
      children. We can judge similarity by the intersection of the styles.
       If no two children of a region have similar styles we should discount
      that region.
       Finally we optionally detect whether or not it looks like there is a
      grid structure on the page and wieth the scores with the square of the total
      number of matching rows.
     */
    var regionNodes = [];
    collectRegions(regionNodes, node.body ? node.body : node, 1);
    if (regionNodes.length === 0) {
      return new Map();
    }
    (0, _timer.time)('findRegions - postprocess');
    regionNodes.sort(function (a, b) {
      return b.score - a.score;
    });

    // TODO: we could put this in collectRegions
    var children = new Map();
    regionNodes.forEach(function (region) {
      var arr = children.get(region.node.parentNode);
      if (!arr) {
        arr = [];
        children.set(region.node.parentNode, arr);
      }
      arr.push(region);
    });
    regionNodes.forEach(function (region) {
      region.children = children.get(region.node) || [];
    });
    // ENDTODO

    // Filter out any regions with a poor score
    var maxScore = regionNodes.reduce(function (max, val) {
      return max < val.score ? val.score : max;
    }, 0);
    var minScore = maxScore < 100 ? 0 : 10;
    regionNodes = regionNodes.filter(function (region) {
      return region.score > minScore;
    });
    // console.log(regionNodes.map( x => x.node.tagName ));

    // Filter out any regions where no children look similar in styles
    var twoSimilar = function twoSimilar(arr) {
      if (arr.length > 50) arr = arr.slice(0, 50);
      return arr.find(function (x) {
        return arr.find(function (y) {
          if (x === y) return false;
          if (y.node.localName !== x.node.localName) return false;
          if (similarStyles(x.style, y.style)) {
            return true;
          }
        });
      });
    };
    regionNodes = regionNodes.filter(function (a) {
      return a.children.length && twoSimilar(a.children);
    });
    // console.log(regionNodes);

    if (detectGrids) {
      // do a grid detection to bind in all the similar regions into a cumulative score

      // partition regionNodes by xpath without positions, e.g. /div/div/div
      var lookup = {};
      regionNodes.forEach(function (region) {
        var key = getKey(region.node);
        if (!lookup[key]) lookup[key] = [];
        lookup[key].push(region);
      });
      var adjustScoreWithoutGridRegions = function adjustScoreWithoutGridRegions(region) {
        region.score *= region.children.length * region.children.length;
        region.linkedRegions = [region];
      };

      // for each set of region nodes in a partition...
      Object.keys(lookup).forEach(function (key) {
        var regions = lookup[key];

        // if there's only one thing in the partition
        if (regions.length === 1) {
          adjustScoreWithoutGridRegions(regions[0]);
          return;
        }

        // partition again, this time based on if the styles are "similar"
        // that would imply that the regions look similar in structure
        var partitions = [];
        regions.forEach(function (region) {
          for (var i = 0; i < partitions.length; i++) {
            var p = partitions[i];
            if (similarStyles(p[0].style, region.style)) {
              p.push(region);
              return;
            }
          }
          partitions.push([region]);
        });
        var gridBoost = 2;
        partitions.forEach(function (partition) {
          // if there's only one partition treat it the same
          if (partition.length == 1) {
            adjustScoreWithoutGridRegions(partition[0]);
            return;
          }

          // adjust score for grid
          var totalScore = partition.reduce(function (sum, region) {
            return sum + region.score;
          }, 0) * gridBoost;
          var totalRows = partition.reduce(function (sum, region) {
            return sum + region.children.length;
          }, 0);
          var score = totalScore * totalRows * totalRows;
          partition.forEach(function (region) {
            region.score = score;
            region.rows = totalRows;
            region.linkedRegions = partition;
          });
        });
      });
    }

    // console.log(regionNodes);

    var map = new Map();
    regionNodes.forEach(function (r) {
      map.set(r.node, r);
    });
    (0, _timer.timeEnd)('findRegions - postprocess');
    return map;
  }
  ;
  function structuralXPath(element, relativeTo) {
    var names = [];
    var el = element;
    while (el !== relativeTo) {
      if (el === el.ownerDocument.documentElement) names.unshift(el.localName);else {
        var c = 1;
        for (var e = el.previousSibling; e; e = e.previousSibling) {
          if (e.localName === el.localName) c++;
        }
        var part = el.localName;
        if (part.indexOf(':') > 0) part = '*[local-name()=\'' + part + '\']';
        // we want the first not to be tied to a position
        if (el.parentNode !== relativeTo) part += '[' + c + ']';
        names.unshift(part);
      }
      el = el.parentNode;
    }
    var sel = './' + names.join('/');
    return sel;
  }
  ;

  /**
   * Return what list element (if any) we think the node is within.
   * We assume that what is clicked is repeated in multiple "rows"
   */
  function getContainingList(clickedElement) {
    var document = clickedElement.ownerDocument;

    // get all the regions on the page
    var regions = findRegions(document, false);

    // initially
    var potentialRegions = [];
    var n = clickedElement.parentNode;
    do {
      var region = regions.get(n);
      if (region) potentialRegions.push(region);
    } while ((n = n.parentNode) !== document.documentElement);

    // sort, best score first
    potentialRegions = potentialRegions.sort(function (a, b) {
      return b.score - a.score;
    });

    // calculate what the xpath is for the clicked element relative to the potential region
    // but generalise it on the first position, i.e. get the xpath for that data element
    // in each list item
    potentialRegions.forEach(function (r) {
      return r.xpath = structuralXPath(clickedElement, r.node);
    });

    // filter the regions such that we only have ones where it looks like more tryWithoutPositionAndId
    // one data points corresponding to the clicked data point exist
    potentialRegions = potentialRegions.filter(function (r) {
      return (0, _utils.getElementsByXPath)(r.xpath, r.node).length > 1;
    });
    if (!potentialRegions.length) return undefined;
    var tbody = potentialRegions.find(function (r) {
      return r.node.tagName === 'TBODY';
    });
    if (tbody) return tbody.node;
    return potentialRegions[0].node;
  }

  /***/
}, /* 19 */
/***/function (module, exports) {
  module.exports = {
    "Aacute": "Á",
    "aacute": "á",
    "Abreve": "Ă",
    "abreve": "ă",
    "ac": "∾",
    "acd": "∿",
    "acE": "∾̳",
    "Acirc": "Â",
    "acirc": "â",
    "acute": "´",
    "Acy": "А",
    "acy": "а",
    "AElig": "Æ",
    "aelig": "æ",
    "af": "⁡",
    "Afr": "𝔄",
    "afr": "𝔞",
    "Agrave": "À",
    "agrave": "à",
    "alefsym": "ℵ",
    "aleph": "ℵ",
    "Alpha": "Α",
    "alpha": "α",
    "Amacr": "Ā",
    "amacr": "ā",
    "amalg": "⨿",
    "amp": "&",
    "AMP": "&",
    "andand": "⩕",
    "And": "⩓",
    "and": "∧",
    "andd": "⩜",
    "andslope": "⩘",
    "andv": "⩚",
    "ang": "∠",
    "ange": "⦤",
    "angle": "∠",
    "angmsdaa": "⦨",
    "angmsdab": "⦩",
    "angmsdac": "⦪",
    "angmsdad": "⦫",
    "angmsdae": "⦬",
    "angmsdaf": "⦭",
    "angmsdag": "⦮",
    "angmsdah": "⦯",
    "angmsd": "∡",
    "angrt": "∟",
    "angrtvb": "⊾",
    "angrtvbd": "⦝",
    "angsph": "∢",
    "angst": "Å",
    "angzarr": "⍼",
    "Aogon": "Ą",
    "aogon": "ą",
    "Aopf": "𝔸",
    "aopf": "𝕒",
    "apacir": "⩯",
    "ap": "≈",
    "apE": "⩰",
    "ape": "≊",
    "apid": "≋",
    "apos": "'",
    "ApplyFunction": "⁡",
    "approx": "≈",
    "approxeq": "≊",
    "Aring": "Å",
    "aring": "å",
    "Ascr": "𝒜",
    "ascr": "𝒶",
    "Assign": "≔",
    "ast": "*",
    "asymp": "≈",
    "asympeq": "≍",
    "Atilde": "Ã",
    "atilde": "ã",
    "Auml": "Ä",
    "auml": "ä",
    "awconint": "∳",
    "awint": "⨑",
    "backcong": "≌",
    "backepsilon": "϶",
    "backprime": "‵",
    "backsim": "∽",
    "backsimeq": "⋍",
    "Backslash": "∖",
    "Barv": "⫧",
    "barvee": "⊽",
    "barwed": "⌅",
    "Barwed": "⌆",
    "barwedge": "⌅",
    "bbrk": "⎵",
    "bbrktbrk": "⎶",
    "bcong": "≌",
    "Bcy": "Б",
    "bcy": "б",
    "bdquo": "„",
    "becaus": "∵",
    "because": "∵",
    "Because": "∵",
    "bemptyv": "⦰",
    "bepsi": "϶",
    "bernou": "ℬ",
    "Bernoullis": "ℬ",
    "Beta": "Β",
    "beta": "β",
    "beth": "ℶ",
    "between": "≬",
    "Bfr": "𝔅",
    "bfr": "𝔟",
    "bigcap": "⋂",
    "bigcirc": "◯",
    "bigcup": "⋃",
    "bigodot": "⨀",
    "bigoplus": "⨁",
    "bigotimes": "⨂",
    "bigsqcup": "⨆",
    "bigstar": "★",
    "bigtriangledown": "▽",
    "bigtriangleup": "△",
    "biguplus": "⨄",
    "bigvee": "⋁",
    "bigwedge": "⋀",
    "bkarow": "⤍",
    "blacklozenge": "⧫",
    "blacksquare": "▪",
    "blacktriangle": "▴",
    "blacktriangledown": "▾",
    "blacktriangleleft": "◂",
    "blacktriangleright": "▸",
    "blank": "␣",
    "blk12": "▒",
    "blk14": "░",
    "blk34": "▓",
    "block": "█",
    "bne": "=⃥",
    "bnequiv": "≡⃥",
    "bNot": "⫭",
    "bnot": "⌐",
    "Bopf": "𝔹",
    "bopf": "𝕓",
    "bot": "⊥",
    "bottom": "⊥",
    "bowtie": "⋈",
    "boxbox": "⧉",
    "boxdl": "┐",
    "boxdL": "╕",
    "boxDl": "╖",
    "boxDL": "╗",
    "boxdr": "┌",
    "boxdR": "╒",
    "boxDr": "╓",
    "boxDR": "╔",
    "boxh": "─",
    "boxH": "═",
    "boxhd": "┬",
    "boxHd": "╤",
    "boxhD": "╥",
    "boxHD": "╦",
    "boxhu": "┴",
    "boxHu": "╧",
    "boxhU": "╨",
    "boxHU": "╩",
    "boxminus": "⊟",
    "boxplus": "⊞",
    "boxtimes": "⊠",
    "boxul": "┘",
    "boxuL": "╛",
    "boxUl": "╜",
    "boxUL": "╝",
    "boxur": "└",
    "boxuR": "╘",
    "boxUr": "╙",
    "boxUR": "╚",
    "boxv": "│",
    "boxV": "║",
    "boxvh": "┼",
    "boxvH": "╪",
    "boxVh": "╫",
    "boxVH": "╬",
    "boxvl": "┤",
    "boxvL": "╡",
    "boxVl": "╢",
    "boxVL": "╣",
    "boxvr": "├",
    "boxvR": "╞",
    "boxVr": "╟",
    "boxVR": "╠",
    "bprime": "‵",
    "breve": "˘",
    "Breve": "˘",
    "brvbar": "¦",
    "bscr": "𝒷",
    "Bscr": "ℬ",
    "bsemi": "⁏",
    "bsim": "∽",
    "bsime": "⋍",
    "bsolb": "⧅",
    "bsol": "\\",
    "bsolhsub": "⟈",
    "bull": "•",
    "bullet": "•",
    "bump": "≎",
    "bumpE": "⪮",
    "bumpe": "≏",
    "Bumpeq": "≎",
    "bumpeq": "≏",
    "Cacute": "Ć",
    "cacute": "ć",
    "capand": "⩄",
    "capbrcup": "⩉",
    "capcap": "⩋",
    "cap": "∩",
    "Cap": "⋒",
    "capcup": "⩇",
    "capdot": "⩀",
    "CapitalDifferentialD": "ⅅ",
    "caps": "∩︀",
    "caret": "⁁",
    "caron": "ˇ",
    "Cayleys": "ℭ",
    "ccaps": "⩍",
    "Ccaron": "Č",
    "ccaron": "č",
    "Ccedil": "Ç",
    "ccedil": "ç",
    "Ccirc": "Ĉ",
    "ccirc": "ĉ",
    "Cconint": "∰",
    "ccups": "⩌",
    "ccupssm": "⩐",
    "Cdot": "Ċ",
    "cdot": "ċ",
    "cedil": "¸",
    "Cedilla": "¸",
    "cemptyv": "⦲",
    "cent": "¢",
    "centerdot": "·",
    "CenterDot": "·",
    "cfr": "𝔠",
    "Cfr": "ℭ",
    "CHcy": "Ч",
    "chcy": "ч",
    "check": "✓",
    "checkmark": "✓",
    "Chi": "Χ",
    "chi": "χ",
    "circ": "ˆ",
    "circeq": "≗",
    "circlearrowleft": "↺",
    "circlearrowright": "↻",
    "circledast": "⊛",
    "circledcirc": "⊚",
    "circleddash": "⊝",
    "CircleDot": "⊙",
    "circledR": "®",
    "circledS": "Ⓢ",
    "CircleMinus": "⊖",
    "CirclePlus": "⊕",
    "CircleTimes": "⊗",
    "cir": "○",
    "cirE": "⧃",
    "cire": "≗",
    "cirfnint": "⨐",
    "cirmid": "⫯",
    "cirscir": "⧂",
    "ClockwiseContourIntegral": "∲",
    "CloseCurlyDoubleQuote": "”",
    "CloseCurlyQuote": "’",
    "clubs": "♣",
    "clubsuit": "♣",
    "colon": ":",
    "Colon": "∷",
    "Colone": "⩴",
    "colone": "≔",
    "coloneq": "≔",
    "comma": ",",
    "commat": "@",
    "comp": "∁",
    "compfn": "∘",
    "complement": "∁",
    "complexes": "ℂ",
    "cong": "≅",
    "congdot": "⩭",
    "Congruent": "≡",
    "conint": "∮",
    "Conint": "∯",
    "ContourIntegral": "∮",
    "copf": "𝕔",
    "Copf": "ℂ",
    "coprod": "∐",
    "Coproduct": "∐",
    "copy": "©",
    "COPY": "©",
    "copysr": "℗",
    "CounterClockwiseContourIntegral": "∳",
    "crarr": "↵",
    "cross": "✗",
    "Cross": "⨯",
    "Cscr": "𝒞",
    "cscr": "𝒸",
    "csub": "⫏",
    "csube": "⫑",
    "csup": "⫐",
    "csupe": "⫒",
    "ctdot": "⋯",
    "cudarrl": "⤸",
    "cudarrr": "⤵",
    "cuepr": "⋞",
    "cuesc": "⋟",
    "cularr": "↶",
    "cularrp": "⤽",
    "cupbrcap": "⩈",
    "cupcap": "⩆",
    "CupCap": "≍",
    "cup": "∪",
    "Cup": "⋓",
    "cupcup": "⩊",
    "cupdot": "⊍",
    "cupor": "⩅",
    "cups": "∪︀",
    "curarr": "↷",
    "curarrm": "⤼",
    "curlyeqprec": "⋞",
    "curlyeqsucc": "⋟",
    "curlyvee": "⋎",
    "curlywedge": "⋏",
    "curren": "¤",
    "curvearrowleft": "↶",
    "curvearrowright": "↷",
    "cuvee": "⋎",
    "cuwed": "⋏",
    "cwconint": "∲",
    "cwint": "∱",
    "cylcty": "⌭",
    "dagger": "†",
    "Dagger": "‡",
    "daleth": "ℸ",
    "darr": "↓",
    "Darr": "↡",
    "dArr": "⇓",
    "dash": "‐",
    "Dashv": "⫤",
    "dashv": "⊣",
    "dbkarow": "⤏",
    "dblac": "˝",
    "Dcaron": "Ď",
    "dcaron": "ď",
    "Dcy": "Д",
    "dcy": "д",
    "ddagger": "‡",
    "ddarr": "⇊",
    "DD": "ⅅ",
    "dd": "ⅆ",
    "DDotrahd": "⤑",
    "ddotseq": "⩷",
    "deg": "°",
    "Del": "∇",
    "Delta": "Δ",
    "delta": "δ",
    "demptyv": "⦱",
    "dfisht": "⥿",
    "Dfr": "𝔇",
    "dfr": "𝔡",
    "dHar": "⥥",
    "dharl": "⇃",
    "dharr": "⇂",
    "DiacriticalAcute": "´",
    "DiacriticalDot": "˙",
    "DiacriticalDoubleAcute": "˝",
    "DiacriticalGrave": "`",
    "DiacriticalTilde": "˜",
    "diam": "⋄",
    "diamond": "⋄",
    "Diamond": "⋄",
    "diamondsuit": "♦",
    "diams": "♦",
    "die": "¨",
    "DifferentialD": "ⅆ",
    "digamma": "ϝ",
    "disin": "⋲",
    "div": "÷",
    "divide": "÷",
    "divideontimes": "⋇",
    "divonx": "⋇",
    "DJcy": "Ђ",
    "djcy": "ђ",
    "dlcorn": "⌞",
    "dlcrop": "⌍",
    "dollar": "$",
    "Dopf": "𝔻",
    "dopf": "𝕕",
    "Dot": "¨",
    "dot": "˙",
    "DotDot": "⃜",
    "doteq": "≐",
    "doteqdot": "≑",
    "DotEqual": "≐",
    "dotminus": "∸",
    "dotplus": "∔",
    "dotsquare": "⊡",
    "doublebarwedge": "⌆",
    "DoubleContourIntegral": "∯",
    "DoubleDot": "¨",
    "DoubleDownArrow": "⇓",
    "DoubleLeftArrow": "⇐",
    "DoubleLeftRightArrow": "⇔",
    "DoubleLeftTee": "⫤",
    "DoubleLongLeftArrow": "⟸",
    "DoubleLongLeftRightArrow": "⟺",
    "DoubleLongRightArrow": "⟹",
    "DoubleRightArrow": "⇒",
    "DoubleRightTee": "⊨",
    "DoubleUpArrow": "⇑",
    "DoubleUpDownArrow": "⇕",
    "DoubleVerticalBar": "∥",
    "DownArrowBar": "⤓",
    "downarrow": "↓",
    "DownArrow": "↓",
    "Downarrow": "⇓",
    "DownArrowUpArrow": "⇵",
    "DownBreve": "̑",
    "downdownarrows": "⇊",
    "downharpoonleft": "⇃",
    "downharpoonright": "⇂",
    "DownLeftRightVector": "⥐",
    "DownLeftTeeVector": "⥞",
    "DownLeftVectorBar": "⥖",
    "DownLeftVector": "↽",
    "DownRightTeeVector": "⥟",
    "DownRightVectorBar": "⥗",
    "DownRightVector": "⇁",
    "DownTeeArrow": "↧",
    "DownTee": "⊤",
    "drbkarow": "⤐",
    "drcorn": "⌟",
    "drcrop": "⌌",
    "Dscr": "𝒟",
    "dscr": "𝒹",
    "DScy": "Ѕ",
    "dscy": "ѕ",
    "dsol": "⧶",
    "Dstrok": "Đ",
    "dstrok": "đ",
    "dtdot": "⋱",
    "dtri": "▿",
    "dtrif": "▾",
    "duarr": "⇵",
    "duhar": "⥯",
    "dwangle": "⦦",
    "DZcy": "Џ",
    "dzcy": "џ",
    "dzigrarr": "⟿",
    "Eacute": "É",
    "eacute": "é",
    "easter": "⩮",
    "Ecaron": "Ě",
    "ecaron": "ě",
    "Ecirc": "Ê",
    "ecirc": "ê",
    "ecir": "≖",
    "ecolon": "≕",
    "Ecy": "Э",
    "ecy": "э",
    "eDDot": "⩷",
    "Edot": "Ė",
    "edot": "ė",
    "eDot": "≑",
    "ee": "ⅇ",
    "efDot": "≒",
    "Efr": "𝔈",
    "efr": "𝔢",
    "eg": "⪚",
    "Egrave": "È",
    "egrave": "è",
    "egs": "⪖",
    "egsdot": "⪘",
    "el": "⪙",
    "Element": "∈",
    "elinters": "⏧",
    "ell": "ℓ",
    "els": "⪕",
    "elsdot": "⪗",
    "Emacr": "Ē",
    "emacr": "ē",
    "empty": "∅",
    "emptyset": "∅",
    "EmptySmallSquare": "◻",
    "emptyv": "∅",
    "EmptyVerySmallSquare": "▫",
    "emsp13": " ",
    "emsp14": " ",
    "emsp": " ",
    "ENG": "Ŋ",
    "eng": "ŋ",
    "ensp": " ",
    "Eogon": "Ę",
    "eogon": "ę",
    "Eopf": "𝔼",
    "eopf": "𝕖",
    "epar": "⋕",
    "eparsl": "⧣",
    "eplus": "⩱",
    "epsi": "ε",
    "Epsilon": "Ε",
    "epsilon": "ε",
    "epsiv": "ϵ",
    "eqcirc": "≖",
    "eqcolon": "≕",
    "eqsim": "≂",
    "eqslantgtr": "⪖",
    "eqslantless": "⪕",
    "Equal": "⩵",
    "equals": "=",
    "EqualTilde": "≂",
    "equest": "≟",
    "Equilibrium": "⇌",
    "equiv": "≡",
    "equivDD": "⩸",
    "eqvparsl": "⧥",
    "erarr": "⥱",
    "erDot": "≓",
    "escr": "ℯ",
    "Escr": "ℰ",
    "esdot": "≐",
    "Esim": "⩳",
    "esim": "≂",
    "Eta": "Η",
    "eta": "η",
    "ETH": "Ð",
    "eth": "ð",
    "Euml": "Ë",
    "euml": "ë",
    "euro": "€",
    "excl": "!",
    "exist": "∃",
    "Exists": "∃",
    "expectation": "ℰ",
    "exponentiale": "ⅇ",
    "ExponentialE": "ⅇ",
    "fallingdotseq": "≒",
    "Fcy": "Ф",
    "fcy": "ф",
    "female": "♀",
    "ffilig": "ﬃ",
    "fflig": "ﬀ",
    "ffllig": "ﬄ",
    "Ffr": "𝔉",
    "ffr": "𝔣",
    "filig": "ﬁ",
    "FilledSmallSquare": "◼",
    "FilledVerySmallSquare": "▪",
    "fjlig": "fj",
    "flat": "♭",
    "fllig": "ﬂ",
    "fltns": "▱",
    "fnof": "ƒ",
    "Fopf": "𝔽",
    "fopf": "𝕗",
    "forall": "∀",
    "ForAll": "∀",
    "fork": "⋔",
    "forkv": "⫙",
    "Fouriertrf": "ℱ",
    "fpartint": "⨍",
    "frac12": "½",
    "frac13": "⅓",
    "frac14": "¼",
    "frac15": "⅕",
    "frac16": "⅙",
    "frac18": "⅛",
    "frac23": "⅔",
    "frac25": "⅖",
    "frac34": "¾",
    "frac35": "⅗",
    "frac38": "⅜",
    "frac45": "⅘",
    "frac56": "⅚",
    "frac58": "⅝",
    "frac78": "⅞",
    "frasl": "⁄",
    "frown": "⌢",
    "fscr": "𝒻",
    "Fscr": "ℱ",
    "gacute": "ǵ",
    "Gamma": "Γ",
    "gamma": "γ",
    "Gammad": "Ϝ",
    "gammad": "ϝ",
    "gap": "⪆",
    "Gbreve": "Ğ",
    "gbreve": "ğ",
    "Gcedil": "Ģ",
    "Gcirc": "Ĝ",
    "gcirc": "ĝ",
    "Gcy": "Г",
    "gcy": "г",
    "Gdot": "Ġ",
    "gdot": "ġ",
    "ge": "≥",
    "gE": "≧",
    "gEl": "⪌",
    "gel": "⋛",
    "geq": "≥",
    "geqq": "≧",
    "geqslant": "⩾",
    "gescc": "⪩",
    "ges": "⩾",
    "gesdot": "⪀",
    "gesdoto": "⪂",
    "gesdotol": "⪄",
    "gesl": "⋛︀",
    "gesles": "⪔",
    "Gfr": "𝔊",
    "gfr": "𝔤",
    "gg": "≫",
    "Gg": "⋙",
    "ggg": "⋙",
    "gimel": "ℷ",
    "GJcy": "Ѓ",
    "gjcy": "ѓ",
    "gla": "⪥",
    "gl": "≷",
    "glE": "⪒",
    "glj": "⪤",
    "gnap": "⪊",
    "gnapprox": "⪊",
    "gne": "⪈",
    "gnE": "≩",
    "gneq": "⪈",
    "gneqq": "≩",
    "gnsim": "⋧",
    "Gopf": "𝔾",
    "gopf": "𝕘",
    "grave": "`",
    "GreaterEqual": "≥",
    "GreaterEqualLess": "⋛",
    "GreaterFullEqual": "≧",
    "GreaterGreater": "⪢",
    "GreaterLess": "≷",
    "GreaterSlantEqual": "⩾",
    "GreaterTilde": "≳",
    "Gscr": "𝒢",
    "gscr": "ℊ",
    "gsim": "≳",
    "gsime": "⪎",
    "gsiml": "⪐",
    "gtcc": "⪧",
    "gtcir": "⩺",
    "gt": ">",
    "GT": ">",
    "Gt": "≫",
    "gtdot": "⋗",
    "gtlPar": "⦕",
    "gtquest": "⩼",
    "gtrapprox": "⪆",
    "gtrarr": "⥸",
    "gtrdot": "⋗",
    "gtreqless": "⋛",
    "gtreqqless": "⪌",
    "gtrless": "≷",
    "gtrsim": "≳",
    "gvertneqq": "≩︀",
    "gvnE": "≩︀",
    "Hacek": "ˇ",
    "hairsp": " ",
    "half": "½",
    "hamilt": "ℋ",
    "HARDcy": "Ъ",
    "hardcy": "ъ",
    "harrcir": "⥈",
    "harr": "↔",
    "hArr": "⇔",
    "harrw": "↭",
    "Hat": "^",
    "hbar": "ℏ",
    "Hcirc": "Ĥ",
    "hcirc": "ĥ",
    "hearts": "♥",
    "heartsuit": "♥",
    "hellip": "…",
    "hercon": "⊹",
    "hfr": "𝔥",
    "Hfr": "ℌ",
    "HilbertSpace": "ℋ",
    "hksearow": "⤥",
    "hkswarow": "⤦",
    "hoarr": "⇿",
    "homtht": "∻",
    "hookleftarrow": "↩",
    "hookrightarrow": "↪",
    "hopf": "𝕙",
    "Hopf": "ℍ",
    "horbar": "―",
    "HorizontalLine": "─",
    "hscr": "𝒽",
    "Hscr": "ℋ",
    "hslash": "ℏ",
    "Hstrok": "Ħ",
    "hstrok": "ħ",
    "HumpDownHump": "≎",
    "HumpEqual": "≏",
    "hybull": "⁃",
    "hyphen": "‐",
    "Iacute": "Í",
    "iacute": "í",
    "ic": "⁣",
    "Icirc": "Î",
    "icirc": "î",
    "Icy": "И",
    "icy": "и",
    "Idot": "İ",
    "IEcy": "Е",
    "iecy": "е",
    "iexcl": "¡",
    "iff": "⇔",
    "ifr": "𝔦",
    "Ifr": "ℑ",
    "Igrave": "Ì",
    "igrave": "ì",
    "ii": "ⅈ",
    "iiiint": "⨌",
    "iiint": "∭",
    "iinfin": "⧜",
    "iiota": "℩",
    "IJlig": "Ĳ",
    "ijlig": "ĳ",
    "Imacr": "Ī",
    "imacr": "ī",
    "image": "ℑ",
    "ImaginaryI": "ⅈ",
    "imagline": "ℐ",
    "imagpart": "ℑ",
    "imath": "ı",
    "Im": "ℑ",
    "imof": "⊷",
    "imped": "Ƶ",
    "Implies": "⇒",
    "incare": "℅",
    "in": "∈",
    "infin": "∞",
    "infintie": "⧝",
    "inodot": "ı",
    "intcal": "⊺",
    "int": "∫",
    "Int": "∬",
    "integers": "ℤ",
    "Integral": "∫",
    "intercal": "⊺",
    "Intersection": "⋂",
    "intlarhk": "⨗",
    "intprod": "⨼",
    "InvisibleComma": "⁣",
    "InvisibleTimes": "⁢",
    "IOcy": "Ё",
    "iocy": "ё",
    "Iogon": "Į",
    "iogon": "į",
    "Iopf": "𝕀",
    "iopf": "𝕚",
    "Iota": "Ι",
    "iota": "ι",
    "iprod": "⨼",
    "iquest": "¿",
    "iscr": "𝒾",
    "Iscr": "ℐ",
    "isin": "∈",
    "isindot": "⋵",
    "isinE": "⋹",
    "isins": "⋴",
    "isinsv": "⋳",
    "isinv": "∈",
    "it": "⁢",
    "Itilde": "Ĩ",
    "itilde": "ĩ",
    "Iukcy": "І",
    "iukcy": "і",
    "Iuml": "Ï",
    "iuml": "ï",
    "Jcirc": "Ĵ",
    "jcirc": "ĵ",
    "Jcy": "Й",
    "jcy": "й",
    "Jfr": "𝔍",
    "jfr": "𝔧",
    "jmath": "ȷ",
    "Jopf": "𝕁",
    "jopf": "𝕛",
    "Jscr": "𝒥",
    "jscr": "𝒿",
    "Jsercy": "Ј",
    "jsercy": "ј",
    "Jukcy": "Є",
    "jukcy": "є",
    "Kappa": "Κ",
    "kappa": "κ",
    "kappav": "ϰ",
    "Kcedil": "Ķ",
    "kcedil": "ķ",
    "Kcy": "К",
    "kcy": "к",
    "Kfr": "𝔎",
    "kfr": "𝔨",
    "kgreen": "ĸ",
    "KHcy": "Х",
    "khcy": "х",
    "KJcy": "Ќ",
    "kjcy": "ќ",
    "Kopf": "𝕂",
    "kopf": "𝕜",
    "Kscr": "𝒦",
    "kscr": "𝓀",
    "lAarr": "⇚",
    "Lacute": "Ĺ",
    "lacute": "ĺ",
    "laemptyv": "⦴",
    "lagran": "ℒ",
    "Lambda": "Λ",
    "lambda": "λ",
    "lang": "⟨",
    "Lang": "⟪",
    "langd": "⦑",
    "langle": "⟨",
    "lap": "⪅",
    "Laplacetrf": "ℒ",
    "laquo": "«",
    "larrb": "⇤",
    "larrbfs": "⤟",
    "larr": "←",
    "Larr": "↞",
    "lArr": "⇐",
    "larrfs": "⤝",
    "larrhk": "↩",
    "larrlp": "↫",
    "larrpl": "⤹",
    "larrsim": "⥳",
    "larrtl": "↢",
    "latail": "⤙",
    "lAtail": "⤛",
    "lat": "⪫",
    "late": "⪭",
    "lates": "⪭︀",
    "lbarr": "⤌",
    "lBarr": "⤎",
    "lbbrk": "❲",
    "lbrace": "{",
    "lbrack": "[",
    "lbrke": "⦋",
    "lbrksld": "⦏",
    "lbrkslu": "⦍",
    "Lcaron": "Ľ",
    "lcaron": "ľ",
    "Lcedil": "Ļ",
    "lcedil": "ļ",
    "lceil": "⌈",
    "lcub": "{",
    "Lcy": "Л",
    "lcy": "л",
    "ldca": "⤶",
    "ldquo": "“",
    "ldquor": "„",
    "ldrdhar": "⥧",
    "ldrushar": "⥋",
    "ldsh": "↲",
    "le": "≤",
    "lE": "≦",
    "LeftAngleBracket": "⟨",
    "LeftArrowBar": "⇤",
    "leftarrow": "←",
    "LeftArrow": "←",
    "Leftarrow": "⇐",
    "LeftArrowRightArrow": "⇆",
    "leftarrowtail": "↢",
    "LeftCeiling": "⌈",
    "LeftDoubleBracket": "⟦",
    "LeftDownTeeVector": "⥡",
    "LeftDownVectorBar": "⥙",
    "LeftDownVector": "⇃",
    "LeftFloor": "⌊",
    "leftharpoondown": "↽",
    "leftharpoonup": "↼",
    "leftleftarrows": "⇇",
    "leftrightarrow": "↔",
    "LeftRightArrow": "↔",
    "Leftrightarrow": "⇔",
    "leftrightarrows": "⇆",
    "leftrightharpoons": "⇋",
    "leftrightsquigarrow": "↭",
    "LeftRightVector": "⥎",
    "LeftTeeArrow": "↤",
    "LeftTee": "⊣",
    "LeftTeeVector": "⥚",
    "leftthreetimes": "⋋",
    "LeftTriangleBar": "⧏",
    "LeftTriangle": "⊲",
    "LeftTriangleEqual": "⊴",
    "LeftUpDownVector": "⥑",
    "LeftUpTeeVector": "⥠",
    "LeftUpVectorBar": "⥘",
    "LeftUpVector": "↿",
    "LeftVectorBar": "⥒",
    "LeftVector": "↼",
    "lEg": "⪋",
    "leg": "⋚",
    "leq": "≤",
    "leqq": "≦",
    "leqslant": "⩽",
    "lescc": "⪨",
    "les": "⩽",
    "lesdot": "⩿",
    "lesdoto": "⪁",
    "lesdotor": "⪃",
    "lesg": "⋚︀",
    "lesges": "⪓",
    "lessapprox": "⪅",
    "lessdot": "⋖",
    "lesseqgtr": "⋚",
    "lesseqqgtr": "⪋",
    "LessEqualGreater": "⋚",
    "LessFullEqual": "≦",
    "LessGreater": "≶",
    "lessgtr": "≶",
    "LessLess": "⪡",
    "lesssim": "≲",
    "LessSlantEqual": "⩽",
    "LessTilde": "≲",
    "lfisht": "⥼",
    "lfloor": "⌊",
    "Lfr": "𝔏",
    "lfr": "𝔩",
    "lg": "≶",
    "lgE": "⪑",
    "lHar": "⥢",
    "lhard": "↽",
    "lharu": "↼",
    "lharul": "⥪",
    "lhblk": "▄",
    "LJcy": "Љ",
    "ljcy": "љ",
    "llarr": "⇇",
    "ll": "≪",
    "Ll": "⋘",
    "llcorner": "⌞",
    "Lleftarrow": "⇚",
    "llhard": "⥫",
    "lltri": "◺",
    "Lmidot": "Ŀ",
    "lmidot": "ŀ",
    "lmoustache": "⎰",
    "lmoust": "⎰",
    "lnap": "⪉",
    "lnapprox": "⪉",
    "lne": "⪇",
    "lnE": "≨",
    "lneq": "⪇",
    "lneqq": "≨",
    "lnsim": "⋦",
    "loang": "⟬",
    "loarr": "⇽",
    "lobrk": "⟦",
    "longleftarrow": "⟵",
    "LongLeftArrow": "⟵",
    "Longleftarrow": "⟸",
    "longleftrightarrow": "⟷",
    "LongLeftRightArrow": "⟷",
    "Longleftrightarrow": "⟺",
    "longmapsto": "⟼",
    "longrightarrow": "⟶",
    "LongRightArrow": "⟶",
    "Longrightarrow": "⟹",
    "looparrowleft": "↫",
    "looparrowright": "↬",
    "lopar": "⦅",
    "Lopf": "𝕃",
    "lopf": "𝕝",
    "loplus": "⨭",
    "lotimes": "⨴",
    "lowast": "∗",
    "lowbar": "_",
    "LowerLeftArrow": "↙",
    "LowerRightArrow": "↘",
    "loz": "◊",
    "lozenge": "◊",
    "lozf": "⧫",
    "lpar": "(",
    "lparlt": "⦓",
    "lrarr": "⇆",
    "lrcorner": "⌟",
    "lrhar": "⇋",
    "lrhard": "⥭",
    "lrm": "‎",
    "lrtri": "⊿",
    "lsaquo": "‹",
    "lscr": "𝓁",
    "Lscr": "ℒ",
    "lsh": "↰",
    "Lsh": "↰",
    "lsim": "≲",
    "lsime": "⪍",
    "lsimg": "⪏",
    "lsqb": "[",
    "lsquo": "‘",
    "lsquor": "‚",
    "Lstrok": "Ł",
    "lstrok": "ł",
    "ltcc": "⪦",
    "ltcir": "⩹",
    "lt": "<",
    "LT": "<",
    "Lt": "≪",
    "ltdot": "⋖",
    "lthree": "⋋",
    "ltimes": "⋉",
    "ltlarr": "⥶",
    "ltquest": "⩻",
    "ltri": "◃",
    "ltrie": "⊴",
    "ltrif": "◂",
    "ltrPar": "⦖",
    "lurdshar": "⥊",
    "luruhar": "⥦",
    "lvertneqq": "≨︀",
    "lvnE": "≨︀",
    "macr": "¯",
    "male": "♂",
    "malt": "✠",
    "maltese": "✠",
    "Map": "⤅",
    "map": "↦",
    "mapsto": "↦",
    "mapstodown": "↧",
    "mapstoleft": "↤",
    "mapstoup": "↥",
    "marker": "▮",
    "mcomma": "⨩",
    "Mcy": "М",
    "mcy": "м",
    "mdash": "—",
    "mDDot": "∺",
    "measuredangle": "∡",
    "MediumSpace": " ",
    "Mellintrf": "ℳ",
    "Mfr": "𝔐",
    "mfr": "𝔪",
    "mho": "℧",
    "micro": "µ",
    "midast": "*",
    "midcir": "⫰",
    "mid": "∣",
    "middot": "·",
    "minusb": "⊟",
    "minus": "−",
    "minusd": "∸",
    "minusdu": "⨪",
    "MinusPlus": "∓",
    "mlcp": "⫛",
    "mldr": "…",
    "mnplus": "∓",
    "models": "⊧",
    "Mopf": "𝕄",
    "mopf": "𝕞",
    "mp": "∓",
    "mscr": "𝓂",
    "Mscr": "ℳ",
    "mstpos": "∾",
    "Mu": "Μ",
    "mu": "μ",
    "multimap": "⊸",
    "mumap": "⊸",
    "nabla": "∇",
    "Nacute": "Ń",
    "nacute": "ń",
    "nang": "∠⃒",
    "nap": "≉",
    "napE": "⩰̸",
    "napid": "≋̸",
    "napos": "ŉ",
    "napprox": "≉",
    "natural": "♮",
    "naturals": "ℕ",
    "natur": "♮",
    "nbsp": " ",
    "nbump": "≎̸",
    "nbumpe": "≏̸",
    "ncap": "⩃",
    "Ncaron": "Ň",
    "ncaron": "ň",
    "Ncedil": "Ņ",
    "ncedil": "ņ",
    "ncong": "≇",
    "ncongdot": "⩭̸",
    "ncup": "⩂",
    "Ncy": "Н",
    "ncy": "н",
    "ndash": "–",
    "nearhk": "⤤",
    "nearr": "↗",
    "neArr": "⇗",
    "nearrow": "↗",
    "ne": "≠",
    "nedot": "≐̸",
    "NegativeMediumSpace": "​",
    "NegativeThickSpace": "​",
    "NegativeThinSpace": "​",
    "NegativeVeryThinSpace": "​",
    "nequiv": "≢",
    "nesear": "⤨",
    "nesim": "≂̸",
    "NestedGreaterGreater": "≫",
    "NestedLessLess": "≪",
    "NewLine": "\n",
    "nexist": "∄",
    "nexists": "∄",
    "Nfr": "𝔑",
    "nfr": "𝔫",
    "ngE": "≧̸",
    "nge": "≱",
    "ngeq": "≱",
    "ngeqq": "≧̸",
    "ngeqslant": "⩾̸",
    "nges": "⩾̸",
    "nGg": "⋙̸",
    "ngsim": "≵",
    "nGt": "≫⃒",
    "ngt": "≯",
    "ngtr": "≯",
    "nGtv": "≫̸",
    "nharr": "↮",
    "nhArr": "⇎",
    "nhpar": "⫲",
    "ni": "∋",
    "nis": "⋼",
    "nisd": "⋺",
    "niv": "∋",
    "NJcy": "Њ",
    "njcy": "њ",
    "nlarr": "↚",
    "nlArr": "⇍",
    "nldr": "‥",
    "nlE": "≦̸",
    "nle": "≰",
    "nleftarrow": "↚",
    "nLeftarrow": "⇍",
    "nleftrightarrow": "↮",
    "nLeftrightarrow": "⇎",
    "nleq": "≰",
    "nleqq": "≦̸",
    "nleqslant": "⩽̸",
    "nles": "⩽̸",
    "nless": "≮",
    "nLl": "⋘̸",
    "nlsim": "≴",
    "nLt": "≪⃒",
    "nlt": "≮",
    "nltri": "⋪",
    "nltrie": "⋬",
    "nLtv": "≪̸",
    "nmid": "∤",
    "NoBreak": "⁠",
    "NonBreakingSpace": " ",
    "nopf": "𝕟",
    "Nopf": "ℕ",
    "Not": "⫬",
    "not": "¬",
    "NotCongruent": "≢",
    "NotCupCap": "≭",
    "NotDoubleVerticalBar": "∦",
    "NotElement": "∉",
    "NotEqual": "≠",
    "NotEqualTilde": "≂̸",
    "NotExists": "∄",
    "NotGreater": "≯",
    "NotGreaterEqual": "≱",
    "NotGreaterFullEqual": "≧̸",
    "NotGreaterGreater": "≫̸",
    "NotGreaterLess": "≹",
    "NotGreaterSlantEqual": "⩾̸",
    "NotGreaterTilde": "≵",
    "NotHumpDownHump": "≎̸",
    "NotHumpEqual": "≏̸",
    "notin": "∉",
    "notindot": "⋵̸",
    "notinE": "⋹̸",
    "notinva": "∉",
    "notinvb": "⋷",
    "notinvc": "⋶",
    "NotLeftTriangleBar": "⧏̸",
    "NotLeftTriangle": "⋪",
    "NotLeftTriangleEqual": "⋬",
    "NotLess": "≮",
    "NotLessEqual": "≰",
    "NotLessGreater": "≸",
    "NotLessLess": "≪̸",
    "NotLessSlantEqual": "⩽̸",
    "NotLessTilde": "≴",
    "NotNestedGreaterGreater": "⪢̸",
    "NotNestedLessLess": "⪡̸",
    "notni": "∌",
    "notniva": "∌",
    "notnivb": "⋾",
    "notnivc": "⋽",
    "NotPrecedes": "⊀",
    "NotPrecedesEqual": "⪯̸",
    "NotPrecedesSlantEqual": "⋠",
    "NotReverseElement": "∌",
    "NotRightTriangleBar": "⧐̸",
    "NotRightTriangle": "⋫",
    "NotRightTriangleEqual": "⋭",
    "NotSquareSubset": "⊏̸",
    "NotSquareSubsetEqual": "⋢",
    "NotSquareSuperset": "⊐̸",
    "NotSquareSupersetEqual": "⋣",
    "NotSubset": "⊂⃒",
    "NotSubsetEqual": "⊈",
    "NotSucceeds": "⊁",
    "NotSucceedsEqual": "⪰̸",
    "NotSucceedsSlantEqual": "⋡",
    "NotSucceedsTilde": "≿̸",
    "NotSuperset": "⊃⃒",
    "NotSupersetEqual": "⊉",
    "NotTilde": "≁",
    "NotTildeEqual": "≄",
    "NotTildeFullEqual": "≇",
    "NotTildeTilde": "≉",
    "NotVerticalBar": "∤",
    "nparallel": "∦",
    "npar": "∦",
    "nparsl": "⫽⃥",
    "npart": "∂̸",
    "npolint": "⨔",
    "npr": "⊀",
    "nprcue": "⋠",
    "nprec": "⊀",
    "npreceq": "⪯̸",
    "npre": "⪯̸",
    "nrarrc": "⤳̸",
    "nrarr": "↛",
    "nrArr": "⇏",
    "nrarrw": "↝̸",
    "nrightarrow": "↛",
    "nRightarrow": "⇏",
    "nrtri": "⋫",
    "nrtrie": "⋭",
    "nsc": "⊁",
    "nsccue": "⋡",
    "nsce": "⪰̸",
    "Nscr": "𝒩",
    "nscr": "𝓃",
    "nshortmid": "∤",
    "nshortparallel": "∦",
    "nsim": "≁",
    "nsime": "≄",
    "nsimeq": "≄",
    "nsmid": "∤",
    "nspar": "∦",
    "nsqsube": "⋢",
    "nsqsupe": "⋣",
    "nsub": "⊄",
    "nsubE": "⫅̸",
    "nsube": "⊈",
    "nsubset": "⊂⃒",
    "nsubseteq": "⊈",
    "nsubseteqq": "⫅̸",
    "nsucc": "⊁",
    "nsucceq": "⪰̸",
    "nsup": "⊅",
    "nsupE": "⫆̸",
    "nsupe": "⊉",
    "nsupset": "⊃⃒",
    "nsupseteq": "⊉",
    "nsupseteqq": "⫆̸",
    "ntgl": "≹",
    "Ntilde": "Ñ",
    "ntilde": "ñ",
    "ntlg": "≸",
    "ntriangleleft": "⋪",
    "ntrianglelefteq": "⋬",
    "ntriangleright": "⋫",
    "ntrianglerighteq": "⋭",
    "Nu": "Ν",
    "nu": "ν",
    "num": "#",
    "numero": "№",
    "numsp": " ",
    "nvap": "≍⃒",
    "nvdash": "⊬",
    "nvDash": "⊭",
    "nVdash": "⊮",
    "nVDash": "⊯",
    "nvge": "≥⃒",
    "nvgt": ">⃒",
    "nvHarr": "⤄",
    "nvinfin": "⧞",
    "nvlArr": "⤂",
    "nvle": "≤⃒",
    "nvlt": "<⃒",
    "nvltrie": "⊴⃒",
    "nvrArr": "⤃",
    "nvrtrie": "⊵⃒",
    "nvsim": "∼⃒",
    "nwarhk": "⤣",
    "nwarr": "↖",
    "nwArr": "⇖",
    "nwarrow": "↖",
    "nwnear": "⤧",
    "Oacute": "Ó",
    "oacute": "ó",
    "oast": "⊛",
    "Ocirc": "Ô",
    "ocirc": "ô",
    "ocir": "⊚",
    "Ocy": "О",
    "ocy": "о",
    "odash": "⊝",
    "Odblac": "Ő",
    "odblac": "ő",
    "odiv": "⨸",
    "odot": "⊙",
    "odsold": "⦼",
    "OElig": "Œ",
    "oelig": "œ",
    "ofcir": "⦿",
    "Ofr": "𝔒",
    "ofr": "𝔬",
    "ogon": "˛",
    "Ograve": "Ò",
    "ograve": "ò",
    "ogt": "⧁",
    "ohbar": "⦵",
    "ohm": "Ω",
    "oint": "∮",
    "olarr": "↺",
    "olcir": "⦾",
    "olcross": "⦻",
    "oline": "‾",
    "olt": "⧀",
    "Omacr": "Ō",
    "omacr": "ō",
    "Omega": "Ω",
    "omega": "ω",
    "Omicron": "Ο",
    "omicron": "ο",
    "omid": "⦶",
    "ominus": "⊖",
    "Oopf": "𝕆",
    "oopf": "𝕠",
    "opar": "⦷",
    "OpenCurlyDoubleQuote": "“",
    "OpenCurlyQuote": "‘",
    "operp": "⦹",
    "oplus": "⊕",
    "orarr": "↻",
    "Or": "⩔",
    "or": "∨",
    "ord": "⩝",
    "order": "ℴ",
    "orderof": "ℴ",
    "ordf": "ª",
    "ordm": "º",
    "origof": "⊶",
    "oror": "⩖",
    "orslope": "⩗",
    "orv": "⩛",
    "oS": "Ⓢ",
    "Oscr": "𝒪",
    "oscr": "ℴ",
    "Oslash": "Ø",
    "oslash": "ø",
    "osol": "⊘",
    "Otilde": "Õ",
    "otilde": "õ",
    "otimesas": "⨶",
    "Otimes": "⨷",
    "otimes": "⊗",
    "Ouml": "Ö",
    "ouml": "ö",
    "ovbar": "⌽",
    "OverBar": "‾",
    "OverBrace": "⏞",
    "OverBracket": "⎴",
    "OverParenthesis": "⏜",
    "para": "¶",
    "parallel": "∥",
    "par": "∥",
    "parsim": "⫳",
    "parsl": "⫽",
    "part": "∂",
    "PartialD": "∂",
    "Pcy": "П",
    "pcy": "п",
    "percnt": "%",
    "period": ".",
    "permil": "‰",
    "perp": "⊥",
    "pertenk": "‱",
    "Pfr": "𝔓",
    "pfr": "𝔭",
    "Phi": "Φ",
    "phi": "φ",
    "phiv": "ϕ",
    "phmmat": "ℳ",
    "phone": "☎",
    "Pi": "Π",
    "pi": "π",
    "pitchfork": "⋔",
    "piv": "ϖ",
    "planck": "ℏ",
    "planckh": "ℎ",
    "plankv": "ℏ",
    "plusacir": "⨣",
    "plusb": "⊞",
    "pluscir": "⨢",
    "plus": "+",
    "plusdo": "∔",
    "plusdu": "⨥",
    "pluse": "⩲",
    "PlusMinus": "±",
    "plusmn": "±",
    "plussim": "⨦",
    "plustwo": "⨧",
    "pm": "±",
    "Poincareplane": "ℌ",
    "pointint": "⨕",
    "popf": "𝕡",
    "Popf": "ℙ",
    "pound": "£",
    "prap": "⪷",
    "Pr": "⪻",
    "pr": "≺",
    "prcue": "≼",
    "precapprox": "⪷",
    "prec": "≺",
    "preccurlyeq": "≼",
    "Precedes": "≺",
    "PrecedesEqual": "⪯",
    "PrecedesSlantEqual": "≼",
    "PrecedesTilde": "≾",
    "preceq": "⪯",
    "precnapprox": "⪹",
    "precneqq": "⪵",
    "precnsim": "⋨",
    "pre": "⪯",
    "prE": "⪳",
    "precsim": "≾",
    "prime": "′",
    "Prime": "″",
    "primes": "ℙ",
    "prnap": "⪹",
    "prnE": "⪵",
    "prnsim": "⋨",
    "prod": "∏",
    "Product": "∏",
    "profalar": "⌮",
    "profline": "⌒",
    "profsurf": "⌓",
    "prop": "∝",
    "Proportional": "∝",
    "Proportion": "∷",
    "propto": "∝",
    "prsim": "≾",
    "prurel": "⊰",
    "Pscr": "𝒫",
    "pscr": "𝓅",
    "Psi": "Ψ",
    "psi": "ψ",
    "puncsp": " ",
    "Qfr": "𝔔",
    "qfr": "𝔮",
    "qint": "⨌",
    "qopf": "𝕢",
    "Qopf": "ℚ",
    "qprime": "⁗",
    "Qscr": "𝒬",
    "qscr": "𝓆",
    "quaternions": "ℍ",
    "quatint": "⨖",
    "quest": "?",
    "questeq": "≟",
    "quot": "\"",
    "QUOT": "\"",
    "rAarr": "⇛",
    "race": "∽̱",
    "Racute": "Ŕ",
    "racute": "ŕ",
    "radic": "√",
    "raemptyv": "⦳",
    "rang": "⟩",
    "Rang": "⟫",
    "rangd": "⦒",
    "range": "⦥",
    "rangle": "⟩",
    "raquo": "»",
    "rarrap": "⥵",
    "rarrb": "⇥",
    "rarrbfs": "⤠",
    "rarrc": "⤳",
    "rarr": "→",
    "Rarr": "↠",
    "rArr": "⇒",
    "rarrfs": "⤞",
    "rarrhk": "↪",
    "rarrlp": "↬",
    "rarrpl": "⥅",
    "rarrsim": "⥴",
    "Rarrtl": "⤖",
    "rarrtl": "↣",
    "rarrw": "↝",
    "ratail": "⤚",
    "rAtail": "⤜",
    "ratio": "∶",
    "rationals": "ℚ",
    "rbarr": "⤍",
    "rBarr": "⤏",
    "RBarr": "⤐",
    "rbbrk": "❳",
    "rbrace": "}",
    "rbrack": "]",
    "rbrke": "⦌",
    "rbrksld": "⦎",
    "rbrkslu": "⦐",
    "Rcaron": "Ř",
    "rcaron": "ř",
    "Rcedil": "Ŗ",
    "rcedil": "ŗ",
    "rceil": "⌉",
    "rcub": "}",
    "Rcy": "Р",
    "rcy": "р",
    "rdca": "⤷",
    "rdldhar": "⥩",
    "rdquo": "”",
    "rdquor": "”",
    "rdsh": "↳",
    "real": "ℜ",
    "realine": "ℛ",
    "realpart": "ℜ",
    "reals": "ℝ",
    "Re": "ℜ",
    "rect": "▭",
    "reg": "®",
    "REG": "®",
    "ReverseElement": "∋",
    "ReverseEquilibrium": "⇋",
    "ReverseUpEquilibrium": "⥯",
    "rfisht": "⥽",
    "rfloor": "⌋",
    "rfr": "𝔯",
    "Rfr": "ℜ",
    "rHar": "⥤",
    "rhard": "⇁",
    "rharu": "⇀",
    "rharul": "⥬",
    "Rho": "Ρ",
    "rho": "ρ",
    "rhov": "ϱ",
    "RightAngleBracket": "⟩",
    "RightArrowBar": "⇥",
    "rightarrow": "→",
    "RightArrow": "→",
    "Rightarrow": "⇒",
    "RightArrowLeftArrow": "⇄",
    "rightarrowtail": "↣",
    "RightCeiling": "⌉",
    "RightDoubleBracket": "⟧",
    "RightDownTeeVector": "⥝",
    "RightDownVectorBar": "⥕",
    "RightDownVector": "⇂",
    "RightFloor": "⌋",
    "rightharpoondown": "⇁",
    "rightharpoonup": "⇀",
    "rightleftarrows": "⇄",
    "rightleftharpoons": "⇌",
    "rightrightarrows": "⇉",
    "rightsquigarrow": "↝",
    "RightTeeArrow": "↦",
    "RightTee": "⊢",
    "RightTeeVector": "⥛",
    "rightthreetimes": "⋌",
    "RightTriangleBar": "⧐",
    "RightTriangle": "⊳",
    "RightTriangleEqual": "⊵",
    "RightUpDownVector": "⥏",
    "RightUpTeeVector": "⥜",
    "RightUpVectorBar": "⥔",
    "RightUpVector": "↾",
    "RightVectorBar": "⥓",
    "RightVector": "⇀",
    "ring": "˚",
    "risingdotseq": "≓",
    "rlarr": "⇄",
    "rlhar": "⇌",
    "rlm": "‏",
    "rmoustache": "⎱",
    "rmoust": "⎱",
    "rnmid": "⫮",
    "roang": "⟭",
    "roarr": "⇾",
    "robrk": "⟧",
    "ropar": "⦆",
    "ropf": "𝕣",
    "Ropf": "ℝ",
    "roplus": "⨮",
    "rotimes": "⨵",
    "RoundImplies": "⥰",
    "rpar": ")",
    "rpargt": "⦔",
    "rppolint": "⨒",
    "rrarr": "⇉",
    "Rrightarrow": "⇛",
    "rsaquo": "›",
    "rscr": "𝓇",
    "Rscr": "ℛ",
    "rsh": "↱",
    "Rsh": "↱",
    "rsqb": "]",
    "rsquo": "’",
    "rsquor": "’",
    "rthree": "⋌",
    "rtimes": "⋊",
    "rtri": "▹",
    "rtrie": "⊵",
    "rtrif": "▸",
    "rtriltri": "⧎",
    "RuleDelayed": "⧴",
    "ruluhar": "⥨",
    "rx": "℞",
    "Sacute": "Ś",
    "sacute": "ś",
    "sbquo": "‚",
    "scap": "⪸",
    "Scaron": "Š",
    "scaron": "š",
    "Sc": "⪼",
    "sc": "≻",
    "sccue": "≽",
    "sce": "⪰",
    "scE": "⪴",
    "Scedil": "Ş",
    "scedil": "ş",
    "Scirc": "Ŝ",
    "scirc": "ŝ",
    "scnap": "⪺",
    "scnE": "⪶",
    "scnsim": "⋩",
    "scpolint": "⨓",
    "scsim": "≿",
    "Scy": "С",
    "scy": "с",
    "sdotb": "⊡",
    "sdot": "⋅",
    "sdote": "⩦",
    "searhk": "⤥",
    "searr": "↘",
    "seArr": "⇘",
    "searrow": "↘",
    "sect": "§",
    "semi": ";",
    "seswar": "⤩",
    "setminus": "∖",
    "setmn": "∖",
    "sext": "✶",
    "Sfr": "𝔖",
    "sfr": "𝔰",
    "sfrown": "⌢",
    "sharp": "♯",
    "SHCHcy": "Щ",
    "shchcy": "щ",
    "SHcy": "Ш",
    "shcy": "ш",
    "ShortDownArrow": "↓",
    "ShortLeftArrow": "←",
    "shortmid": "∣",
    "shortparallel": "∥",
    "ShortRightArrow": "→",
    "ShortUpArrow": "↑",
    "shy": "­",
    "Sigma": "Σ",
    "sigma": "σ",
    "sigmaf": "ς",
    "sigmav": "ς",
    "sim": "∼",
    "simdot": "⩪",
    "sime": "≃",
    "simeq": "≃",
    "simg": "⪞",
    "simgE": "⪠",
    "siml": "⪝",
    "simlE": "⪟",
    "simne": "≆",
    "simplus": "⨤",
    "simrarr": "⥲",
    "slarr": "←",
    "SmallCircle": "∘",
    "smallsetminus": "∖",
    "smashp": "⨳",
    "smeparsl": "⧤",
    "smid": "∣",
    "smile": "⌣",
    "smt": "⪪",
    "smte": "⪬",
    "smtes": "⪬︀",
    "SOFTcy": "Ь",
    "softcy": "ь",
    "solbar": "⌿",
    "solb": "⧄",
    "sol": "/",
    "Sopf": "𝕊",
    "sopf": "𝕤",
    "spades": "♠",
    "spadesuit": "♠",
    "spar": "∥",
    "sqcap": "⊓",
    "sqcaps": "⊓︀",
    "sqcup": "⊔",
    "sqcups": "⊔︀",
    "Sqrt": "√",
    "sqsub": "⊏",
    "sqsube": "⊑",
    "sqsubset": "⊏",
    "sqsubseteq": "⊑",
    "sqsup": "⊐",
    "sqsupe": "⊒",
    "sqsupset": "⊐",
    "sqsupseteq": "⊒",
    "square": "□",
    "Square": "□",
    "SquareIntersection": "⊓",
    "SquareSubset": "⊏",
    "SquareSubsetEqual": "⊑",
    "SquareSuperset": "⊐",
    "SquareSupersetEqual": "⊒",
    "SquareUnion": "⊔",
    "squarf": "▪",
    "squ": "□",
    "squf": "▪",
    "srarr": "→",
    "Sscr": "𝒮",
    "sscr": "𝓈",
    "ssetmn": "∖",
    "ssmile": "⌣",
    "sstarf": "⋆",
    "Star": "⋆",
    "star": "☆",
    "starf": "★",
    "straightepsilon": "ϵ",
    "straightphi": "ϕ",
    "strns": "¯",
    "sub": "⊂",
    "Sub": "⋐",
    "subdot": "⪽",
    "subE": "⫅",
    "sube": "⊆",
    "subedot": "⫃",
    "submult": "⫁",
    "subnE": "⫋",
    "subne": "⊊",
    "subplus": "⪿",
    "subrarr": "⥹",
    "subset": "⊂",
    "Subset": "⋐",
    "subseteq": "⊆",
    "subseteqq": "⫅",
    "SubsetEqual": "⊆",
    "subsetneq": "⊊",
    "subsetneqq": "⫋",
    "subsim": "⫇",
    "subsub": "⫕",
    "subsup": "⫓",
    "succapprox": "⪸",
    "succ": "≻",
    "succcurlyeq": "≽",
    "Succeeds": "≻",
    "SucceedsEqual": "⪰",
    "SucceedsSlantEqual": "≽",
    "SucceedsTilde": "≿",
    "succeq": "⪰",
    "succnapprox": "⪺",
    "succneqq": "⪶",
    "succnsim": "⋩",
    "succsim": "≿",
    "SuchThat": "∋",
    "sum": "∑",
    "Sum": "∑",
    "sung": "♪",
    "sup1": "¹",
    "sup2": "²",
    "sup3": "³",
    "sup": "⊃",
    "Sup": "⋑",
    "supdot": "⪾",
    "supdsub": "⫘",
    "supE": "⫆",
    "supe": "⊇",
    "supedot": "⫄",
    "Superset": "⊃",
    "SupersetEqual": "⊇",
    "suphsol": "⟉",
    "suphsub": "⫗",
    "suplarr": "⥻",
    "supmult": "⫂",
    "supnE": "⫌",
    "supne": "⊋",
    "supplus": "⫀",
    "supset": "⊃",
    "Supset": "⋑",
    "supseteq": "⊇",
    "supseteqq": "⫆",
    "supsetneq": "⊋",
    "supsetneqq": "⫌",
    "supsim": "⫈",
    "supsub": "⫔",
    "supsup": "⫖",
    "swarhk": "⤦",
    "swarr": "↙",
    "swArr": "⇙",
    "swarrow": "↙",
    "swnwar": "⤪",
    "szlig": "ß",
    "Tab": "\t",
    "target": "⌖",
    "Tau": "Τ",
    "tau": "τ",
    "tbrk": "⎴",
    "Tcaron": "Ť",
    "tcaron": "ť",
    "Tcedil": "Ţ",
    "tcedil": "ţ",
    "Tcy": "Т",
    "tcy": "т",
    "tdot": "⃛",
    "telrec": "⌕",
    "Tfr": "𝔗",
    "tfr": "𝔱",
    "there4": "∴",
    "therefore": "∴",
    "Therefore": "∴",
    "Theta": "Θ",
    "theta": "θ",
    "thetasym": "ϑ",
    "thetav": "ϑ",
    "thickapprox": "≈",
    "thicksim": "∼",
    "ThickSpace": "  ",
    "ThinSpace": " ",
    "thinsp": " ",
    "thkap": "≈",
    "thksim": "∼",
    "THORN": "Þ",
    "thorn": "þ",
    "tilde": "˜",
    "Tilde": "∼",
    "TildeEqual": "≃",
    "TildeFullEqual": "≅",
    "TildeTilde": "≈",
    "timesbar": "⨱",
    "timesb": "⊠",
    "times": "×",
    "timesd": "⨰",
    "tint": "∭",
    "toea": "⤨",
    "topbot": "⌶",
    "topcir": "⫱",
    "top": "⊤",
    "Topf": "𝕋",
    "topf": "𝕥",
    "topfork": "⫚",
    "tosa": "⤩",
    "tprime": "‴",
    "trade": "™",
    "TRADE": "™",
    "triangle": "▵",
    "triangledown": "▿",
    "triangleleft": "◃",
    "trianglelefteq": "⊴",
    "triangleq": "≜",
    "triangleright": "▹",
    "trianglerighteq": "⊵",
    "tridot": "◬",
    "trie": "≜",
    "triminus": "⨺",
    "TripleDot": "⃛",
    "triplus": "⨹",
    "trisb": "⧍",
    "tritime": "⨻",
    "trpezium": "⏢",
    "Tscr": "𝒯",
    "tscr": "𝓉",
    "TScy": "Ц",
    "tscy": "ц",
    "TSHcy": "Ћ",
    "tshcy": "ћ",
    "Tstrok": "Ŧ",
    "tstrok": "ŧ",
    "twixt": "≬",
    "twoheadleftarrow": "↞",
    "twoheadrightarrow": "↠",
    "Uacute": "Ú",
    "uacute": "ú",
    "uarr": "↑",
    "Uarr": "↟",
    "uArr": "⇑",
    "Uarrocir": "⥉",
    "Ubrcy": "Ў",
    "ubrcy": "ў",
    "Ubreve": "Ŭ",
    "ubreve": "ŭ",
    "Ucirc": "Û",
    "ucirc": "û",
    "Ucy": "У",
    "ucy": "у",
    "udarr": "⇅",
    "Udblac": "Ű",
    "udblac": "ű",
    "udhar": "⥮",
    "ufisht": "⥾",
    "Ufr": "𝔘",
    "ufr": "𝔲",
    "Ugrave": "Ù",
    "ugrave": "ù",
    "uHar": "⥣",
    "uharl": "↿",
    "uharr": "↾",
    "uhblk": "▀",
    "ulcorn": "⌜",
    "ulcorner": "⌜",
    "ulcrop": "⌏",
    "ultri": "◸",
    "Umacr": "Ū",
    "umacr": "ū",
    "uml": "¨",
    "UnderBar": "_",
    "UnderBrace": "⏟",
    "UnderBracket": "⎵",
    "UnderParenthesis": "⏝",
    "Union": "⋃",
    "UnionPlus": "⊎",
    "Uogon": "Ų",
    "uogon": "ų",
    "Uopf": "𝕌",
    "uopf": "𝕦",
    "UpArrowBar": "⤒",
    "uparrow": "↑",
    "UpArrow": "↑",
    "Uparrow": "⇑",
    "UpArrowDownArrow": "⇅",
    "updownarrow": "↕",
    "UpDownArrow": "↕",
    "Updownarrow": "⇕",
    "UpEquilibrium": "⥮",
    "upharpoonleft": "↿",
    "upharpoonright": "↾",
    "uplus": "⊎",
    "UpperLeftArrow": "↖",
    "UpperRightArrow": "↗",
    "upsi": "υ",
    "Upsi": "ϒ",
    "upsih": "ϒ",
    "Upsilon": "Υ",
    "upsilon": "υ",
    "UpTeeArrow": "↥",
    "UpTee": "⊥",
    "upuparrows": "⇈",
    "urcorn": "⌝",
    "urcorner": "⌝",
    "urcrop": "⌎",
    "Uring": "Ů",
    "uring": "ů",
    "urtri": "◹",
    "Uscr": "𝒰",
    "uscr": "𝓊",
    "utdot": "⋰",
    "Utilde": "Ũ",
    "utilde": "ũ",
    "utri": "▵",
    "utrif": "▴",
    "uuarr": "⇈",
    "Uuml": "Ü",
    "uuml": "ü",
    "uwangle": "⦧",
    "vangrt": "⦜",
    "varepsilon": "ϵ",
    "varkappa": "ϰ",
    "varnothing": "∅",
    "varphi": "ϕ",
    "varpi": "ϖ",
    "varpropto": "∝",
    "varr": "↕",
    "vArr": "⇕",
    "varrho": "ϱ",
    "varsigma": "ς",
    "varsubsetneq": "⊊︀",
    "varsubsetneqq": "⫋︀",
    "varsupsetneq": "⊋︀",
    "varsupsetneqq": "⫌︀",
    "vartheta": "ϑ",
    "vartriangleleft": "⊲",
    "vartriangleright": "⊳",
    "vBar": "⫨",
    "Vbar": "⫫",
    "vBarv": "⫩",
    "Vcy": "В",
    "vcy": "в",
    "vdash": "⊢",
    "vDash": "⊨",
    "Vdash": "⊩",
    "VDash": "⊫",
    "Vdashl": "⫦",
    "veebar": "⊻",
    "vee": "∨",
    "Vee": "⋁",
    "veeeq": "≚",
    "vellip": "⋮",
    "verbar": "|",
    "Verbar": "‖",
    "vert": "|",
    "Vert": "‖",
    "VerticalBar": "∣",
    "VerticalLine": "|",
    "VerticalSeparator": "❘",
    "VerticalTilde": "≀",
    "VeryThinSpace": " ",
    "Vfr": "𝔙",
    "vfr": "𝔳",
    "vltri": "⊲",
    "vnsub": "⊂⃒",
    "vnsup": "⊃⃒",
    "Vopf": "𝕍",
    "vopf": "𝕧",
    "vprop": "∝",
    "vrtri": "⊳",
    "Vscr": "𝒱",
    "vscr": "𝓋",
    "vsubnE": "⫋︀",
    "vsubne": "⊊︀",
    "vsupnE": "⫌︀",
    "vsupne": "⊋︀",
    "Vvdash": "⊪",
    "vzigzag": "⦚",
    "Wcirc": "Ŵ",
    "wcirc": "ŵ",
    "wedbar": "⩟",
    "wedge": "∧",
    "Wedge": "⋀",
    "wedgeq": "≙",
    "weierp": "℘",
    "Wfr": "𝔚",
    "wfr": "𝔴",
    "Wopf": "𝕎",
    "wopf": "𝕨",
    "wp": "℘",
    "wr": "≀",
    "wreath": "≀",
    "Wscr": "𝒲",
    "wscr": "𝓌",
    "xcap": "⋂",
    "xcirc": "◯",
    "xcup": "⋃",
    "xdtri": "▽",
    "Xfr": "𝔛",
    "xfr": "𝔵",
    "xharr": "⟷",
    "xhArr": "⟺",
    "Xi": "Ξ",
    "xi": "ξ",
    "xlarr": "⟵",
    "xlArr": "⟸",
    "xmap": "⟼",
    "xnis": "⋻",
    "xodot": "⨀",
    "Xopf": "𝕏",
    "xopf": "𝕩",
    "xoplus": "⨁",
    "xotime": "⨂",
    "xrarr": "⟶",
    "xrArr": "⟹",
    "Xscr": "𝒳",
    "xscr": "𝓍",
    "xsqcup": "⨆",
    "xuplus": "⨄",
    "xutri": "△",
    "xvee": "⋁",
    "xwedge": "⋀",
    "Yacute": "Ý",
    "yacute": "ý",
    "YAcy": "Я",
    "yacy": "я",
    "Ycirc": "Ŷ",
    "ycirc": "ŷ",
    "Ycy": "Ы",
    "ycy": "ы",
    "yen": "¥",
    "Yfr": "𝔜",
    "yfr": "𝔶",
    "YIcy": "Ї",
    "yicy": "ї",
    "Yopf": "𝕐",
    "yopf": "𝕪",
    "Yscr": "𝒴",
    "yscr": "𝓎",
    "YUcy": "Ю",
    "yucy": "ю",
    "yuml": "ÿ",
    "Yuml": "Ÿ",
    "Zacute": "Ź",
    "zacute": "ź",
    "Zcaron": "Ž",
    "zcaron": "ž",
    "Zcy": "З",
    "zcy": "з",
    "Zdot": "Ż",
    "zdot": "ż",
    "zeetrf": "ℨ",
    "ZeroWidthSpace": "​",
    "Zeta": "Ζ",
    "zeta": "ζ",
    "zfr": "𝔷",
    "Zfr": "ℨ",
    "ZHcy": "Ж",
    "zhcy": "ж",
    "zigrarr": "⇝",
    "zopf": "𝕫",
    "Zopf": "ℤ",
    "Zscr": "𝒵",
    "zscr": "𝓏",
    "zwj": "‍",
    "zwnj": "‌"
  };

  /***/
}, /* 20 */
/***/function (module, exports) {
  module.exports = {
    "amp": "&",
    "apos": "'",
    "gt": ">",
    "lt": "<",
    "quot": "\""
  };

  /***/
}, /* 21 */
/***/function (module, exports) {
  module.exports = function (module) {
    if (!module.webpackPolyfill) {
      module.deprecate = function () {};
      module.paths = [];
      // module.parent = undefined by default
      if (!module.children) module.children = [];
      Object.defineProperty(module, "loaded", {
        enumerable: true,
        get: function get() {
          return module.l;
        }
      });
      Object.defineProperty(module, "id", {
        enumerable: true,
        get: function get() {
          return module.i;
        }
      });
      module.webpackPolyfill = 1;
    }
    return module;
  };

  /***/
}, /* 22 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = handleEvent;
  var _selector = __webpack_require__(0);
  var _selectorcalculator = __webpack_require__(11);
  var _extractor = __webpack_require__(3);
  __webpack_require__(12);
  var _PageSet = __webpack_require__(14);
  var _PageSet2 = _interopRequireDefault(_PageSet);
  var _Field = __webpack_require__(7);
  var _Field2 = _interopRequireDefault(_Field);
  var _Page = __webpack_require__(9);
  var _Page2 = _interopRequireDefault(_Page);
  var _Example = __webpack_require__(2);
  var _Example2 = _interopRequireDefault(_Example);
  var _logger = __webpack_require__(4);
  var _logger2 = _interopRequireDefault(_logger);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function handleEvent(doc, event, useIds) {
    var maxItems = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    // for backwards compatibility
    if (useIds === undefined) {
      useIds = false;
    }
    if (event.magicConfig) {
      var configs = void 0;
      try {
        configs = event.magicConfig.slice(0, maxItems);
      } catch (e) {
        _logger2.default.error('Cannot call slice on event.magicConfig: ', JSON.stringify(event.magicConfig));
        return [];
      }
      return configs.map(function (magicConfig) {
        var pageSet = new _PageSet2.default();
        var page = new _Page2.default();
        page.resourceId = event.resourceId;
        pageSet.addPage(page);
        page.url = event.url;
        page.overrideDom(doc);
        var xpath = magicConfig.resolvedXPath ? magicConfig.resolvedXPath : magicConfig.rowXPath;
        importTraining(pageSet, page, xpath, magicConfig.fields);
        var runtimeConfig = pageSet.runtimeConfig();
        var fields = runtimeConfig.fields.map(function (a) {
          return {
            name: a.name,
            type: a.type
          };
        });
        var result = {
          config: pageSet,
          fields: fields
        };
        if (event.extractData) {
          result.data = (0, _extractor.extract)(runtimeConfig, doc, page.url, useIds);
        }
        return result;
      });
    }
    return {
      url: event.url,
      resourceId: event.resourceId,
      data: (0, _extractor.extract)(event.runtimeConfig, doc, null, useIds)
    };
  }
  ;

  /**
   * Import training from magic (or elsewhere)
   * @param  {Page} page
   * @param  {Array} training [ { name, xpaths: [...] },... ]
   * @return {void}
   */
  function importTraining(pageSet, page, rowXPath, training) {
    pageSet.recordXPath = rowXPath;
    training.forEach(function (importedField) {
      var type = importedField.type === 'IMAGE' ? importedField.type : 'TEXT';
      var field = new _Field2.default({
        name: importedField.name,
        type: type,
        ranking: importedField.ranking || 0
      });
      // import the id as well, if present
      if (importedField.id !== undefined) field.id = importedField.id;
      var captureLink = importedField.type === 'URL';
      pageSet.addField(field);
      importedField.xpaths.forEach(function (xpath) {
        try {
          var el = (0, _selector.getByFullXPath)(xpath, page.dom());
          if (!el) {
            throw 'XPath [' + xpath + '] doesn\'t match any node';
          }
          if (!captureLink) captureLink = containedByLink(el);
          var path = (0, _selector.getPath)(el);
          var example = new _Example2.default({
            path: path,
            xpath: xpath
          });
          page.addFieldExample(field, example);
        } catch (e) {
          _logger2.default.error('Couldn\'t import field', e);
        }
      });
      field.captureLink = captureLink;
      (0, _selectorcalculator.calculateAndSetFieldSelector)(pageSet, field);
    });
  }
  function containedByLink(el) {
    var a = getAnchor(el);
    if (!a) return false;
    var href = a.getAttribute('href');
    return href && !/^\s*javascript:/i.exec(href);
  }
  function getAnchor(element) {
    do {
      if (element.tagName === 'A') return element;
    } while (element = element.parentNode);
  }

  /***/
}, /* 23 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var RowFilter = function () {
    function RowFilter(_ref) {
      var ruleName = _ref.ruleName,
        regExp = _ref.regExp;
      _classCallCheck(this, RowFilter);
      this._ruleName = ruleName;
      this._regExp = regExp;
    }
    _createClass(RowFilter, [{
      key: "toJSON",
      value: function toJSON() {
        return {
          ruleName: this.ruleName,
          regExp: this.regExp
        };
      }
    }, {
      key: "ruleName",
      get: function get() {
        return this._ruleName;
      },
      set: function set(ruleName) {
        this._ruleName = ruleName;
      }
    }, {
      key: "regExp",
      get: function get() {
        return this._regExp;
      },
      set: function set(regExp) {
        this._regExp = regExp;
      }
    }]);
    return RowFilter;
  }();
  exports.default = RowFilter;

  /***/
}, /* 24 */
/***/function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extractor = __webpack_require__(3);
  Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
      return _extractor.extract;
    }
  });
  Object.defineProperty(exports, 'extract', {
    enumerable: true,
    get: function get() {
      return _extractor.extract;
    }
  });
  Object.defineProperty(exports, 'getRecordElements', {
    enumerable: true,
    get: function get() {
      return _extractor.getRecordElements;
    }
  });
  var _Page = __webpack_require__(9);
  Object.defineProperty(exports, 'Page', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Page).default;
    }
  });
  var _Field = __webpack_require__(7);
  Object.defineProperty(exports, 'Field', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Field).default;
    }
  });
  var _PageSet = __webpack_require__(14);
  Object.defineProperty(exports, 'PageSet', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_PageSet).default;
    }
  });
  var _selectorcalculator = __webpack_require__(11);
  Object.defineProperty(exports, 'initializeEditorDocument', {
    enumerable: true,
    get: function get() {
      return _selectorcalculator.initializeEditorDocument;
    }
  });
  Object.defineProperty(exports, 'calculateAndSetFieldSelector', {
    enumerable: true,
    get: function get() {
      return _selectorcalculator.calculateAndSetFieldSelector;
    }
  });
  Object.defineProperty(exports, 'calculateAndSetRegionsSelector', {
    enumerable: true,
    get: function get() {
      return _selectorcalculator.calculateAndSetRegionsSelector;
    }
  });
  Object.defineProperty(exports, 'suggestElements', {
    enumerable: true,
    get: function get() {
      return _selectorcalculator.suggestElements;
    }
  });
  Object.defineProperty(exports, 'trainField', {
    enumerable: true,
    get: function get() {
      return _selectorcalculator.trainField;
    }
  });
  Object.defineProperty(exports, 'getElementSelector', {
    enumerable: true,
    get: function get() {
      return _selectorcalculator.getElementSelector;
    }
  });
  var _Example = __webpack_require__(2);
  Object.defineProperty(exports, 'Example', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_Example).default;
    }
  });
  Object.defineProperty(exports, 'makeExample', {
    enumerable: true,
    get: function get() {
      return _Example.makeExample;
    }
  });
  var _selector = __webpack_require__(0);
  Object.defineProperty(exports, 'selectNodes', {
    enumerable: true,
    get: function get() {
      return _selector.selectNodes;
    }
  });
  Object.defineProperty(exports, 'getByFullXPath', {
    enumerable: true,
    get: function get() {
      return _selector.getByFullXPath;
    }
  });
  Object.defineProperty(exports, 'toCssSelector', {
    enumerable: true,
    get: function get() {
      return _selector.toCssSelector;
    }
  });
  Object.defineProperty(exports, 'fullXPath', {
    enumerable: true,
    get: function get() {
      return _selector.fullXPath;
    }
  });
  var _lazyimg = __webpack_require__(16);
  Object.defineProperty(exports, 'showLazyImages', {
    enumerable: true,
    get: function get() {
      return _lazyimg.showLazyImages;
    }
  });
  var _utils = __webpack_require__(1);
  Object.defineProperty(exports, 'isWhitespace', {
    enumerable: true,
    get: function get() {
      return _utils.isWhitespace;
    }
  });
  Object.defineProperty(exports, 'validHref', {
    enumerable: true,
    get: function get() {
      return _utils.validHref;
    }
  });
  Object.defineProperty(exports, 'stripSessionIds', {
    enumerable: true,
    get: function get() {
      return _utils.stripSessionIds;
    }
  });
  Object.defineProperty(exports, 'textContent', {
    enumerable: true,
    get: function get() {
      return _utils.textContent;
    }
  });
  Object.defineProperty(exports, 'getElementsByXPath', {
    enumerable: true,
    get: function get() {
      return _utils.getElementsByXPath;
    }
  });
  Object.defineProperty(exports, 'makeUrlAbsolute', {
    enumerable: true,
    get: function get() {
      return _utils.makeUrlAbsolute;
    }
  });
  var _group = __webpack_require__(10);
  Object.defineProperty(exports, 'enableExtractionCache', {
    enumerable: true,
    get: function get() {
      return _group.enablePageCache;
    }
  });
  var _eventhandler = __webpack_require__(22);
  Object.defineProperty(exports, 'handleEvent', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(_eventhandler).default;
    }
  });
  var _htmlparser = __webpack_require__(15);
  Object.defineProperty(exports, 'importIntoDocument', {
    enumerable: true,
    get: function get() {
      return _htmlparser.importIntoDocument;
    }
  });
  var _regiondetect = __webpack_require__(18);
  Object.defineProperty(exports, 'findRegions', {
    enumerable: true,
    get: function get() {
      return _regiondetect.findRegions;
    }
  });
  Object.defineProperty(exports, 'getContainingList', {
    enumerable: true,
    get: function get() {
      return _regiondetect.getContainingList;
    }
  });
  var _micro = __webpack_require__(17);
  Object.defineProperty(exports, 'getMainItemMicrodataRuntimeConfig', {
    enumerable: true,
    get: function get() {
      return _micro.getMainItemRuntimeConfig;
    }
  });
  Object.defineProperty(exports, 'getMainItemMicrodata', {
    enumerable: true,
    get: function get() {
      return _micro.getMainItem;
    }
  });
  Object.defineProperty(exports, 'getMicrodata', {
    enumerable: true,
    get: function get() {
      return _micro.getData;
    }
  });
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /***/
}, /* 25 */
/***/function (module, exports) {
  var supportsArgumentsClass = function () {
    return Object.prototype.toString.call(arguments);
  }() == '[object Arguments]';
  exports = module.exports = supportsArgumentsClass ? supported : unsupported;
  exports.supported = supported;
  function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
  }
  ;
  exports.unsupported = unsupported;
  function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
  }
  ;

  /***/
}, /* 26 */
/***/function (module, exports) {
  exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
  exports.shim = shim;
  function shim(obj) {
    var keys = [];
    for (var key in obj) keys.push(key);
    return keys;
  }

  /***/
}, /* 27 */
/***/function (module, exports, __webpack_require__) {
  var encode = __webpack_require__(30),
    decode = __webpack_require__(28);
  exports.decode = function (data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
  };
  exports.decodeStrict = function (data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
  };
  exports.encode = function (data, level) {
    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
  };
  exports.encodeXML = encode.XML;
  exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;
  exports.decodeXML = exports.decodeXMLStrict = decode.XML;
  exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;
  exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;
  exports.escape = encode.escape;

  /***/
}, /* 28 */
/***/function (module, exports, __webpack_require__) {
  var entityMap = __webpack_require__(19),
    legacyMap = __webpack_require__(32),
    xmlMap = __webpack_require__(20),
    decodeCodePoint = __webpack_require__(29);
  var decodeXMLStrict = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);
  function getStrictDecoder(map) {
    var keys = Object.keys(map).join("|"),
      replace = getReplacer(map);
    keys += "|#[xX][\\da-fA-F]+|#\\d+";
    var re = new RegExp("&(?:" + keys + ");", "g");
    return function (str) {
      return String(str).replace(re, replace);
    };
  }
  var decodeHTML = function () {
    var legacy = Object.keys(legacyMap).sort(sorter);
    var keys = Object.keys(entityMap).sort(sorter);
    for (var i = 0, j = 0; i < keys.length; i++) {
      if (legacy[j] === keys[i]) {
        keys[i] += ";?";
        j++;
      } else {
        keys[i] += ";";
      }
    }
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
      replace = getReplacer(entityMap);
    function replacer(str) {
      if (str.substr(-1) !== ";") str += ";";
      return replace(str);
    }

    //TODO consider creating a merged map
    return function (str) {
      return String(str).replace(re, replacer);
    };
  }();
  function sorter(a, b) {
    return a < b ? 1 : -1;
  }
  function getReplacer(map) {
    return function replace(str) {
      if (str.charAt(1) === "#") {
        if (str.charAt(2) === "X" || str.charAt(2) === "x") {
          return decodeCodePoint(parseInt(str.substr(3), 16));
        }
        return decodeCodePoint(parseInt(str.substr(2), 10));
      }
      return map[str.slice(1, -1)];
    };
  }
  module.exports = {
    XML: decodeXMLStrict,
    HTML: decodeHTML,
    HTMLStrict: decodeHTMLStrict
  };

  /***/
}, /* 29 */
/***/function (module, exports, __webpack_require__) {
  var decodeMap = __webpack_require__(31);
  module.exports = decodeCodePoint;

  // modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
  function decodeCodePoint(codePoint) {
    if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
      return "\uFFFD";
    }
    if (codePoint in decodeMap) {
      codePoint = decodeMap[codePoint];
    }
    var output = "";
    if (codePoint > 0xFFFF) {
      codePoint -= 0x10000;
      output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    output += String.fromCharCode(codePoint);
    return output;
  }

  /***/
}, /* 30 */
/***/function (module, exports, __webpack_require__) {
  var inverseXML = getInverseObj(__webpack_require__(20)),
    xmlReplacer = getInverseReplacer(inverseXML);
  exports.XML = getInverse(inverseXML, xmlReplacer);
  var inverseHTML = getInverseObj(__webpack_require__(19)),
    htmlReplacer = getInverseReplacer(inverseHTML);
  exports.HTML = getInverse(inverseHTML, htmlReplacer);
  function getInverseObj(obj) {
    return Object.keys(obj).sort().reduce(function (inverse, name) {
      inverse[obj[name]] = "&" + name + ";";
      return inverse;
    }, {});
  }
  function getInverseReplacer(inverse) {
    var single = [],
      multiple = [];
    Object.keys(inverse).forEach(function (k) {
      if (k.length === 1) {
        single.push("\\" + k);
      } else {
        multiple.push(k);
      }
    });

    //TODO add ranges
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
  }
  var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  function singleCharReplacer(c) {
    return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
  }
  function astralReplacer(c) {
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    var high = c.charCodeAt(0);
    var low = c.charCodeAt(1);
    var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
  }
  function getInverse(inverse, re) {
    function func(name) {
      return inverse[name];
    }
    return function (data) {
      return data.replace(re, func).replace(re_astralSymbols, astralReplacer).replace(re_nonASCII, singleCharReplacer);
    };
  }
  var re_xmlChars = getInverseReplacer(inverseXML);
  function escapeXML(data) {
    return data.replace(re_xmlChars, singleCharReplacer).replace(re_astralSymbols, astralReplacer).replace(re_nonASCII, singleCharReplacer);
  }
  exports.escape = escapeXML;

  /***/
}, /* 31 */
/***/function (module, exports) {
  module.exports = {
    "0": 65533,
    "128": 8364,
    "130": 8218,
    "131": 402,
    "132": 8222,
    "133": 8230,
    "134": 8224,
    "135": 8225,
    "136": 710,
    "137": 8240,
    "138": 352,
    "139": 8249,
    "140": 338,
    "142": 381,
    "145": 8216,
    "146": 8217,
    "147": 8220,
    "148": 8221,
    "149": 8226,
    "150": 8211,
    "151": 8212,
    "152": 732,
    "153": 8482,
    "154": 353,
    "155": 8250,
    "156": 339,
    "158": 382,
    "159": 376
  };

  /***/
}, /* 32 */
/***/function (module, exports) {
  module.exports = {
    "Aacute": "Á",
    "aacute": "á",
    "Acirc": "Â",
    "acirc": "â",
    "acute": "´",
    "AElig": "Æ",
    "aelig": "æ",
    "Agrave": "À",
    "agrave": "à",
    "amp": "&",
    "AMP": "&",
    "Aring": "Å",
    "aring": "å",
    "Atilde": "Ã",
    "atilde": "ã",
    "Auml": "Ä",
    "auml": "ä",
    "brvbar": "¦",
    "Ccedil": "Ç",
    "ccedil": "ç",
    "cedil": "¸",
    "cent": "¢",
    "copy": "©",
    "COPY": "©",
    "curren": "¤",
    "deg": "°",
    "divide": "÷",
    "Eacute": "É",
    "eacute": "é",
    "Ecirc": "Ê",
    "ecirc": "ê",
    "Egrave": "È",
    "egrave": "è",
    "ETH": "Ð",
    "eth": "ð",
    "Euml": "Ë",
    "euml": "ë",
    "frac12": "½",
    "frac14": "¼",
    "frac34": "¾",
    "gt": ">",
    "GT": ">",
    "Iacute": "Í",
    "iacute": "í",
    "Icirc": "Î",
    "icirc": "î",
    "iexcl": "¡",
    "Igrave": "Ì",
    "igrave": "ì",
    "iquest": "¿",
    "Iuml": "Ï",
    "iuml": "ï",
    "laquo": "«",
    "lt": "<",
    "LT": "<",
    "macr": "¯",
    "micro": "µ",
    "middot": "·",
    "nbsp": " ",
    "not": "¬",
    "Ntilde": "Ñ",
    "ntilde": "ñ",
    "Oacute": "Ó",
    "oacute": "ó",
    "Ocirc": "Ô",
    "ocirc": "ô",
    "Ograve": "Ò",
    "ograve": "ò",
    "ordf": "ª",
    "ordm": "º",
    "Oslash": "Ø",
    "oslash": "ø",
    "Otilde": "Õ",
    "otilde": "õ",
    "Ouml": "Ö",
    "ouml": "ö",
    "para": "¶",
    "plusmn": "±",
    "pound": "£",
    "quot": "\"",
    "QUOT": "\"",
    "raquo": "»",
    "reg": "®",
    "REG": "®",
    "sect": "§",
    "shy": "­",
    "sup1": "¹",
    "sup2": "²",
    "sup3": "³",
    "szlig": "ß",
    "THORN": "Þ",
    "thorn": "þ",
    "times": "×",
    "Uacute": "Ú",
    "uacute": "ú",
    "Ucirc": "Û",
    "ucirc": "û",
    "Ugrave": "Ù",
    "ugrave": "ù",
    "uml": "¨",
    "Uuml": "Ü",
    "uuml": "ü",
    "Yacute": "Ý",
    "yacute": "ý",
    "yen": "¥",
    "yuml": "ÿ"
  };

  /***/
}, /* 33 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (module, global) {
    var __WEBPACK_AMD_DEFINE_RESULT__; /*! https://mths.be/he v1.1.1 by @mathias | MIT license */
    ;
    (function (root) {
      // Detect free variables `exports`.
      var freeExports = typeof exports == 'object' && exports;

      // Detect free variable `module`.
      var freeModule = typeof module == 'object' && module && module.exports == freeExports && module;

      // Detect free variable `global`, from Node.js or Browserified code,
      // and use it as `root`.
      var freeGlobal = typeof global == 'object' && global;
      if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
        root = freeGlobal;
      }

      /*--------------------------------------------------------------------------*/

      // All astral symbols.
      var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
      // All ASCII symbols (not just printable ASCII) except those listed in the
      // first column of the overrides table.
      // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
      var regexAsciiWhitelist = /[\x01-\x7F]/g;
      // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
      // code points listed in the first column of the overrides table on
      // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
      var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
      var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
      var encodeMap = {
        '\xAD': 'shy',
        "\u200C": 'zwnj',
        "\u200D": 'zwj',
        "\u200E": 'lrm',
        "\u2063": 'ic',
        "\u2062": 'it',
        "\u2061": 'af',
        "\u200F": 'rlm',
        "\u200B": 'ZeroWidthSpace',
        "\u2060": 'NoBreak',
        "\u0311": 'DownBreve',
        "\u20DB": 'tdot',
        "\u20DC": 'DotDot',
        '\t': 'Tab',
        '\n': 'NewLine',
        "\u2008": 'puncsp',
        "\u205F": 'MediumSpace',
        "\u2009": 'thinsp',
        "\u200A": 'hairsp',
        "\u2004": 'emsp13',
        "\u2002": 'ensp',
        "\u2005": 'emsp14',
        "\u2003": 'emsp',
        "\u2007": 'numsp',
        '\xA0': 'nbsp',
        "\u205F\u200A": 'ThickSpace',
        "\u203E": 'oline',
        '_': 'lowbar',
        "\u2010": 'dash',
        "\u2013": 'ndash',
        "\u2014": 'mdash',
        "\u2015": 'horbar',
        ',': 'comma',
        ';': 'semi',
        "\u204F": 'bsemi',
        ':': 'colon',
        "\u2A74": 'Colone',
        '!': 'excl',
        '\xA1': 'iexcl',
        '?': 'quest',
        '\xBF': 'iquest',
        '.': 'period',
        "\u2025": 'nldr',
        "\u2026": 'mldr',
        '\xB7': 'middot',
        '\'': 'apos',
        "\u2018": 'lsquo',
        "\u2019": 'rsquo',
        "\u201A": 'sbquo',
        "\u2039": 'lsaquo',
        "\u203A": 'rsaquo',
        '"': 'quot',
        "\u201C": 'ldquo',
        "\u201D": 'rdquo',
        "\u201E": 'bdquo',
        '\xAB': 'laquo',
        '\xBB': 'raquo',
        '(': 'lpar',
        ')': 'rpar',
        '[': 'lsqb',
        ']': 'rsqb',
        '{': 'lcub',
        '}': 'rcub',
        "\u2308": 'lceil',
        "\u2309": 'rceil',
        "\u230A": 'lfloor',
        "\u230B": 'rfloor',
        "\u2985": 'lopar',
        "\u2986": 'ropar',
        "\u298B": 'lbrke',
        "\u298C": 'rbrke',
        "\u298D": 'lbrkslu',
        "\u298E": 'rbrksld',
        "\u298F": 'lbrksld',
        "\u2990": 'rbrkslu',
        "\u2991": 'langd',
        "\u2992": 'rangd',
        "\u2993": 'lparlt',
        "\u2994": 'rpargt',
        "\u2995": 'gtlPar',
        "\u2996": 'ltrPar',
        "\u27E6": 'lobrk',
        "\u27E7": 'robrk',
        "\u27E8": 'lang',
        "\u27E9": 'rang',
        "\u27EA": 'Lang',
        "\u27EB": 'Rang',
        "\u27EC": 'loang',
        "\u27ED": 'roang',
        "\u2772": 'lbbrk',
        "\u2773": 'rbbrk',
        "\u2016": 'Vert',
        '\xA7': 'sect',
        '\xB6': 'para',
        '@': 'commat',
        '*': 'ast',
        '/': 'sol',
        'undefined': null,
        '&': 'amp',
        '#': 'num',
        '%': 'percnt',
        "\u2030": 'permil',
        "\u2031": 'pertenk',
        "\u2020": 'dagger',
        "\u2021": 'Dagger',
        "\u2022": 'bull',
        "\u2043": 'hybull',
        "\u2032": 'prime',
        "\u2033": 'Prime',
        "\u2034": 'tprime',
        "\u2057": 'qprime',
        "\u2035": 'bprime',
        "\u2041": 'caret',
        '`': 'grave',
        '\xB4': 'acute',
        "\u02DC": 'tilde',
        '^': 'Hat',
        '\xAF': 'macr',
        "\u02D8": 'breve',
        "\u02D9": 'dot',
        '\xA8': 'die',
        "\u02DA": 'ring',
        "\u02DD": 'dblac',
        '\xB8': 'cedil',
        "\u02DB": 'ogon',
        "\u02C6": 'circ',
        "\u02C7": 'caron',
        '\xB0': 'deg',
        '\xA9': 'copy',
        '\xAE': 'reg',
        "\u2117": 'copysr',
        "\u2118": 'wp',
        "\u211E": 'rx',
        "\u2127": 'mho',
        "\u2129": 'iiota',
        "\u2190": 'larr',
        "\u219A": 'nlarr',
        "\u2192": 'rarr',
        "\u219B": 'nrarr',
        "\u2191": 'uarr',
        "\u2193": 'darr',
        "\u2194": 'harr',
        "\u21AE": 'nharr',
        "\u2195": 'varr',
        "\u2196": 'nwarr',
        "\u2197": 'nearr',
        "\u2198": 'searr',
        "\u2199": 'swarr',
        "\u219D": 'rarrw',
        "\u219D\u0338": 'nrarrw',
        "\u219E": 'Larr',
        "\u219F": 'Uarr',
        "\u21A0": 'Rarr',
        "\u21A1": 'Darr',
        "\u21A2": 'larrtl',
        "\u21A3": 'rarrtl',
        "\u21A4": 'mapstoleft',
        "\u21A5": 'mapstoup',
        "\u21A6": 'map',
        "\u21A7": 'mapstodown',
        "\u21A9": 'larrhk',
        "\u21AA": 'rarrhk',
        "\u21AB": 'larrlp',
        "\u21AC": 'rarrlp',
        "\u21AD": 'harrw',
        "\u21B0": 'lsh',
        "\u21B1": 'rsh',
        "\u21B2": 'ldsh',
        "\u21B3": 'rdsh',
        "\u21B5": 'crarr',
        "\u21B6": 'cularr',
        "\u21B7": 'curarr',
        "\u21BA": 'olarr',
        "\u21BB": 'orarr',
        "\u21BC": 'lharu',
        "\u21BD": 'lhard',
        "\u21BE": 'uharr',
        "\u21BF": 'uharl',
        "\u21C0": 'rharu',
        "\u21C1": 'rhard',
        "\u21C2": 'dharr',
        "\u21C3": 'dharl',
        "\u21C4": 'rlarr',
        "\u21C5": 'udarr',
        "\u21C6": 'lrarr',
        "\u21C7": 'llarr',
        "\u21C8": 'uuarr',
        "\u21C9": 'rrarr',
        "\u21CA": 'ddarr',
        "\u21CB": 'lrhar',
        "\u21CC": 'rlhar',
        "\u21D0": 'lArr',
        "\u21CD": 'nlArr',
        "\u21D1": 'uArr',
        "\u21D2": 'rArr',
        "\u21CF": 'nrArr',
        "\u21D3": 'dArr',
        "\u21D4": 'iff',
        "\u21CE": 'nhArr',
        "\u21D5": 'vArr',
        "\u21D6": 'nwArr',
        "\u21D7": 'neArr',
        "\u21D8": 'seArr',
        "\u21D9": 'swArr',
        "\u21DA": 'lAarr',
        "\u21DB": 'rAarr',
        "\u21DD": 'zigrarr',
        "\u21E4": 'larrb',
        "\u21E5": 'rarrb',
        "\u21F5": 'duarr',
        "\u21FD": 'loarr',
        "\u21FE": 'roarr',
        "\u21FF": 'hoarr',
        "\u2200": 'forall',
        "\u2201": 'comp',
        "\u2202": 'part',
        "\u2202\u0338": 'npart',
        "\u2203": 'exist',
        "\u2204": 'nexist',
        "\u2205": 'empty',
        "\u2207": 'Del',
        "\u2208": 'in',
        "\u2209": 'notin',
        "\u220B": 'ni',
        "\u220C": 'notni',
        "\u03F6": 'bepsi',
        "\u220F": 'prod',
        "\u2210": 'coprod',
        "\u2211": 'sum',
        '+': 'plus',
        '\xB1': 'pm',
        '\xF7': 'div',
        '\xD7': 'times',
        '<': 'lt',
        "\u226E": 'nlt',
        "<\u20D2": 'nvlt',
        '=': 'equals',
        "\u2260": 'ne',
        "=\u20E5": 'bne',
        "\u2A75": 'Equal',
        '>': 'gt',
        "\u226F": 'ngt',
        ">\u20D2": 'nvgt',
        '\xAC': 'not',
        '|': 'vert',
        '\xA6': 'brvbar',
        "\u2212": 'minus',
        "\u2213": 'mp',
        "\u2214": 'plusdo',
        "\u2044": 'frasl',
        "\u2216": 'setmn',
        "\u2217": 'lowast',
        "\u2218": 'compfn',
        "\u221A": 'Sqrt',
        "\u221D": 'prop',
        "\u221E": 'infin',
        "\u221F": 'angrt',
        "\u2220": 'ang',
        "\u2220\u20D2": 'nang',
        "\u2221": 'angmsd',
        "\u2222": 'angsph',
        "\u2223": 'mid',
        "\u2224": 'nmid',
        "\u2225": 'par',
        "\u2226": 'npar',
        "\u2227": 'and',
        "\u2228": 'or',
        "\u2229": 'cap',
        "\u2229\uFE00": 'caps',
        "\u222A": 'cup',
        "\u222A\uFE00": 'cups',
        "\u222B": 'int',
        "\u222C": 'Int',
        "\u222D": 'tint',
        "\u2A0C": 'qint',
        "\u222E": 'oint',
        "\u222F": 'Conint',
        "\u2230": 'Cconint',
        "\u2231": 'cwint',
        "\u2232": 'cwconint',
        "\u2233": 'awconint',
        "\u2234": 'there4',
        "\u2235": 'becaus',
        "\u2236": 'ratio',
        "\u2237": 'Colon',
        "\u2238": 'minusd',
        "\u223A": 'mDDot',
        "\u223B": 'homtht',
        "\u223C": 'sim',
        "\u2241": 'nsim',
        "\u223C\u20D2": 'nvsim',
        "\u223D": 'bsim',
        "\u223D\u0331": 'race',
        "\u223E": 'ac',
        "\u223E\u0333": 'acE',
        "\u223F": 'acd',
        "\u2240": 'wr',
        "\u2242": 'esim',
        "\u2242\u0338": 'nesim',
        "\u2243": 'sime',
        "\u2244": 'nsime',
        "\u2245": 'cong',
        "\u2247": 'ncong',
        "\u2246": 'simne',
        "\u2248": 'ap',
        "\u2249": 'nap',
        "\u224A": 'ape',
        "\u224B": 'apid',
        "\u224B\u0338": 'napid',
        "\u224C": 'bcong',
        "\u224D": 'CupCap',
        "\u226D": 'NotCupCap',
        "\u224D\u20D2": 'nvap',
        "\u224E": 'bump',
        "\u224E\u0338": 'nbump',
        "\u224F": 'bumpe',
        "\u224F\u0338": 'nbumpe',
        "\u2250": 'doteq',
        "\u2250\u0338": 'nedot',
        "\u2251": 'eDot',
        "\u2252": 'efDot',
        "\u2253": 'erDot',
        "\u2254": 'colone',
        "\u2255": 'ecolon',
        "\u2256": 'ecir',
        "\u2257": 'cire',
        "\u2259": 'wedgeq',
        "\u225A": 'veeeq',
        "\u225C": 'trie',
        "\u225F": 'equest',
        "\u2261": 'equiv',
        "\u2262": 'nequiv',
        "\u2261\u20E5": 'bnequiv',
        "\u2264": 'le',
        "\u2270": 'nle',
        "\u2264\u20D2": 'nvle',
        "\u2265": 'ge',
        "\u2271": 'nge',
        "\u2265\u20D2": 'nvge',
        "\u2266": 'lE',
        "\u2266\u0338": 'nlE',
        "\u2267": 'gE',
        "\u2267\u0338": 'ngE',
        "\u2268\uFE00": 'lvnE',
        "\u2268": 'lnE',
        "\u2269": 'gnE',
        "\u2269\uFE00": 'gvnE',
        "\u226A": 'll',
        "\u226A\u0338": 'nLtv',
        "\u226A\u20D2": 'nLt',
        "\u226B": 'gg',
        "\u226B\u0338": 'nGtv',
        "\u226B\u20D2": 'nGt',
        "\u226C": 'twixt',
        "\u2272": 'lsim',
        "\u2274": 'nlsim',
        "\u2273": 'gsim',
        "\u2275": 'ngsim',
        "\u2276": 'lg',
        "\u2278": 'ntlg',
        "\u2277": 'gl',
        "\u2279": 'ntgl',
        "\u227A": 'pr',
        "\u2280": 'npr',
        "\u227B": 'sc',
        "\u2281": 'nsc',
        "\u227C": 'prcue',
        "\u22E0": 'nprcue',
        "\u227D": 'sccue',
        "\u22E1": 'nsccue',
        "\u227E": 'prsim',
        "\u227F": 'scsim',
        "\u227F\u0338": 'NotSucceedsTilde',
        "\u2282": 'sub',
        "\u2284": 'nsub',
        "\u2282\u20D2": 'vnsub',
        "\u2283": 'sup',
        "\u2285": 'nsup',
        "\u2283\u20D2": 'vnsup',
        "\u2286": 'sube',
        "\u2288": 'nsube',
        "\u2287": 'supe',
        "\u2289": 'nsupe',
        "\u228A\uFE00": 'vsubne',
        "\u228A": 'subne',
        "\u228B\uFE00": 'vsupne',
        "\u228B": 'supne',
        "\u228D": 'cupdot',
        "\u228E": 'uplus',
        "\u228F": 'sqsub',
        "\u228F\u0338": 'NotSquareSubset',
        "\u2290": 'sqsup',
        "\u2290\u0338": 'NotSquareSuperset',
        "\u2291": 'sqsube',
        "\u22E2": 'nsqsube',
        "\u2292": 'sqsupe',
        "\u22E3": 'nsqsupe',
        "\u2293": 'sqcap',
        "\u2293\uFE00": 'sqcaps',
        "\u2294": 'sqcup',
        "\u2294\uFE00": 'sqcups',
        "\u2295": 'oplus',
        "\u2296": 'ominus',
        "\u2297": 'otimes',
        "\u2298": 'osol',
        "\u2299": 'odot',
        "\u229A": 'ocir',
        "\u229B": 'oast',
        "\u229D": 'odash',
        "\u229E": 'plusb',
        "\u229F": 'minusb',
        "\u22A0": 'timesb',
        "\u22A1": 'sdotb',
        "\u22A2": 'vdash',
        "\u22AC": 'nvdash',
        "\u22A3": 'dashv',
        "\u22A4": 'top',
        "\u22A5": 'bot',
        "\u22A7": 'models',
        "\u22A8": 'vDash',
        "\u22AD": 'nvDash',
        "\u22A9": 'Vdash',
        "\u22AE": 'nVdash',
        "\u22AA": 'Vvdash',
        "\u22AB": 'VDash',
        "\u22AF": 'nVDash',
        "\u22B0": 'prurel',
        "\u22B2": 'vltri',
        "\u22EA": 'nltri',
        "\u22B3": 'vrtri',
        "\u22EB": 'nrtri',
        "\u22B4": 'ltrie',
        "\u22EC": 'nltrie',
        "\u22B4\u20D2": 'nvltrie',
        "\u22B5": 'rtrie',
        "\u22ED": 'nrtrie',
        "\u22B5\u20D2": 'nvrtrie',
        "\u22B6": 'origof',
        "\u22B7": 'imof',
        "\u22B8": 'mumap',
        "\u22B9": 'hercon',
        "\u22BA": 'intcal',
        "\u22BB": 'veebar',
        "\u22BD": 'barvee',
        "\u22BE": 'angrtvb',
        "\u22BF": 'lrtri',
        "\u22C0": 'Wedge',
        "\u22C1": 'Vee',
        "\u22C2": 'xcap',
        "\u22C3": 'xcup',
        "\u22C4": 'diam',
        "\u22C5": 'sdot',
        "\u22C6": 'Star',
        "\u22C7": 'divonx',
        "\u22C8": 'bowtie',
        "\u22C9": 'ltimes',
        "\u22CA": 'rtimes',
        "\u22CB": 'lthree',
        "\u22CC": 'rthree',
        "\u22CD": 'bsime',
        "\u22CE": 'cuvee',
        "\u22CF": 'cuwed',
        "\u22D0": 'Sub',
        "\u22D1": 'Sup',
        "\u22D2": 'Cap',
        "\u22D3": 'Cup',
        "\u22D4": 'fork',
        "\u22D5": 'epar',
        "\u22D6": 'ltdot',
        "\u22D7": 'gtdot',
        "\u22D8": 'Ll',
        "\u22D8\u0338": 'nLl',
        "\u22D9": 'Gg',
        "\u22D9\u0338": 'nGg',
        "\u22DA\uFE00": 'lesg',
        "\u22DA": 'leg',
        "\u22DB": 'gel',
        "\u22DB\uFE00": 'gesl',
        "\u22DE": 'cuepr',
        "\u22DF": 'cuesc',
        "\u22E6": 'lnsim',
        "\u22E7": 'gnsim',
        "\u22E8": 'prnsim',
        "\u22E9": 'scnsim',
        "\u22EE": 'vellip',
        "\u22EF": 'ctdot',
        "\u22F0": 'utdot',
        "\u22F1": 'dtdot',
        "\u22F2": 'disin',
        "\u22F3": 'isinsv',
        "\u22F4": 'isins',
        "\u22F5": 'isindot',
        "\u22F5\u0338": 'notindot',
        "\u22F6": 'notinvc',
        "\u22F7": 'notinvb',
        "\u22F9": 'isinE',
        "\u22F9\u0338": 'notinE',
        "\u22FA": 'nisd',
        "\u22FB": 'xnis',
        "\u22FC": 'nis',
        "\u22FD": 'notnivc',
        "\u22FE": 'notnivb',
        "\u2305": 'barwed',
        "\u2306": 'Barwed',
        "\u230C": 'drcrop',
        "\u230D": 'dlcrop',
        "\u230E": 'urcrop',
        "\u230F": 'ulcrop',
        "\u2310": 'bnot',
        "\u2312": 'profline',
        "\u2313": 'profsurf',
        "\u2315": 'telrec',
        "\u2316": 'target',
        "\u231C": 'ulcorn',
        "\u231D": 'urcorn',
        "\u231E": 'dlcorn',
        "\u231F": 'drcorn',
        "\u2322": 'frown',
        "\u2323": 'smile',
        "\u232D": 'cylcty',
        "\u232E": 'profalar',
        "\u2336": 'topbot',
        "\u233D": 'ovbar',
        "\u233F": 'solbar',
        "\u237C": 'angzarr',
        "\u23B0": 'lmoust',
        "\u23B1": 'rmoust',
        "\u23B4": 'tbrk',
        "\u23B5": 'bbrk',
        "\u23B6": 'bbrktbrk',
        "\u23DC": 'OverParenthesis',
        "\u23DD": 'UnderParenthesis',
        "\u23DE": 'OverBrace',
        "\u23DF": 'UnderBrace',
        "\u23E2": 'trpezium',
        "\u23E7": 'elinters',
        "\u2423": 'blank',
        "\u2500": 'boxh',
        "\u2502": 'boxv',
        "\u250C": 'boxdr',
        "\u2510": 'boxdl',
        "\u2514": 'boxur',
        "\u2518": 'boxul',
        "\u251C": 'boxvr',
        "\u2524": 'boxvl',
        "\u252C": 'boxhd',
        "\u2534": 'boxhu',
        "\u253C": 'boxvh',
        "\u2550": 'boxH',
        "\u2551": 'boxV',
        "\u2552": 'boxdR',
        "\u2553": 'boxDr',
        "\u2554": 'boxDR',
        "\u2555": 'boxdL',
        "\u2556": 'boxDl',
        "\u2557": 'boxDL',
        "\u2558": 'boxuR',
        "\u2559": 'boxUr',
        "\u255A": 'boxUR',
        "\u255B": 'boxuL',
        "\u255C": 'boxUl',
        "\u255D": 'boxUL',
        "\u255E": 'boxvR',
        "\u255F": 'boxVr',
        "\u2560": 'boxVR',
        "\u2561": 'boxvL',
        "\u2562": 'boxVl',
        "\u2563": 'boxVL',
        "\u2564": 'boxHd',
        "\u2565": 'boxhD',
        "\u2566": 'boxHD',
        "\u2567": 'boxHu',
        "\u2568": 'boxhU',
        "\u2569": 'boxHU',
        "\u256A": 'boxvH',
        "\u256B": 'boxVh',
        "\u256C": 'boxVH',
        "\u2580": 'uhblk',
        "\u2584": 'lhblk',
        "\u2588": 'block',
        "\u2591": 'blk14',
        "\u2592": 'blk12',
        "\u2593": 'blk34',
        "\u25A1": 'squ',
        "\u25AA": 'squf',
        "\u25AB": 'EmptyVerySmallSquare',
        "\u25AD": 'rect',
        "\u25AE": 'marker',
        "\u25B1": 'fltns',
        "\u25B3": 'xutri',
        "\u25B4": 'utrif',
        "\u25B5": 'utri',
        "\u25B8": 'rtrif',
        "\u25B9": 'rtri',
        "\u25BD": 'xdtri',
        "\u25BE": 'dtrif',
        "\u25BF": 'dtri',
        "\u25C2": 'ltrif',
        "\u25C3": 'ltri',
        "\u25CA": 'loz',
        "\u25CB": 'cir',
        "\u25EC": 'tridot',
        "\u25EF": 'xcirc',
        "\u25F8": 'ultri',
        "\u25F9": 'urtri',
        "\u25FA": 'lltri',
        "\u25FB": 'EmptySmallSquare',
        "\u25FC": 'FilledSmallSquare',
        "\u2605": 'starf',
        "\u2606": 'star',
        "\u260E": 'phone',
        "\u2640": 'female',
        "\u2642": 'male',
        "\u2660": 'spades',
        "\u2663": 'clubs',
        "\u2665": 'hearts',
        "\u2666": 'diams',
        "\u266A": 'sung',
        "\u2713": 'check',
        "\u2717": 'cross',
        "\u2720": 'malt',
        "\u2736": 'sext',
        "\u2758": 'VerticalSeparator',
        "\u27C8": 'bsolhsub',
        "\u27C9": 'suphsol',
        "\u27F5": 'xlarr',
        "\u27F6": 'xrarr',
        "\u27F7": 'xharr',
        "\u27F8": 'xlArr',
        "\u27F9": 'xrArr',
        "\u27FA": 'xhArr',
        "\u27FC": 'xmap',
        "\u27FF": 'dzigrarr',
        "\u2902": 'nvlArr',
        "\u2903": 'nvrArr',
        "\u2904": 'nvHarr',
        "\u2905": 'Map',
        "\u290C": 'lbarr',
        "\u290D": 'rbarr',
        "\u290E": 'lBarr',
        "\u290F": 'rBarr',
        "\u2910": 'RBarr',
        "\u2911": 'DDotrahd',
        "\u2912": 'UpArrowBar',
        "\u2913": 'DownArrowBar',
        "\u2916": 'Rarrtl',
        "\u2919": 'latail',
        "\u291A": 'ratail',
        "\u291B": 'lAtail',
        "\u291C": 'rAtail',
        "\u291D": 'larrfs',
        "\u291E": 'rarrfs',
        "\u291F": 'larrbfs',
        "\u2920": 'rarrbfs',
        "\u2923": 'nwarhk',
        "\u2924": 'nearhk',
        "\u2925": 'searhk',
        "\u2926": 'swarhk',
        "\u2927": 'nwnear',
        "\u2928": 'toea',
        "\u2929": 'tosa',
        "\u292A": 'swnwar',
        "\u2933": 'rarrc',
        "\u2933\u0338": 'nrarrc',
        "\u2935": 'cudarrr',
        "\u2936": 'ldca',
        "\u2937": 'rdca',
        "\u2938": 'cudarrl',
        "\u2939": 'larrpl',
        "\u293C": 'curarrm',
        "\u293D": 'cularrp',
        "\u2945": 'rarrpl',
        "\u2948": 'harrcir',
        "\u2949": 'Uarrocir',
        "\u294A": 'lurdshar',
        "\u294B": 'ldrushar',
        "\u294E": 'LeftRightVector',
        "\u294F": 'RightUpDownVector',
        "\u2950": 'DownLeftRightVector',
        "\u2951": 'LeftUpDownVector',
        "\u2952": 'LeftVectorBar',
        "\u2953": 'RightVectorBar',
        "\u2954": 'RightUpVectorBar',
        "\u2955": 'RightDownVectorBar',
        "\u2956": 'DownLeftVectorBar',
        "\u2957": 'DownRightVectorBar',
        "\u2958": 'LeftUpVectorBar',
        "\u2959": 'LeftDownVectorBar',
        "\u295A": 'LeftTeeVector',
        "\u295B": 'RightTeeVector',
        "\u295C": 'RightUpTeeVector',
        "\u295D": 'RightDownTeeVector',
        "\u295E": 'DownLeftTeeVector',
        "\u295F": 'DownRightTeeVector',
        "\u2960": 'LeftUpTeeVector',
        "\u2961": 'LeftDownTeeVector',
        "\u2962": 'lHar',
        "\u2963": 'uHar',
        "\u2964": 'rHar',
        "\u2965": 'dHar',
        "\u2966": 'luruhar',
        "\u2967": 'ldrdhar',
        "\u2968": 'ruluhar',
        "\u2969": 'rdldhar',
        "\u296A": 'lharul',
        "\u296B": 'llhard',
        "\u296C": 'rharul',
        "\u296D": 'lrhard',
        "\u296E": 'udhar',
        "\u296F": 'duhar',
        "\u2970": 'RoundImplies',
        "\u2971": 'erarr',
        "\u2972": 'simrarr',
        "\u2973": 'larrsim',
        "\u2974": 'rarrsim',
        "\u2975": 'rarrap',
        "\u2976": 'ltlarr',
        "\u2978": 'gtrarr',
        "\u2979": 'subrarr',
        "\u297B": 'suplarr',
        "\u297C": 'lfisht',
        "\u297D": 'rfisht',
        "\u297E": 'ufisht',
        "\u297F": 'dfisht',
        "\u299A": 'vzigzag',
        "\u299C": 'vangrt',
        "\u299D": 'angrtvbd',
        "\u29A4": 'ange',
        "\u29A5": 'range',
        "\u29A6": 'dwangle',
        "\u29A7": 'uwangle',
        "\u29A8": 'angmsdaa',
        "\u29A9": 'angmsdab',
        "\u29AA": 'angmsdac',
        "\u29AB": 'angmsdad',
        "\u29AC": 'angmsdae',
        "\u29AD": 'angmsdaf',
        "\u29AE": 'angmsdag',
        "\u29AF": 'angmsdah',
        "\u29B0": 'bemptyv',
        "\u29B1": 'demptyv',
        "\u29B2": 'cemptyv',
        "\u29B3": 'raemptyv',
        "\u29B4": 'laemptyv',
        "\u29B5": 'ohbar',
        "\u29B6": 'omid',
        "\u29B7": 'opar',
        "\u29B9": 'operp',
        "\u29BB": 'olcross',
        "\u29BC": 'odsold',
        "\u29BE": 'olcir',
        "\u29BF": 'ofcir',
        "\u29C0": 'olt',
        "\u29C1": 'ogt',
        "\u29C2": 'cirscir',
        "\u29C3": 'cirE',
        "\u29C4": 'solb',
        "\u29C5": 'bsolb',
        "\u29C9": 'boxbox',
        "\u29CD": 'trisb',
        "\u29CE": 'rtriltri',
        "\u29CF": 'LeftTriangleBar',
        "\u29CF\u0338": 'NotLeftTriangleBar',
        "\u29D0": 'RightTriangleBar',
        "\u29D0\u0338": 'NotRightTriangleBar',
        "\u29DC": 'iinfin',
        "\u29DD": 'infintie',
        "\u29DE": 'nvinfin',
        "\u29E3": 'eparsl',
        "\u29E4": 'smeparsl',
        "\u29E5": 'eqvparsl',
        "\u29EB": 'lozf',
        "\u29F4": 'RuleDelayed',
        "\u29F6": 'dsol',
        "\u2A00": 'xodot',
        "\u2A01": 'xoplus',
        "\u2A02": 'xotime',
        "\u2A04": 'xuplus',
        "\u2A06": 'xsqcup',
        "\u2A0D": 'fpartint',
        "\u2A10": 'cirfnint',
        "\u2A11": 'awint',
        "\u2A12": 'rppolint',
        "\u2A13": 'scpolint',
        "\u2A14": 'npolint',
        "\u2A15": 'pointint',
        "\u2A16": 'quatint',
        "\u2A17": 'intlarhk',
        "\u2A22": 'pluscir',
        "\u2A23": 'plusacir',
        "\u2A24": 'simplus',
        "\u2A25": 'plusdu',
        "\u2A26": 'plussim',
        "\u2A27": 'plustwo',
        "\u2A29": 'mcomma',
        "\u2A2A": 'minusdu',
        "\u2A2D": 'loplus',
        "\u2A2E": 'roplus',
        "\u2A2F": 'Cross',
        "\u2A30": 'timesd',
        "\u2A31": 'timesbar',
        "\u2A33": 'smashp',
        "\u2A34": 'lotimes',
        "\u2A35": 'rotimes',
        "\u2A36": 'otimesas',
        "\u2A37": 'Otimes',
        "\u2A38": 'odiv',
        "\u2A39": 'triplus',
        "\u2A3A": 'triminus',
        "\u2A3B": 'tritime',
        "\u2A3C": 'iprod',
        "\u2A3F": 'amalg',
        "\u2A40": 'capdot',
        "\u2A42": 'ncup',
        "\u2A43": 'ncap',
        "\u2A44": 'capand',
        "\u2A45": 'cupor',
        "\u2A46": 'cupcap',
        "\u2A47": 'capcup',
        "\u2A48": 'cupbrcap',
        "\u2A49": 'capbrcup',
        "\u2A4A": 'cupcup',
        "\u2A4B": 'capcap',
        "\u2A4C": 'ccups',
        "\u2A4D": 'ccaps',
        "\u2A50": 'ccupssm',
        "\u2A53": 'And',
        "\u2A54": 'Or',
        "\u2A55": 'andand',
        "\u2A56": 'oror',
        "\u2A57": 'orslope',
        "\u2A58": 'andslope',
        "\u2A5A": 'andv',
        "\u2A5B": 'orv',
        "\u2A5C": 'andd',
        "\u2A5D": 'ord',
        "\u2A5F": 'wedbar',
        "\u2A66": 'sdote',
        "\u2A6A": 'simdot',
        "\u2A6D": 'congdot',
        "\u2A6D\u0338": 'ncongdot',
        "\u2A6E": 'easter',
        "\u2A6F": 'apacir',
        "\u2A70": 'apE',
        "\u2A70\u0338": 'napE',
        "\u2A71": 'eplus',
        "\u2A72": 'pluse',
        "\u2A73": 'Esim',
        "\u2A77": 'eDDot',
        "\u2A78": 'equivDD',
        "\u2A79": 'ltcir',
        "\u2A7A": 'gtcir',
        "\u2A7B": 'ltquest',
        "\u2A7C": 'gtquest',
        "\u2A7D": 'les',
        "\u2A7D\u0338": 'nles',
        "\u2A7E": 'ges',
        "\u2A7E\u0338": 'nges',
        "\u2A7F": 'lesdot',
        "\u2A80": 'gesdot',
        "\u2A81": 'lesdoto',
        "\u2A82": 'gesdoto',
        "\u2A83": 'lesdotor',
        "\u2A84": 'gesdotol',
        "\u2A85": 'lap',
        "\u2A86": 'gap',
        "\u2A87": 'lne',
        "\u2A88": 'gne',
        "\u2A89": 'lnap',
        "\u2A8A": 'gnap',
        "\u2A8B": 'lEg',
        "\u2A8C": 'gEl',
        "\u2A8D": 'lsime',
        "\u2A8E": 'gsime',
        "\u2A8F": 'lsimg',
        "\u2A90": 'gsiml',
        "\u2A91": 'lgE',
        "\u2A92": 'glE',
        "\u2A93": 'lesges',
        "\u2A94": 'gesles',
        "\u2A95": 'els',
        "\u2A96": 'egs',
        "\u2A97": 'elsdot',
        "\u2A98": 'egsdot',
        "\u2A99": 'el',
        "\u2A9A": 'eg',
        "\u2A9D": 'siml',
        "\u2A9E": 'simg',
        "\u2A9F": 'simlE',
        "\u2AA0": 'simgE',
        "\u2AA1": 'LessLess',
        "\u2AA1\u0338": 'NotNestedLessLess',
        "\u2AA2": 'GreaterGreater',
        "\u2AA2\u0338": 'NotNestedGreaterGreater',
        "\u2AA4": 'glj',
        "\u2AA5": 'gla',
        "\u2AA6": 'ltcc',
        "\u2AA7": 'gtcc',
        "\u2AA8": 'lescc',
        "\u2AA9": 'gescc',
        "\u2AAA": 'smt',
        "\u2AAB": 'lat',
        "\u2AAC": 'smte',
        "\u2AAC\uFE00": 'smtes',
        "\u2AAD": 'late',
        "\u2AAD\uFE00": 'lates',
        "\u2AAE": 'bumpE',
        "\u2AAF": 'pre',
        "\u2AAF\u0338": 'npre',
        "\u2AB0": 'sce',
        "\u2AB0\u0338": 'nsce',
        "\u2AB3": 'prE',
        "\u2AB4": 'scE',
        "\u2AB5": 'prnE',
        "\u2AB6": 'scnE',
        "\u2AB7": 'prap',
        "\u2AB8": 'scap',
        "\u2AB9": 'prnap',
        "\u2ABA": 'scnap',
        "\u2ABB": 'Pr',
        "\u2ABC": 'Sc',
        "\u2ABD": 'subdot',
        "\u2ABE": 'supdot',
        "\u2ABF": 'subplus',
        "\u2AC0": 'supplus',
        "\u2AC1": 'submult',
        "\u2AC2": 'supmult',
        "\u2AC3": 'subedot',
        "\u2AC4": 'supedot',
        "\u2AC5": 'subE',
        "\u2AC5\u0338": 'nsubE',
        "\u2AC6": 'supE',
        "\u2AC6\u0338": 'nsupE',
        "\u2AC7": 'subsim',
        "\u2AC8": 'supsim',
        "\u2ACB\uFE00": 'vsubnE',
        "\u2ACB": 'subnE',
        "\u2ACC\uFE00": 'vsupnE',
        "\u2ACC": 'supnE',
        "\u2ACF": 'csub',
        "\u2AD0": 'csup',
        "\u2AD1": 'csube',
        "\u2AD2": 'csupe',
        "\u2AD3": 'subsup',
        "\u2AD4": 'supsub',
        "\u2AD5": 'subsub',
        "\u2AD6": 'supsup',
        "\u2AD7": 'suphsub',
        "\u2AD8": 'supdsub',
        "\u2AD9": 'forkv',
        "\u2ADA": 'topfork',
        "\u2ADB": 'mlcp',
        "\u2AE4": 'Dashv',
        "\u2AE6": 'Vdashl',
        "\u2AE7": 'Barv',
        "\u2AE8": 'vBar',
        "\u2AE9": 'vBarv',
        "\u2AEB": 'Vbar',
        "\u2AEC": 'Not',
        "\u2AED": 'bNot',
        "\u2AEE": 'rnmid',
        "\u2AEF": 'cirmid',
        "\u2AF0": 'midcir',
        "\u2AF1": 'topcir',
        "\u2AF2": 'nhpar',
        "\u2AF3": 'parsim',
        "\u2AFD": 'parsl',
        "\u2AFD\u20E5": 'nparsl',
        "\u266D": 'flat',
        "\u266E": 'natur',
        "\u266F": 'sharp',
        '\xA4': 'curren',
        '\xA2': 'cent',
        '$': 'dollar',
        '\xA3': 'pound',
        '\xA5': 'yen',
        "\u20AC": 'euro',
        '\xB9': 'sup1',
        '\xBD': 'half',
        "\u2153": 'frac13',
        '\xBC': 'frac14',
        "\u2155": 'frac15',
        "\u2159": 'frac16',
        "\u215B": 'frac18',
        '\xB2': 'sup2',
        "\u2154": 'frac23',
        "\u2156": 'frac25',
        '\xB3': 'sup3',
        '\xBE': 'frac34',
        "\u2157": 'frac35',
        "\u215C": 'frac38',
        "\u2158": 'frac45',
        "\u215A": 'frac56',
        "\u215D": 'frac58',
        "\u215E": 'frac78',
        "\uD835\uDCB6": 'ascr',
        "\uD835\uDD52": 'aopf',
        "\uD835\uDD1E": 'afr',
        "\uD835\uDD38": 'Aopf',
        "\uD835\uDD04": 'Afr',
        "\uD835\uDC9C": 'Ascr',
        '\xAA': 'ordf',
        '\xE1': 'aacute',
        '\xC1': 'Aacute',
        '\xE0': 'agrave',
        '\xC0': 'Agrave',
        "\u0103": 'abreve',
        "\u0102": 'Abreve',
        '\xE2': 'acirc',
        '\xC2': 'Acirc',
        '\xE5': 'aring',
        '\xC5': 'angst',
        '\xE4': 'auml',
        '\xC4': 'Auml',
        '\xE3': 'atilde',
        '\xC3': 'Atilde',
        "\u0105": 'aogon',
        "\u0104": 'Aogon',
        "\u0101": 'amacr',
        "\u0100": 'Amacr',
        '\xE6': 'aelig',
        '\xC6': 'AElig',
        "\uD835\uDCB7": 'bscr',
        "\uD835\uDD53": 'bopf',
        "\uD835\uDD1F": 'bfr',
        "\uD835\uDD39": 'Bopf',
        "\u212C": 'Bscr',
        "\uD835\uDD05": 'Bfr',
        "\uD835\uDD20": 'cfr',
        "\uD835\uDCB8": 'cscr',
        "\uD835\uDD54": 'copf',
        "\u212D": 'Cfr',
        "\uD835\uDC9E": 'Cscr',
        "\u2102": 'Copf',
        "\u0107": 'cacute',
        "\u0106": 'Cacute',
        "\u0109": 'ccirc',
        "\u0108": 'Ccirc',
        "\u010D": 'ccaron',
        "\u010C": 'Ccaron',
        "\u010B": 'cdot',
        "\u010A": 'Cdot',
        '\xE7': 'ccedil',
        '\xC7': 'Ccedil',
        "\u2105": 'incare',
        "\uD835\uDD21": 'dfr',
        "\u2146": 'dd',
        "\uD835\uDD55": 'dopf',
        "\uD835\uDCB9": 'dscr',
        "\uD835\uDC9F": 'Dscr',
        "\uD835\uDD07": 'Dfr',
        "\u2145": 'DD',
        "\uD835\uDD3B": 'Dopf',
        "\u010F": 'dcaron',
        "\u010E": 'Dcaron',
        "\u0111": 'dstrok',
        "\u0110": 'Dstrok',
        '\xF0': 'eth',
        '\xD0': 'ETH',
        "\u2147": 'ee',
        "\u212F": 'escr',
        "\uD835\uDD22": 'efr',
        "\uD835\uDD56": 'eopf',
        "\u2130": 'Escr',
        "\uD835\uDD08": 'Efr',
        "\uD835\uDD3C": 'Eopf',
        '\xE9': 'eacute',
        '\xC9': 'Eacute',
        '\xE8': 'egrave',
        '\xC8': 'Egrave',
        '\xEA': 'ecirc',
        '\xCA': 'Ecirc',
        "\u011B": 'ecaron',
        "\u011A": 'Ecaron',
        '\xEB': 'euml',
        '\xCB': 'Euml',
        "\u0117": 'edot',
        "\u0116": 'Edot',
        "\u0119": 'eogon',
        "\u0118": 'Eogon',
        "\u0113": 'emacr',
        "\u0112": 'Emacr',
        "\uD835\uDD23": 'ffr',
        "\uD835\uDD57": 'fopf',
        "\uD835\uDCBB": 'fscr',
        "\uD835\uDD09": 'Ffr',
        "\uD835\uDD3D": 'Fopf',
        "\u2131": 'Fscr',
        "\uFB00": 'fflig',
        "\uFB03": 'ffilig',
        "\uFB04": 'ffllig',
        "\uFB01": 'filig',
        'fj': 'fjlig',
        "\uFB02": 'fllig',
        "\u0192": 'fnof',
        "\u210A": 'gscr',
        "\uD835\uDD58": 'gopf',
        "\uD835\uDD24": 'gfr',
        "\uD835\uDCA2": 'Gscr',
        "\uD835\uDD3E": 'Gopf',
        "\uD835\uDD0A": 'Gfr',
        "\u01F5": 'gacute',
        "\u011F": 'gbreve',
        "\u011E": 'Gbreve',
        "\u011D": 'gcirc',
        "\u011C": 'Gcirc',
        "\u0121": 'gdot',
        "\u0120": 'Gdot',
        "\u0122": 'Gcedil',
        "\uD835\uDD25": 'hfr',
        "\u210E": 'planckh',
        "\uD835\uDCBD": 'hscr',
        "\uD835\uDD59": 'hopf',
        "\u210B": 'Hscr',
        "\u210C": 'Hfr',
        "\u210D": 'Hopf',
        "\u0125": 'hcirc',
        "\u0124": 'Hcirc',
        "\u210F": 'hbar',
        "\u0127": 'hstrok',
        "\u0126": 'Hstrok',
        "\uD835\uDD5A": 'iopf',
        "\uD835\uDD26": 'ifr',
        "\uD835\uDCBE": 'iscr',
        "\u2148": 'ii',
        "\uD835\uDD40": 'Iopf',
        "\u2110": 'Iscr',
        "\u2111": 'Im',
        '\xED': 'iacute',
        '\xCD': 'Iacute',
        '\xEC': 'igrave',
        '\xCC': 'Igrave',
        '\xEE': 'icirc',
        '\xCE': 'Icirc',
        '\xEF': 'iuml',
        '\xCF': 'Iuml',
        "\u0129": 'itilde',
        "\u0128": 'Itilde',
        "\u0130": 'Idot',
        "\u012F": 'iogon',
        "\u012E": 'Iogon',
        "\u012B": 'imacr',
        "\u012A": 'Imacr',
        "\u0133": 'ijlig',
        "\u0132": 'IJlig',
        "\u0131": 'imath',
        "\uD835\uDCBF": 'jscr',
        "\uD835\uDD5B": 'jopf',
        "\uD835\uDD27": 'jfr',
        "\uD835\uDCA5": 'Jscr',
        "\uD835\uDD0D": 'Jfr',
        "\uD835\uDD41": 'Jopf',
        "\u0135": 'jcirc',
        "\u0134": 'Jcirc',
        "\u0237": 'jmath',
        "\uD835\uDD5C": 'kopf',
        "\uD835\uDCC0": 'kscr',
        "\uD835\uDD28": 'kfr',
        "\uD835\uDCA6": 'Kscr',
        "\uD835\uDD42": 'Kopf',
        "\uD835\uDD0E": 'Kfr',
        "\u0137": 'kcedil',
        "\u0136": 'Kcedil',
        "\uD835\uDD29": 'lfr',
        "\uD835\uDCC1": 'lscr',
        "\u2113": 'ell',
        "\uD835\uDD5D": 'lopf',
        "\u2112": 'Lscr',
        "\uD835\uDD0F": 'Lfr',
        "\uD835\uDD43": 'Lopf',
        "\u013A": 'lacute',
        "\u0139": 'Lacute',
        "\u013E": 'lcaron',
        "\u013D": 'Lcaron',
        "\u013C": 'lcedil',
        "\u013B": 'Lcedil',
        "\u0142": 'lstrok',
        "\u0141": 'Lstrok',
        "\u0140": 'lmidot',
        "\u013F": 'Lmidot',
        "\uD835\uDD2A": 'mfr',
        "\uD835\uDD5E": 'mopf',
        "\uD835\uDCC2": 'mscr',
        "\uD835\uDD10": 'Mfr',
        "\uD835\uDD44": 'Mopf',
        "\u2133": 'Mscr',
        "\uD835\uDD2B": 'nfr',
        "\uD835\uDD5F": 'nopf',
        "\uD835\uDCC3": 'nscr',
        "\u2115": 'Nopf',
        "\uD835\uDCA9": 'Nscr',
        "\uD835\uDD11": 'Nfr',
        "\u0144": 'nacute',
        "\u0143": 'Nacute',
        "\u0148": 'ncaron',
        "\u0147": 'Ncaron',
        '\xF1': 'ntilde',
        '\xD1': 'Ntilde',
        "\u0146": 'ncedil',
        "\u0145": 'Ncedil',
        "\u2116": 'numero',
        "\u014B": 'eng',
        "\u014A": 'ENG',
        "\uD835\uDD60": 'oopf',
        "\uD835\uDD2C": 'ofr',
        "\u2134": 'oscr',
        "\uD835\uDCAA": 'Oscr',
        "\uD835\uDD12": 'Ofr',
        "\uD835\uDD46": 'Oopf',
        '\xBA': 'ordm',
        '\xF3': 'oacute',
        '\xD3': 'Oacute',
        '\xF2': 'ograve',
        '\xD2': 'Ograve',
        '\xF4': 'ocirc',
        '\xD4': 'Ocirc',
        '\xF6': 'ouml',
        '\xD6': 'Ouml',
        "\u0151": 'odblac',
        "\u0150": 'Odblac',
        '\xF5': 'otilde',
        '\xD5': 'Otilde',
        '\xF8': 'oslash',
        '\xD8': 'Oslash',
        "\u014D": 'omacr',
        "\u014C": 'Omacr',
        "\u0153": 'oelig',
        "\u0152": 'OElig',
        "\uD835\uDD2D": 'pfr',
        "\uD835\uDCC5": 'pscr',
        "\uD835\uDD61": 'popf',
        "\u2119": 'Popf',
        "\uD835\uDD13": 'Pfr',
        "\uD835\uDCAB": 'Pscr',
        "\uD835\uDD62": 'qopf',
        "\uD835\uDD2E": 'qfr',
        "\uD835\uDCC6": 'qscr',
        "\uD835\uDCAC": 'Qscr',
        "\uD835\uDD14": 'Qfr',
        "\u211A": 'Qopf',
        "\u0138": 'kgreen',
        "\uD835\uDD2F": 'rfr',
        "\uD835\uDD63": 'ropf',
        "\uD835\uDCC7": 'rscr',
        "\u211B": 'Rscr',
        "\u211C": 'Re',
        "\u211D": 'Ropf',
        "\u0155": 'racute',
        "\u0154": 'Racute',
        "\u0159": 'rcaron',
        "\u0158": 'Rcaron',
        "\u0157": 'rcedil',
        "\u0156": 'Rcedil',
        "\uD835\uDD64": 'sopf',
        "\uD835\uDCC8": 'sscr',
        "\uD835\uDD30": 'sfr',
        "\uD835\uDD4A": 'Sopf',
        "\uD835\uDD16": 'Sfr',
        "\uD835\uDCAE": 'Sscr',
        "\u24C8": 'oS',
        "\u015B": 'sacute',
        "\u015A": 'Sacute',
        "\u015D": 'scirc',
        "\u015C": 'Scirc',
        "\u0161": 'scaron',
        "\u0160": 'Scaron',
        "\u015F": 'scedil',
        "\u015E": 'Scedil',
        '\xDF': 'szlig',
        "\uD835\uDD31": 'tfr',
        "\uD835\uDCC9": 'tscr',
        "\uD835\uDD65": 'topf',
        "\uD835\uDCAF": 'Tscr',
        "\uD835\uDD17": 'Tfr',
        "\uD835\uDD4B": 'Topf',
        "\u0165": 'tcaron',
        "\u0164": 'Tcaron',
        "\u0163": 'tcedil',
        "\u0162": 'Tcedil',
        "\u2122": 'trade',
        "\u0167": 'tstrok',
        "\u0166": 'Tstrok',
        "\uD835\uDCCA": 'uscr',
        "\uD835\uDD66": 'uopf',
        "\uD835\uDD32": 'ufr',
        "\uD835\uDD4C": 'Uopf',
        "\uD835\uDD18": 'Ufr',
        "\uD835\uDCB0": 'Uscr',
        '\xFA': 'uacute',
        '\xDA': 'Uacute',
        '\xF9': 'ugrave',
        '\xD9': 'Ugrave',
        "\u016D": 'ubreve',
        "\u016C": 'Ubreve',
        '\xFB': 'ucirc',
        '\xDB': 'Ucirc',
        "\u016F": 'uring',
        "\u016E": 'Uring',
        '\xFC': 'uuml',
        '\xDC': 'Uuml',
        "\u0171": 'udblac',
        "\u0170": 'Udblac',
        "\u0169": 'utilde',
        "\u0168": 'Utilde',
        "\u0173": 'uogon',
        "\u0172": 'Uogon',
        "\u016B": 'umacr',
        "\u016A": 'Umacr',
        "\uD835\uDD33": 'vfr',
        "\uD835\uDD67": 'vopf',
        "\uD835\uDCCB": 'vscr',
        "\uD835\uDD19": 'Vfr',
        "\uD835\uDD4D": 'Vopf',
        "\uD835\uDCB1": 'Vscr',
        "\uD835\uDD68": 'wopf',
        "\uD835\uDCCC": 'wscr',
        "\uD835\uDD34": 'wfr',
        "\uD835\uDCB2": 'Wscr',
        "\uD835\uDD4E": 'Wopf',
        "\uD835\uDD1A": 'Wfr',
        "\u0175": 'wcirc',
        "\u0174": 'Wcirc',
        "\uD835\uDD35": 'xfr',
        "\uD835\uDCCD": 'xscr',
        "\uD835\uDD69": 'xopf',
        "\uD835\uDD4F": 'Xopf',
        "\uD835\uDD1B": 'Xfr',
        "\uD835\uDCB3": 'Xscr',
        "\uD835\uDD36": 'yfr',
        "\uD835\uDCCE": 'yscr',
        "\uD835\uDD6A": 'yopf',
        "\uD835\uDCB4": 'Yscr',
        "\uD835\uDD1C": 'Yfr',
        "\uD835\uDD50": 'Yopf',
        '\xFD': 'yacute',
        '\xDD': 'Yacute',
        "\u0177": 'ycirc',
        "\u0176": 'Ycirc',
        '\xFF': 'yuml',
        "\u0178": 'Yuml',
        "\uD835\uDCCF": 'zscr',
        "\uD835\uDD37": 'zfr',
        "\uD835\uDD6B": 'zopf',
        "\u2128": 'Zfr',
        "\u2124": 'Zopf',
        "\uD835\uDCB5": 'Zscr',
        "\u017A": 'zacute',
        "\u0179": 'Zacute',
        "\u017E": 'zcaron',
        "\u017D": 'Zcaron',
        "\u017C": 'zdot',
        "\u017B": 'Zdot',
        "\u01B5": 'imped',
        '\xFE': 'thorn',
        '\xDE': 'THORN',
        "\u0149": 'napos',
        "\u03B1": 'alpha',
        "\u0391": 'Alpha',
        "\u03B2": 'beta',
        "\u0392": 'Beta',
        "\u03B3": 'gamma',
        "\u0393": 'Gamma',
        "\u03B4": 'delta',
        "\u0394": 'Delta',
        "\u03B5": 'epsi',
        "\u03F5": 'epsiv',
        "\u0395": 'Epsilon',
        "\u03DD": 'gammad',
        "\u03DC": 'Gammad',
        "\u03B6": 'zeta',
        "\u0396": 'Zeta',
        "\u03B7": 'eta',
        "\u0397": 'Eta',
        "\u03B8": 'theta',
        "\u03D1": 'thetav',
        "\u0398": 'Theta',
        "\u03B9": 'iota',
        "\u0399": 'Iota',
        "\u03BA": 'kappa',
        "\u03F0": 'kappav',
        "\u039A": 'Kappa',
        "\u03BB": 'lambda',
        "\u039B": 'Lambda',
        "\u03BC": 'mu',
        '\xB5': 'micro',
        "\u039C": 'Mu',
        "\u03BD": 'nu',
        "\u039D": 'Nu',
        "\u03BE": 'xi',
        "\u039E": 'Xi',
        "\u03BF": 'omicron',
        "\u039F": 'Omicron',
        "\u03C0": 'pi',
        "\u03D6": 'piv',
        "\u03A0": 'Pi',
        "\u03C1": 'rho',
        "\u03F1": 'rhov',
        "\u03A1": 'Rho',
        "\u03C3": 'sigma',
        "\u03A3": 'Sigma',
        "\u03C2": 'sigmaf',
        "\u03C4": 'tau',
        "\u03A4": 'Tau',
        "\u03C5": 'upsi',
        "\u03A5": 'Upsilon',
        "\u03D2": 'Upsi',
        "\u03C6": 'phi',
        "\u03D5": 'phiv',
        "\u03A6": 'Phi',
        "\u03C7": 'chi',
        "\u03A7": 'Chi',
        "\u03C8": 'psi',
        "\u03A8": 'Psi',
        "\u03C9": 'omega',
        "\u03A9": 'ohm',
        "\u0430": 'acy',
        "\u0410": 'Acy',
        "\u0431": 'bcy',
        "\u0411": 'Bcy',
        "\u0432": 'vcy',
        "\u0412": 'Vcy',
        "\u0433": 'gcy',
        "\u0413": 'Gcy',
        "\u0453": 'gjcy',
        "\u0403": 'GJcy',
        "\u0434": 'dcy',
        "\u0414": 'Dcy',
        "\u0452": 'djcy',
        "\u0402": 'DJcy',
        "\u0435": 'iecy',
        "\u0415": 'IEcy',
        "\u0451": 'iocy',
        "\u0401": 'IOcy',
        "\u0454": 'jukcy',
        "\u0404": 'Jukcy',
        "\u0436": 'zhcy',
        "\u0416": 'ZHcy',
        "\u0437": 'zcy',
        "\u0417": 'Zcy',
        "\u0455": 'dscy',
        "\u0405": 'DScy',
        "\u0438": 'icy',
        "\u0418": 'Icy',
        "\u0456": 'iukcy',
        "\u0406": 'Iukcy',
        "\u0457": 'yicy',
        "\u0407": 'YIcy',
        "\u0439": 'jcy',
        "\u0419": 'Jcy',
        "\u0458": 'jsercy',
        "\u0408": 'Jsercy',
        "\u043A": 'kcy',
        "\u041A": 'Kcy',
        "\u045C": 'kjcy',
        "\u040C": 'KJcy',
        "\u043B": 'lcy',
        "\u041B": 'Lcy',
        "\u0459": 'ljcy',
        "\u0409": 'LJcy',
        "\u043C": 'mcy',
        "\u041C": 'Mcy',
        "\u043D": 'ncy',
        "\u041D": 'Ncy',
        "\u045A": 'njcy',
        "\u040A": 'NJcy',
        "\u043E": 'ocy',
        "\u041E": 'Ocy',
        "\u043F": 'pcy',
        "\u041F": 'Pcy',
        "\u0440": 'rcy',
        "\u0420": 'Rcy',
        "\u0441": 'scy',
        "\u0421": 'Scy',
        "\u0442": 'tcy',
        "\u0422": 'Tcy',
        "\u045B": 'tshcy',
        "\u040B": 'TSHcy',
        "\u0443": 'ucy',
        "\u0423": 'Ucy',
        "\u045E": 'ubrcy',
        "\u040E": 'Ubrcy',
        "\u0444": 'fcy',
        "\u0424": 'Fcy',
        "\u0445": 'khcy',
        "\u0425": 'KHcy',
        "\u0446": 'tscy',
        "\u0426": 'TScy',
        "\u0447": 'chcy',
        "\u0427": 'CHcy',
        "\u045F": 'dzcy',
        "\u040F": 'DZcy',
        "\u0448": 'shcy',
        "\u0428": 'SHcy',
        "\u0449": 'shchcy',
        "\u0429": 'SHCHcy',
        "\u044A": 'hardcy',
        "\u042A": 'HARDcy',
        "\u044B": 'ycy',
        "\u042B": 'Ycy',
        "\u044C": 'softcy',
        "\u042C": 'SOFTcy',
        "\u044D": 'ecy',
        "\u042D": 'Ecy',
        "\u044E": 'yucy',
        "\u042E": 'YUcy',
        "\u044F": 'yacy',
        "\u042F": 'YAcy',
        "\u2135": 'aleph',
        "\u2136": 'beth',
        "\u2137": 'gimel',
        "\u2138": 'daleth'
      };
      var regexEscape = /["&'<>`]/g;
      var escapeMap = {
        '"': '&quot;',
        '&': '&amp;',
        '\'': '&#x27;',
        '<': '&lt;',
        // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
        // following is not strictly necessary unless it’s part of a tag or an
        // unquoted attribute value. We’re only escaping it to support those
        // situations, and for XML support.
        '>': '&gt;',
        // In Internet Explorer ≤ 8, the backtick character can be used
        // to break out of (un)quoted attribute values or HTML comments.
        // See http://html5sec.org/#102, http://html5sec.org/#108, and
        // http://html5sec.org/#133.
        '`': '&#x60;'
      };
      var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
      var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
      var regexDecode = /&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)([=a-zA-Z0-9])?/g;
      var decodeMap = {
        'aacute': '\xE1',
        'Aacute': '\xC1',
        'abreve': "\u0103",
        'Abreve': "\u0102",
        'ac': "\u223E",
        'acd': "\u223F",
        'acE': "\u223E\u0333",
        'acirc': '\xE2',
        'Acirc': '\xC2',
        'acute': '\xB4',
        'acy': "\u0430",
        'Acy': "\u0410",
        'aelig': '\xE6',
        'AElig': '\xC6',
        'af': "\u2061",
        'afr': "\uD835\uDD1E",
        'Afr': "\uD835\uDD04",
        'agrave': '\xE0',
        'Agrave': '\xC0',
        'alefsym': "\u2135",
        'aleph': "\u2135",
        'alpha': "\u03B1",
        'Alpha': "\u0391",
        'amacr': "\u0101",
        'Amacr': "\u0100",
        'amalg': "\u2A3F",
        'amp': '&',
        'AMP': '&',
        'and': "\u2227",
        'And': "\u2A53",
        'andand': "\u2A55",
        'andd': "\u2A5C",
        'andslope': "\u2A58",
        'andv': "\u2A5A",
        'ang': "\u2220",
        'ange': "\u29A4",
        'angle': "\u2220",
        'angmsd': "\u2221",
        'angmsdaa': "\u29A8",
        'angmsdab': "\u29A9",
        'angmsdac': "\u29AA",
        'angmsdad': "\u29AB",
        'angmsdae': "\u29AC",
        'angmsdaf': "\u29AD",
        'angmsdag': "\u29AE",
        'angmsdah': "\u29AF",
        'angrt': "\u221F",
        'angrtvb': "\u22BE",
        'angrtvbd': "\u299D",
        'angsph': "\u2222",
        'angst': '\xC5',
        'angzarr': "\u237C",
        'aogon': "\u0105",
        'Aogon': "\u0104",
        'aopf': "\uD835\uDD52",
        'Aopf': "\uD835\uDD38",
        'ap': "\u2248",
        'apacir': "\u2A6F",
        'ape': "\u224A",
        'apE': "\u2A70",
        'apid': "\u224B",
        'apos': '\'',
        'ApplyFunction': "\u2061",
        'approx': "\u2248",
        'approxeq': "\u224A",
        'aring': '\xE5',
        'Aring': '\xC5',
        'ascr': "\uD835\uDCB6",
        'Ascr': "\uD835\uDC9C",
        'Assign': "\u2254",
        'ast': '*',
        'asymp': "\u2248",
        'asympeq': "\u224D",
        'atilde': '\xE3',
        'Atilde': '\xC3',
        'auml': '\xE4',
        'Auml': '\xC4',
        'awconint': "\u2233",
        'awint': "\u2A11",
        'backcong': "\u224C",
        'backepsilon': "\u03F6",
        'backprime': "\u2035",
        'backsim': "\u223D",
        'backsimeq': "\u22CD",
        'Backslash': "\u2216",
        'Barv': "\u2AE7",
        'barvee': "\u22BD",
        'barwed': "\u2305",
        'Barwed': "\u2306",
        'barwedge': "\u2305",
        'bbrk': "\u23B5",
        'bbrktbrk': "\u23B6",
        'bcong': "\u224C",
        'bcy': "\u0431",
        'Bcy': "\u0411",
        'bdquo': "\u201E",
        'becaus': "\u2235",
        'because': "\u2235",
        'Because': "\u2235",
        'bemptyv': "\u29B0",
        'bepsi': "\u03F6",
        'bernou': "\u212C",
        'Bernoullis': "\u212C",
        'beta': "\u03B2",
        'Beta': "\u0392",
        'beth': "\u2136",
        'between': "\u226C",
        'bfr': "\uD835\uDD1F",
        'Bfr': "\uD835\uDD05",
        'bigcap': "\u22C2",
        'bigcirc': "\u25EF",
        'bigcup': "\u22C3",
        'bigodot': "\u2A00",
        'bigoplus': "\u2A01",
        'bigotimes': "\u2A02",
        'bigsqcup': "\u2A06",
        'bigstar': "\u2605",
        'bigtriangledown': "\u25BD",
        'bigtriangleup': "\u25B3",
        'biguplus': "\u2A04",
        'bigvee': "\u22C1",
        'bigwedge': "\u22C0",
        'bkarow': "\u290D",
        'blacklozenge': "\u29EB",
        'blacksquare': "\u25AA",
        'blacktriangle': "\u25B4",
        'blacktriangledown': "\u25BE",
        'blacktriangleleft': "\u25C2",
        'blacktriangleright': "\u25B8",
        'blank': "\u2423",
        'blk12': "\u2592",
        'blk14': "\u2591",
        'blk34': "\u2593",
        'block': "\u2588",
        'bne': "=\u20E5",
        'bnequiv': "\u2261\u20E5",
        'bnot': "\u2310",
        'bNot': "\u2AED",
        'bopf': "\uD835\uDD53",
        'Bopf': "\uD835\uDD39",
        'bot': "\u22A5",
        'bottom': "\u22A5",
        'bowtie': "\u22C8",
        'boxbox': "\u29C9",
        'boxdl': "\u2510",
        'boxdL': "\u2555",
        'boxDl': "\u2556",
        'boxDL': "\u2557",
        'boxdr': "\u250C",
        'boxdR': "\u2552",
        'boxDr': "\u2553",
        'boxDR': "\u2554",
        'boxh': "\u2500",
        'boxH': "\u2550",
        'boxhd': "\u252C",
        'boxhD': "\u2565",
        'boxHd': "\u2564",
        'boxHD': "\u2566",
        'boxhu': "\u2534",
        'boxhU': "\u2568",
        'boxHu': "\u2567",
        'boxHU': "\u2569",
        'boxminus': "\u229F",
        'boxplus': "\u229E",
        'boxtimes': "\u22A0",
        'boxul': "\u2518",
        'boxuL': "\u255B",
        'boxUl': "\u255C",
        'boxUL': "\u255D",
        'boxur': "\u2514",
        'boxuR': "\u2558",
        'boxUr': "\u2559",
        'boxUR': "\u255A",
        'boxv': "\u2502",
        'boxV': "\u2551",
        'boxvh': "\u253C",
        'boxvH': "\u256A",
        'boxVh': "\u256B",
        'boxVH': "\u256C",
        'boxvl': "\u2524",
        'boxvL': "\u2561",
        'boxVl': "\u2562",
        'boxVL': "\u2563",
        'boxvr': "\u251C",
        'boxvR': "\u255E",
        'boxVr': "\u255F",
        'boxVR': "\u2560",
        'bprime': "\u2035",
        'breve': "\u02D8",
        'Breve': "\u02D8",
        'brvbar': '\xA6',
        'bscr': "\uD835\uDCB7",
        'Bscr': "\u212C",
        'bsemi': "\u204F",
        'bsim': "\u223D",
        'bsime': "\u22CD",
        'bsol': '\\',
        'bsolb': "\u29C5",
        'bsolhsub': "\u27C8",
        'bull': "\u2022",
        'bullet': "\u2022",
        'bump': "\u224E",
        'bumpe': "\u224F",
        'bumpE': "\u2AAE",
        'bumpeq': "\u224F",
        'Bumpeq': "\u224E",
        'cacute': "\u0107",
        'Cacute': "\u0106",
        'cap': "\u2229",
        'Cap': "\u22D2",
        'capand': "\u2A44",
        'capbrcup': "\u2A49",
        'capcap': "\u2A4B",
        'capcup': "\u2A47",
        'capdot': "\u2A40",
        'CapitalDifferentialD': "\u2145",
        'caps': "\u2229\uFE00",
        'caret': "\u2041",
        'caron': "\u02C7",
        'Cayleys': "\u212D",
        'ccaps': "\u2A4D",
        'ccaron': "\u010D",
        'Ccaron': "\u010C",
        'ccedil': '\xE7',
        'Ccedil': '\xC7',
        'ccirc': "\u0109",
        'Ccirc': "\u0108",
        'Cconint': "\u2230",
        'ccups': "\u2A4C",
        'ccupssm': "\u2A50",
        'cdot': "\u010B",
        'Cdot': "\u010A",
        'cedil': '\xB8',
        'Cedilla': '\xB8',
        'cemptyv': "\u29B2",
        'cent': '\xA2',
        'centerdot': '\xB7',
        'CenterDot': '\xB7',
        'cfr': "\uD835\uDD20",
        'Cfr': "\u212D",
        'chcy': "\u0447",
        'CHcy': "\u0427",
        'check': "\u2713",
        'checkmark': "\u2713",
        'chi': "\u03C7",
        'Chi': "\u03A7",
        'cir': "\u25CB",
        'circ': "\u02C6",
        'circeq': "\u2257",
        'circlearrowleft': "\u21BA",
        'circlearrowright': "\u21BB",
        'circledast': "\u229B",
        'circledcirc': "\u229A",
        'circleddash': "\u229D",
        'CircleDot': "\u2299",
        'circledR': '\xAE',
        'circledS': "\u24C8",
        'CircleMinus': "\u2296",
        'CirclePlus': "\u2295",
        'CircleTimes': "\u2297",
        'cire': "\u2257",
        'cirE': "\u29C3",
        'cirfnint': "\u2A10",
        'cirmid': "\u2AEF",
        'cirscir': "\u29C2",
        'ClockwiseContourIntegral': "\u2232",
        'CloseCurlyDoubleQuote': "\u201D",
        'CloseCurlyQuote': "\u2019",
        'clubs': "\u2663",
        'clubsuit': "\u2663",
        'colon': ':',
        'Colon': "\u2237",
        'colone': "\u2254",
        'Colone': "\u2A74",
        'coloneq': "\u2254",
        'comma': ',',
        'commat': '@',
        'comp': "\u2201",
        'compfn': "\u2218",
        'complement': "\u2201",
        'complexes': "\u2102",
        'cong': "\u2245",
        'congdot': "\u2A6D",
        'Congruent': "\u2261",
        'conint': "\u222E",
        'Conint': "\u222F",
        'ContourIntegral': "\u222E",
        'copf': "\uD835\uDD54",
        'Copf': "\u2102",
        'coprod': "\u2210",
        'Coproduct': "\u2210",
        'copy': '\xA9',
        'COPY': '\xA9',
        'copysr': "\u2117",
        'CounterClockwiseContourIntegral': "\u2233",
        'crarr': "\u21B5",
        'cross': "\u2717",
        'Cross': "\u2A2F",
        'cscr': "\uD835\uDCB8",
        'Cscr': "\uD835\uDC9E",
        'csub': "\u2ACF",
        'csube': "\u2AD1",
        'csup': "\u2AD0",
        'csupe': "\u2AD2",
        'ctdot': "\u22EF",
        'cudarrl': "\u2938",
        'cudarrr': "\u2935",
        'cuepr': "\u22DE",
        'cuesc': "\u22DF",
        'cularr': "\u21B6",
        'cularrp': "\u293D",
        'cup': "\u222A",
        'Cup': "\u22D3",
        'cupbrcap': "\u2A48",
        'cupcap': "\u2A46",
        'CupCap': "\u224D",
        'cupcup': "\u2A4A",
        'cupdot': "\u228D",
        'cupor': "\u2A45",
        'cups': "\u222A\uFE00",
        'curarr': "\u21B7",
        'curarrm': "\u293C",
        'curlyeqprec': "\u22DE",
        'curlyeqsucc': "\u22DF",
        'curlyvee': "\u22CE",
        'curlywedge': "\u22CF",
        'curren': '\xA4',
        'curvearrowleft': "\u21B6",
        'curvearrowright': "\u21B7",
        'cuvee': "\u22CE",
        'cuwed': "\u22CF",
        'cwconint': "\u2232",
        'cwint': "\u2231",
        'cylcty': "\u232D",
        'dagger': "\u2020",
        'Dagger': "\u2021",
        'daleth': "\u2138",
        'darr': "\u2193",
        'dArr': "\u21D3",
        'Darr': "\u21A1",
        'dash': "\u2010",
        'dashv': "\u22A3",
        'Dashv': "\u2AE4",
        'dbkarow': "\u290F",
        'dblac': "\u02DD",
        'dcaron': "\u010F",
        'Dcaron': "\u010E",
        'dcy': "\u0434",
        'Dcy': "\u0414",
        'dd': "\u2146",
        'DD': "\u2145",
        'ddagger': "\u2021",
        'ddarr': "\u21CA",
        'DDotrahd': "\u2911",
        'ddotseq': "\u2A77",
        'deg': '\xB0',
        'Del': "\u2207",
        'delta': "\u03B4",
        'Delta': "\u0394",
        'demptyv': "\u29B1",
        'dfisht': "\u297F",
        'dfr': "\uD835\uDD21",
        'Dfr': "\uD835\uDD07",
        'dHar': "\u2965",
        'dharl': "\u21C3",
        'dharr': "\u21C2",
        'DiacriticalAcute': '\xB4',
        'DiacriticalDot': "\u02D9",
        'DiacriticalDoubleAcute': "\u02DD",
        'DiacriticalGrave': '`',
        'DiacriticalTilde': "\u02DC",
        'diam': "\u22C4",
        'diamond': "\u22C4",
        'Diamond': "\u22C4",
        'diamondsuit': "\u2666",
        'diams': "\u2666",
        'die': '\xA8',
        'DifferentialD': "\u2146",
        'digamma': "\u03DD",
        'disin': "\u22F2",
        'div': '\xF7',
        'divide': '\xF7',
        'divideontimes': "\u22C7",
        'divonx': "\u22C7",
        'djcy': "\u0452",
        'DJcy': "\u0402",
        'dlcorn': "\u231E",
        'dlcrop': "\u230D",
        'dollar': '$',
        'dopf': "\uD835\uDD55",
        'Dopf': "\uD835\uDD3B",
        'dot': "\u02D9",
        'Dot': '\xA8',
        'DotDot': "\u20DC",
        'doteq': "\u2250",
        'doteqdot': "\u2251",
        'DotEqual': "\u2250",
        'dotminus': "\u2238",
        'dotplus': "\u2214",
        'dotsquare': "\u22A1",
        'doublebarwedge': "\u2306",
        'DoubleContourIntegral': "\u222F",
        'DoubleDot': '\xA8',
        'DoubleDownArrow': "\u21D3",
        'DoubleLeftArrow': "\u21D0",
        'DoubleLeftRightArrow': "\u21D4",
        'DoubleLeftTee': "\u2AE4",
        'DoubleLongLeftArrow': "\u27F8",
        'DoubleLongLeftRightArrow': "\u27FA",
        'DoubleLongRightArrow': "\u27F9",
        'DoubleRightArrow': "\u21D2",
        'DoubleRightTee': "\u22A8",
        'DoubleUpArrow': "\u21D1",
        'DoubleUpDownArrow': "\u21D5",
        'DoubleVerticalBar': "\u2225",
        'downarrow': "\u2193",
        'Downarrow': "\u21D3",
        'DownArrow': "\u2193",
        'DownArrowBar': "\u2913",
        'DownArrowUpArrow': "\u21F5",
        'DownBreve': "\u0311",
        'downdownarrows': "\u21CA",
        'downharpoonleft': "\u21C3",
        'downharpoonright': "\u21C2",
        'DownLeftRightVector': "\u2950",
        'DownLeftTeeVector': "\u295E",
        'DownLeftVector': "\u21BD",
        'DownLeftVectorBar': "\u2956",
        'DownRightTeeVector': "\u295F",
        'DownRightVector': "\u21C1",
        'DownRightVectorBar': "\u2957",
        'DownTee': "\u22A4",
        'DownTeeArrow': "\u21A7",
        'drbkarow': "\u2910",
        'drcorn': "\u231F",
        'drcrop': "\u230C",
        'dscr': "\uD835\uDCB9",
        'Dscr': "\uD835\uDC9F",
        'dscy': "\u0455",
        'DScy': "\u0405",
        'dsol': "\u29F6",
        'dstrok': "\u0111",
        'Dstrok': "\u0110",
        'dtdot': "\u22F1",
        'dtri': "\u25BF",
        'dtrif': "\u25BE",
        'duarr': "\u21F5",
        'duhar': "\u296F",
        'dwangle': "\u29A6",
        'dzcy': "\u045F",
        'DZcy': "\u040F",
        'dzigrarr': "\u27FF",
        'eacute': '\xE9',
        'Eacute': '\xC9',
        'easter': "\u2A6E",
        'ecaron': "\u011B",
        'Ecaron': "\u011A",
        'ecir': "\u2256",
        'ecirc': '\xEA',
        'Ecirc': '\xCA',
        'ecolon': "\u2255",
        'ecy': "\u044D",
        'Ecy': "\u042D",
        'eDDot': "\u2A77",
        'edot': "\u0117",
        'eDot': "\u2251",
        'Edot': "\u0116",
        'ee': "\u2147",
        'efDot': "\u2252",
        'efr': "\uD835\uDD22",
        'Efr': "\uD835\uDD08",
        'eg': "\u2A9A",
        'egrave': '\xE8',
        'Egrave': '\xC8',
        'egs': "\u2A96",
        'egsdot': "\u2A98",
        'el': "\u2A99",
        'Element': "\u2208",
        'elinters': "\u23E7",
        'ell': "\u2113",
        'els': "\u2A95",
        'elsdot': "\u2A97",
        'emacr': "\u0113",
        'Emacr': "\u0112",
        'empty': "\u2205",
        'emptyset': "\u2205",
        'EmptySmallSquare': "\u25FB",
        'emptyv': "\u2205",
        'EmptyVerySmallSquare': "\u25AB",
        'emsp': "\u2003",
        'emsp13': "\u2004",
        'emsp14': "\u2005",
        'eng': "\u014B",
        'ENG': "\u014A",
        'ensp': "\u2002",
        'eogon': "\u0119",
        'Eogon': "\u0118",
        'eopf': "\uD835\uDD56",
        'Eopf': "\uD835\uDD3C",
        'epar': "\u22D5",
        'eparsl': "\u29E3",
        'eplus': "\u2A71",
        'epsi': "\u03B5",
        'epsilon': "\u03B5",
        'Epsilon': "\u0395",
        'epsiv': "\u03F5",
        'eqcirc': "\u2256",
        'eqcolon': "\u2255",
        'eqsim': "\u2242",
        'eqslantgtr': "\u2A96",
        'eqslantless': "\u2A95",
        'Equal': "\u2A75",
        'equals': '=',
        'EqualTilde': "\u2242",
        'equest': "\u225F",
        'Equilibrium': "\u21CC",
        'equiv': "\u2261",
        'equivDD': "\u2A78",
        'eqvparsl': "\u29E5",
        'erarr': "\u2971",
        'erDot': "\u2253",
        'escr': "\u212F",
        'Escr': "\u2130",
        'esdot': "\u2250",
        'esim': "\u2242",
        'Esim': "\u2A73",
        'eta': "\u03B7",
        'Eta': "\u0397",
        'eth': '\xF0',
        'ETH': '\xD0',
        'euml': '\xEB',
        'Euml': '\xCB',
        'euro': "\u20AC",
        'excl': '!',
        'exist': "\u2203",
        'Exists': "\u2203",
        'expectation': "\u2130",
        'exponentiale': "\u2147",
        'ExponentialE': "\u2147",
        'fallingdotseq': "\u2252",
        'fcy': "\u0444",
        'Fcy': "\u0424",
        'female': "\u2640",
        'ffilig': "\uFB03",
        'fflig': "\uFB00",
        'ffllig': "\uFB04",
        'ffr': "\uD835\uDD23",
        'Ffr': "\uD835\uDD09",
        'filig': "\uFB01",
        'FilledSmallSquare': "\u25FC",
        'FilledVerySmallSquare': "\u25AA",
        'fjlig': 'fj',
        'flat': "\u266D",
        'fllig': "\uFB02",
        'fltns': "\u25B1",
        'fnof': "\u0192",
        'fopf': "\uD835\uDD57",
        'Fopf': "\uD835\uDD3D",
        'forall': "\u2200",
        'ForAll': "\u2200",
        'fork': "\u22D4",
        'forkv': "\u2AD9",
        'Fouriertrf': "\u2131",
        'fpartint': "\u2A0D",
        'frac12': '\xBD',
        'frac13': "\u2153",
        'frac14': '\xBC',
        'frac15': "\u2155",
        'frac16': "\u2159",
        'frac18': "\u215B",
        'frac23': "\u2154",
        'frac25': "\u2156",
        'frac34': '\xBE',
        'frac35': "\u2157",
        'frac38': "\u215C",
        'frac45': "\u2158",
        'frac56': "\u215A",
        'frac58': "\u215D",
        'frac78': "\u215E",
        'frasl': "\u2044",
        'frown': "\u2322",
        'fscr': "\uD835\uDCBB",
        'Fscr': "\u2131",
        'gacute': "\u01F5",
        'gamma': "\u03B3",
        'Gamma': "\u0393",
        'gammad': "\u03DD",
        'Gammad': "\u03DC",
        'gap': "\u2A86",
        'gbreve': "\u011F",
        'Gbreve': "\u011E",
        'Gcedil': "\u0122",
        'gcirc': "\u011D",
        'Gcirc': "\u011C",
        'gcy': "\u0433",
        'Gcy': "\u0413",
        'gdot': "\u0121",
        'Gdot': "\u0120",
        'ge': "\u2265",
        'gE': "\u2267",
        'gel': "\u22DB",
        'gEl': "\u2A8C",
        'geq': "\u2265",
        'geqq': "\u2267",
        'geqslant': "\u2A7E",
        'ges': "\u2A7E",
        'gescc': "\u2AA9",
        'gesdot': "\u2A80",
        'gesdoto': "\u2A82",
        'gesdotol': "\u2A84",
        'gesl': "\u22DB\uFE00",
        'gesles': "\u2A94",
        'gfr': "\uD835\uDD24",
        'Gfr': "\uD835\uDD0A",
        'gg': "\u226B",
        'Gg': "\u22D9",
        'ggg': "\u22D9",
        'gimel': "\u2137",
        'gjcy': "\u0453",
        'GJcy': "\u0403",
        'gl': "\u2277",
        'gla': "\u2AA5",
        'glE': "\u2A92",
        'glj': "\u2AA4",
        'gnap': "\u2A8A",
        'gnapprox': "\u2A8A",
        'gne': "\u2A88",
        'gnE': "\u2269",
        'gneq': "\u2A88",
        'gneqq': "\u2269",
        'gnsim': "\u22E7",
        'gopf': "\uD835\uDD58",
        'Gopf': "\uD835\uDD3E",
        'grave': '`',
        'GreaterEqual': "\u2265",
        'GreaterEqualLess': "\u22DB",
        'GreaterFullEqual': "\u2267",
        'GreaterGreater': "\u2AA2",
        'GreaterLess': "\u2277",
        'GreaterSlantEqual': "\u2A7E",
        'GreaterTilde': "\u2273",
        'gscr': "\u210A",
        'Gscr': "\uD835\uDCA2",
        'gsim': "\u2273",
        'gsime': "\u2A8E",
        'gsiml': "\u2A90",
        'gt': '>',
        'Gt': "\u226B",
        'GT': '>',
        'gtcc': "\u2AA7",
        'gtcir': "\u2A7A",
        'gtdot': "\u22D7",
        'gtlPar': "\u2995",
        'gtquest': "\u2A7C",
        'gtrapprox': "\u2A86",
        'gtrarr': "\u2978",
        'gtrdot': "\u22D7",
        'gtreqless': "\u22DB",
        'gtreqqless': "\u2A8C",
        'gtrless': "\u2277",
        'gtrsim': "\u2273",
        'gvertneqq': "\u2269\uFE00",
        'gvnE': "\u2269\uFE00",
        'Hacek': "\u02C7",
        'hairsp': "\u200A",
        'half': '\xBD',
        'hamilt': "\u210B",
        'hardcy': "\u044A",
        'HARDcy': "\u042A",
        'harr': "\u2194",
        'hArr': "\u21D4",
        'harrcir': "\u2948",
        'harrw': "\u21AD",
        'Hat': '^',
        'hbar': "\u210F",
        'hcirc': "\u0125",
        'Hcirc': "\u0124",
        'hearts': "\u2665",
        'heartsuit': "\u2665",
        'hellip': "\u2026",
        'hercon': "\u22B9",
        'hfr': "\uD835\uDD25",
        'Hfr': "\u210C",
        'HilbertSpace': "\u210B",
        'hksearow': "\u2925",
        'hkswarow': "\u2926",
        'hoarr': "\u21FF",
        'homtht': "\u223B",
        'hookleftarrow': "\u21A9",
        'hookrightarrow': "\u21AA",
        'hopf': "\uD835\uDD59",
        'Hopf': "\u210D",
        'horbar': "\u2015",
        'HorizontalLine': "\u2500",
        'hscr': "\uD835\uDCBD",
        'Hscr': "\u210B",
        'hslash': "\u210F",
        'hstrok': "\u0127",
        'Hstrok': "\u0126",
        'HumpDownHump': "\u224E",
        'HumpEqual': "\u224F",
        'hybull': "\u2043",
        'hyphen': "\u2010",
        'iacute': '\xED',
        'Iacute': '\xCD',
        'ic': "\u2063",
        'icirc': '\xEE',
        'Icirc': '\xCE',
        'icy': "\u0438",
        'Icy': "\u0418",
        'Idot': "\u0130",
        'iecy': "\u0435",
        'IEcy': "\u0415",
        'iexcl': '\xA1',
        'iff': "\u21D4",
        'ifr': "\uD835\uDD26",
        'Ifr': "\u2111",
        'igrave': '\xEC',
        'Igrave': '\xCC',
        'ii': "\u2148",
        'iiiint': "\u2A0C",
        'iiint': "\u222D",
        'iinfin': "\u29DC",
        'iiota': "\u2129",
        'ijlig': "\u0133",
        'IJlig': "\u0132",
        'Im': "\u2111",
        'imacr': "\u012B",
        'Imacr': "\u012A",
        'image': "\u2111",
        'ImaginaryI': "\u2148",
        'imagline': "\u2110",
        'imagpart': "\u2111",
        'imath': "\u0131",
        'imof': "\u22B7",
        'imped': "\u01B5",
        'Implies': "\u21D2",
        'in': "\u2208",
        'incare': "\u2105",
        'infin': "\u221E",
        'infintie': "\u29DD",
        'inodot': "\u0131",
        'int': "\u222B",
        'Int': "\u222C",
        'intcal': "\u22BA",
        'integers': "\u2124",
        'Integral': "\u222B",
        'intercal': "\u22BA",
        'Intersection': "\u22C2",
        'intlarhk': "\u2A17",
        'intprod': "\u2A3C",
        'InvisibleComma': "\u2063",
        'InvisibleTimes': "\u2062",
        'iocy': "\u0451",
        'IOcy': "\u0401",
        'iogon': "\u012F",
        'Iogon': "\u012E",
        'iopf': "\uD835\uDD5A",
        'Iopf': "\uD835\uDD40",
        'iota': "\u03B9",
        'Iota': "\u0399",
        'iprod': "\u2A3C",
        'iquest': '\xBF',
        'iscr': "\uD835\uDCBE",
        'Iscr': "\u2110",
        'isin': "\u2208",
        'isindot': "\u22F5",
        'isinE': "\u22F9",
        'isins': "\u22F4",
        'isinsv': "\u22F3",
        'isinv': "\u2208",
        'it': "\u2062",
        'itilde': "\u0129",
        'Itilde': "\u0128",
        'iukcy': "\u0456",
        'Iukcy': "\u0406",
        'iuml': '\xEF',
        'Iuml': '\xCF',
        'jcirc': "\u0135",
        'Jcirc': "\u0134",
        'jcy': "\u0439",
        'Jcy': "\u0419",
        'jfr': "\uD835\uDD27",
        'Jfr': "\uD835\uDD0D",
        'jmath': "\u0237",
        'jopf': "\uD835\uDD5B",
        'Jopf': "\uD835\uDD41",
        'jscr': "\uD835\uDCBF",
        'Jscr': "\uD835\uDCA5",
        'jsercy': "\u0458",
        'Jsercy': "\u0408",
        'jukcy': "\u0454",
        'Jukcy': "\u0404",
        'kappa': "\u03BA",
        'Kappa': "\u039A",
        'kappav': "\u03F0",
        'kcedil': "\u0137",
        'Kcedil': "\u0136",
        'kcy': "\u043A",
        'Kcy': "\u041A",
        'kfr': "\uD835\uDD28",
        'Kfr': "\uD835\uDD0E",
        'kgreen': "\u0138",
        'khcy': "\u0445",
        'KHcy': "\u0425",
        'kjcy': "\u045C",
        'KJcy': "\u040C",
        'kopf': "\uD835\uDD5C",
        'Kopf': "\uD835\uDD42",
        'kscr': "\uD835\uDCC0",
        'Kscr': "\uD835\uDCA6",
        'lAarr': "\u21DA",
        'lacute': "\u013A",
        'Lacute': "\u0139",
        'laemptyv': "\u29B4",
        'lagran': "\u2112",
        'lambda': "\u03BB",
        'Lambda': "\u039B",
        'lang': "\u27E8",
        'Lang': "\u27EA",
        'langd': "\u2991",
        'langle': "\u27E8",
        'lap': "\u2A85",
        'Laplacetrf': "\u2112",
        'laquo': '\xAB',
        'larr': "\u2190",
        'lArr': "\u21D0",
        'Larr': "\u219E",
        'larrb': "\u21E4",
        'larrbfs': "\u291F",
        'larrfs': "\u291D",
        'larrhk': "\u21A9",
        'larrlp': "\u21AB",
        'larrpl': "\u2939",
        'larrsim': "\u2973",
        'larrtl': "\u21A2",
        'lat': "\u2AAB",
        'latail': "\u2919",
        'lAtail': "\u291B",
        'late': "\u2AAD",
        'lates': "\u2AAD\uFE00",
        'lbarr': "\u290C",
        'lBarr': "\u290E",
        'lbbrk': "\u2772",
        'lbrace': '{',
        'lbrack': '[',
        'lbrke': "\u298B",
        'lbrksld': "\u298F",
        'lbrkslu': "\u298D",
        'lcaron': "\u013E",
        'Lcaron': "\u013D",
        'lcedil': "\u013C",
        'Lcedil': "\u013B",
        'lceil': "\u2308",
        'lcub': '{',
        'lcy': "\u043B",
        'Lcy': "\u041B",
        'ldca': "\u2936",
        'ldquo': "\u201C",
        'ldquor': "\u201E",
        'ldrdhar': "\u2967",
        'ldrushar': "\u294B",
        'ldsh': "\u21B2",
        'le': "\u2264",
        'lE': "\u2266",
        'LeftAngleBracket': "\u27E8",
        'leftarrow': "\u2190",
        'Leftarrow': "\u21D0",
        'LeftArrow': "\u2190",
        'LeftArrowBar': "\u21E4",
        'LeftArrowRightArrow': "\u21C6",
        'leftarrowtail': "\u21A2",
        'LeftCeiling': "\u2308",
        'LeftDoubleBracket': "\u27E6",
        'LeftDownTeeVector': "\u2961",
        'LeftDownVector': "\u21C3",
        'LeftDownVectorBar': "\u2959",
        'LeftFloor': "\u230A",
        'leftharpoondown': "\u21BD",
        'leftharpoonup': "\u21BC",
        'leftleftarrows': "\u21C7",
        'leftrightarrow': "\u2194",
        'Leftrightarrow': "\u21D4",
        'LeftRightArrow': "\u2194",
        'leftrightarrows': "\u21C6",
        'leftrightharpoons': "\u21CB",
        'leftrightsquigarrow': "\u21AD",
        'LeftRightVector': "\u294E",
        'LeftTee': "\u22A3",
        'LeftTeeArrow': "\u21A4",
        'LeftTeeVector': "\u295A",
        'leftthreetimes': "\u22CB",
        'LeftTriangle': "\u22B2",
        'LeftTriangleBar': "\u29CF",
        'LeftTriangleEqual': "\u22B4",
        'LeftUpDownVector': "\u2951",
        'LeftUpTeeVector': "\u2960",
        'LeftUpVector': "\u21BF",
        'LeftUpVectorBar': "\u2958",
        'LeftVector': "\u21BC",
        'LeftVectorBar': "\u2952",
        'leg': "\u22DA",
        'lEg': "\u2A8B",
        'leq': "\u2264",
        'leqq': "\u2266",
        'leqslant': "\u2A7D",
        'les': "\u2A7D",
        'lescc': "\u2AA8",
        'lesdot': "\u2A7F",
        'lesdoto': "\u2A81",
        'lesdotor': "\u2A83",
        'lesg': "\u22DA\uFE00",
        'lesges': "\u2A93",
        'lessapprox': "\u2A85",
        'lessdot': "\u22D6",
        'lesseqgtr': "\u22DA",
        'lesseqqgtr': "\u2A8B",
        'LessEqualGreater': "\u22DA",
        'LessFullEqual': "\u2266",
        'LessGreater': "\u2276",
        'lessgtr': "\u2276",
        'LessLess': "\u2AA1",
        'lesssim': "\u2272",
        'LessSlantEqual': "\u2A7D",
        'LessTilde': "\u2272",
        'lfisht': "\u297C",
        'lfloor': "\u230A",
        'lfr': "\uD835\uDD29",
        'Lfr': "\uD835\uDD0F",
        'lg': "\u2276",
        'lgE': "\u2A91",
        'lHar': "\u2962",
        'lhard': "\u21BD",
        'lharu': "\u21BC",
        'lharul': "\u296A",
        'lhblk': "\u2584",
        'ljcy': "\u0459",
        'LJcy': "\u0409",
        'll': "\u226A",
        'Ll': "\u22D8",
        'llarr': "\u21C7",
        'llcorner': "\u231E",
        'Lleftarrow': "\u21DA",
        'llhard': "\u296B",
        'lltri': "\u25FA",
        'lmidot': "\u0140",
        'Lmidot': "\u013F",
        'lmoust': "\u23B0",
        'lmoustache': "\u23B0",
        'lnap': "\u2A89",
        'lnapprox': "\u2A89",
        'lne': "\u2A87",
        'lnE': "\u2268",
        'lneq': "\u2A87",
        'lneqq': "\u2268",
        'lnsim': "\u22E6",
        'loang': "\u27EC",
        'loarr': "\u21FD",
        'lobrk': "\u27E6",
        'longleftarrow': "\u27F5",
        'Longleftarrow': "\u27F8",
        'LongLeftArrow': "\u27F5",
        'longleftrightarrow': "\u27F7",
        'Longleftrightarrow': "\u27FA",
        'LongLeftRightArrow': "\u27F7",
        'longmapsto': "\u27FC",
        'longrightarrow': "\u27F6",
        'Longrightarrow': "\u27F9",
        'LongRightArrow': "\u27F6",
        'looparrowleft': "\u21AB",
        'looparrowright': "\u21AC",
        'lopar': "\u2985",
        'lopf': "\uD835\uDD5D",
        'Lopf': "\uD835\uDD43",
        'loplus': "\u2A2D",
        'lotimes': "\u2A34",
        'lowast': "\u2217",
        'lowbar': '_',
        'LowerLeftArrow': "\u2199",
        'LowerRightArrow': "\u2198",
        'loz': "\u25CA",
        'lozenge': "\u25CA",
        'lozf': "\u29EB",
        'lpar': '(',
        'lparlt': "\u2993",
        'lrarr': "\u21C6",
        'lrcorner': "\u231F",
        'lrhar': "\u21CB",
        'lrhard': "\u296D",
        'lrm': "\u200E",
        'lrtri': "\u22BF",
        'lsaquo': "\u2039",
        'lscr': "\uD835\uDCC1",
        'Lscr': "\u2112",
        'lsh': "\u21B0",
        'Lsh': "\u21B0",
        'lsim': "\u2272",
        'lsime': "\u2A8D",
        'lsimg': "\u2A8F",
        'lsqb': '[',
        'lsquo': "\u2018",
        'lsquor': "\u201A",
        'lstrok': "\u0142",
        'Lstrok': "\u0141",
        'lt': '<',
        'Lt': "\u226A",
        'LT': '<',
        'ltcc': "\u2AA6",
        'ltcir': "\u2A79",
        'ltdot': "\u22D6",
        'lthree': "\u22CB",
        'ltimes': "\u22C9",
        'ltlarr': "\u2976",
        'ltquest': "\u2A7B",
        'ltri': "\u25C3",
        'ltrie': "\u22B4",
        'ltrif': "\u25C2",
        'ltrPar': "\u2996",
        'lurdshar': "\u294A",
        'luruhar': "\u2966",
        'lvertneqq': "\u2268\uFE00",
        'lvnE': "\u2268\uFE00",
        'macr': '\xAF',
        'male': "\u2642",
        'malt': "\u2720",
        'maltese': "\u2720",
        'map': "\u21A6",
        'Map': "\u2905",
        'mapsto': "\u21A6",
        'mapstodown': "\u21A7",
        'mapstoleft': "\u21A4",
        'mapstoup': "\u21A5",
        'marker': "\u25AE",
        'mcomma': "\u2A29",
        'mcy': "\u043C",
        'Mcy': "\u041C",
        'mdash': "\u2014",
        'mDDot': "\u223A",
        'measuredangle': "\u2221",
        'MediumSpace': "\u205F",
        'Mellintrf': "\u2133",
        'mfr': "\uD835\uDD2A",
        'Mfr': "\uD835\uDD10",
        'mho': "\u2127",
        'micro': '\xB5',
        'mid': "\u2223",
        'midast': '*',
        'midcir': "\u2AF0",
        'middot': '\xB7',
        'minus': "\u2212",
        'minusb': "\u229F",
        'minusd': "\u2238",
        'minusdu': "\u2A2A",
        'MinusPlus': "\u2213",
        'mlcp': "\u2ADB",
        'mldr': "\u2026",
        'mnplus': "\u2213",
        'models': "\u22A7",
        'mopf': "\uD835\uDD5E",
        'Mopf': "\uD835\uDD44",
        'mp': "\u2213",
        'mscr': "\uD835\uDCC2",
        'Mscr': "\u2133",
        'mstpos': "\u223E",
        'mu': "\u03BC",
        'Mu': "\u039C",
        'multimap': "\u22B8",
        'mumap': "\u22B8",
        'nabla': "\u2207",
        'nacute': "\u0144",
        'Nacute': "\u0143",
        'nang': "\u2220\u20D2",
        'nap': "\u2249",
        'napE': "\u2A70\u0338",
        'napid': "\u224B\u0338",
        'napos': "\u0149",
        'napprox': "\u2249",
        'natur': "\u266E",
        'natural': "\u266E",
        'naturals': "\u2115",
        'nbsp': '\xA0',
        'nbump': "\u224E\u0338",
        'nbumpe': "\u224F\u0338",
        'ncap': "\u2A43",
        'ncaron': "\u0148",
        'Ncaron': "\u0147",
        'ncedil': "\u0146",
        'Ncedil': "\u0145",
        'ncong': "\u2247",
        'ncongdot': "\u2A6D\u0338",
        'ncup': "\u2A42",
        'ncy': "\u043D",
        'Ncy': "\u041D",
        'ndash': "\u2013",
        'ne': "\u2260",
        'nearhk': "\u2924",
        'nearr': "\u2197",
        'neArr': "\u21D7",
        'nearrow': "\u2197",
        'nedot': "\u2250\u0338",
        'NegativeMediumSpace': "\u200B",
        'NegativeThickSpace': "\u200B",
        'NegativeThinSpace': "\u200B",
        'NegativeVeryThinSpace': "\u200B",
        'nequiv': "\u2262",
        'nesear': "\u2928",
        'nesim': "\u2242\u0338",
        'NestedGreaterGreater': "\u226B",
        'NestedLessLess': "\u226A",
        'NewLine': '\n',
        'nexist': "\u2204",
        'nexists': "\u2204",
        'nfr': "\uD835\uDD2B",
        'Nfr': "\uD835\uDD11",
        'nge': "\u2271",
        'ngE': "\u2267\u0338",
        'ngeq': "\u2271",
        'ngeqq': "\u2267\u0338",
        'ngeqslant': "\u2A7E\u0338",
        'nges': "\u2A7E\u0338",
        'nGg': "\u22D9\u0338",
        'ngsim': "\u2275",
        'ngt': "\u226F",
        'nGt': "\u226B\u20D2",
        'ngtr': "\u226F",
        'nGtv': "\u226B\u0338",
        'nharr': "\u21AE",
        'nhArr': "\u21CE",
        'nhpar': "\u2AF2",
        'ni': "\u220B",
        'nis': "\u22FC",
        'nisd': "\u22FA",
        'niv': "\u220B",
        'njcy': "\u045A",
        'NJcy': "\u040A",
        'nlarr': "\u219A",
        'nlArr': "\u21CD",
        'nldr': "\u2025",
        'nle': "\u2270",
        'nlE': "\u2266\u0338",
        'nleftarrow': "\u219A",
        'nLeftarrow': "\u21CD",
        'nleftrightarrow': "\u21AE",
        'nLeftrightarrow': "\u21CE",
        'nleq': "\u2270",
        'nleqq': "\u2266\u0338",
        'nleqslant': "\u2A7D\u0338",
        'nles': "\u2A7D\u0338",
        'nless': "\u226E",
        'nLl': "\u22D8\u0338",
        'nlsim': "\u2274",
        'nlt': "\u226E",
        'nLt': "\u226A\u20D2",
        'nltri': "\u22EA",
        'nltrie': "\u22EC",
        'nLtv': "\u226A\u0338",
        'nmid': "\u2224",
        'NoBreak': "\u2060",
        'NonBreakingSpace': '\xA0',
        'nopf': "\uD835\uDD5F",
        'Nopf': "\u2115",
        'not': '\xAC',
        'Not': "\u2AEC",
        'NotCongruent': "\u2262",
        'NotCupCap': "\u226D",
        'NotDoubleVerticalBar': "\u2226",
        'NotElement': "\u2209",
        'NotEqual': "\u2260",
        'NotEqualTilde': "\u2242\u0338",
        'NotExists': "\u2204",
        'NotGreater': "\u226F",
        'NotGreaterEqual': "\u2271",
        'NotGreaterFullEqual': "\u2267\u0338",
        'NotGreaterGreater': "\u226B\u0338",
        'NotGreaterLess': "\u2279",
        'NotGreaterSlantEqual': "\u2A7E\u0338",
        'NotGreaterTilde': "\u2275",
        'NotHumpDownHump': "\u224E\u0338",
        'NotHumpEqual': "\u224F\u0338",
        'notin': "\u2209",
        'notindot': "\u22F5\u0338",
        'notinE': "\u22F9\u0338",
        'notinva': "\u2209",
        'notinvb': "\u22F7",
        'notinvc': "\u22F6",
        'NotLeftTriangle': "\u22EA",
        'NotLeftTriangleBar': "\u29CF\u0338",
        'NotLeftTriangleEqual': "\u22EC",
        'NotLess': "\u226E",
        'NotLessEqual': "\u2270",
        'NotLessGreater': "\u2278",
        'NotLessLess': "\u226A\u0338",
        'NotLessSlantEqual': "\u2A7D\u0338",
        'NotLessTilde': "\u2274",
        'NotNestedGreaterGreater': "\u2AA2\u0338",
        'NotNestedLessLess': "\u2AA1\u0338",
        'notni': "\u220C",
        'notniva': "\u220C",
        'notnivb': "\u22FE",
        'notnivc': "\u22FD",
        'NotPrecedes': "\u2280",
        'NotPrecedesEqual': "\u2AAF\u0338",
        'NotPrecedesSlantEqual': "\u22E0",
        'NotReverseElement': "\u220C",
        'NotRightTriangle': "\u22EB",
        'NotRightTriangleBar': "\u29D0\u0338",
        'NotRightTriangleEqual': "\u22ED",
        'NotSquareSubset': "\u228F\u0338",
        'NotSquareSubsetEqual': "\u22E2",
        'NotSquareSuperset': "\u2290\u0338",
        'NotSquareSupersetEqual': "\u22E3",
        'NotSubset': "\u2282\u20D2",
        'NotSubsetEqual': "\u2288",
        'NotSucceeds': "\u2281",
        'NotSucceedsEqual': "\u2AB0\u0338",
        'NotSucceedsSlantEqual': "\u22E1",
        'NotSucceedsTilde': "\u227F\u0338",
        'NotSuperset': "\u2283\u20D2",
        'NotSupersetEqual': "\u2289",
        'NotTilde': "\u2241",
        'NotTildeEqual': "\u2244",
        'NotTildeFullEqual': "\u2247",
        'NotTildeTilde': "\u2249",
        'NotVerticalBar': "\u2224",
        'npar': "\u2226",
        'nparallel': "\u2226",
        'nparsl': "\u2AFD\u20E5",
        'npart': "\u2202\u0338",
        'npolint': "\u2A14",
        'npr': "\u2280",
        'nprcue': "\u22E0",
        'npre': "\u2AAF\u0338",
        'nprec': "\u2280",
        'npreceq': "\u2AAF\u0338",
        'nrarr': "\u219B",
        'nrArr': "\u21CF",
        'nrarrc': "\u2933\u0338",
        'nrarrw': "\u219D\u0338",
        'nrightarrow': "\u219B",
        'nRightarrow': "\u21CF",
        'nrtri': "\u22EB",
        'nrtrie': "\u22ED",
        'nsc': "\u2281",
        'nsccue': "\u22E1",
        'nsce': "\u2AB0\u0338",
        'nscr': "\uD835\uDCC3",
        'Nscr': "\uD835\uDCA9",
        'nshortmid': "\u2224",
        'nshortparallel': "\u2226",
        'nsim': "\u2241",
        'nsime': "\u2244",
        'nsimeq': "\u2244",
        'nsmid': "\u2224",
        'nspar': "\u2226",
        'nsqsube': "\u22E2",
        'nsqsupe': "\u22E3",
        'nsub': "\u2284",
        'nsube': "\u2288",
        'nsubE': "\u2AC5\u0338",
        'nsubset': "\u2282\u20D2",
        'nsubseteq': "\u2288",
        'nsubseteqq': "\u2AC5\u0338",
        'nsucc': "\u2281",
        'nsucceq': "\u2AB0\u0338",
        'nsup': "\u2285",
        'nsupe': "\u2289",
        'nsupE': "\u2AC6\u0338",
        'nsupset': "\u2283\u20D2",
        'nsupseteq': "\u2289",
        'nsupseteqq': "\u2AC6\u0338",
        'ntgl': "\u2279",
        'ntilde': '\xF1',
        'Ntilde': '\xD1',
        'ntlg': "\u2278",
        'ntriangleleft': "\u22EA",
        'ntrianglelefteq': "\u22EC",
        'ntriangleright': "\u22EB",
        'ntrianglerighteq': "\u22ED",
        'nu': "\u03BD",
        'Nu': "\u039D",
        'num': '#',
        'numero': "\u2116",
        'numsp': "\u2007",
        'nvap': "\u224D\u20D2",
        'nvdash': "\u22AC",
        'nvDash': "\u22AD",
        'nVdash': "\u22AE",
        'nVDash': "\u22AF",
        'nvge': "\u2265\u20D2",
        'nvgt': ">\u20D2",
        'nvHarr': "\u2904",
        'nvinfin': "\u29DE",
        'nvlArr': "\u2902",
        'nvle': "\u2264\u20D2",
        'nvlt': "<\u20D2",
        'nvltrie': "\u22B4\u20D2",
        'nvrArr': "\u2903",
        'nvrtrie': "\u22B5\u20D2",
        'nvsim': "\u223C\u20D2",
        'nwarhk': "\u2923",
        'nwarr': "\u2196",
        'nwArr': "\u21D6",
        'nwarrow': "\u2196",
        'nwnear': "\u2927",
        'oacute': '\xF3',
        'Oacute': '\xD3',
        'oast': "\u229B",
        'ocir': "\u229A",
        'ocirc': '\xF4',
        'Ocirc': '\xD4',
        'ocy': "\u043E",
        'Ocy': "\u041E",
        'odash': "\u229D",
        'odblac': "\u0151",
        'Odblac': "\u0150",
        'odiv': "\u2A38",
        'odot': "\u2299",
        'odsold': "\u29BC",
        'oelig': "\u0153",
        'OElig': "\u0152",
        'ofcir': "\u29BF",
        'ofr': "\uD835\uDD2C",
        'Ofr': "\uD835\uDD12",
        'ogon': "\u02DB",
        'ograve': '\xF2',
        'Ograve': '\xD2',
        'ogt': "\u29C1",
        'ohbar': "\u29B5",
        'ohm': "\u03A9",
        'oint': "\u222E",
        'olarr': "\u21BA",
        'olcir': "\u29BE",
        'olcross': "\u29BB",
        'oline': "\u203E",
        'olt': "\u29C0",
        'omacr': "\u014D",
        'Omacr': "\u014C",
        'omega': "\u03C9",
        'Omega': "\u03A9",
        'omicron': "\u03BF",
        'Omicron': "\u039F",
        'omid': "\u29B6",
        'ominus': "\u2296",
        'oopf': "\uD835\uDD60",
        'Oopf': "\uD835\uDD46",
        'opar': "\u29B7",
        'OpenCurlyDoubleQuote': "\u201C",
        'OpenCurlyQuote': "\u2018",
        'operp': "\u29B9",
        'oplus': "\u2295",
        'or': "\u2228",
        'Or': "\u2A54",
        'orarr': "\u21BB",
        'ord': "\u2A5D",
        'order': "\u2134",
        'orderof': "\u2134",
        'ordf': '\xAA',
        'ordm': '\xBA',
        'origof': "\u22B6",
        'oror': "\u2A56",
        'orslope': "\u2A57",
        'orv': "\u2A5B",
        'oS': "\u24C8",
        'oscr': "\u2134",
        'Oscr': "\uD835\uDCAA",
        'oslash': '\xF8',
        'Oslash': '\xD8',
        'osol': "\u2298",
        'otilde': '\xF5',
        'Otilde': '\xD5',
        'otimes': "\u2297",
        'Otimes': "\u2A37",
        'otimesas': "\u2A36",
        'ouml': '\xF6',
        'Ouml': '\xD6',
        'ovbar': "\u233D",
        'OverBar': "\u203E",
        'OverBrace': "\u23DE",
        'OverBracket': "\u23B4",
        'OverParenthesis': "\u23DC",
        'par': "\u2225",
        'para': '\xB6',
        'parallel': "\u2225",
        'parsim': "\u2AF3",
        'parsl': "\u2AFD",
        'part': "\u2202",
        'PartialD': "\u2202",
        'pcy': "\u043F",
        'Pcy': "\u041F",
        'percnt': '%',
        'period': '.',
        'permil': "\u2030",
        'perp': "\u22A5",
        'pertenk': "\u2031",
        'pfr': "\uD835\uDD2D",
        'Pfr': "\uD835\uDD13",
        'phi': "\u03C6",
        'Phi': "\u03A6",
        'phiv': "\u03D5",
        'phmmat': "\u2133",
        'phone': "\u260E",
        'pi': "\u03C0",
        'Pi': "\u03A0",
        'pitchfork': "\u22D4",
        'piv': "\u03D6",
        'planck': "\u210F",
        'planckh': "\u210E",
        'plankv': "\u210F",
        'plus': '+',
        'plusacir': "\u2A23",
        'plusb': "\u229E",
        'pluscir': "\u2A22",
        'plusdo': "\u2214",
        'plusdu': "\u2A25",
        'pluse': "\u2A72",
        'PlusMinus': '\xB1',
        'plusmn': '\xB1',
        'plussim': "\u2A26",
        'plustwo': "\u2A27",
        'pm': '\xB1',
        'Poincareplane': "\u210C",
        'pointint': "\u2A15",
        'popf': "\uD835\uDD61",
        'Popf': "\u2119",
        'pound': '\xA3',
        'pr': "\u227A",
        'Pr': "\u2ABB",
        'prap': "\u2AB7",
        'prcue': "\u227C",
        'pre': "\u2AAF",
        'prE': "\u2AB3",
        'prec': "\u227A",
        'precapprox': "\u2AB7",
        'preccurlyeq': "\u227C",
        'Precedes': "\u227A",
        'PrecedesEqual': "\u2AAF",
        'PrecedesSlantEqual': "\u227C",
        'PrecedesTilde': "\u227E",
        'preceq': "\u2AAF",
        'precnapprox': "\u2AB9",
        'precneqq': "\u2AB5",
        'precnsim': "\u22E8",
        'precsim': "\u227E",
        'prime': "\u2032",
        'Prime': "\u2033",
        'primes': "\u2119",
        'prnap': "\u2AB9",
        'prnE': "\u2AB5",
        'prnsim': "\u22E8",
        'prod': "\u220F",
        'Product': "\u220F",
        'profalar': "\u232E",
        'profline': "\u2312",
        'profsurf': "\u2313",
        'prop': "\u221D",
        'Proportion': "\u2237",
        'Proportional': "\u221D",
        'propto': "\u221D",
        'prsim': "\u227E",
        'prurel': "\u22B0",
        'pscr': "\uD835\uDCC5",
        'Pscr': "\uD835\uDCAB",
        'psi': "\u03C8",
        'Psi': "\u03A8",
        'puncsp': "\u2008",
        'qfr': "\uD835\uDD2E",
        'Qfr': "\uD835\uDD14",
        'qint': "\u2A0C",
        'qopf': "\uD835\uDD62",
        'Qopf': "\u211A",
        'qprime': "\u2057",
        'qscr': "\uD835\uDCC6",
        'Qscr': "\uD835\uDCAC",
        'quaternions': "\u210D",
        'quatint': "\u2A16",
        'quest': '?',
        'questeq': "\u225F",
        'quot': '"',
        'QUOT': '"',
        'rAarr': "\u21DB",
        'race': "\u223D\u0331",
        'racute': "\u0155",
        'Racute': "\u0154",
        'radic': "\u221A",
        'raemptyv': "\u29B3",
        'rang': "\u27E9",
        'Rang': "\u27EB",
        'rangd': "\u2992",
        'range': "\u29A5",
        'rangle': "\u27E9",
        'raquo': '\xBB',
        'rarr': "\u2192",
        'rArr': "\u21D2",
        'Rarr': "\u21A0",
        'rarrap': "\u2975",
        'rarrb': "\u21E5",
        'rarrbfs': "\u2920",
        'rarrc': "\u2933",
        'rarrfs': "\u291E",
        'rarrhk': "\u21AA",
        'rarrlp': "\u21AC",
        'rarrpl': "\u2945",
        'rarrsim': "\u2974",
        'rarrtl': "\u21A3",
        'Rarrtl': "\u2916",
        'rarrw': "\u219D",
        'ratail': "\u291A",
        'rAtail': "\u291C",
        'ratio': "\u2236",
        'rationals': "\u211A",
        'rbarr': "\u290D",
        'rBarr': "\u290F",
        'RBarr': "\u2910",
        'rbbrk': "\u2773",
        'rbrace': '}',
        'rbrack': ']',
        'rbrke': "\u298C",
        'rbrksld': "\u298E",
        'rbrkslu': "\u2990",
        'rcaron': "\u0159",
        'Rcaron': "\u0158",
        'rcedil': "\u0157",
        'Rcedil': "\u0156",
        'rceil': "\u2309",
        'rcub': '}',
        'rcy': "\u0440",
        'Rcy': "\u0420",
        'rdca': "\u2937",
        'rdldhar': "\u2969",
        'rdquo': "\u201D",
        'rdquor': "\u201D",
        'rdsh': "\u21B3",
        'Re': "\u211C",
        'real': "\u211C",
        'realine': "\u211B",
        'realpart': "\u211C",
        'reals': "\u211D",
        'rect': "\u25AD",
        'reg': '\xAE',
        'REG': '\xAE',
        'ReverseElement': "\u220B",
        'ReverseEquilibrium': "\u21CB",
        'ReverseUpEquilibrium': "\u296F",
        'rfisht': "\u297D",
        'rfloor': "\u230B",
        'rfr': "\uD835\uDD2F",
        'Rfr': "\u211C",
        'rHar': "\u2964",
        'rhard': "\u21C1",
        'rharu': "\u21C0",
        'rharul': "\u296C",
        'rho': "\u03C1",
        'Rho': "\u03A1",
        'rhov': "\u03F1",
        'RightAngleBracket': "\u27E9",
        'rightarrow': "\u2192",
        'Rightarrow': "\u21D2",
        'RightArrow': "\u2192",
        'RightArrowBar': "\u21E5",
        'RightArrowLeftArrow': "\u21C4",
        'rightarrowtail': "\u21A3",
        'RightCeiling': "\u2309",
        'RightDoubleBracket': "\u27E7",
        'RightDownTeeVector': "\u295D",
        'RightDownVector': "\u21C2",
        'RightDownVectorBar': "\u2955",
        'RightFloor': "\u230B",
        'rightharpoondown': "\u21C1",
        'rightharpoonup': "\u21C0",
        'rightleftarrows': "\u21C4",
        'rightleftharpoons': "\u21CC",
        'rightrightarrows': "\u21C9",
        'rightsquigarrow': "\u219D",
        'RightTee': "\u22A2",
        'RightTeeArrow': "\u21A6",
        'RightTeeVector': "\u295B",
        'rightthreetimes': "\u22CC",
        'RightTriangle': "\u22B3",
        'RightTriangleBar': "\u29D0",
        'RightTriangleEqual': "\u22B5",
        'RightUpDownVector': "\u294F",
        'RightUpTeeVector': "\u295C",
        'RightUpVector': "\u21BE",
        'RightUpVectorBar': "\u2954",
        'RightVector': "\u21C0",
        'RightVectorBar': "\u2953",
        'ring': "\u02DA",
        'risingdotseq': "\u2253",
        'rlarr': "\u21C4",
        'rlhar': "\u21CC",
        'rlm': "\u200F",
        'rmoust': "\u23B1",
        'rmoustache': "\u23B1",
        'rnmid': "\u2AEE",
        'roang': "\u27ED",
        'roarr': "\u21FE",
        'robrk': "\u27E7",
        'ropar': "\u2986",
        'ropf': "\uD835\uDD63",
        'Ropf': "\u211D",
        'roplus': "\u2A2E",
        'rotimes': "\u2A35",
        'RoundImplies': "\u2970",
        'rpar': ')',
        'rpargt': "\u2994",
        'rppolint': "\u2A12",
        'rrarr': "\u21C9",
        'Rrightarrow': "\u21DB",
        'rsaquo': "\u203A",
        'rscr': "\uD835\uDCC7",
        'Rscr': "\u211B",
        'rsh': "\u21B1",
        'Rsh': "\u21B1",
        'rsqb': ']',
        'rsquo': "\u2019",
        'rsquor': "\u2019",
        'rthree': "\u22CC",
        'rtimes': "\u22CA",
        'rtri': "\u25B9",
        'rtrie': "\u22B5",
        'rtrif': "\u25B8",
        'rtriltri': "\u29CE",
        'RuleDelayed': "\u29F4",
        'ruluhar': "\u2968",
        'rx': "\u211E",
        'sacute': "\u015B",
        'Sacute': "\u015A",
        'sbquo': "\u201A",
        'sc': "\u227B",
        'Sc': "\u2ABC",
        'scap': "\u2AB8",
        'scaron': "\u0161",
        'Scaron': "\u0160",
        'sccue': "\u227D",
        'sce': "\u2AB0",
        'scE': "\u2AB4",
        'scedil': "\u015F",
        'Scedil': "\u015E",
        'scirc': "\u015D",
        'Scirc': "\u015C",
        'scnap': "\u2ABA",
        'scnE': "\u2AB6",
        'scnsim': "\u22E9",
        'scpolint': "\u2A13",
        'scsim': "\u227F",
        'scy': "\u0441",
        'Scy': "\u0421",
        'sdot': "\u22C5",
        'sdotb': "\u22A1",
        'sdote': "\u2A66",
        'searhk': "\u2925",
        'searr': "\u2198",
        'seArr': "\u21D8",
        'searrow': "\u2198",
        'sect': '\xA7',
        'semi': ';',
        'seswar': "\u2929",
        'setminus': "\u2216",
        'setmn': "\u2216",
        'sext': "\u2736",
        'sfr': "\uD835\uDD30",
        'Sfr': "\uD835\uDD16",
        'sfrown': "\u2322",
        'sharp': "\u266F",
        'shchcy': "\u0449",
        'SHCHcy': "\u0429",
        'shcy': "\u0448",
        'SHcy': "\u0428",
        'ShortDownArrow': "\u2193",
        'ShortLeftArrow': "\u2190",
        'shortmid': "\u2223",
        'shortparallel': "\u2225",
        'ShortRightArrow': "\u2192",
        'ShortUpArrow': "\u2191",
        'shy': '\xAD',
        'sigma': "\u03C3",
        'Sigma': "\u03A3",
        'sigmaf': "\u03C2",
        'sigmav': "\u03C2",
        'sim': "\u223C",
        'simdot': "\u2A6A",
        'sime': "\u2243",
        'simeq': "\u2243",
        'simg': "\u2A9E",
        'simgE': "\u2AA0",
        'siml': "\u2A9D",
        'simlE': "\u2A9F",
        'simne': "\u2246",
        'simplus': "\u2A24",
        'simrarr': "\u2972",
        'slarr': "\u2190",
        'SmallCircle': "\u2218",
        'smallsetminus': "\u2216",
        'smashp': "\u2A33",
        'smeparsl': "\u29E4",
        'smid': "\u2223",
        'smile': "\u2323",
        'smt': "\u2AAA",
        'smte': "\u2AAC",
        'smtes': "\u2AAC\uFE00",
        'softcy': "\u044C",
        'SOFTcy': "\u042C",
        'sol': '/',
        'solb': "\u29C4",
        'solbar': "\u233F",
        'sopf': "\uD835\uDD64",
        'Sopf': "\uD835\uDD4A",
        'spades': "\u2660",
        'spadesuit': "\u2660",
        'spar': "\u2225",
        'sqcap': "\u2293",
        'sqcaps': "\u2293\uFE00",
        'sqcup': "\u2294",
        'sqcups': "\u2294\uFE00",
        'Sqrt': "\u221A",
        'sqsub': "\u228F",
        'sqsube': "\u2291",
        'sqsubset': "\u228F",
        'sqsubseteq': "\u2291",
        'sqsup': "\u2290",
        'sqsupe': "\u2292",
        'sqsupset': "\u2290",
        'sqsupseteq': "\u2292",
        'squ': "\u25A1",
        'square': "\u25A1",
        'Square': "\u25A1",
        'SquareIntersection': "\u2293",
        'SquareSubset': "\u228F",
        'SquareSubsetEqual': "\u2291",
        'SquareSuperset': "\u2290",
        'SquareSupersetEqual': "\u2292",
        'SquareUnion': "\u2294",
        'squarf': "\u25AA",
        'squf': "\u25AA",
        'srarr': "\u2192",
        'sscr': "\uD835\uDCC8",
        'Sscr': "\uD835\uDCAE",
        'ssetmn': "\u2216",
        'ssmile': "\u2323",
        'sstarf': "\u22C6",
        'star': "\u2606",
        'Star': "\u22C6",
        'starf': "\u2605",
        'straightepsilon': "\u03F5",
        'straightphi': "\u03D5",
        'strns': '\xAF',
        'sub': "\u2282",
        'Sub': "\u22D0",
        'subdot': "\u2ABD",
        'sube': "\u2286",
        'subE': "\u2AC5",
        'subedot': "\u2AC3",
        'submult': "\u2AC1",
        'subne': "\u228A",
        'subnE': "\u2ACB",
        'subplus': "\u2ABF",
        'subrarr': "\u2979",
        'subset': "\u2282",
        'Subset': "\u22D0",
        'subseteq': "\u2286",
        'subseteqq': "\u2AC5",
        'SubsetEqual': "\u2286",
        'subsetneq': "\u228A",
        'subsetneqq': "\u2ACB",
        'subsim': "\u2AC7",
        'subsub': "\u2AD5",
        'subsup': "\u2AD3",
        'succ': "\u227B",
        'succapprox': "\u2AB8",
        'succcurlyeq': "\u227D",
        'Succeeds': "\u227B",
        'SucceedsEqual': "\u2AB0",
        'SucceedsSlantEqual': "\u227D",
        'SucceedsTilde': "\u227F",
        'succeq': "\u2AB0",
        'succnapprox': "\u2ABA",
        'succneqq': "\u2AB6",
        'succnsim': "\u22E9",
        'succsim': "\u227F",
        'SuchThat': "\u220B",
        'sum': "\u2211",
        'Sum': "\u2211",
        'sung': "\u266A",
        'sup': "\u2283",
        'Sup': "\u22D1",
        'sup1': '\xB9',
        'sup2': '\xB2',
        'sup3': '\xB3',
        'supdot': "\u2ABE",
        'supdsub': "\u2AD8",
        'supe': "\u2287",
        'supE': "\u2AC6",
        'supedot': "\u2AC4",
        'Superset': "\u2283",
        'SupersetEqual': "\u2287",
        'suphsol': "\u27C9",
        'suphsub': "\u2AD7",
        'suplarr': "\u297B",
        'supmult': "\u2AC2",
        'supne': "\u228B",
        'supnE': "\u2ACC",
        'supplus': "\u2AC0",
        'supset': "\u2283",
        'Supset': "\u22D1",
        'supseteq': "\u2287",
        'supseteqq': "\u2AC6",
        'supsetneq': "\u228B",
        'supsetneqq': "\u2ACC",
        'supsim': "\u2AC8",
        'supsub': "\u2AD4",
        'supsup': "\u2AD6",
        'swarhk': "\u2926",
        'swarr': "\u2199",
        'swArr': "\u21D9",
        'swarrow': "\u2199",
        'swnwar': "\u292A",
        'szlig': '\xDF',
        'Tab': '\t',
        'target': "\u2316",
        'tau': "\u03C4",
        'Tau': "\u03A4",
        'tbrk': "\u23B4",
        'tcaron': "\u0165",
        'Tcaron': "\u0164",
        'tcedil': "\u0163",
        'Tcedil': "\u0162",
        'tcy': "\u0442",
        'Tcy': "\u0422",
        'tdot': "\u20DB",
        'telrec': "\u2315",
        'tfr': "\uD835\uDD31",
        'Tfr': "\uD835\uDD17",
        'there4': "\u2234",
        'therefore': "\u2234",
        'Therefore': "\u2234",
        'theta': "\u03B8",
        'Theta': "\u0398",
        'thetasym': "\u03D1",
        'thetav': "\u03D1",
        'thickapprox': "\u2248",
        'thicksim': "\u223C",
        'ThickSpace': "\u205F\u200A",
        'thinsp': "\u2009",
        'ThinSpace': "\u2009",
        'thkap': "\u2248",
        'thksim': "\u223C",
        'thorn': '\xFE',
        'THORN': '\xDE',
        'tilde': "\u02DC",
        'Tilde': "\u223C",
        'TildeEqual': "\u2243",
        'TildeFullEqual': "\u2245",
        'TildeTilde': "\u2248",
        'times': '\xD7',
        'timesb': "\u22A0",
        'timesbar': "\u2A31",
        'timesd': "\u2A30",
        'tint': "\u222D",
        'toea': "\u2928",
        'top': "\u22A4",
        'topbot': "\u2336",
        'topcir': "\u2AF1",
        'topf': "\uD835\uDD65",
        'Topf': "\uD835\uDD4B",
        'topfork': "\u2ADA",
        'tosa': "\u2929",
        'tprime': "\u2034",
        'trade': "\u2122",
        'TRADE': "\u2122",
        'triangle': "\u25B5",
        'triangledown': "\u25BF",
        'triangleleft': "\u25C3",
        'trianglelefteq': "\u22B4",
        'triangleq': "\u225C",
        'triangleright': "\u25B9",
        'trianglerighteq': "\u22B5",
        'tridot': "\u25EC",
        'trie': "\u225C",
        'triminus': "\u2A3A",
        'TripleDot': "\u20DB",
        'triplus': "\u2A39",
        'trisb': "\u29CD",
        'tritime': "\u2A3B",
        'trpezium': "\u23E2",
        'tscr': "\uD835\uDCC9",
        'Tscr': "\uD835\uDCAF",
        'tscy': "\u0446",
        'TScy': "\u0426",
        'tshcy': "\u045B",
        'TSHcy': "\u040B",
        'tstrok': "\u0167",
        'Tstrok': "\u0166",
        'twixt': "\u226C",
        'twoheadleftarrow': "\u219E",
        'twoheadrightarrow': "\u21A0",
        'uacute': '\xFA',
        'Uacute': '\xDA',
        'uarr': "\u2191",
        'uArr': "\u21D1",
        'Uarr': "\u219F",
        'Uarrocir': "\u2949",
        'ubrcy': "\u045E",
        'Ubrcy': "\u040E",
        'ubreve': "\u016D",
        'Ubreve': "\u016C",
        'ucirc': '\xFB',
        'Ucirc': '\xDB',
        'ucy': "\u0443",
        'Ucy': "\u0423",
        'udarr': "\u21C5",
        'udblac': "\u0171",
        'Udblac': "\u0170",
        'udhar': "\u296E",
        'ufisht': "\u297E",
        'ufr': "\uD835\uDD32",
        'Ufr': "\uD835\uDD18",
        'ugrave': '\xF9',
        'Ugrave': '\xD9',
        'uHar': "\u2963",
        'uharl': "\u21BF",
        'uharr': "\u21BE",
        'uhblk': "\u2580",
        'ulcorn': "\u231C",
        'ulcorner': "\u231C",
        'ulcrop': "\u230F",
        'ultri': "\u25F8",
        'umacr': "\u016B",
        'Umacr': "\u016A",
        'uml': '\xA8',
        'UnderBar': '_',
        'UnderBrace': "\u23DF",
        'UnderBracket': "\u23B5",
        'UnderParenthesis': "\u23DD",
        'Union': "\u22C3",
        'UnionPlus': "\u228E",
        'uogon': "\u0173",
        'Uogon': "\u0172",
        'uopf': "\uD835\uDD66",
        'Uopf': "\uD835\uDD4C",
        'uparrow': "\u2191",
        'Uparrow': "\u21D1",
        'UpArrow': "\u2191",
        'UpArrowBar': "\u2912",
        'UpArrowDownArrow': "\u21C5",
        'updownarrow': "\u2195",
        'Updownarrow': "\u21D5",
        'UpDownArrow': "\u2195",
        'UpEquilibrium': "\u296E",
        'upharpoonleft': "\u21BF",
        'upharpoonright': "\u21BE",
        'uplus': "\u228E",
        'UpperLeftArrow': "\u2196",
        'UpperRightArrow': "\u2197",
        'upsi': "\u03C5",
        'Upsi': "\u03D2",
        'upsih': "\u03D2",
        'upsilon': "\u03C5",
        'Upsilon': "\u03A5",
        'UpTee': "\u22A5",
        'UpTeeArrow': "\u21A5",
        'upuparrows': "\u21C8",
        'urcorn': "\u231D",
        'urcorner': "\u231D",
        'urcrop': "\u230E",
        'uring': "\u016F",
        'Uring': "\u016E",
        'urtri': "\u25F9",
        'uscr': "\uD835\uDCCA",
        'Uscr': "\uD835\uDCB0",
        'utdot': "\u22F0",
        'utilde': "\u0169",
        'Utilde': "\u0168",
        'utri': "\u25B5",
        'utrif': "\u25B4",
        'uuarr': "\u21C8",
        'uuml': '\xFC',
        'Uuml': '\xDC',
        'uwangle': "\u29A7",
        'vangrt': "\u299C",
        'varepsilon': "\u03F5",
        'varkappa': "\u03F0",
        'varnothing': "\u2205",
        'varphi': "\u03D5",
        'varpi': "\u03D6",
        'varpropto': "\u221D",
        'varr': "\u2195",
        'vArr': "\u21D5",
        'varrho': "\u03F1",
        'varsigma': "\u03C2",
        'varsubsetneq': "\u228A\uFE00",
        'varsubsetneqq': "\u2ACB\uFE00",
        'varsupsetneq': "\u228B\uFE00",
        'varsupsetneqq': "\u2ACC\uFE00",
        'vartheta': "\u03D1",
        'vartriangleleft': "\u22B2",
        'vartriangleright': "\u22B3",
        'vBar': "\u2AE8",
        'Vbar': "\u2AEB",
        'vBarv': "\u2AE9",
        'vcy': "\u0432",
        'Vcy': "\u0412",
        'vdash': "\u22A2",
        'vDash': "\u22A8",
        'Vdash': "\u22A9",
        'VDash': "\u22AB",
        'Vdashl': "\u2AE6",
        'vee': "\u2228",
        'Vee': "\u22C1",
        'veebar': "\u22BB",
        'veeeq': "\u225A",
        'vellip': "\u22EE",
        'verbar': '|',
        'Verbar': "\u2016",
        'vert': '|',
        'Vert': "\u2016",
        'VerticalBar': "\u2223",
        'VerticalLine': '|',
        'VerticalSeparator': "\u2758",
        'VerticalTilde': "\u2240",
        'VeryThinSpace': "\u200A",
        'vfr': "\uD835\uDD33",
        'Vfr': "\uD835\uDD19",
        'vltri': "\u22B2",
        'vnsub': "\u2282\u20D2",
        'vnsup': "\u2283\u20D2",
        'vopf': "\uD835\uDD67",
        'Vopf': "\uD835\uDD4D",
        'vprop': "\u221D",
        'vrtri': "\u22B3",
        'vscr': "\uD835\uDCCB",
        'Vscr': "\uD835\uDCB1",
        'vsubne': "\u228A\uFE00",
        'vsubnE': "\u2ACB\uFE00",
        'vsupne': "\u228B\uFE00",
        'vsupnE': "\u2ACC\uFE00",
        'Vvdash': "\u22AA",
        'vzigzag': "\u299A",
        'wcirc': "\u0175",
        'Wcirc': "\u0174",
        'wedbar': "\u2A5F",
        'wedge': "\u2227",
        'Wedge': "\u22C0",
        'wedgeq': "\u2259",
        'weierp': "\u2118",
        'wfr': "\uD835\uDD34",
        'Wfr': "\uD835\uDD1A",
        'wopf': "\uD835\uDD68",
        'Wopf': "\uD835\uDD4E",
        'wp': "\u2118",
        'wr': "\u2240",
        'wreath': "\u2240",
        'wscr': "\uD835\uDCCC",
        'Wscr': "\uD835\uDCB2",
        'xcap': "\u22C2",
        'xcirc': "\u25EF",
        'xcup': "\u22C3",
        'xdtri': "\u25BD",
        'xfr': "\uD835\uDD35",
        'Xfr': "\uD835\uDD1B",
        'xharr': "\u27F7",
        'xhArr': "\u27FA",
        'xi': "\u03BE",
        'Xi': "\u039E",
        'xlarr': "\u27F5",
        'xlArr': "\u27F8",
        'xmap': "\u27FC",
        'xnis': "\u22FB",
        'xodot': "\u2A00",
        'xopf': "\uD835\uDD69",
        'Xopf': "\uD835\uDD4F",
        'xoplus': "\u2A01",
        'xotime': "\u2A02",
        'xrarr': "\u27F6",
        'xrArr': "\u27F9",
        'xscr': "\uD835\uDCCD",
        'Xscr': "\uD835\uDCB3",
        'xsqcup': "\u2A06",
        'xuplus': "\u2A04",
        'xutri': "\u25B3",
        'xvee': "\u22C1",
        'xwedge': "\u22C0",
        'yacute': '\xFD',
        'Yacute': '\xDD',
        'yacy': "\u044F",
        'YAcy': "\u042F",
        'ycirc': "\u0177",
        'Ycirc': "\u0176",
        'ycy': "\u044B",
        'Ycy': "\u042B",
        'yen': '\xA5',
        'yfr': "\uD835\uDD36",
        'Yfr': "\uD835\uDD1C",
        'yicy': "\u0457",
        'YIcy': "\u0407",
        'yopf': "\uD835\uDD6A",
        'Yopf': "\uD835\uDD50",
        'yscr': "\uD835\uDCCE",
        'Yscr': "\uD835\uDCB4",
        'yucy': "\u044E",
        'YUcy': "\u042E",
        'yuml': '\xFF',
        'Yuml': "\u0178",
        'zacute': "\u017A",
        'Zacute': "\u0179",
        'zcaron': "\u017E",
        'Zcaron': "\u017D",
        'zcy': "\u0437",
        'Zcy': "\u0417",
        'zdot': "\u017C",
        'Zdot': "\u017B",
        'zeetrf': "\u2128",
        'ZeroWidthSpace': "\u200B",
        'zeta': "\u03B6",
        'Zeta': "\u0396",
        'zfr': "\uD835\uDD37",
        'Zfr': "\u2128",
        'zhcy': "\u0436",
        'ZHcy': "\u0416",
        'zigrarr': "\u21DD",
        'zopf': "\uD835\uDD6B",
        'Zopf': "\u2124",
        'zscr': "\uD835\uDCCF",
        'Zscr': "\uD835\uDCB5",
        'zwj': "\u200D",
        'zwnj': "\u200C"
      };
      var decodeMapLegacy = {
        'aacute': '\xE1',
        'Aacute': '\xC1',
        'acirc': '\xE2',
        'Acirc': '\xC2',
        'acute': '\xB4',
        'aelig': '\xE6',
        'AElig': '\xC6',
        'agrave': '\xE0',
        'Agrave': '\xC0',
        'amp': '&',
        'AMP': '&',
        'aring': '\xE5',
        'Aring': '\xC5',
        'atilde': '\xE3',
        'Atilde': '\xC3',
        'auml': '\xE4',
        'Auml': '\xC4',
        'brvbar': '\xA6',
        'ccedil': '\xE7',
        'Ccedil': '\xC7',
        'cedil': '\xB8',
        'cent': '\xA2',
        'copy': '\xA9',
        'COPY': '\xA9',
        'curren': '\xA4',
        'deg': '\xB0',
        'divide': '\xF7',
        'eacute': '\xE9',
        'Eacute': '\xC9',
        'ecirc': '\xEA',
        'Ecirc': '\xCA',
        'egrave': '\xE8',
        'Egrave': '\xC8',
        'eth': '\xF0',
        'ETH': '\xD0',
        'euml': '\xEB',
        'Euml': '\xCB',
        'frac12': '\xBD',
        'frac14': '\xBC',
        'frac34': '\xBE',
        'gt': '>',
        'GT': '>',
        'iacute': '\xED',
        'Iacute': '\xCD',
        'icirc': '\xEE',
        'Icirc': '\xCE',
        'iexcl': '\xA1',
        'igrave': '\xEC',
        'Igrave': '\xCC',
        'iquest': '\xBF',
        'iuml': '\xEF',
        'Iuml': '\xCF',
        'laquo': '\xAB',
        'lt': '<',
        'LT': '<',
        'macr': '\xAF',
        'micro': '\xB5',
        'middot': '\xB7',
        'nbsp': '\xA0',
        'not': '\xAC',
        'ntilde': '\xF1',
        'Ntilde': '\xD1',
        'oacute': '\xF3',
        'Oacute': '\xD3',
        'ocirc': '\xF4',
        'Ocirc': '\xD4',
        'ograve': '\xF2',
        'Ograve': '\xD2',
        'ordf': '\xAA',
        'ordm': '\xBA',
        'oslash': '\xF8',
        'Oslash': '\xD8',
        'otilde': '\xF5',
        'Otilde': '\xD5',
        'ouml': '\xF6',
        'Ouml': '\xD6',
        'para': '\xB6',
        'plusmn': '\xB1',
        'pound': '\xA3',
        'quot': '"',
        'QUOT': '"',
        'raquo': '\xBB',
        'reg': '\xAE',
        'REG': '\xAE',
        'sect': '\xA7',
        'shy': '\xAD',
        'sup1': '\xB9',
        'sup2': '\xB2',
        'sup3': '\xB3',
        'szlig': '\xDF',
        'thorn': '\xFE',
        'THORN': '\xDE',
        'times': '\xD7',
        'uacute': '\xFA',
        'Uacute': '\xDA',
        'ucirc': '\xFB',
        'Ucirc': '\xDB',
        'ugrave': '\xF9',
        'Ugrave': '\xD9',
        'uml': '\xA8',
        'uuml': '\xFC',
        'Uuml': '\xDC',
        'yacute': '\xFD',
        'Yacute': '\xDD',
        'yen': '\xA5',
        'yuml': '\xFF'
      };
      var decodeMapNumeric = {
        '0': "\uFFFD",
        '128': "\u20AC",
        '130': "\u201A",
        '131': "\u0192",
        '132': "\u201E",
        '133': "\u2026",
        '134': "\u2020",
        '135': "\u2021",
        '136': "\u02C6",
        '137': "\u2030",
        '138': "\u0160",
        '139': "\u2039",
        '140': "\u0152",
        '142': "\u017D",
        '145': "\u2018",
        '146': "\u2019",
        '147': "\u201C",
        '148': "\u201D",
        '149': "\u2022",
        '150': "\u2013",
        '151': "\u2014",
        '152': "\u02DC",
        '153': "\u2122",
        '154': "\u0161",
        '155': "\u203A",
        '156': "\u0153",
        '158': "\u017E",
        '159': "\u0178"
      };
      var invalidReferenceCodePoints = [1, 2, 3, 4, 5, 6, 7, 8, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 64976, 64977, 64978, 64979, 64980, 64981, 64982, 64983, 64984, 64985, 64986, 64987, 64988, 64989, 64990, 64991, 64992, 64993, 64994, 64995, 64996, 64997, 64998, 64999, 65000, 65001, 65002, 65003, 65004, 65005, 65006, 65007, 65534, 65535, 131070, 131071, 196606, 196607, 262142, 262143, 327678, 327679, 393214, 393215, 458750, 458751, 524286, 524287, 589822, 589823, 655358, 655359, 720894, 720895, 786430, 786431, 851966, 851967, 917502, 917503, 983038, 983039, 1048574, 1048575, 1114110, 1114111];

      /*--------------------------------------------------------------------------*/

      var stringFromCharCode = String.fromCharCode;
      var object = {};
      var hasOwnProperty = object.hasOwnProperty;
      var has = function has(object, propertyName) {
        return hasOwnProperty.call(object, propertyName);
      };
      var contains = function contains(array, value) {
        var index = -1;
        var length = array.length;
        while (++index < length) {
          if (array[index] == value) {
            return true;
          }
        }
        return false;
      };
      var merge = function merge(options, defaults) {
        if (!options) {
          return defaults;
        }
        var result = {};
        var key;
        for (key in defaults) {
          // A `hasOwnProperty` check is not needed here, since only recognized
          // option names are used anyway. Any others are ignored.
          result[key] = has(options, key) ? options[key] : defaults[key];
        }
        return result;
      };

      // Modified version of `ucs2encode`; see https://mths.be/punycode.
      var codePointToSymbol = function codePointToSymbol(codePoint, strict) {
        var output = '';
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
          // See issue #4:
          // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
          // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
          // REPLACEMENT CHARACTER.”
          if (strict) {
            parseError('character reference outside the permissible Unicode range');
          }
          return "\uFFFD";
        }
        if (has(decodeMapNumeric, codePoint)) {
          if (strict) {
            parseError('disallowed character reference');
          }
          return decodeMapNumeric[codePoint];
        }
        if (strict && contains(invalidReferenceCodePoints, codePoint)) {
          parseError('disallowed character reference');
        }
        if (codePoint > 0xFFFF) {
          codePoint -= 0x10000;
          output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
          codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        output += stringFromCharCode(codePoint);
        return output;
      };
      var hexEscape = function hexEscape(codePoint) {
        return '&#x' + codePoint.toString(16).toUpperCase() + ';';
      };
      var decEscape = function decEscape(codePoint) {
        return '&#' + codePoint + ';';
      };
      var parseError = function parseError(message) {
        throw Error('Parse error: ' + message);
      };

      /*--------------------------------------------------------------------------*/

      var encode = function encode(string, options) {
        options = merge(options, encode.options);
        var strict = options.strict;
        if (strict && regexInvalidRawCodePoint.test(string)) {
          parseError('forbidden code point');
        }
        var encodeEverything = options.encodeEverything;
        var useNamedReferences = options.useNamedReferences;
        var allowUnsafeSymbols = options.allowUnsafeSymbols;
        var escapeCodePoint = options.decimal ? decEscape : hexEscape;
        var escapeBmpSymbol = function escapeBmpSymbol(symbol) {
          return escapeCodePoint(symbol.charCodeAt(0));
        };
        if (encodeEverything) {
          // Encode ASCII symbols.
          string = string.replace(regexAsciiWhitelist, function (symbol) {
            // Use named references if requested & possible.
            if (useNamedReferences && has(encodeMap, symbol)) {
              return '&' + encodeMap[symbol] + ';';
            }
            return escapeBmpSymbol(symbol);
          });
          // Shorten a few escapes that represent two symbols, of which at least one
          // is within the ASCII range.
          if (useNamedReferences) {
            string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;').replace(/&#x66;&#x6A;/g, '&fjlig;');
          }
          // Encode non-ASCII symbols.
          if (useNamedReferences) {
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function (string) {
              // Note: there is no need to check `has(encodeMap, string)` here.
              return '&' + encodeMap[string] + ';';
            });
          }
          // Note: any remaining non-ASCII symbols are handled outside of the `if`.
        } else if (useNamedReferences) {
          // Apply named character references.
          // Encode `<>"'&` using named character references.
          if (!allowUnsafeSymbols) {
            string = string.replace(regexEscape, function (string) {
              return '&' + encodeMap[string] + ';'; // no need to check `has()` here
            });
          }
          // Shorten escapes that represent two symbols, of which at least one is
          // `<>"'&`.
          string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;');
          // Encode non-ASCII symbols that can be replaced with a named reference.
          string = string.replace(regexEncodeNonAscii, function (string) {
            // Note: there is no need to check `has(encodeMap, string)` here.
            return '&' + encodeMap[string] + ';';
          });
        } else if (!allowUnsafeSymbols) {
          // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
          // using named character references.
          string = string.replace(regexEscape, escapeBmpSymbol);
        }
        return string
        // Encode astral symbols.
        .replace(regexAstralSymbols, function ($0) {
          // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
          var high = $0.charCodeAt(0);
          var low = $0.charCodeAt(1);
          var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
          return escapeCodePoint(codePoint);
        })
        // Encode any remaining BMP symbols that are not printable ASCII symbols
        // using a hexadecimal escape.
        .replace(regexBmpWhitelist, escapeBmpSymbol);
      };
      // Expose default options (so they can be overridden globally).
      encode.options = {
        'allowUnsafeSymbols': false,
        'encodeEverything': false,
        'strict': false,
        'useNamedReferences': false,
        'decimal': false
      };
      var decode = function decode(html, options) {
        options = merge(options, decode.options);
        var strict = options.strict;
        if (strict && regexInvalidEntity.test(html)) {
          parseError('malformed character reference');
        }
        return html.replace(regexDecode, function ($0, $1, $2, $3, $4, $5, $6, $7) {
          var codePoint;
          var semicolon;
          var decDigits;
          var hexDigits;
          var reference;
          var next;
          if ($1) {
            // Decode decimal escapes, e.g. `&#119558;`.
            decDigits = $1;
            semicolon = $2;
            if (strict && !semicolon) {
              parseError('character reference was not terminated by a semicolon');
            }
            codePoint = parseInt(decDigits, 10);
            return codePointToSymbol(codePoint, strict);
          }
          if ($3) {
            // Decode hexadecimal escapes, e.g. `&#x1D306;`.
            hexDigits = $3;
            semicolon = $4;
            if (strict && !semicolon) {
              parseError('character reference was not terminated by a semicolon');
            }
            codePoint = parseInt(hexDigits, 16);
            return codePointToSymbol(codePoint, strict);
          }
          if ($5) {
            // Decode named character references with trailing `;`, e.g. `&copy;`.
            reference = $5;
            if (has(decodeMap, reference)) {
              return decodeMap[reference];
            } else {
              // Ambiguous ampersand. https://mths.be/notes/ambiguous-ampersands
              if (strict) {
                parseError('named character reference was not terminated by a semicolon');
              }
              return $0;
            }
          }
          // If we’re still here, it’s a legacy reference for sure. No need for an
          // extra `if` check.
          // Decode named character references without trailing `;`, e.g. `&amp`
          // This is only a parse error if it gets converted to `&`, or if it is
          // followed by `=` in an attribute context.
          reference = $6;
          next = $7;
          if (next && options.isAttributeValue) {
            if (strict && next == '=') {
              parseError('`&` did not start a character reference');
            }
            return $0;
          } else {
            if (strict) {
              parseError('named character reference was not terminated by a semicolon');
            }
            // Note: there is no need to check `has(decodeMapLegacy, reference)`.
            return decodeMapLegacy[reference] + (next || '');
          }
        });
      };
      // Expose default options (so they can be overridden globally).
      decode.options = {
        'isAttributeValue': false,
        'strict': false
      };
      var escape = function escape(string) {
        return string.replace(regexEscape, function ($0) {
          // Note: there is no need to check `has(escapeMap, $0)` here.
          return escapeMap[$0];
        });
      };

      /*--------------------------------------------------------------------------*/

      var he = {
        'version': '1.1.1',
        'encode': encode,
        'decode': decode,
        'escape': escape,
        'unescape': decode
      };

      // Some AMD build optimizers, like r.js, check for specific condition patterns
      // like the following:
      if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return he;
        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else if (freeExports && !freeExports.nodeType) {
        if (freeModule) {
          // in Node.js, io.js, or RingoJS v0.8.0+
          freeModule.exports = he;
        } else {
          // in Narwhal or RingoJS v0.7.0-
          for (var key in he) {
            has(he, key) && (freeExports[key] = he[key]);
          }
        }
      } else {
        // in Rhino or a web browser
        root.he = he;
      }
    })(this);

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(21)(module), __webpack_require__(6));

  /***/
}, /* 34 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (module) {
    /*
    * Copyright (C) 2007-2015 Diego Perini
    * All rights reserved.
    *
    * nwmatcher-noqsa.js - A fast CSS selector engine and matcher
    *
    * Author: Diego Perini <diego.perini at gmail com>
    * Version: 1.3.7
    * Created: 20070722
    * Release: 20151120
    *
    * License:
    *  http://javascript.nwbox.com/NWMatcher/MIT-LICENSE
    * Download:
    *  http://javascript.nwbox.com/NWMatcher/nwmatcher.js
    */

    (function (global, factory) {
      if (true) {
        module.exports = function (browserGlobal) {
          // passed global does not contain
          // references to native objects
          browserGlobal.console = console;
          browserGlobal.parseInt = parseInt;
          browserGlobal.Function = Function;
          browserGlobal.Boolean = Boolean;
          browserGlobal.Number = Number;
          browserGlobal.RegExp = RegExp;
          browserGlobal.String = String;
          browserGlobal.Object = Object;
          browserGlobal.Array = Array;
          browserGlobal.Error = Error;
          browserGlobal.Date = Date;
          browserGlobal.Math = Math;
          var exports = browserGlobal.Object();
          factory(browserGlobal, exports);
          return exports;
        };
        module.factory = factory;
      } else {
        factory(global, (global.NW || (global.NW = global.Object())) && (global.NW.Dom || (global.NW.Dom = global.Object())));
        global.NW.Dom.factory = factory;
      }
    })(this, function (global, exports) {
      var version = 'nwmatcher-1.3.7',
        Dom = exports,
        doc = global.document,
        root = doc.documentElement,
        isSingleMatch,
        isSingleSelect,
        lastSlice,
        lastContext,
        lastPosition,
        lastMatcher,
        lastSelector,
        lastPartsMatch,
        lastPartsSelect,
        operators = '([~*^$|!]?={1})',
        combinators = '[\\s]|[>+~](?=[^>+~])',
        pseudoparms = '(?:[-+]?\\d*n)?[-+]?\\d*',
        quotedvalue = '"[^"\\\\]*(?:\\\\.[^"\\\\]*)*"' + "|'[^'\\\\]*(?:\\\\.[^'\\\\]*)*'",
        skipgroup = '\\[.*\\]|\\(.*\\)|\\{.*\\}',
        encoding = '(?:[-\\w]|[^\\x00-\\xa0]|\\\\.)',
        identifier = '(?:-?[_a-zA-Z]{1}[-\\w]*|[^\\x00-\\xa0]+|\\\\.+)+',
        attrcheck = '(' + quotedvalue + '|' + identifier + ')',
        attributes = '\\s*(' + encoding + '*:?' + encoding + '+)\\s*(?:' + operators + '\\s*' + attrcheck + ')?\\s*',
        attrmatcher = attributes.replace(attrcheck, '([\\x22\\x27]*)((?:\\\\?.)*?)\\3'),
        pseudoclass = '((?:' + pseudoparms + '|' + quotedvalue + '|' + '[#.:]?|' + encoding + '+|' + '\\[' + attributes + '\\]|' + '\\(.+\\)|\\s*|' + ',)+)',
        extensions = '.+',
        standardValidator = '(?=\\s*[^>+~(){}<>])' + '(' + '\\*' + '|(?:[#.:]?' + identifier + ')' + '|' + combinators + '|\\[' + attributes + '\\]' + '|\\(' + pseudoclass + '\\)' + '|\\{' + extensions + '\\}' + '|(?:,|\\s*)' + ')+',
        extendedValidator = standardValidator.replace(pseudoclass, '.*'),
        reValidator = global.RegExp(standardValidator),
        reTrimSpaces = /^\s*|\s*$/g,
        reSimpleNot = global.RegExp('^(' + '(?!:not)' + '([#.:]?' + '|' + identifier + '|\\([^()]*\\))+' + '|\\[' + attributes + '\\]' + ')$'),
        reSplitGroup = /([^,\\()[\]]+|\[[^[\]]*\]|\[.*\]|\([^()]+\)|\(.*\)|\{[^{}]+\}|\{.*\}|\\.)+/g,
        reSplitToken = global.RegExp('(' + '\\[' + attributes + '\\]|' + '\\(' + pseudoclass + '\\)|' + '\\:(?:link|visited|target|active|focus|hover|checked|disabled|enabled|selected|lang\\((?:[-\\w]{2,})\\)|not\\(\\s*(?::nth(?:-last)?(?:-child|-of-type)\\(\\s*(?:even|odd|(?:[-+]{0,1}\\d*n\\s*)?[-+]{0,1}\\s*\\d*)\\s*\\)|[^()]*)\\s*\\))?|' + '\\\\.|[^\\s>+~])+', 'g'),
        reOptimizeSelector = global.RegExp(identifier + '|^$'),
        QUIRKS_MODE,
        XML_DOCUMENT,
        GEBTN = ('getElementsByTagName' in doc),
        GEBCN = ('getElementsByClassName' in doc),
        LINK_NODES = global.Object({
          a: 1,
          A: 1,
          area: 1,
          AREA: 1,
          link: 1,
          LINK: 1
        }),
        ATTR_BOOLEAN = global.Object({
          checked: 1,
          disabled: 1,
          ismap: 1,
          multiple: 1,
          readonly: 1,
          selected: 1
        }),
        ATTR_DEFAULT = global.Object({
          value: 'defaultValue',
          checked: 'defaultChecked',
          selected: 'defaultSelected'
        }),
        ATTR_URIDATA = global.Object({
          action: 2,
          cite: 2,
          codebase: 2,
          data: 2,
          href: 2,
          longdesc: 2,
          lowsrc: 2,
          src: 2,
          usemap: 2
        }),
        Selectors = global.Object({}),
        Operators = global.Object({
          '=': "n=='%m'",
          '^=': "n.indexOf('%m')==0",
          '*=': "n.indexOf('%m')>-1",
          '|=': "(n+'-').indexOf('%m-')==0",
          '~=': "(' '+n+' ').indexOf(' %m ')>-1",
          '$=': "n.substr(n.length-'%m'.length)=='%m'"
        }),
        Optimize = global.Object({
          ID: global.RegExp('^\\*?#(' + encoding + '+)|' + skipgroup),
          TAG: global.RegExp('^(' + encoding + '+)|' + skipgroup),
          CLASS: global.RegExp('^\\*?\\.(' + encoding + '+$)|' + skipgroup)
        }),
        Patterns = global.Object({
          spseudos: /^\:(root|empty|(?:first|last|only)(?:-child|-of-type)|nth(?:-last)?(?:-child|-of-type)\(\s*(even|odd|(?:[-+]{0,1}\d*n\s*)?[-+]{0,1}\s*\d*)\s*\))?(.*)/i,
          dpseudos: /^\:(link|visited|target|active|focus|hover|checked|disabled|enabled|selected|lang\(([-\w]{2,})\)|not\(\s*(:nth(?:-last)?(?:-child|-of-type)\(\s*(?:even|odd|(?:[-+]{0,1}\d*n\s*)?[-+]{0,1}\s*\d*)\s*\)|[^()]*)\s*\))?(.*)/i,
          attribute: global.RegExp('^\\[' + attrmatcher + '\\](.*)'),
          children: /^\s*\>\s*(.*)/,
          adjacent: /^\s*\+\s*(.*)/,
          relative: /^\s*\~\s*(.*)/,
          ancestor: /^\s+(.*)/,
          universal: /^\*(.*)/,
          id: global.RegExp('^#(' + encoding + '+)(.*)'),
          tagName: global.RegExp('^(' + encoding + '+)(.*)'),
          className: global.RegExp('^\\.(' + encoding + '+)(.*)')
        }),
        concatCall = function concatCall(data, elements, callback) {
          var i = -1,
            element;
          while (element = elements[++i]) {
            if (false === callback(data[data.length] = element)) {
              break;
            }
          }
          return data;
        },
        switchContext = function switchContext(from, force) {
          var oldDoc = doc;
          lastContext = from;
          doc = from.ownerDocument || from;
          if (force || oldDoc !== doc) {
            root = doc.documentElement;
            XML_DOCUMENT = doc.createElement('DiV').nodeName == 'DiV';
            QUIRKS_MODE = !XML_DOCUMENT && typeof doc.compatMode == 'string' ? doc.compatMode.indexOf('CSS') < 0 : function () {
              var style = doc.createElement('div').style;
              return style && (style.width = 1) && style.width == '1px';
            }();
            Config.CACHING && Dom.setCache(true, doc);
          }
        },
        convertEscapes = function convertEscapes(str) {
          return str.replace(/\\([0-9a-fA-F]{1,6}\x20?|.)|([\x22\x27])/g, function (substring, p1, p2) {
            var codePoint, highHex, highSurrogate, lowHex, lowSurrogate;
            if (p2) {
              return '\\' + p2;
            }
            if (/^[0-9a-fA-F]/.test(p1)) {
              codePoint = parseInt(p1, 16);
              if (codePoint < 0 || codePoint > 0x10ffff) {
                return "\\ufffd";
              }
              if (codePoint <= 0xffff) {
                lowHex = '000' + codePoint.toString(16);
                return "\\u" + lowHex.substr(lowHex.length - 4);
              }
              codePoint -= 0x10000;
              highSurrogate = (codePoint >> 10) + 0xd800;
              lowSurrogate = codePoint % 0x400 + 0xdc00;
              highHex = '000' + highSurrogate.toString(16);
              lowHex = '000' + lowSurrogate.toString(16);
              return "\\u" + highHex.substr(highHex.length - 4) + "\\u" + lowHex.substr(lowHex.length - 4);
            }
            if (/^[\\\x22\x27]/.test(p1)) {
              return substring;
            }
            return p1;
          });
        },
        byIdRaw = function byIdRaw(id, elements) {
          var i = -1,
            element = null;
          while (element = elements[++i]) {
            if (element.getAttribute('id') == id) {
              break;
            }
          }
          return element;
        },
        _byId = !('fileSize' in doc) ? function (id, from) {
          id = id.replace(/\\([^\\]{1})/g, '$1');
          return from.getElementById && from.getElementById(id) || byIdRaw(id, from.getElementsByTagName('*'));
        } : function (id, from) {
          var element = null;
          id = id.replace(/\\([^\\]{1})/g, '$1');
          if (XML_DOCUMENT || from.nodeType != 9) {
            return byIdRaw(id, from.getElementsByTagName('*'));
          }
          if ((element = from.getElementById(id)) && element.name == id && from.getElementsByName) {
            return byIdRaw(id, from.getElementsByName(id));
          }
          return element;
        },
        byId = function byId(id, from) {
          from || (from = doc);
          if (lastContext !== from) {
            switchContext(from);
          }
          return _byId(id, from);
        },
        byTagRaw = function byTagRaw(tag, from) {
          var any = tag == '*',
            element = from,
            elements = global.Array(),
            next = element.firstChild;
          any || (tag = tag.toUpperCase());
          while (element = next) {
            if (element.tagName > '@' && (any || element.tagName.toUpperCase() == tag)) {
              elements[elements.length] = element;
            }
            if (next = element.firstChild || element.nextSibling) continue;
            while (!next && (element = element.parentNode) && element !== from) {
              next = element.nextSibling;
            }
          }
          return elements;
        },
        contains = 'compareDocumentPosition' in root ? function (container, element) {
          return (container.compareDocumentPosition(element) & 16) == 16;
        } : 'contains' in root ? function (container, element) {
          return element.nodeType == 1 && container.contains(element);
        } : function (container, element) {
          while ((element = element.parentNode) && element.nodeType == 1) {
            if (element === container) return true;
          }
          return false;
        },
        getAttribute = function getAttribute(node, attribute) {
          attribute = attribute.toLowerCase();
          if (typeof node[attribute] == 'object') {
            return node.attributes[attribute] && node.attributes[attribute].value;
          }
          return attribute == 'type' ? node.getAttribute(attribute) : ATTR_URIDATA[attribute] ? node.getAttribute(attribute, 2) : ATTR_BOOLEAN[attribute] ? node.getAttribute(attribute) ? attribute : 'false' : (node = node.getAttributeNode(attribute)) && node.value;
        },
        hasAttribute = root.hasAttribute ? function (node, attribute) {
          return node.hasAttribute(attribute);
        } : function (node, attribute) {
          var obj = node.getAttributeNode(attribute = attribute.toLowerCase());
          return ATTR_DEFAULT[attribute] && attribute != 'value' ? node[ATTR_DEFAULT[attribute]] : obj && obj.specified;
        },
        isLink = function isLink(element) {
          return element.getAttribute('href') && LINK_NODES[element.nodeName];
        },
        isEmpty = function isEmpty(node) {
          node = node.firstChild;
          while (node) {
            if (node.nodeType == 3 || node.nodeName > '@') return false;
            node = node.nextSibling;
          }
          return true;
        },
        nthElement = function nthElement(element, last) {
          var count = 1,
            succ = last ? 'nextSibling' : 'previousSibling';
          while (element = element[succ]) {
            if (element.nodeName > '@') ++count;
          }
          return count;
        },
        nthOfType = function nthOfType(element, last) {
          var count = 1,
            succ = last ? 'nextSibling' : 'previousSibling',
            type = element.nodeName;
          while (element = element[succ]) {
            if (element.nodeName == type) ++count;
          }
          return count;
        },
        configure = function configure(option) {
          if (typeof option == 'string') {
            return Config[option] || Config;
          }
          if (typeof option != 'object') {
            return false;
          }
          for (var i in option) {
            Config[i] = !!option[i];
            if (i == 'SIMPLENOT') {
              matchContexts = global.Object();
              matchResolvers = global.Object();
              selectContexts = global.Object();
              selectResolvers = global.Object();
            }
          }
          reValidator = global.RegExp(Config.SIMPLENOT ? standardValidator : extendedValidator);
          return true;
        },
        emit = function emit(message) {
          if (Config.VERBOSITY) {
            throw global.Error(message);
          }
          if (global.console && global.console.log) {
            global.console.log(message);
          }
        },
        Config = global.Object({
          CACHING: false,
          SIMPLENOT: true,
          UNIQUE_ID: true,
          USE_HTML5: true,
          VERBOSITY: true
        }),
        IE_LT_9 = typeof doc.addEventListener != 'function',
        INSENSITIVE_MAP = global.Object({
          href: 1,
          lang: 1,
          src: 1,
          style: 1,
          title: 1,
          type: 1,
          xmlns: 1,
          'xml:lang': 1,
          'xml:space': 1
        }),
        TO_UPPER_CASE = IE_LT_9 ? '.toUpperCase()' : '',
        ACCEPT_NODE = 'r[r.length]=c[k];if(f&&false===f(c[k]))break main;else continue main;',
        REJECT_NODE = IE_LT_9 ? 'if(e.nodeName<"A")continue;' : '',
        compile = function compile(selector, source, mode) {
          var parts = typeof selector == 'string' ? selector.match(reSplitGroup) : selector;
          typeof source == 'string' || (source = '');
          if (parts.length == 1) {
            source += compileSelector(parts[0], mode ? ACCEPT_NODE : 'f&&f(k);return true;', mode);
          } else {
            var i = -1,
              seen = global.Object(),
              token;
            while (token = parts[++i]) {
              token = token.replace(reTrimSpaces, '');
              if (!seen[token] && (seen[token] = true)) {
                source += compileSelector(token, mode ? ACCEPT_NODE : 'f&&f(k);return true;', mode);
              }
            }
          }
          if (mode) {
            return global.Function('c,s,r,d,h,g,f,v', 'var N,n,x=0,k=-1,e;main:while((e=c[++k])){' + source + '}return r;');
          } else {
            return global.Function('e,s,r,d,h,g,f,v', 'var N,n,x=0,k=e;' + source + 'return false;');
          }
        },
        FILTER = 'var z=v[@]||(v[@]=[]),l=z.length-1;' + 'while(l>=0&&z[l]!==e)--l;' + 'if(l!==-1){break;}' + 'z[z.length]=e;',
        compileSelector = function compileSelector(selector, source, mode) {
          var a,
            b,
            n,
            k = 0,
            expr,
            match,
            name,
            result,
            status,
            test,
            type;
          while (selector) {
            k++;
            if (match = selector.match(Patterns.universal)) {
              expr = '';
            } else if (match = selector.match(Patterns.id)) {
              source = 'if(' + (XML_DOCUMENT ? 's.getAttribute(e,"id")' : '(e.submit?s.getAttribute(e,"id"):e.id)') + '=="' + match[1] + '"' + '){' + source + '}';
            } else if (match = selector.match(Patterns.tagName)) {
              source = 'if(e.nodeName' + (XML_DOCUMENT ? '=="' + match[1] + '"' : TO_UPPER_CASE + '=="' + match[1].toUpperCase() + '"') + '){' + source + '}';
            } else if (match = selector.match(Patterns.className)) {
              source = 'if((n=' + (XML_DOCUMENT ? 'e.getAttribute("class")' : 'e.className') + ')&&n.length&&(" "+' + (QUIRKS_MODE ? 'n.toLowerCase()' : 'n') + '.replace(/\\s+/g," ")+" ").indexOf(" ' + (QUIRKS_MODE ? match[1].toLowerCase() : match[1]) + ' ")>-1' + '){' + source + '}';
            } else if (match = selector.match(Patterns.attribute)) {
              if (match[2] && !Operators[match[2]]) {
                emit('Unsupported operator in attribute selectors "' + selector + '"');
                return '';
              }
              test = 'false';
              if (match[2] && match[4] && (test = Operators[match[2]])) {
                match[4] = convertEscapes(match[4]);
                type = INSENSITIVE_MAP[match[1].toLowerCase()];
                test = test.replace(/\%m/g, type ? match[4].toLowerCase() : match[4]);
              } else if (match[2] == '!=' || match[2] == '=') {
                test = 'n' + match[2] + '=""';
              }
              source = 'if(n=s.hasAttribute(e,"' + match[1] + '")){' + (match[2] ? 'n=s.getAttribute(e,"' + match[1] + '")' : '') + (type && match[2] ? '.toLowerCase();' : ';') + 'if(' + (match[2] ? test : 'n') + '){' + source + '}}';
            } else if (match = selector.match(Patterns.adjacent)) {
              source = (mode ? '' : FILTER.replace(/@/g, k)) + source;
              source = 'var N' + k + '=e;while(e&&(e=e.previousSibling)){if(e.nodeName>"@"){' + source + 'break;}}e=N' + k + ';';
            } else if (match = selector.match(Patterns.relative)) {
              source = (mode ? '' : FILTER.replace(/@/g, k)) + source;
              source = 'var N' + k + '=e;e=e.parentNode.firstChild;while(e&&e!==N' + k + '){if(e.nodeName>"@"){' + source + '}e=e.nextSibling;}e=N' + k + ';';
            } else if (match = selector.match(Patterns.children)) {
              source = (mode ? '' : FILTER.replace(/@/g, k)) + source;
              source = 'var N' + k + '=e;while(e&&e!==h&&e!==g&&(e=e.parentNode)){' + source + 'break;}e=N' + k + ';';
            } else if (match = selector.match(Patterns.ancestor)) {
              source = (mode ? '' : FILTER.replace(/@/g, k)) + source;
              source = 'var N' + k + '=e;while(e&&e!==h&&e!==g&&(e=e.parentNode)){' + source + '}e=N' + k + ';';
            } else if ((match = selector.match(Patterns.spseudos)) && match[1]) {
              switch (match[1]) {
                case 'root':
                  if (match[3]) {
                    source = 'if(e===h||s.contains(h,e)){' + source + '}';
                  } else {
                    source = 'if(e===h){' + source + '}';
                  }
                  break;
                case 'empty':
                  source = 'if(s.isEmpty(e)){' + source + '}';
                  break;
                default:
                  if (match[1] && match[2]) {
                    if (match[2] == 'n') {
                      source = 'if(e!==h){' + source + '}';
                      break;
                    } else if (match[2] == 'even') {
                      a = 2;
                      b = 0;
                    } else if (match[2] == 'odd') {
                      a = 2;
                      b = 1;
                    } else {
                      b = (n = match[2].match(/(-?\d+)$/)) ? global.parseInt(n[1], 10) : 0;
                      a = (n = match[2].match(/(-?\d*)n/i)) ? global.parseInt(n[1], 10) : 0;
                      if (n && n[1] == '-') a = -1;
                    }
                    test = a > 1 ? /last/i.test(match[1]) ? '(n-(' + b + '))%' + a + '==0' : 'n>=' + b + '&&(n-(' + b + '))%' + a + '==0' : a < -1 ? /last/i.test(match[1]) ? '(n-(' + b + '))%' + a + '==0' : 'n<=' + b + '&&(n-(' + b + '))%' + a + '==0' : a === 0 ? 'n==' + b : a == -1 ? 'n<=' + b : 'n>=' + b;
                    source = 'if(e!==h){' + 'n=s[' + (/-of-type/i.test(match[1]) ? '"nthOfType"' : '"nthElement"') + ']' + '(e,' + (/last/i.test(match[1]) ? 'true' : 'false') + ');' + 'if(' + test + '){' + source + '}' + '}';
                  } else {
                    a = /first/i.test(match[1]) ? 'previous' : 'next';
                    n = /only/i.test(match[1]) ? 'previous' : 'next';
                    b = /first|last/i.test(match[1]);
                    type = /-of-type/i.test(match[1]) ? '&&n.nodeName!=e.nodeName' : '&&n.nodeName<"@"';
                    source = 'if(e!==h){' + ('n=e;while((n=n.' + a + 'Sibling)' + type + ');if(!n){' + (b ? source : 'n=e;while((n=n.' + n + 'Sibling)' + type + ');if(!n){' + source + '}') + '}') + '}';
                  }
                  break;
              }
            } else if ((match = selector.match(Patterns.dpseudos)) && match[1]) {
              switch (match[1].match(/^\w+/)[0]) {
                case 'not':
                  expr = match[3].replace(reTrimSpaces, '');
                  if (Config.SIMPLENOT && !reSimpleNot.test(expr)) {
                    emit('Negation pseudo-class only accepts simple selectors "' + match.join('') + '"');
                    return '';
                  } else {
                    if ('compatMode' in doc) {
                      source = 'if(!' + compile(expr, '', false) + '(e,s,r,d,h,g)){' + source + '}';
                    } else {
                      source = 'if(!s.match(e, "' + expr.replace(/\x22/g, '\\"') + '",g)){' + source + '}';
                    }
                  }
                  break;
                case 'checked':
                  source = 'if((typeof e.form!=="undefined"&&(/^(?:radio|checkbox)$/i).test(e.type)&&e.checked)' + (Config.USE_HTML5 ? '||(/^option$/i.test(e.nodeName)&&(e.selected||e.checked))' : '') + '){' + source + '}';
                  break;
                case 'disabled':
                  source = 'if(((typeof e.form!=="undefined"' + (Config.USE_HTML5 ? '' : '&&!(/^hidden$/i).test(e.type)') + ')||s.isLink(e))&&e.disabled===true){' + source + '}';
                  break;
                case 'enabled':
                  source = 'if(((typeof e.form!=="undefined"' + (Config.USE_HTML5 ? '' : '&&!(/^hidden$/i).test(e.type)') + ')||s.isLink(e))&&e.disabled===false){' + source + '}';
                  break;
                case 'lang':
                  test = '';
                  if (match[2]) test = match[2].substr(0, 2) + '-';
                  source = 'do{(n=e.lang||"").toLowerCase();' + 'if((n==""&&h.lang=="' + match[2].toLowerCase() + '")||' + '(n&&(n=="' + match[2].toLowerCase() + '"||n.substr(0,3)=="' + test.toLowerCase() + '")))' + '{' + source + 'break;}}while((e=e.parentNode)&&e!==g);';
                  break;
                case 'target':
                  source = 'if(e.id==d.location.hash.slice(1)){' + source + '}';
                  break;
                case 'link':
                  source = 'if(s.isLink(e)&&!e.visited){' + source + '}';
                  break;
                case 'visited':
                  source = 'if(s.isLink(e)&&e.visited){' + source + '}';
                  break;
                case 'active':
                  source = 'if(e===d.activeElement){' + source + '}';
                  break;
                case 'hover':
                  source = 'if(e===d.hoverElement){' + source + '}';
                  break;
                case 'focus':
                  source = 'hasFocus' in doc ? 'if(e===d.activeElement&&d.hasFocus()&&(e.type||e.href||typeof e.tabIndex=="number")){' + source + '}' : 'if(e===d.activeElement&&(e.type||e.href)){' + source + '}';
                  break;
                case 'selected':
                  source = 'if(/^option$/i.test(e.nodeName)&&(e.selected||e.checked)){' + source + '}';
                  break;
                default:
                  break;
              }
            } else {
              expr = false;
              status = false;
              for (expr in Selectors) {
                if ((match = selector.match(Selectors[expr].Expression)) && match[1]) {
                  result = Selectors[expr].Callback(match, source);
                  source = result.source;
                  status = result.status;
                  if (status) {
                    break;
                  }
                }
              }
              if (!status) {
                emit('Unknown pseudo-class selector "' + selector + '"');
                return '';
              }
              if (!expr) {
                emit('Unknown token in selector "' + selector + '"');
                return '';
              }
            }
            if (!match) {
              emit('Invalid syntax in selector "' + selector + '"');
              return '';
            }
            selector = match && match[match.length - 1];
          }
          return source;
        },
        match = function match(element, selector, from, callback) {
          var parts;
          if (!(element && element.nodeType == 1)) {
            emit('Invalid element argument');
            return false;
          } else if (typeof selector != 'string') {
            emit('Invalid selector argument');
            return false;
          } else if (lastContext !== from) {
            switchContext(from || (from = element.ownerDocument));
          }
          selector = selector.replace(reTrimSpaces, '');
          Config.SHORTCUTS && (selector = Dom.shortcuts(selector, element, from));
          if (lastMatcher != selector) {
            if ((parts = selector.match(reValidator)) && parts[0] == selector) {
              isSingleMatch = (parts = selector.match(reSplitGroup)).length < 2;
              lastMatcher = selector;
              lastPartsMatch = parts;
            } else {
              emit('The string "' + selector + '", is not a valid CSS selector');
              return false;
            }
          } else parts = lastPartsMatch;
          if (!matchResolvers[selector] || matchContexts[selector] !== from) {
            matchResolvers[selector] = compile(isSingleMatch ? [selector] : parts, '', false);
            matchContexts[selector] = from;
          }
          return matchResolvers[selector](element, Snapshot, [], doc, root, from, callback, {});
        },
        first = function first(selector, from) {
          return select(selector, from, function () {
            return false;
          })[0] || null;
        },
        select = function select(selector, from, callback) {
          var i,
            changed,
            element,
            elements,
            parts,
            token,
            original = selector;
          if (arguments.length === 0) {
            emit('Not enough arguments');
            return [];
          } else if (typeof selector != 'string') {
            return [];
          } else if (from && !/1|9|11/.test(from.nodeType)) {
            emit('Invalid or illegal context element');
            return [];
          } else if (lastContext !== from) {
            switchContext(from || (from = doc));
          }
          if (Config.CACHING && (elements = Dom.loadResults(original, from, doc, root))) {
            return callback ? concatCall([], elements, callback) : elements;
          }
          selector = selector.replace(reTrimSpaces, '');
          Config.SHORTCUTS && (selector = Dom.shortcuts(selector, from));
          if (changed = lastSelector != selector) {
            if ((parts = selector.match(reValidator)) && parts[0] == selector) {
              isSingleSelect = (parts = selector.match(reSplitGroup)).length < 2;
              lastSelector = selector;
              lastPartsSelect = parts;
            } else {
              emit('The string "' + selector + '", is not a valid CSS selector');
              return [];
            }
          } else parts = lastPartsSelect;
          if (from.nodeType == 11) {
            elements = byTagRaw('*', from);
          } else if (isSingleSelect) {
            if (changed) {
              parts = selector.match(reSplitToken);
              token = parts[parts.length - 1];
              lastSlice = token.split(':not')[0];
              lastPosition = selector.length - token.length;
            }
            if (Config.UNIQUE_ID && (parts = lastSlice.match(Optimize.ID)) && (token = parts[1])) {
              if (element = _byId(token, from)) {
                if (match(element, selector)) {
                  callback && callback(element);
                  elements = global.Array(element);
                } else elements = global.Array();
              }
            } else if (Config.UNIQUE_ID && (parts = selector.match(Optimize.ID)) && (token = parts[1])) {
              if (element = _byId(token, doc)) {
                if ('#' + token == selector) {
                  callback && callback(element);
                  elements = global.Array(element);
                } else if (/[>+~]/.test(selector)) {
                  from = element.parentNode;
                } else {
                  from = element;
                }
              } else elements = global.Array();
            }
            if (elements) {
              Config.CACHING && Dom.saveResults(original, from, doc, elements);
              return elements;
            }
            if (!XML_DOCUMENT && GEBTN && (parts = lastSlice.match(Optimize.TAG)) && (token = parts[1])) {
              if ((elements = from.getElementsByTagName(token)).length === 0) {
                return [];
              }
              selector = selector.slice(0, lastPosition) + selector.slice(lastPosition).replace(token, '*');
            } else if (!XML_DOCUMENT && GEBCN && (parts = lastSlice.match(Optimize.CLASS)) && (token = parts[1])) {
              if ((elements = from.getElementsByClassName(token.replace(/\\([^\\]{1})/g, '$1'))).length === 0) {
                return [];
              }
              selector = selector.slice(0, lastPosition) + selector.slice(lastPosition).replace('.' + token, reOptimizeSelector.test(selector.charAt(selector.indexOf(token) - 1)) ? '' : '*');
            }
          }
          if (!elements) {
            if (IE_LT_9) {
              elements = /^(?:applet|object)$/i.test(from.nodeName) ? from.childNodes : from.all;
            } else {
              elements = from.getElementsByTagName('*');
            }
          }
          if (!selectResolvers[selector] || selectContexts[selector] !== from) {
            selectResolvers[selector] = compile(isSingleSelect ? [selector] : parts, REJECT_NODE, true);
            selectContexts[selector] = from;
          }
          elements = selectResolvers[selector](elements, Snapshot, [], doc, root, from, callback, {});
          Config.CACHING && Dom.saveResults(original, from, doc, elements);
          return elements;
        },
        FN = function FN(x) {
          return x;
        },
        matchContexts = global.Object(),
        matchResolvers = global.Object(),
        selectContexts = global.Object(),
        selectResolvers = global.Object(),
        Snapshot = global.Object({
          byId: _byId,
          match: match,
          select: select,
          isLink: isLink,
          isEmpty: isEmpty,
          contains: contains,
          nthOfType: nthOfType,
          nthElement: nthElement,
          getAttribute: getAttribute,
          hasAttribute: hasAttribute
        });
      Dom.ACCEPT_NODE = ACCEPT_NODE;
      Dom.byId = byId;
      Dom.match = match;
      Dom.first = first;
      Dom.select = select;
      Dom.compile = compile;
      Dom.contains = contains;
      Dom.configure = configure;
      Dom.getAttribute = getAttribute;
      Dom.hasAttribute = hasAttribute;
      Dom.setCache = FN;
      Dom.shortcuts = FN;
      Dom.loadResults = FN;
      Dom.saveResults = FN;
      Dom.emit = emit;
      Dom.Config = Config;
      Dom.Snapshot = Snapshot;
      Dom.Operators = Operators;
      Dom.Selectors = Selectors;
      Dom.Version = version;
      Dom.registerOperator = function (symbol, resolver) {
        Operators[symbol] || (Operators[symbol] = resolver);
      };
      Dom.registerSelector = function (name, rexp, func) {
        Selectors[name] || (Selectors[name] = global.Object({
          Expression: rexp,
          Callback: func
        }));
      };
      switchContext(doc, true);
    });

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(21)(module));

  /***/
}, /* 35 */
/***/function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {};

  // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;
  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }
  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }
    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();
  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }
    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }
  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }
    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;
  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }
    draining = false;
    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }
    if (queue.length) {
      drainQueue();
    }
  }
  function drainQueue() {
    if (draining) {
      return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while (len) {
      currentQueue = queue;
      queue = [];
      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }
      queueIndex = -1;
      len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }
  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  };

  // v8 likes predictible objects
  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }
  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues
  process.versions = {};
  function noop() {}
  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;
  process.listeners = function (name) {
    return [];
  };
  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };
  process.cwd = function () {
    return '/';
  };
  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };
  process.umask = function () {
    return 0;
  };

  /***/
}, /* 36 */
/***/function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */(function (global) {
    var rng;
    var crypto = global.crypto || global.msCrypto; // for IE 11
    if (crypto && crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      // Moderately fast, high quality
      var _rnds8 = new Uint8Array(16);
      rng = function whatwgRNG() {
        crypto.getRandomValues(_rnds8);
        return _rnds8;
      };
    }
    if (!rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var _rnds = new Array(16);
      rng = function rng() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return _rnds;
      };
    }
    module.exports = rng;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(6));

  /***/
}
/******/]);